const itemsJson = [
  {
    tags: ['Trees'],
    price: 10.99,
    name: 'Handcrafted Trees Mug',
    description:
      'enim corporis voluptatibus laudantium possimus alias dolorem voluptatem similique aut aliquam voluptatem voluptatem omnis id consequatur',
    slug: 'Handcrafted-Trees-Mug',
    added: 1485723766805,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Water'],
    price: 19.99,
    name: 'Rustic Beach Mug',
    description:
      'totam at veritatis eligendi assumenda ex quia praesentium quibusdam ducimus',
    slug: 'Rustic-Beach-Mug',
    added: 1481573896833,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Bear'],
    price: 17.99,
    name: 'Handcrafted Bear Mug',
    description:
      'vitae mollitia et in accusantium est voluptas officiis est non',
    slug: 'Handcrafted-Bear-Mug',
    added: 1485991071829,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Road'],
    price: 15.99,
    name: 'Refined Road Mug',
    description:
      'explicabo fugit magnam fugit dolorem itaque unde quidem est quia ut a veritatis sit facere possimus fugit ipsam',
    slug: 'Refined-Road-Mug',
    added: 1482213983048,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 10.99,
    name: 'Unbranded Ocean Mug',
    description:
      'facilis aut velit vitae sit dolorum illum nostrum pariatur dolorem vel atque quasi placeat qui',
    slug: 'Unbranded-Ocean-Mug',
    added: 1483408192004,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Beach', 'Ocean'],
    price: 9.99,
    name: 'Rustic Ocean Mug',
    description:
      'libero reprehenderit blanditiis quidem laborum ullam quae fuga consequuntur minima praesentium consequatur qui excepturi nostrum tempora sunt deleniti',
    slug: 'Rustic-Ocean-Mug',
    added: 1485511118573,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Rust', 'Old', 'Car'],
    price: 19.99,
    name: 'Sleek Old Mug',
    description:
      'necessitatibus suscipit iure quia voluptates voluptas quidem ipsum laboriosam adipisci',
    slug: 'Sleek-Old-Mug',
    added: 1485759837725,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Coffee'],
    price: 14.99,
    name: 'Sleek Coffee Mug',
    description:
      'et adipisci explicabo consequatur rerum voluptas dolorem qui omnis vel',
    slug: 'Sleek-Coffee-Mug',
    added: 1479259996312,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'People'],
    price: 16.99,
    name: 'Rustic Trees Mug',
    description:
      'ut architecto est similique sit nostrum sit sed ipsa itaque aliquam nesciunt reprehenderit et neque aut id nulla dolore sed sit facere eligendi',
    slug: 'Rustic-Trees-Mug',
    added: 1480664800826,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Ocean', 'Dock'],
    price: 18.99,
    name: 'Sleek Ocean Mug',
    description:
      'magnam maxime nostrum minima dolores repellat laborum pariatur et quia maiores quidem eos quod est voluptas voluptatem quia ipsum odit dolorem et blanditiis aut voluptates',
    slug: 'Sleek-Ocean-Mug',
    added: 1485278625462,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Hills', 'Animals', 'Sheep'],
    price: 16.99,
    name: 'Ergonomic Person Mug',
    description:
      'sunt id omnis nihil consectetur et porro ut molestias ab et rem quia omnis voluptatem est libero reiciendis voluptatem dolores excepturi',
    slug: 'Ergonomic-Person-Mug',
    added: 1485835498313,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Lake', 'Water'],
    price: 9.99,
    name: 'Gorgeous Water Mug',
    description:
      'perspiciatis in qui et nemo nisi ad quam consequatur et dignissimos',
    slug: 'Gorgeous-Water-Mug',
    added: 1485880263998,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Fog'],
    price: 14.99,
    name: 'Generic Fog Mug',
    description:
      'consectetur voluptas sint excepturi voluptas aut culpa qui excepturi dicta ut voluptas',
    slug: 'Generic-Fog-Mug',
    added: 1484633915311,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Building', 'Metal'],
    price: 11.99,
    name: 'Gorgeous Building Mug',
    description:
      'quisquam maxime laudantium error totam unde commodi ullam qui quo sed aperiam',
    slug: 'Gorgeous-Building-Mug',
    added: 1482336621275,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Person', 'Woman', 'Meadow'],
    price: 10.99,
    name: 'Intelligent Sunset Mug',
    description:
      'qui ipsa hic voluptas et rem sed architecto reiciendis labore saepe fugit ab sed sed quos ut adipisci accusantium molestias',
    slug: 'Intelligent-Sunset-Mug',
    added: 1484735389245,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Coffee'],
    price: 11.99,
    name: 'Unbranded Coffee Mug',
    description:
      'soluta eligendi harum quis molestiae omnis excepturi deserunt sed dolorum dolorum ea non dolor',
    slug: 'Unbranded-Coffee-Mug',
    added: 1484144067274,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Road'],
    price: 9.99,
    name: 'Rustic Road Mug',
    description:
      'est ad ipsa et ipsum amet nemo cupiditate placeat praesentium qui illum harum',
    slug: 'Rustic-Road-Mug',
    added: 1480653821277,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Windows', 'Architecture', 'Building'],
    price: 17.99,
    name: 'Sleek Building Mug',
    description:
      'in cumque suscipit et perspiciatis minima ut et consequatur ab neque rerum hic dolore a aut dignissimos',
    slug: 'Sleek-Building-Mug',
    added: 1478843419299,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['House', 'Trees', 'Fog', 'Secluded'],
    price: 20.99,
    name: 'Tasty Secluded Mug',
    description:
      'non et omnis accusantium ut non voluptatem sunt iusto cumque laudantium sunt laboriosam et sequi et totam voluptatem aut vero occaecati quia laudantium',
    slug: 'Tasty-Secluded-Mug',
    added: 1482236584965,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Wall'],
    price: 14.99,
    name: 'Ergonomic Architecture Mug',
    description:
      'rerum sit voluptatibus sint voluptatem saepe delectus et quasi perferendis laborum et enim dolores quaerat iusto eos odio nisi',
    slug: 'Ergonomic-Architecture-Mug',
    added: 1484099772336,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Surf', 'Ocean', 'Waves'],
    price: 12.99,
    name: 'Intelligent Waves Mug',
    description:
      'architecto amet doloremque sit ut repudiandae ducimus rerum enim aut veniam autem aut ut ea consectetur est excepturi explicabo aliquid',
    slug: 'Intelligent-Waves-Mug',
    added: 1481166939534,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Bike', 'City', 'People'],
    price: 17.99,
    name: 'Intelligent City Mug',
    description:
      'sit animi repellendus voluptas vitae consequatur accusantium optio cupiditate et',
    slug: 'Intelligent-City-Mug',
    added: 1478209012932,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Fog'],
    price: 18.99,
    name: 'Refined Sky Mug',
    description:
      'non est voluptatem sint nulla dicta iste natus consequatur accusantium dolores dolore in et distinctio dolore similique',
    slug: 'Refined-Sky-Mug',
    added: 1481150082814,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Rust', 'Machine', 'Car'],
    price: 12.99,
    name: 'Incredible Car Mug',
    description:
      'rerum vero cupiditate et est similique soluta ex sit ex esse repellat necessitatibus voluptatum corrupti et nihil quod',
    slug: 'Incredible-Car-Mug',
    added: 1484684041316,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Fur', 'Monkey'],
    price: 15.99,
    name: 'Gorgeous Animal Mug',
    description:
      'rerum consectetur magni sed enim eveniet et dolorem laudantium ut aut qui voluptatem praesentium soluta iste aliquid dolorem quibusdam veniam voluptas quaerat excepturi',
    slug: 'Gorgeous-Animal-Mug',
    added: 1481333026774,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Machine', 'Ocean'],
    price: 13.99,
    name: 'Ergonomic Machine Mug',
    description:
      'minus nihil ipsum explicabo pariatur adipisci harum quia ab et voluptate odio',
    slug: 'Ergonomic-Machine-Mug',
    added: 1481307879405,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Planes', 'Sun', 'Clouds'],
    price: 15.99,
    name: 'Licensed Clouds Mug',
    description:
      'maiores esse culpa qui fuga dignissimos officia aliquid perferendis consequatur possimus accusantium',
    slug: 'Licensed-Clouds-Mug',
    added: 1481505340969,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Television', 'Tv'],
    price: 11.99,
    name: 'Awesome Television Mug',
    description:
      'tenetur perspiciatis necessitatibus eligendi perspiciatis et facilis expedita reiciendis et in corporis nostrum quam molestiae voluptatum soluta consequuntur nemo totam magnam doloremque adipisci architecto',
    slug: 'Awesome-Television-Mug',
    added: 1483267004259,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Grass', 'Meadow', 'Plants'],
    price: 11.99,
    name: 'Fantastic Grass Mug',
    description:
      'quod voluptas porro animi et praesentium velit aperiam ut officiis ut praesentium perspiciatis quia iste molestias voluptas',
    slug: 'Fantastic-Grass-Mug',
    added: 1483834365140,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['People'],
    price: 13.99,
    name: 'Refined People Mug',
    description:
      'sequi aliquam sapiente quibusdam fugit consequuntur voluptatum sint reprehenderit est mollitia voluptas consequatur similique quibusdam dolorem rerum quis',
    slug: 'Refined-People-Mug',
    added: 1482852590065,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 13.99,
    name: 'Practical Beach Mug',
    description:
      'dolorum quam nulla assumenda harum expedita est animi possimus a quod repellendus doloribus quae a in praesentium ut voluptatem quae esse consectetur et',
    slug: 'Practical-Beach-Mug',
    added: 1483847156817,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['American', 'Sky', 'Patriotic', 'Flag'],
    price: 13.99,
    name: 'Intelligent Patriotic Mug',
    description:
      'perspiciatis quia animi maxime modi non molestiae ab voluptas modi molestias non et sed repudiandae iste accusamus autem',
    slug: 'Intelligent-Patriotic-Mug',
    added: 1479597182568,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 16.99,
    name: 'Unbranded Office Mug',
    description:
      'et qui sint modi expedita similique consequatur esse quis aliquam est aliquam architecto quidem rerum nihil',
    slug: 'Unbranded-Office-Mug',
    added: 1481770180832,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Building'],
    price: 10.99,
    name: 'Awesome City Mug',
    description:
      'sint voluptatem accusantium quae facilis ipsum numquam ut possimus eveniet quia autem repudiandae ipsa qui ratione molestiae id voluptatem sit',
    slug: 'Awesome-City-Mug',
    added: 1479130102615,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Mugs', 'Coffee', 'Wood'],
    price: 9.99,
    name: 'Incredible Coffee Mug',
    description:
      'mollitia nostrum sequi aperiam quia nostrum aliquam expedita sint sit voluptatibus incidunt officia illum est doloribus',
    slug: 'Incredible-Coffee-Mug',
    added: 1485255015871,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Tree', 'Plant', 'Flowers'],
    price: 10.99,
    name: 'Gorgeous Tree Mug',
    description:
      'ut enim et odit inventore sunt eos culpa incidunt laudantium magnam veniam sequi consequatur quia recusandae unde et incidunt quod et a',
    slug: 'Gorgeous-Tree-Mug',
    added: 1477784601773,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Metal', 'Bridge', 'People'],
    price: 17.99,
    name: 'Fantastic Metal Mug',
    description:
      'qui minima et quibusdam accusantium facere doloribus culpa rerum eum accusamus nam',
    slug: 'Fantastic-Metal-Mug',
    added: 1479359688647,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Ocean', 'Hillside'],
    price: 14.99,
    name: 'Licensed Hillside Mug',
    description:
      'ex corrupti vel esse perferendis non similique at quia voluptatem sit illo ut maiores et magni',
    slug: 'Licensed-Hillside-Mug',
    added: 1485195149049,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Raindrops', 'Hand'],
    price: 10.99,
    name: 'Intelligent Person Mug',
    description:
      'necessitatibus voluptas rerum ea ea pariatur aut enim nam voluptas voluptatem maxime dignissimos',
    slug: 'Intelligent-Person-Mug',
    added: 1480379459639,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Chair lift', 'Ski', 'Snowboard', 'Mountain'],
    price: 17.99,
    name: 'Small Snow Mug',
    description:
      'laboriosam delectus accusamus aut aspernatur optio natus necessitatibus eos voluptas ut excepturi alias qui non et dolor in sint esse reprehenderit veniam consequatur',
    slug: 'Small-Snow-Mug',
    added: 1486327799048,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Waves'],
    price: 17.99,
    name: 'Intelligent Waves Mug',
    description:
      'aliquam odit iure porro facere ea adipisci laboriosam eligendi qui commodi officiis quia beatae dolorem ducimus aut et',
    slug: 'Intelligent-Waves-Mug-1',
    added: 1479103379933,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Person', 'Reflection'],
    price: 12.99,
    name: 'Licensed Person Mug',
    description:
      'inventore ut dolores facilis soluta excepturi necessitatibus saepe et expedita omnis omnis nihil eos dignissimos harum sequi aliquid sed voluptatem illum porro',
    slug: 'Licensed-Person-Mug',
    added: 1483379331438,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Buildings', 'City'],
    price: 20.99,
    name: 'Handcrafted City Mug',
    description:
      'omnis nemo nisi praesentium cumque a est dolore distinctio porro asperiores ut non officia hic aut velit deleniti et nihil',
    slug: 'Handcrafted-City-Mug',
    added: 1486194521970,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'City'],
    price: 15.99,
    name: 'Intelligent Bridge Mug',
    description:
      'molestiae nostrum aliquid odit omnis id perspiciatis iure ut aperiam suscipit dolores',
    slug: 'Intelligent-Bridge-Mug',
    added: 1484796278055,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Italy', 'Building'],
    price: 19.99,
    name: 'Refined Building Mug',
    description:
      'et dolorum rerum provident nobis ipsam delectus qui et cupiditate est aut et',
    slug: 'Refined-Building-Mug',
    added: 1485727487020,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Night', 'Stars'],
    price: 18.99,
    name: 'Practical Stars Mug',
    description:
      'fugit facere facilis laborum rerum culpa nulla nesciunt et ex error unde',
    slug: 'Practical-Stars-Mug',
    added: 1483437823499,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Forest'],
    price: 10.99,
    name: 'Small Forest Mug',
    description:
      'doloribus est odio nam magnam sed alias vitae sed non voluptates necessitatibus optio id voluptatem laborum aperiam quia est mollitia repellat accusamus',
    slug: 'Small-Forest-Mug',
    added: 1480056059539,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Surf', 'Ocean', 'Waves'],
    price: 19.99,
    name: 'Fantastic Ocean Mug',
    description:
      'et blanditiis sit consequatur sit quos vero nesciunt quas possimus deleniti dolor voluptatem laborum',
    slug: 'Fantastic-Ocean-Mug',
    added: 1479105879352,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Flowers', 'People'],
    price: 13.99,
    name: 'Fantastic Flowers Mug',
    description:
      'sit autem voluptas quo magni exercitationem aliquam adipisci amet earum et voluptate aut modi veritatis totam enim nam provident est',
    slug: 'Fantastic-Flowers-Mug',
    added: 1483908215736,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Wave', 'Ocean'],
    price: 9.99,
    name: 'Fantastic Sunset Mug',
    description:
      'eveniet animi fugit eligendi nihil quod eum officiis atque ad eum et aliquid odio sunt saepe similique non id esse accusantium in quas eius',
    slug: 'Fantastic-Sunset-Mug',
    added: 1484941428019,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Fog', 'Mountains', 'Bird'],
    price: 16.99,
    name: 'Awesome Fog Mug',
    description:
      'rerum et eveniet sed ea voluptatem quod minus ea eum labore et quia possimus error et quaerat',
    slug: 'Awesome-Fog-Mug',
    added: 1481690908770,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees', 'Mountains'],
    price: 13.99,
    name: 'Fantastic Snow Mug',
    description:
      'eos ipsa consequatur accusantium voluptate iste odit totam voluptates voluptatem mollitia atque et eum tempore rerum vel voluptatem commodi',
    slug: 'Fantastic-Snow-Mug',
    added: 1482800937717,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Buildings'],
    price: 14.99,
    name: 'Handcrafted Ocean Mug',
    description:
      'laboriosam ab incidunt excepturi at maxime numquam nihil placeat ipsa sequi accusamus quam et ut rerum',
    slug: 'Handcrafted-Ocean-Mug',
    added: 1482864575852,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Park', 'Swings'],
    price: 16.99,
    name: 'Rustic Swings Mug',
    description:
      'animi qui possimus molestiae voluptas architecto eius aut commodi error ea facilis ut',
    slug: 'Rustic-Swings-Mug',
    added: 1478545252127,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Flowers'],
    price: 16.99,
    name: 'Licensed Flowers Mug',
    description:
      'consequatur molestiae voluptates quia ut accusantium totam voluptatibus est ut asperiores rerum sed nisi debitis nam facere aperiam itaque',
    slug: 'Licensed-Flowers-Mug',
    added: 1478046327618,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Forest'],
    price: 14.99,
    name: 'Small Fog Mug',
    description:
      'ut voluptates ut qui recusandae in maiores in magni iure optio omnis incidunt ea ducimus non rem ex quia dolorem in est impedit',
    slug: 'Small-Fog-Mug',
    added: 1485264248334,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Animals', 'Meadow', 'Cows'],
    price: 10.99,
    name: 'Rustic Cows Mug',
    description:
      'voluptatibus corrupti quia quis debitis rerum nihil occaecati iste maxime quas molestiae perspiciatis accusamus deserunt inventore reiciendis error',
    slug: 'Rustic-Cows-Mug',
    added: 1485570199754,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Lights', 'Night', 'City', 'Phonebooth'],
    price: 13.99,
    name: 'Awesome Night Mug',
    description:
      'repellat sapiente ut atque unde in iure consequatur fuga mollitia ex',
    slug: 'Awesome-Night-Mug',
    added: 1485550855090,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 19.99,
    name: 'Ergonomic Mountains Mug',
    description:
      'atque deleniti adipisci rerum tempora rerum et totam nisi aspernatur animi nostrum natus sint adipisci id dolorem et et',
    slug: 'Ergonomic-Mountains-Mug',
    added: 1485892565725,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 12.99,
    name: 'Refined Fog Mug',
    description:
      'quas consequatur voluptatibus amet distinctio debitis et voluptatem cumque dolor quae laudantium illum et',
    slug: 'Refined-Fog-Mug',
    added: 1485451876612,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Castle'],
    price: 12.99,
    name: 'Sleek Castle Mug',
    description:
      'sunt consequatur nulla ea eaque sunt ipsum ut reiciendis non adipisci ratione et est maxime explicabo necessitatibus possimus natus est numquam nobis vero',
    slug: 'Sleek-Castle-Mug',
    added: 1485443534623,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 20.99,
    name: 'Small City Mug',
    description:
      'qui vel in voluptas incidunt nulla ut ad iure eligendi autem facilis ea earum aut beatae',
    slug: 'Small-City-Mug',
    added: 1482629125753,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'Fog', 'City'],
    price: 12.99,
    name: 'Handcrafted Bridge Mug',
    description:
      'necessitatibus molestiae quam eveniet et et quia nihil distinctio qui non placeat corporis unde dignissimos et sint itaque sit eum voluptates voluptatem atque veritatis est',
    slug: 'Handcrafted-Bridge-Mug',
    added: 1478802622624,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 13.99,
    name: 'Awesome Ocean Mug',
    description:
      'laborum expedita esse aut aut culpa rerum dolorem odit culpa eligendi vitae deleniti soluta aut quas beatae maiores et',
    slug: 'Awesome-Ocean-Mug',
    added: 1485267321515,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Wolf', 'Forest'],
    price: 19.99,
    name: 'Intelligent Animal Mug',
    description:
      'debitis suscipit quis fuga animi consequatur temporibus non sit cumque iusto',
    slug: 'Intelligent-Animal-Mug',
    added: 1478035444483,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Forest', 'Road', 'Trees'],
    price: 17.99,
    name: 'Licensed Forest Mug',
    description:
      'ipsa sed et quia consequatur autem aut dolores assumenda distinctio consequatur omnis ut ex minima consequatur sed veritatis',
    slug: 'Licensed-Forest-Mug',
    added: 1482090663572,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Abstract', 'Buildings'],
    price: 14.99,
    name: 'Intelligent Abstract Mug',
    description:
      'aperiam pariatur sit atque excepturi rerum hic omnis laborum ut illo doloremque quibusdam sequi aut minus hic placeat modi',
    slug: 'Intelligent-Abstract-Mug',
    added: 1478058988655,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees', 'Macro'],
    price: 11.99,
    name: 'Tasty Snow Mug',
    description:
      'dolores esse est eos in sequi qui error fugit est laborum occaecati quidem culpa natus voluptatem asperiores',
    slug: 'Tasty-Snow-Mug',
    added: 1485840346046,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Sand', 'Desert'],
    price: 9.99,
    name: 'Refined Sand Mug',
    description:
      'ea illo omnis sed ut voluptatem et et magni et sint ex distinctio',
    slug: 'Refined-Sand-Mug',
    added: 1482867052692,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Central Park', 'City', 'Buildings', 'New York'],
    price: 15.99,
    name: 'Generic New York Mug',
    description:
      'necessitatibus repudiandae delectus aut assumenda porro harum eos voluptas quos odio doloremque exercitationem qui incidunt numquam velit tempore aut eos nulla',
    slug: 'Generic-New-York-Mug',
    added: 1479851262315,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Meadow', 'Flowers'],
    price: 18.99,
    name: 'Sleek Flowers Mug',
    description:
      'velit ut quo autem repellat libero incidunt est animi qui sunt eum consequuntur soluta natus eveniet aspernatur est molestiae iure',
    slug: 'Sleek-Flowers-Mug',
    added: 1480159855457,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Sunset'],
    price: 12.99,
    name: 'Small Sunset Mug',
    description:
      'dolorem blanditiis quas quaerat aliquam nostrum nostrum qui sint sit ut molestias quo beatae aut dolore',
    slug: 'Small-Sunset-Mug',
    added: 1480495684444,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Ocean', 'Rocks'],
    price: 16.99,
    name: 'Incredible Ocean Mug',
    description:
      'nobis et amet maxime qui neque reprehenderit accusamus similique sed quia debitis quia odio assumenda nulla necessitatibus cum qui enim',
    slug: 'Incredible-Ocean-Mug',
    added: 1483772950486,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Sunrise', 'Meadow'],
    price: 16.99,
    name: 'Ergonomic Meadow Mug',
    description:
      'in corrupti quasi ducimus inventore aut repellat praesentium debitis qui amet itaque quasi quisquam',
    slug: 'Ergonomic-Meadow-Mug',
    added: 1486323692695,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Forest', 'Trees', 'Fog'],
    price: 20.99,
    name: 'Gorgeous Trees Mug',
    description:
      'consequatur enim alias voluptatem et et omnis sunt qui et rerum qui quae voluptates cum',
    slug: 'Gorgeous-Trees-Mug',
    added: 1480483845955,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Pool', 'Person', 'Water', 'Swimming'],
    price: 9.99,
    name: 'Handmade Pool Mug',
    description:
      'voluptate ducimus est praesentium perspiciatis et non id ipsa totam',
    slug: 'Handmade-Pool-Mug',
    added: 1480796059949,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Green beans', 'Vegetables', 'Food'],
    price: 14.99,
    name: 'Fantastic Green Beans Mug',
    description:
      'id nihil maiores doloremque expedita alias enim laudantium odio ad maiores nulla earum aut',
    slug: 'Fantastic-Green-Beans-Mug',
    added: 1481622286039,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Mountains', 'Water', 'Clouds'],
    price: 15.99,
    name: 'Handcrafted Mountains Mug',
    description:
      'autem aut atque inventore rerum est soluta maxime unde occaecati ut omnis corporis enim animi qui',
    slug: 'Handcrafted-Mountains-Mug',
    added: 1484706264952,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Station', 'People'],
    price: 16.99,
    name: 'Generic Station Mug',
    description:
      'velit aut nulla explicabo magnam quis reiciendis incidunt minima et aut provident quod nostrum',
    slug: 'Generic-Station-Mug',
    added: 1486331707159,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Buildings', 'Architecture'],
    price: 20.99,
    name: 'Refined Buildings Mug',
    description:
      'eos qui reprehenderit sed voluptatem et neque saepe commodi rem et praesentium distinctio atque dignissimos quas eos doloribus veritatis est in consequatur nostrum',
    slug: 'Refined-Buildings-Mug',
    added: 1484980018672,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['City', 'People'],
    price: 20.99,
    name: 'Incredible People Mug',
    description:
      'quas neque quia ut facilis deleniti qui minus iure velit non veritatis nemo amet nobis dolorem',
    slug: 'Incredible-People-Mug',
    added: 1480900958787,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Fog', 'Mountains'],
    price: 13.99,
    name: 'Ergonomic Mountains Mug',
    description:
      'aliquid libero laudantium aut officiis id voluptatem beatae molestiae aspernatur quisquam doloribus eum pariatur et',
    slug: 'Ergonomic-Mountains-Mug-1',
    added: 1480832695787,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Flower', 'Plants'],
    price: 19.99,
    name: 'Generic Flower Mug',
    description:
      'optio nesciunt id deserunt autem veniam est explicabo facere voluptas omnis illo necessitatibus nihil',
    slug: 'Generic-Flower-Mug',
    added: 1481216101998,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Hands', 'Phone'],
    price: 12.99,
    name: 'Ergonomic Sunset Mug',
    description:
      'aliquid officia est quis illum aspernatur quae provident ut velit quia nihil consequuntur perspiciatis provident voluptas',
    slug: 'Ergonomic-Sunset-Mug',
    added: 1480461823110,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Airplane', 'Clouds'],
    price: 15.99,
    name: 'Fantastic Sunset Mug',
    description:
      'amet vitae labore minima dolore sed maxime quisquam voluptatem deserunt sed eveniet',
    slug: 'Fantastic-Sunset-Mug-1',
    added: 1480773409066,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Deer'],
    price: 19.99,
    name: 'Incredible Deer Mug',
    description:
      'distinctio nostrum quia sit illum ipsa quidem non et totam voluptate sit quidem tempora voluptas non possimus et tenetur enim dolorem quod',
    slug: 'Incredible-Deer-Mug',
    added: 1486348034948,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Bird'],
    price: 12.99,
    name: 'Practical Bird Mug',
    description:
      'nam reiciendis explicabo ut illo sequi velit beatae doloribus maxime consequatur debitis consequatur fugiat natus est quisquam',
    slug: 'Practical-Bird-Mug',
    added: 1480950184827,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Train', 'Railroad', 'Freeway'],
    price: 9.99,
    name: 'Sleek Railroad Mug',
    description:
      'laboriosam ut et tempore unde esse consequatur architecto corporis quaerat et ad eum et possimus at dolores placeat recusandae ut laborum soluta',
    slug: 'Sleek-Railroad-Mug',
    added: 1479336170617,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['House', 'Pool'],
    price: 11.99,
    name: 'Rustic Pool Mug',
    description:
      'rerum tempora veritatis harum voluptas dignissimos minus voluptates eum labore in ipsum odio',
    slug: 'Rustic-Pool-Mug',
    added: 1479457991039,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Building'],
    price: 14.99,
    name: 'Awesome Building Mug',
    description:
      'quos dolor alias ipsum asperiores et tenetur voluptatum ipsum similique',
    slug: 'Awesome-Building-Mug',
    added: 1483951181657,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Space', 'NASA'],
    price: 16.99,
    name: 'Tasty NASA Mug',
    description:
      'et ratione illum fugiat sapiente voluptatibus sapiente velit voluptatem debitis eos rerum ea tempore culpa nihil consectetur nobis sapiente quae quo est consequatur',
    slug: 'Tasty-NASA-Mug',
    added: 1477982049815,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Mountains', 'Lake'],
    price: 18.99,
    name: 'Handcrafted Lake Mug',
    description:
      'atque fugiat aut laboriosam dolor error dignissimos neque voluptates occaecati cumque perspiciatis sint odio dicta repudiandae et fuga porro',
    slug: 'Handcrafted-Lake-Mug',
    added: 1482746549123,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Bird', 'Water'],
    price: 10.99,
    name: 'Unbranded Water Mug',
    description:
      'dolor eveniet rerum ut enim aliquid hic nostrum mollitia laboriosam eum rerum quis voluptate',
    slug: 'Unbranded-Water-Mug',
    added: 1478842329594,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Winter', 'Snow', 'Trees', 'Mountains'],
    price: 17.99,
    name: 'Small Snow Mug',
    description:
      'fugiat vero qui nobis id excepturi tempora quis dolor voluptates voluptas similique distinctio optio ad id ab vero voluptatem',
    slug: 'Small-Snow-Mug-1',
    added: 1486226600207,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Mountains', 'Rocks'],
    price: 15.99,
    name: 'Ergonomic Sky Mug',
    description:
      'similique ea beatae fuga enim velit inventore hic nulla ullam velit non consequatur consequatur illo provident',
    slug: 'Ergonomic-Sky-Mug',
    added: 1478391049659,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Statue of liberty', 'Architecture', 'Monument'],
    price: 20.99,
    name: 'Refined Statue Of Liberty Mug',
    description:
      'et odit hic blanditiis ipsa ullam quo debitis amet non facere eos maiores qui sit facilis est nihil in facere sed velit',
    slug: 'Refined-Statue-Of-Liberty-Mug',
    added: 1478775662076,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Rust', 'Car'],
    price: 16.99,
    name: 'Small Rust Mug',
    description:
      'soluta enim molestiae aut et reprehenderit illo expedita neque eligendi consequatur illo mollitia',
    slug: 'Small-Rust-Mug',
    added: 1478378071935,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Married', 'Wedding', 'Bride'],
    price: 16.99,
    name: 'Tasty Married Mug',
    description:
      'quaerat minima maxime ut quo ipsam facere recusandae numquam ipsum qui ut esse quod pariatur alias',
    slug: 'Tasty-Married-Mug',
    added: 1484606005625,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Plants', 'Cactus'],
    price: 17.99,
    name: 'Unbranded Plants Mug',
    description:
      'dignissimos nesciunt odio doloremque vel ut id consequatur eligendi dolorem blanditiis',
    slug: 'Unbranded-Plants-Mug',
    added: 1481149025847,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Dock'],
    price: 15.99,
    name: 'Unbranded Ocean Mug',
    description:
      'minima et ipsum explicabo ut veniam tenetur nesciunt velit recusandae suscipit animi facere voluptatem optio nesciunt',
    slug: 'Unbranded-Ocean-Mug-1',
    added: 1479285494231,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Mountains', 'Meadow'],
    price: 17.99,
    name: 'Generic Mountains Mug',
    description:
      'est quia expedita velit quibusdam est nam excepturi officiis quas',
    slug: 'Generic-Mountains-Mug',
    added: 1486373909869,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Northern lights', 'Snow', 'Night'],
    price: 18.99,
    name: 'Handcrafted Night Mug',
    description:
      'quo dolores quo libero dolores maiores sed sed libero ut animi voluptatem fuga accusamus cum',
    slug: 'Handcrafted-Night-Mug',
    added: 1481638622630,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Field', 'Person'],
    price: 19.99,
    name: 'Licensed Sunset Mug',
    description:
      'quidem officiis voluptas omnis accusantium consectetur assumenda at ut occaecati blanditiis possimus id',
    slug: 'Licensed-Sunset-Mug',
    added: 1485542501380,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Mountains', 'Lake'],
    price: 17.99,
    name: 'Gorgeous Mountains Mug',
    description:
      'beatae autem ex nulla nisi occaecati quis et minus commodi omnis tempore illo deleniti',
    slug: 'Gorgeous-Mountains-Mug',
    added: 1481165508725,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Clothing', 'Person'],
    price: 17.99,
    name: 'Awesome Person Mug',
    description:
      'rerum soluta voluptatem facere cum sit est et quas dolores illo quia dolores',
    slug: 'Awesome-Person-Mug',
    added: 1483748867725,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Hands', 'People'],
    price: 10.99,
    name: 'Ergonomic People Mug',
    description:
      'ratione qui id ut excepturi eaque maiores qui aperiam et quis voluptatum aut impedit ducimus provident voluptate quia',
    slug: 'Ergonomic-People-Mug',
    added: 1478150401128,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Mountains'],
    price: 19.99,
    name: 'Licensed Mountains Mug',
    description:
      'consequatur ipsam id perferendis praesentium quia quod blanditiis facere animi dolorum tempora quidem sint voluptatum exercitationem modi qui exercitationem esse sunt',
    slug: 'Licensed-Mountains-Mug',
    added: 1481327579256,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees', 'Fog'],
    price: 19.99,
    name: 'Handcrafted Snow Mug',
    description:
      'neque corporis quidem qui iste delectus sunt et ipsa vero iste dolores quibusdam non id recusandae molestiae consequatur voluptas eligendi et eius rerum eius commodi',
    slug: 'Handcrafted-Snow-Mug',
    added: 1481858837334,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Mountains', 'Forest'],
    price: 11.99,
    name: 'Small Forest Mug',
    description:
      'voluptates dicta vel praesentium fuga dolores ratione rerum maiores sapiente tempora dolor et asperiores porro harum ratione quia exercitationem aut quas aut',
    slug: 'Small-Forest-Mug-1',
    added: 1485564219662,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Plant', 'Flower', 'Macro'],
    price: 12.99,
    name: 'Ergonomic Macro Mug',
    description:
      'rerum fuga magnam alias eveniet non velit nesciunt vitae placeat dolores delectus itaque modi ipsa magnam cum',
    slug: 'Ergonomic-Macro-Mug',
    added: 1479284365513,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Woman', 'Desert'],
    price: 10.99,
    name: 'Gorgeous Woman Mug',
    description:
      'doloremque architecto ducimus sit nemo voluptatem dolor vel ratione sed quis nostrum et voluptatem quisquam nihil labore recusandae quas nisi rem sit',
    slug: 'Gorgeous-Woman-Mug',
    added: 1479995150673,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Sunset', 'Forrest'],
    price: 13.99,
    name: 'Fantastic Sunset Mug',
    description:
      'totam quis deserunt dicta recusandae fugiat sapiente voluptatem est quidem ut in nulla sunt officiis',
    slug: 'Fantastic-Sunset-Mug-2',
    added: 1479729984509,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Jelly fish', 'Ocean'],
    price: 16.99,
    name: 'Intelligent Ocean Mug',
    description:
      'quis consectetur tenetur et non illo aut consequatur rerum maiores quasi iusto qui occaecati amet rerum culpa vel earum quasi dolor accusamus',
    slug: 'Intelligent-Ocean-Mug',
    added: 1478863438581,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Flora', 'Flowers'],
    price: 20.99,
    name: 'Sleek Flora Mug',
    description:
      'iure sint porro dolores enim ipsam aliquam quam expedita harum culpa totam et tempora et quae vitae rerum dolorum quo quo tempore',
    slug: 'Sleek-Flora-Mug',
    added: 1485284701863,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings'],
    price: 19.99,
    name: 'Incredible City Mug',
    description:
      'accusantium sequi sed consequatur id optio vitae aut ullam voluptatum temporibus cupiditate alias numquam explicabo sit doloribus ut consequatur ab illum et maxime et',
    slug: 'Incredible-City-Mug',
    added: 1481816798407,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Ocean', 'Rocks'],
    price: 15.99,
    name: 'Generic Sunset Mug',
    description:
      'quis explicabo fuga minus et voluptate ut dolorum facilis cupiditate aperiam earum unde',
    slug: 'Generic-Sunset-Mug',
    added: 1482906865826,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Plants'],
    price: 14.99,
    name: 'Refined Plants Mug',
    description:
      'porro provident pariatur autem non deserunt quia consequatur voluptatibus ut quia et',
    slug: 'Refined-Plants-Mug',
    added: 1480240119832,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Mountains'],
    price: 19.99,
    name: 'Tasty Mountains Mug',
    description:
      'qui voluptatem harum enim veniam quod corporis id quisquam doloribus repellat odit ipsum veritatis aut blanditiis rerum fugiat et ea soluta laborum in',
    slug: 'Tasty-Mountains-Mug',
    added: 1484440696507,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Stairs'],
    price: 15.99,
    name: 'Fantastic Stairs Mug',
    description:
      'eum excepturi sed explicabo necessitatibus sequi ab odio minus ratione harum ut praesentium tempore recusandae',
    slug: 'Fantastic-Stairs-Mug',
    added: 1485497521000,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Stars', 'Space'],
    price: 20.99,
    name: 'Handcrafted Stars Mug',
    description:
      'et sit consequatur unde ut sunt autem neque necessitatibus et id aut id occaecati est a esse doloribus debitis consequuntur excepturi enim velit tenetur',
    slug: 'Handcrafted-Stars-Mug',
    added: 1480352701799,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Sunrise', 'Forest'],
    price: 14.99,
    name: 'Tasty Forest Mug',
    description:
      'numquam distinctio fugiat nam est possimus velit est quam dolores quibusdam esse autem qui temporibus mollitia architecto nisi vel est et veniam et',
    slug: 'Tasty-Forest-Mug',
    added: 1484457328729,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Nature', 'Mountains'],
    price: 18.99,
    name: 'Sleek Nature Mug',
    description:
      'id eius nostrum accusamus optio itaque ut quisquam delectus ut voluptatem accusamus aperiam',
    slug: 'Sleek-Nature-Mug',
    added: 1484400074637,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Abstract', 'Fabric', 'Antler'],
    price: 16.99,
    name: 'Rustic Antler Mug',
    description:
      'aut temporibus dolorem rem alias optio nobis aut hic quasi rerum dolore sunt debitis',
    slug: 'Rustic-Antler-Mug',
    added: 1479711870807,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Snow'],
    price: 20.99,
    name: 'Gorgeous Mountain Mug',
    description:
      'quod quia sed autem molestias et sapiente nobis quidem cumque laborum sint corporis ratione',
    slug: 'Gorgeous-Mountain-Mug',
    added: 1486085708997,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Building'],
    price: 18.99,
    name: 'Practical City Mug',
    description:
      'voluptas dicta sit in tempore enim voluptas asperiores autem temporibus voluptas est porro omnis dicta ad est et cupiditate harum optio',
    slug: 'Practical-City-Mug',
    added: 1482084912716,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Mountains'],
    price: 10.99,
    name: 'Handcrafted Mountains Mug',
    description:
      'in est dolorem qui qui velit fuga hic veniam recusandae delectus ullam nesciunt voluptates distinctio recusandae',
    slug: 'Handcrafted-Mountains-Mug-1',
    added: 1478045056307,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Clouds'],
    price: 16.99,
    name: 'Generic Clouds Mug',
    description:
      'nihil commodi delectus vitae eius distinctio velit et laudantium eos consectetur commodi nisi eveniet',
    slug: 'Generic-Clouds-Mug',
    added: 1484674383506,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Trees', 'Mist', 'Fog'],
    price: 13.99,
    name: 'Refined Fog Mug',
    description:
      'qui dolores voluptatem autem atque magnam qui vel ut quo harum labore exercitationem dolorem dolore numquam ut aut voluptas',
    slug: 'Refined-Fog-Mug-1',
    added: 1479175470623,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Dog', 'Animal'],
    price: 17.99,
    name: 'Awesome Dog Mug',
    description:
      'at doloremque natus similique quo labore quisquam laudantium placeat quasi vero cumque sit dolores quis eos dolor sint neque dolores voluptatem qui et sed vero',
    slug: 'Awesome-Dog-Mug',
    added: 1485798679848,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Road', 'Trail'],
    price: 16.99,
    name: 'Awesome Trail Mug',
    description:
      'officia deserunt necessitatibus dignissimos aliquam perferendis quis sunt dicta quod rem recusandae aut eaque nulla maiores quisquam et excepturi voluptate consequatur deserunt impedit adipisci ducimus',
    slug: 'Awesome-Trail-Mug',
    added: 1481528688362,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Cup', 'Bed'],
    price: 14.99,
    name: 'Rustic Bed Mug',
    description:
      'minima distinctio non illo vel necessitatibus totam esse est fugiat tempora quia qui et sit assumenda et ipsum consequatur',
    slug: 'Rustic-Bed-Mug',
    added: 1479497530344,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Dock', 'People'],
    price: 11.99,
    name: 'Fantastic Dock Mug',
    description:
      'blanditiis voluptatem aliquam fugit aut voluptates ducimus molestias sit sapiente omnis',
    slug: 'Fantastic-Dock-Mug',
    added: 1485872556438,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Road'],
    price: 11.99,
    name: 'Handcrafted Road Mug',
    description:
      'reprehenderit velit odit corrupti alias dolore esse qui et reiciendis',
    slug: 'Handcrafted-Road-Mug',
    added: 1482458946864,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 11.99,
    name: 'Unbranded Trees Mug',
    description:
      'culpa dignissimos sit iste sed et quis vitae facere sunt aliquid voluptatem voluptatem est eos aperiam adipisci modi ut vitae explicabo veniam',
    slug: 'Unbranded-Trees-Mug',
    added: 1478546119290,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Farms'],
    price: 14.99,
    name: 'Handcrafted Arial Mug',
    description:
      'excepturi qui est officia consequatur sunt eos dolore est occaecati officiis corporis hic sapiente reprehenderit eaque consequatur qui doloribus omnis quo provident aperiam officia',
    slug: 'Handcrafted-Arial-Mug',
    added: 1484342948965,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Cliff', 'Lighthouse', 'Ocean'],
    price: 19.99,
    name: 'Tasty Ocean Mug',
    description:
      'debitis et ut non repudiandae voluptas reiciendis labore natus non ut cumque et dolores temporibus blanditiis natus et quis veniam quo',
    slug: 'Tasty-Ocean-Mug',
    added: 1483976159464,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'Night'],
    price: 10.99,
    name: 'Handcrafted Night Mug',
    description:
      'dolorum cumque vel at vel nam id enim repellat consequatur aut et fuga',
    slug: 'Handcrafted-Night-Mug-1',
    added: 1485447347041,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'City', 'Building'],
    price: 19.99,
    name: 'Handcrafted City Mug',
    description:
      'veritatis asperiores et aut voluptatibus eveniet maxime voluptatem ea dolores laborum aut qui ut ullam quaerat repellat',
    slug: 'Handcrafted-City-Mug-1',
    added: 1482085554027,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Grass', 'Ocean'],
    price: 11.99,
    name: 'Handmade Beach Mug',
    description:
      'et enim est esse fugiat et totam vero dolores rem debitis qui commodi et doloremque vel quaerat sequi atque',
    slug: 'Handmade-Beach-Mug',
    added: 1478462923749,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Plant', 'Table', 'Blue'],
    price: 13.99,
    name: 'Ergonomic Table Mug',
    description:
      'amet asperiores minus inventore voluptas harum laudantium qui ullam eligendi ab fuga neque asperiores vel vel impedit quaerat aliquid nulla quod',
    slug: 'Ergonomic-Table-Mug',
    added: 1481381323448,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Valley', 'Fog', 'Mountains'],
    price: 20.99,
    name: 'Ergonomic Mountains Mug',
    description:
      'aliquam blanditiis illum illum voluptate ut nemo ullam praesentium voluptatum et fugit maiores doloremque quidem assumenda',
    slug: 'Ergonomic-Mountains-Mug-2',
    added: 1482849901113,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Mountains'],
    price: 17.99,
    name: 'Handcrafted Mountains Mug',
    description:
      'reprehenderit aliquid ipsum et aliquid ut vero et porro a odio quidem nam ipsum et dignissimos vel quo ipsam et consequatur nisi eaque explicabo',
    slug: 'Handcrafted-Mountains-Mug-2',
    added: 1485323880423,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Lights', 'City', 'Buildings', 'River'],
    price: 20.99,
    name: 'Ergonomic Lights Mug',
    description:
      'nemo et praesentium hic sit perspiciatis autem fuga laborum ratione saepe autem voluptatem aut enim nihil est',
    slug: 'Ergonomic-Lights-Mug',
    added: 1478304535080,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Classic', 'Car'],
    price: 18.99,
    name: 'Licensed Classic Mug',
    description:
      'commodi quo exercitationem sed at assumenda dignissimos autem et odit animi architecto necessitatibus incidunt quo',
    slug: 'Licensed-Classic-Mug',
    added: 1478092303399,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Ocean', 'Rocks'],
    price: 9.99,
    name: 'Refined Fog Mug',
    description:
      'pariatur animi velit sed nam qui voluptatum pariatur qui assumenda eos',
    slug: 'Refined-Fog-Mug-2',
    added: 1481446006073,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Meadow', 'Plants'],
    price: 10.99,
    name: 'Sleek Meadow Mug',
    description:
      'itaque rerum facere consequuntur rem architecto doloremque quasi quam consequuntur aut dolore sint sit ut',
    slug: 'Sleek-Meadow-Mug',
    added: 1478390293078,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 17.99,
    name: 'Handcrafted Beach Mug',
    description:
      'aut rerum consequatur vitae quidem rerum earum est magni officiis consectetur qui doloremque qui placeat dolore inventore voluptas enim ex ratione',
    slug: 'Handcrafted-Beach-Mug',
    added: 1481477670309,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'City', 'Buildings', 'People'],
    price: 17.99,
    name: 'Incredible People Mug',
    description:
      'facere sint ut aut est non et libero omnis nam nisi nihil libero voluptatem in rem et dolorem sunt quisquam saepe repellendus',
    slug: 'Incredible-People-Mug-1',
    added: 1482128950315,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Chairs', 'Office', 'Table'],
    price: 12.99,
    name: 'Generic Chairs Mug',
    description:
      'labore deleniti sapiente perspiciatis ut assumenda neque ad officiis est suscipit quaerat voluptas magnam delectus reprehenderit nisi nam voluptatibus aperiam',
    slug: 'Generic-Chairs-Mug',
    added: 1481605584401,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Alaska'],
    price: 19.99,
    name: 'Fantastic Snow Mug',
    description:
      'dolorem voluptatem voluptatem aut et eveniet voluptatem aperiam id in laboriosam voluptatem eveniet a aliquid voluptatem officia earum necessitatibus qui eligendi aut consequuntur error',
    slug: 'Fantastic-Snow-Mug-1',
    added: 1482141745116,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Nature', 'Ocean'],
    price: 18.99,
    name: 'Small Beach Mug',
    description:
      'qui inventore error ad eveniet quisquam non non nesciunt exercitationem dolore sit voluptate nihil',
    slug: 'Small-Beach-Mug',
    added: 1482836883025,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Brick'],
    price: 18.99,
    name: 'Handcrafted Brick Mug',
    description:
      'et doloremque quia voluptas reiciendis rerum quasi ullam odit ex velit a in modi quisquam sed repellendus enim veritatis beatae commodi ut',
    slug: 'Handcrafted-Brick-Mug',
    added: 1483834372267,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Coffee'],
    price: 20.99,
    name: 'Generic Coffee Mug',
    description:
      'ipsum consectetur ad optio sunt sit laborum sed aut labore consequatur sed quia et vitae',
    slug: 'Generic-Coffee-Mug',
    added: 1480003544501,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Glass', 'Architecture', 'Ceiling'],
    price: 9.99,
    name: 'Handcrafted Ceiling Mug',
    description:
      'eius qui tempora assumenda ut id qui voluptas aspernatur et voluptatem veniam',
    slug: 'Handcrafted-Ceiling-Mug',
    added: 1482594298038,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Snow', 'Person', 'Valley'],
    price: 12.99,
    name: 'Unbranded Valley Mug',
    description:
      'laborum nihil non ut dolorum fugiat atque aperiam sit a quis eaque dolores nihil ipsa ex excepturi et omnis et dolor et',
    slug: 'Unbranded-Valley-Mug',
    added: 1480481367339,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Trees'],
    price: 10.99,
    name: 'Handmade Trees Mug',
    description:
      'aliquid voluptatem et enim voluptas non mollitia provident non quam repellat occaecati eaque doloribus et magnam sit aperiam ut',
    slug: 'Handmade-Trees-Mug',
    added: 1480253563698,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings', 'People'],
    price: 20.99,
    name: 'Small Buildings Mug',
    description:
      'tempora eligendi nihil quasi velit dolorem et deleniti alias et quae reiciendis dolorem qui ex earum et autem',
    slug: 'Small-Buildings-Mug',
    added: 1483926923432,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees', 'Fog'],
    price: 13.99,
    name: 'Handmade Snow Mug',
    description:
      'non sed excepturi culpa aut sit dolor qui reiciendis perspiciatis',
    slug: 'Handmade-Snow-Mug',
    added: 1479547198582,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Statue of libery', 'Monument'],
    price: 11.99,
    name: 'Ergonomic Monument Mug',
    description:
      'vero dolor sed culpa molestias repellat quo provident expedita totam eos est quis laudantium expedita nobis quis',
    slug: 'Ergonomic-Monument-Mug',
    added: 1477791443936,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Mountains'],
    price: 13.99,
    name: 'Sleek Mountains Mug',
    description:
      'consectetur at quis et quam vel cumque blanditiis quis rerum sit rerum corrupti voluptas qui itaque reprehenderit voluptatem nostrum voluptatem at',
    slug: 'Sleek-Mountains-Mug',
    added: 1484020598984,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Island', 'Ocean'],
    price: 13.99,
    name: 'Fantastic Sky Mug',
    description:
      'repudiandae magni qui esse labore magni maiores unde ullam itaque maxime aut',
    slug: 'Fantastic-Sky-Mug',
    added: 1479690799477,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Flora', 'Nature', 'Plants'],
    price: 10.99,
    name: 'Unbranded Flora Mug',
    description:
      'sit tenetur praesentium nam nostrum cum tempora maiores amet eveniet ex aliquid nobis repudiandae maxime illum voluptatum quo vero quia quidem laboriosam unde',
    slug: 'Unbranded-Flora-Mug',
    added: 1477924794064,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Bear'],
    price: 20.99,
    name: 'Small Animal Mug',
    description:
      'reiciendis quaerat possimus cumque praesentium laboriosam animi natus molestiae quo aut qui eligendi quaerat quo qui et sed ducimus est inventore ut',
    slug: 'Small-Animal-Mug',
    added: 1481345945274,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'City'],
    price: 20.99,
    name: 'Refined City Mug',
    description:
      'commodi sequi quia tempore consequatur tempora ut fugit reprehenderit reiciendis quia ullam qui',
    slug: 'Refined-City-Mug',
    added: 1479218510845,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Mountains', 'Water'],
    price: 10.99,
    name: 'Tasty Nature Mug',
    description:
      'sint odio optio illum eos et est dolores perspiciatis velit sapiente ut reprehenderit quia ullam quas eaque dolores quo enim hic reprehenderit',
    slug: 'Tasty-Nature-Mug',
    added: 1479289801144,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Baby', 'People'],
    price: 12.99,
    name: 'Refined Baby Mug',
    description:
      'enim perferendis placeat aut dicta et explicabo eligendi laudantium earum non quia error nostrum libero quas cupiditate voluptatem velit',
    slug: 'Refined-Baby-Mug',
    added: 1478389242389,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Mountains'],
    price: 16.99,
    name: 'Rustic Mountains Mug',
    description:
      'doloribus distinctio aut culpa quas ut exercitationem aut dignissimos voluptas sit soluta magnam',
    slug: 'Rustic-Mountains-Mug',
    added: 1484309081958,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings', 'Architecture'],
    price: 11.99,
    name: 'Practical Architecture Mug',
    description:
      'dolorem corrupti vel quis eveniet et unde non quos adipisci id voluptate',
    slug: 'Practical-Architecture-Mug',
    added: 1483509310377,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 14.99,
    name: 'Licensed Snow Mug',
    description:
      'magni libero ut et dolore qui aut eveniet a ut provident ut qui omnis cupiditate esse',
    slug: 'Licensed-Snow-Mug',
    added: 1481961192552,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Rain'],
    price: 11.99,
    name: 'Practical Rain Mug',
    description:
      'adipisci quia in odit repellat cupiditate aut unde facilis dolorem accusantium laborum sit optio laboriosam facere',
    slug: 'Practical-Rain-Mug',
    added: 1481339229554,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Boats', 'Food', 'People'],
    price: 16.99,
    name: 'Generic People Mug',
    description:
      'repudiandae cumque voluptatibus eum laudantium reprehenderit magni quidem dolorum culpa nobis',
    slug: 'Generic-People-Mug',
    added: 1479452566888,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office', 'Laptop'],
    price: 11.99,
    name: 'Handmade Desk Mug',
    description: 'accusantium qui rerum qui vel qui ut vitae veniam rerum',
    slug: 'Handmade-Desk-Mug',
    added: 1481187869255,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Meadow', 'Wood'],
    price: 14.99,
    name: 'Handmade Wood Mug',
    description:
      'amet fuga eius mollitia natus quos velit aliquam quia laboriosam',
    slug: 'Handmade-Wood-Mug',
    added: 1479056384776,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Lake', 'Water'],
    price: 9.99,
    name: 'Practical Lake Mug',
    description:
      'dolore magni deserunt cumque non qui qui consequatur quia et totam temporibus sunt et at quia beatae doloribus placeat est libero',
    slug: 'Practical-Lake-Mug',
    added: 1478555201749,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Beach', 'Fish'],
    price: 14.99,
    name: 'Incredible Person Mug',
    description:
      'quo delectus quisquam fuga occaecati assumenda libero ipsam tempora totam minus id maxime similique debitis dicta non ea ad sed',
    slug: 'Incredible-Person-Mug',
    added: 1481925087760,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog'],
    price: 13.99,
    name: 'Practical Trees Mug',
    description:
      'sint animi aut itaque ut voluptatibus inventore quia magni sint est facere excepturi corporis sit sed autem assumenda unde blanditiis id illo ea vero',
    slug: 'Practical-Trees-Mug',
    added: 1480093302586,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Pier', 'Dock'],
    price: 18.99,
    name: 'Awesome Pier Mug',
    description:
      'quis incidunt facilis optio laborum laboriosam et eius dolorem commodi nihil amet',
    slug: 'Awesome-Pier-Mug',
    added: 1479460729094,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Space', 'NASA'],
    price: 14.99,
    name: 'Generic NASA Mug',
    description:
      'culpa id culpa rerum nostrum odio nemo id tempora aut quo sed veritatis eveniet eligendi',
    slug: 'Generic-NASA-Mug',
    added: 1484460017387,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'People'],
    price: 16.99,
    name: 'Incredible Ocean Mug',
    description:
      'qui aut id dolor fugiat blanditiis qui occaecati unde rerum inventore corporis error nulla ut provident dolores animi',
    slug: 'Incredible-Ocean-Mug-1',
    added: 1485422143095,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Nature', 'Ocean'],
    price: 11.99,
    name: 'Awesome Ocean Mug',
    description:
      'iure et dicta nisi accusantium qui sed veritatis quia molestiae doloribus accusantium sed nostrum aliquam cumque quia porro non earum dolorum sequi quia assumenda libero',
    slug: 'Awesome-Ocean-Mug-1',
    added: 1481692545855,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Pool', 'Night', 'Ocean', 'Water'],
    price: 9.99,
    name: 'Refined Water Mug',
    description:
      'ipsam ducimus velit tempore vitae enim voluptatem rem doloribus laboriosam quo quaerat',
    slug: 'Refined-Water-Mug',
    added: 1485665692193,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Car', 'People'],
    price: 9.99,
    name: 'Tasty People Mug',
    description:
      'dignissimos ut quae molestiae saepe nihil quod et odio corporis unde veritatis nemo molestiae quibusdam laudantium quia eos perferendis',
    slug: 'Tasty-People-Mug',
    added: 1485730518938,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Bus', 'Transit', 'People'],
    price: 14.99,
    name: 'Tasty People Mug',
    description:
      'cum et officia corrupti sequi perspiciatis maiores quo fugit nam pariatur sunt assumenda doloribus qui consequatur modi nemo voluptates magnam nisi',
    slug: 'Tasty-People-Mug-1',
    added: 1485682317357,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Ocean'],
    price: 18.99,
    name: 'Handcrafted Arial Mug',
    description:
      'dolorem consequuntur quisquam sequi quia vitae impedit quaerat similique sequi porro impedit nihil vitae vel natus non',
    slug: 'Handcrafted-Arial-Mug-1',
    added: 1478645259222,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Beach'],
    price: 16.99,
    name: 'Tasty Trees Mug',
    description:
      'est aliquid et autem quasi reiciendis sint illo aut accusantium dolorem et corrupti corrupti aperiam qui consequatur cumque dolore commodi ipsam molestiae neque',
    slug: 'Tasty-Trees-Mug',
    added: 1486011799472,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Ocean'],
    price: 11.99,
    name: 'Awesome Ocean Mug',
    description:
      'aut ea alias corrupti maxime minima officia beatae veritatis quis commodi iste adipisci voluptatem neque aut consectetur deleniti',
    slug: 'Awesome-Ocean-Mug-2',
    added: 1485271625546,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Utah', 'Sand', 'Desert'],
    price: 14.99,
    name: 'Practical Desert Mug',
    description:
      'enim deserunt ut esse aut molestiae quibusdam incidunt aut voluptates voluptatem corporis vel ut quo exercitationem consequatur sunt voluptatem qui quibusdam consequatur',
    slug: 'Practical-Desert-Mug',
    added: 1478922745405,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Bicycle'],
    price: 12.99,
    name: 'Licensed Bicycle Mug',
    description:
      'a ratione aut sed similique excepturi blanditiis provident ullam quaerat occaecati nulla ad rerum quo aperiam est doloribus reprehenderit accusamus',
    slug: 'Licensed-Bicycle-Mug',
    added: 1485296103943,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Hands', 'Tea'],
    price: 20.99,
    name: 'Handcrafted Tea Mug',
    description:
      'repellat beatae adipisci aperiam quae esse alias voluptates quibusdam rerum quis optio aliquid esse est rerum est eos ea corporis',
    slug: 'Handcrafted-Tea-Mug',
    added: 1483118678875,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 14.99,
    name: 'Gorgeous Ocean Mug',
    description:
      'neque vel cum laborum repudiandae aspernatur similique laudantium beatae reiciendis quo reprehenderit qui',
    slug: 'Gorgeous-Ocean-Mug',
    added: 1482088867150,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Lake', 'Fog'],
    price: 16.99,
    name: 'Small Lake Mug',
    description:
      'et assumenda blanditiis unde labore voluptas tenetur quod molestias et veritatis totam id consequuntur aliquam nostrum ea dolores amet sit quia ex quidem',
    slug: 'Small-Lake-Mug',
    added: 1482167477583,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 15.99,
    name: 'Licensed Forest Mug',
    description:
      'soluta consequatur ut error odit dolorem dolor eos hic libero qui et est itaque quam laudantium quo molestiae enim perferendis',
    slug: 'Licensed-Forest-Mug-1',
    added: 1484153283817,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Forest'],
    price: 14.99,
    name: 'Intelligent Fog Mug',
    description:
      'ut vero dicta accusamus velit beatae modi dolores qui et voluptate perspiciatis voluptas cum facere omnis eum perspiciatis eius ab voluptates',
    slug: 'Intelligent-Fog-Mug',
    added: 1485126515562,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 12.99,
    name: 'Handcrafted Ocean Mug',
    description:
      'dicta eum voluptates quisquam hic qui ad enim nihil nihil quia iure odit aut a',
    slug: 'Handcrafted-Ocean-Mug-1',
    added: 1478245713884,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Grass', 'Flowers', 'Plants'],
    price: 16.99,
    name: 'Intelligent Plants Mug',
    description:
      'ea quis distinctio ea ratione esse et maxime consectetur eos neque error sint aspernatur facere ut necessitatibus nemo impedit rerum non velit',
    slug: 'Intelligent-Plants-Mug',
    added: 1478136697430,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings'],
    price: 15.99,
    name: 'Rustic City Mug',
    description:
      'reiciendis omnis ea quasi ab cum et enim dolorem quas facere corrupti',
    slug: 'Rustic-City-Mug',
    added: 1478707106926,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Waterfall', 'Fog', 'Mountains'],
    price: 13.99,
    name: 'Fantastic Fog Mug',
    description:
      'fuga ut consequatur inventore aut voluptatibus quia commodi velit nemo officiis',
    slug: 'Fantastic-Fog-Mug',
    added: 1479486897949,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Machine', 'Antique', 'Camera'],
    price: 15.99,
    name: 'Gorgeous Camera Mug',
    description:
      'numquam esse excepturi odit excepturi et maxime quia quia illum aperiam iure a ea et ut aperiam',
    slug: 'Gorgeous-Camera-Mug',
    added: 1481497914429,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Guitar'],
    price: 19.99,
    name: 'Small Person Mug',
    description:
      'nostrum error quod libero pariatur minus enim suscipit molestiae aliquid praesentium repudiandae repellendus voluptatum illum qui et sapiente voluptas',
    slug: 'Small-Person-Mug',
    added: 1481640245194,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings', 'Architecture'],
    price: 17.99,
    name: 'Rustic City Mug',
    description:
      'odit eaque aut possimus corrupti nobis voluptatibus veritatis reprehenderit natus debitis',
    slug: 'Rustic-City-Mug-1',
    added: 1480874919186,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Night'],
    price: 16.99,
    name: 'Tasty Night Mug',
    description:
      'placeat culpa sint autem repudiandae reiciendis rerum voluptatem pariatur sapiente nostrum aliquid adipisci eos expedita numquam et autem incidunt illum qui qui hic',
    slug: 'Tasty-Night-Mug',
    added: 1484566557077,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Trees', 'Nature', 'Mountains'],
    price: 15.99,
    name: 'Small River Mug',
    description:
      'reprehenderit neque voluptatem omnis eveniet reiciendis perspiciatis repellendus officia quod quis amet sed sint molestiae',
    slug: 'Small-River-Mug',
    added: 1484956304092,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Mountains', 'Sun'],
    price: 11.99,
    name: 'Tasty Mountains Mug',
    description:
      'quos soluta velit enim magni nesciunt iure atque ipsam corrupti recusandae voluptates minus eos odit ratione dignissimos nesciunt excepturi maxime velit necessitatibus',
    slug: 'Tasty-Mountains-Mug-1',
    added: 1480018352736,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Shoes', 'Person', 'Water'],
    price: 9.99,
    name: 'Handmade Shoes Mug',
    description:
      'sed qui repellat sed molestiae ut sunt numquam temporibus atque et consequatur aut ut maxime aperiam est nam debitis exercitationem quia',
    slug: 'Handmade-Shoes-Mug',
    added: 1479283992110,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Hot air balloons', 'Plateau'],
    price: 10.99,
    name: 'Small Sunset Mug',
    description:
      'possimus magnam nulla ipsa earum ut ut itaque et soluta quod velit maiores voluptates et nesciunt ad voluptatem sunt similique assumenda',
    slug: 'Small-Sunset-Mug-1',
    added: 1483568635179,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Forrest', 'Sunrise', 'Flowers'],
    price: 15.99,
    name: 'Licensed Sunrise Mug',
    description:
      'nesciunt ipsum nam et quae rerum praesentium provident velit quibusdam autem praesentium nisi saepe autem magni pariatur eaque et aspernatur aut voluptas debitis',
    slug: 'Licensed-Sunrise-Mug',
    added: 1485820590092,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Mountains', 'Desert'],
    price: 15.99,
    name: 'Unbranded Desert Mug',
    description:
      'facere quisquam tenetur molestiae eligendi animi dolores necessitatibus assumenda repellat molestiae',
    slug: 'Unbranded-Desert-Mug',
    added: 1485461388291,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Night'],
    price: 13.99,
    name: 'Incredible Night Mug',
    description:
      'hic quis autem repellat animi animi odit impedit nesciunt at incidunt eos',
    slug: 'Incredible-Night-Mug',
    added: 1484337339319,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Birds', 'Ocean'],
    price: 11.99,
    name: 'Small Birds Mug',
    description:
      'eveniet omnis molestiae et ad quam aperiam et repellat vitae itaque sint in iusto reprehenderit recusandae aut illo nihil explicabo error omnis architecto',
    slug: 'Small-Birds-Mug',
    added: 1480919358578,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Tent', 'Mountains'],
    price: 12.99,
    name: 'Licensed Mountains Mug',
    description:
      'a illum dolorem quaerat exercitationem minima nobis dolorem voluptatem facilis ut ut aspernatur',
    slug: 'Licensed-Mountains-Mug-1',
    added: 1480670885868,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Bridge', 'Ocean'],
    price: 15.99,
    name: 'Ergonomic Ocean Mug',
    description:
      'quos quisquam necessitatibus impedit dolorem consequuntur laudantium aut ex aut et mollitia rerum modi amet ullam molestias beatae aut maiores id ex voluptatum omnis',
    slug: 'Ergonomic-Ocean-Mug',
    added: 1479303579903,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Trail', 'Meadow'],
    price: 18.99,
    name: 'Practical Meadow Mug',
    description:
      'alias nostrum itaque harum doloribus vero repellendus blanditiis esse alias cumque',
    slug: 'Practical-Meadow-Mug',
    added: 1481398937121,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'Fog'],
    price: 14.99,
    name: 'Awesome Fog Mug',
    description:
      'mollitia non error nobis libero odio nesciunt eum rerum et consequatur ut ducimus architecto error aut illo est officia impedit',
    slug: 'Awesome-Fog-Mug-1',
    added: 1478802357598,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains', 'People'],
    price: 14.99,
    name: 'Generic Snow Mug',
    description:
      'temporibus eligendi exercitationem qui eos porro harum minus pariatur corrupti suscipit quaerat',
    slug: 'Generic-Snow-Mug',
    added: 1485052368420,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Bird'],
    price: 20.99,
    name: 'Handcrafted Animal Mug',
    description:
      'doloribus ipsum aliquid est et id neque iure eligendi nihil dolor illum nisi omnis optio minus porro corporis animi reprehenderit cum numquam et hic',
    slug: 'Handcrafted-Animal-Mug',
    added: 1478613556335,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Nature'],
    price: 13.99,
    name: 'Unbranded Nature Mug',
    description:
      'est sit et enim maiores dolorem alias error est omnis et placeat ratione voluptatem qui non',
    slug: 'Unbranded-Nature-Mug',
    added: 1482490598175,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Photos', 'Vintage'],
    price: 20.99,
    name: 'Unbranded Vintage Mug',
    description:
      'molestiae sed aut ipsa excepturi nostrum dolorum earum voluptas et tempore quod et modi',
    slug: 'Unbranded-Vintage-Mug',
    added: 1485814768555,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Peru', 'Fog', 'Mountains', 'Ruins'],
    price: 13.99,
    name: 'Ergonomic Ruins Mug',
    description:
      'laudantium assumenda dolores nesciunt accusantium qui facere non dolor veniam nihil ab libero deserunt',
    slug: 'Ergonomic-Ruins-Mug',
    added: 1483596240775,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office'],
    price: 14.99,
    name: 'Sleek Desk Mug',
    description:
      'consequuntur doloremque aspernatur nihil nisi enim quam totam vero voluptate impedit est',
    slug: 'Sleek-Desk-Mug',
    added: 1479000515222,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Mountains'],
    price: 10.99,
    name: 'Rustic Fog Mug',
    description:
      'et officia expedita quis totam eos consequatur a tempore nesciunt voluptates maiores culpa eveniet saepe',
    slug: 'Rustic-Fog-Mug',
    added: 1486362733127,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Blindfold', 'Person', 'Fabric'],
    price: 17.99,
    name: 'Awesome Fabric Mug',
    description:
      'ab et eum earum fugit sequi et ipsum est velit veritatis voluptatem repudiandae quis',
    slug: 'Awesome-Fabric-Mug',
    added: 1483466733189,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'People'],
    price: 12.99,
    name: 'Small Snow Mug',
    description:
      'saepe eligendi quia vel aut quidem alias ad aliquid quia est tenetur qui sit porro quis ut in',
    slug: 'Small-Snow-Mug-2',
    added: 1484099610625,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest', 'Woman'],
    price: 18.99,
    name: 'Handcrafted Woman Mug',
    description:
      'et molestias facilis commodi officia non eveniet neque et aut adipisci labore et enim explicabo vitae molestias et sequi illum ad sunt sint',
    slug: 'Handcrafted-Woman-Mug',
    added: 1480086717966,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 19.99,
    name: 'Generic Snow Mug',
    description:
      'tenetur ut dolorem repellat natus tempore voluptatem earum at neque cumque et in non quis rerum eius sunt',
    slug: 'Generic-Snow-Mug-1',
    added: 1478280064353,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Forest'],
    price: 9.99,
    name: 'Intelligent Fog Mug',
    description:
      'natus tempora autem aliquam est quis provident et quia illum a maxime fugiat error numquam ea qui eaque',
    slug: 'Intelligent-Fog-Mug-1',
    added: 1478395699885,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Moutains'],
    price: 20.99,
    name: 'Fantastic Moutains Mug',
    description:
      'in et eos quidem porro atque quia unde eius aut molestiae perspiciatis blanditiis velit sit fuga accusantium',
    slug: 'Fantastic-Moutains-Mug',
    added: 1478166997836,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Tea'],
    price: 17.99,
    name: 'Handcrafted Tea Mug',
    description:
      'autem error nisi vel explicabo voluptatem ut molestiae laudantium et autem',
    slug: 'Handcrafted-Tea-Mug-1',
    added: 1485612874772,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Machine', 'Antique'],
    price: 18.99,
    name: 'Rustic Machine Mug',
    description:
      'soluta illum voluptatem asperiores eveniet est at nihil deleniti dolor et quia omnis quo ducimus',
    slug: 'Rustic-Machine-Mug',
    added: 1480282789490,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 14.99,
    name: 'Ergonomic Rocks Mug',
    description:
      'ut dolorem ea repellat dolores excepturi aut ut quibusdam autem cupiditate voluptatem aliquam aspernatur sunt tempore',
    slug: 'Ergonomic-Rocks-Mug',
    added: 1486001182520,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Mountains', 'Lake', 'Clouds'],
    price: 18.99,
    name: 'Handcrafted Lake Mug',
    description:
      'velit voluptas quod facere magnam ad enim qui soluta et quasi repudiandae dicta libero',
    slug: 'Handcrafted-Lake-Mug-1',
    added: 1483701635391,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 12.99,
    name: 'Licensed City Mug',
    description:
      'excepturi sed consequatur nam qui eum cupiditate quod eos ducimus neque et tenetur aut aut modi consequatur omnis et distinctio quaerat',
    slug: 'Licensed-City-Mug',
    added: 1478903982513,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Breakfast', 'Strawberry', 'Food'],
    price: 18.99,
    name: 'Handmade Breakfast Mug',
    description:
      'libero debitis accusamus quidem optio est voluptatibus magnam dignissimos sed autem modi sed tenetur',
    slug: 'Handmade-Breakfast-Mug',
    added: 1486336424972,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Beach', 'Surf', 'Ocean'],
    price: 17.99,
    name: 'Handcrafted Surf Mug',
    description:
      'quibusdam et accusamus numquam vitae enim repellat illum molestiae in ad in delectus aut eos in suscipit',
    slug: 'Handcrafted-Surf-Mug',
    added: 1481061825610,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Pier'],
    price: 17.99,
    name: 'Rustic Ocean Mug',
    description:
      'omnis dolor voluptate facilis ducimus repellendus exercitationem est eos velit',
    slug: 'Rustic-Ocean-Mug-1',
    added: 1478218439061,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Shoes', 'Person', 'Feet'],
    price: 19.99,
    name: 'Handcrafted Feet Mug',
    description:
      'et aut quas et labore omnis eius ut sunt consectetur earum similique consequuntur molestiae enim',
    slug: 'Handcrafted-Feet-Mug',
    added: 1479855790961,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 10.99,
    name: 'Rustic Abstract Mug',
    description:
      'magni maxime totam labore et debitis iure modi et eveniet assumenda quam quo saepe qui odit cum labore ducimus fuga labore iusto aut',
    slug: 'Rustic-Abstract-Mug',
    added: 1480702702851,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Tree', 'Reflection', 'Water'],
    price: 13.99,
    name: 'Ergonomic Reflection Mug',
    description:
      'ut vel non accusamus dolorem necessitatibus nemo incidunt voluptatem consequatur ipsa distinctio commodi delectus est consequatur',
    slug: 'Ergonomic-Reflection-Mug',
    added: 1484935491205,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Autumn', 'Fall', 'Nature', 'Leaves'],
    price: 12.99,
    name: 'Generic Leaves Mug',
    description:
      'cum dolor reiciendis laudantium suscipit aspernatur dignissimos corporis esse qui',
    slug: 'Generic-Leaves-Mug',
    added: 1480706204222,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'City', 'Building'],
    price: 13.99,
    name: 'Tasty City Mug',
    description:
      'mollitia recusandae et laborum animi cupiditate quo dolore et id pariatur eaque omnis reiciendis modi commodi odio sequi',
    slug: 'Tasty-City-Mug',
    added: 1478055559957,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Building', 'Ocean', 'Architecture', 'Sun'],
    price: 12.99,
    name: 'Handcrafted Sun Mug',
    description:
      'delectus nostrum sint aliquid quibusdam cumque suscipit praesentium dolores veritatis suscipit tenetur qui explicabo eum repellat at nemo necessitatibus aliquam qui architecto qui',
    slug: 'Handcrafted-Sun-Mug',
    added: 1480486026562,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'San Francisco', 'Fog'],
    price: 13.99,
    name: 'Refined Fog Mug',
    description:
      'deleniti ut facilis ut est eveniet harum rem perferendis quo qui eligendi explicabo eligendi alias incidunt perferendis',
    slug: 'Refined-Fog-Mug-3',
    added: 1485886518655,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Wave', 'Ocean'],
    price: 17.99,
    name: 'Handcrafted Wave Mug',
    description:
      'laborum iusto id eum laboriosam quia vel unde amet autem sed animi dolorem quia nisi ut doloremque quis perspiciatis voluptates id temporibus tempora debitis',
    slug: 'Handcrafted-Wave-Mug',
    added: 1481494131462,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Lake'],
    price: 9.99,
    name: 'Handcrafted Lake Mug',
    description:
      'est rerum voluptates architecto quo quo molestiae hic perferendis ut et ab vero laudantium',
    slug: 'Handcrafted-Lake-Mug-2',
    added: 1486108862920,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Stairs', 'Indoors'],
    price: 19.99,
    name: 'Rustic Stairs Mug',
    description:
      'ut velit ut rerum blanditiis non aut alias facilis enim molestiae ea voluptas dolorem cupiditate fuga suscipit dolore sapiente praesentium vel sint',
    slug: 'Rustic-Stairs-Mug',
    added: 1478213842057,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Stairs', 'People'],
    price: 12.99,
    name: 'Incredible Stairs Mug',
    description:
      'quidem labore expedita repudiandae ducimus ea dolorum consectetur maiores dolore saepe qui sit similique minima aperiam repellendus aut numquam eum officia dolor',
    slug: 'Incredible-Stairs-Mug',
    added: 1485893711649,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Cliff', 'Water', 'Rocks'],
    price: 10.99,
    name: 'Awesome Cliff Mug',
    description:
      'magni sit natus nobis repellendus cum qui reprehenderit aut sed vel',
    slug: 'Awesome-Cliff-Mug',
    added: 1480476720961,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Nature', 'Bike'],
    price: 13.99,
    name: 'Fantastic Bike Mug',
    description:
      'autem non est eius impedit cum sunt consequatur adipisci blanditiis nisi ipsam impedit maxime similique doloremque ut et et et qui velit aut doloribus molestiae',
    slug: 'Fantastic-Bike-Mug',
    added: 1484293409706,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Clock', 'Antique'],
    price: 11.99,
    name: 'Intelligent Clock Mug',
    description:
      'voluptas earum voluptates maiores qui natus et aliquid iure aut provident quas cupiditate eveniet quod deserunt fugit modi ad nihil repudiandae exercitationem aut',
    slug: 'Intelligent-Clock-Mug',
    added: 1480460332165,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Alarm'],
    price: 13.99,
    name: 'Small Alarm Mug',
    description:
      'similique veritatis natus voluptatem non fuga doloremque quia voluptatem maxime dolorum dolores nesciunt magni quo perspiciatis quis eveniet vero et tenetur enim',
    slug: 'Small-Alarm-Mug',
    added: 1481891255479,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 9.99,
    name: 'Tasty Architecture Mug',
    description:
      'numquam qui accusantium delectus quas dicta laudantium itaque est deserunt quia aspernatur optio omnis dolorum',
    slug: 'Tasty-Architecture-Mug',
    added: 1485704056919,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Lifeguard'],
    price: 17.99,
    name: 'Fantastic Lifeguard Mug',
    description:
      'perferendis eligendi eum non ut ut optio sapiente omnis quia consequuntur',
    slug: 'Fantastic-Lifeguard-Mug',
    added: 1486171764665,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees'],
    price: 11.99,
    name: 'Intelligent Trees Mug',
    description:
      'quia et laudantium ea repellendus aut autem quia enim qui eveniet quos natus',
    slug: 'Intelligent-Trees-Mug',
    added: 1482938301049,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Animals'],
    price: 13.99,
    name: 'Sleek Nature Mug',
    description:
      'in consequatur cupiditate rerum quia tempore ut minus error id aspernatur voluptatem atque debitis est',
    slug: 'Sleek-Nature-Mug-1',
    added: 1483841292663,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Doors'],
    price: 11.99,
    name: 'Rustic Doors Mug',
    description:
      'quo quaerat consequatur laborum distinctio est provident iste nemo accusamus voluptatem ea repudiandae esse perferendis qui sint aspernatur beatae eligendi voluptatibus necessitatibus',
    slug: 'Rustic-Doors-Mug',
    added: 1479924729729,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Mountains', 'Trees', 'Fog'],
    price: 16.99,
    name: 'Sleek Mountains Mug',
    description:
      'ut ducimus at in quibusdam sed non magni sint nostrum et molestiae mollitia quod non voluptas est dolorem sapiente',
    slug: 'Sleek-Mountains-Mug-1',
    added: 1482226336669,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Cars', 'City'],
    price: 19.99,
    name: 'Ergonomic Cars Mug',
    description:
      'eum tempore aperiam velit aut sit alias a et blanditiis dicta eum laudantium eaque repellat quam similique quia nobis maxime omnis veniam ipsum',
    slug: 'Ergonomic-Cars-Mug',
    added: 1486007574678,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Mountains', 'Silhouette'],
    price: 16.99,
    name: 'Handmade Fog Mug',
    description:
      'architecto doloribus sed nemo laudantium ut sint quisquam adipisci suscipit in rerum',
    slug: 'Handmade-Fog-Mug',
    added: 1482717636776,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 9.99,
    name: 'Unbranded Architecture Mug',
    description:
      'reiciendis cum dolor consectetur nobis officia dolorem reiciendis molestiae modi autem voluptas',
    slug: 'Unbranded-Architecture-Mug',
    added: 1480717922262,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Animals', 'Wild'],
    price: 10.99,
    name: 'Fantastic Nature Mug',
    description:
      'eveniet porro pariatur aut et consequatur laboriosam labore aperiam iste voluptate dolorem asperiores ut tempora tempore voluptatibus adipisci laboriosam minima est veniam voluptates iste',
    slug: 'Fantastic-Nature-Mug',
    added: 1478943234427,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office'],
    price: 9.99,
    name: 'Rustic Office Mug',
    description:
      'et fuga quo vitae iste voluptas maiores quis perferendis qui est mollitia qui et nihil temporibus quo qui nisi quam occaecati perspiciatis eveniet quis',
    slug: 'Rustic-Office-Mug',
    added: 1482890948366,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Shells', 'Beach'],
    price: 9.99,
    name: 'Practical Beach Mug',
    description:
      'soluta natus possimus et ipsa sint possimus non iste eos eum sequi deserunt et modi velit voluptatum et tempore consequuntur odit quam',
    slug: 'Practical-Beach-Mug-1',
    added: 1485953437265,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Trees', 'Forest'],
    price: 16.99,
    name: 'Licensed Person Mug',
    description:
      'eveniet facilis non ullam placeat eius similique delectus ipsam et eum illo',
    slug: 'Licensed-Person-Mug-1',
    added: 1485455897800,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'City', 'Buildings'],
    price: 16.99,
    name: 'Sleek Arial Mug',
    description:
      'labore mollitia molestiae amet dolores quia quo excepturi nulla ipsum',
    slug: 'Sleek-Arial-Mug',
    added: 1478939481746,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Forest', 'Rocks'],
    price: 17.99,
    name: 'Generic Rocks Mug',
    description:
      'tempora inventore voluptas debitis iure tenetur magni distinctio sit in maxime',
    slug: 'Generic-Rocks-Mug',
    added: 1480399716711,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Fog', 'Mountains'],
    price: 11.99,
    name: 'Awesome Fog Mug',
    description:
      'quas excepturi dolorem voluptate molestiae vel qui aut tempore sit autem sed ipsam voluptatem nam omnis hic eos mollitia aut',
    slug: 'Awesome-Fog-Mug-2',
    added: 1483348011345,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office'],
    price: 17.99,
    name: 'Handcrafted Desk Mug',
    description:
      'tenetur incidunt velit doloremque incidunt rem error aliquam ipsa unde repellendus et animi quia reprehenderit',
    slug: 'Handcrafted-Desk-Mug',
    added: 1484614684253,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Waterfall', 'Person', 'Nature'],
    price: 11.99,
    name: 'Refined Waterfall Mug',
    description:
      'alias corporis nulla cumque eius nemo accusamus voluptatibus unde nam temporibus nobis ullam quo iusto adipisci dolores quaerat odio accusamus et provident ad temporibus',
    slug: 'Refined-Waterfall-Mug',
    added: 1478080216361,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 12.99,
    name: 'Awesome Water Mug',
    description:
      'sit asperiores non quos dolore et ullam dolor similique hic molestiae facilis ut eaque sunt sunt enim',
    slug: 'Awesome-Water-Mug',
    added: 1479217344098,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Forrest', 'Mushroom'],
    price: 17.99,
    name: 'Sleek Mushroom Mug',
    description:
      'earum neque enim totam maiores dolores distinctio quas saepe sit velit et maiores',
    slug: 'Sleek-Mushroom-Mug',
    added: 1486273480164,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings'],
    price: 10.99,
    name: 'Fantastic Buildings Mug',
    description:
      'et ut in et qui iure explicabo quos aut itaque similique exercitationem ipsam inventore in libero recusandae',
    slug: 'Fantastic-Buildings-Mug',
    added: 1485445558000,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 13.99,
    name: 'Ergonomic Building Mug',
    description:
      'nesciunt consequatur tempora vero repellat quis occaecati blanditiis inventore aut perspiciatis laborum quia',
    slug: 'Ergonomic-Building-Mug',
    added: 1477844391037,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Barn'],
    price: 9.99,
    name: 'Intelligent Barn Mug',
    description:
      'doloribus quo autem aut similique et eligendi sunt dignissimos quo enim dolorem mollitia',
    slug: 'Intelligent-Barn-Mug',
    added: 1486265033164,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 10.99,
    name: 'Fantastic Fog Mug',
    description:
      'debitis repellendus eum non numquam fuga sit repellat laborum blanditiis eveniet cupiditate nihil',
    slug: 'Fantastic-Fog-Mug-1',
    added: 1480791369288,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Desert', 'Flowers'],
    price: 18.99,
    name: 'Small Flowers Mug',
    description:
      'sit consequatur magnam eius dolore iure sunt quidem voluptatum omnis qui et aut similique vitae distinctio',
    slug: 'Small-Flowers-Mug',
    added: 1480683733589,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['City'],
    price: 20.99,
    name: 'Awesome City Mug',
    description:
      'quidem nostrum id aut ipsa ea totam et beatae eum aut delectus odio atque et commodi dicta nisi nostrum hic omnis officia et quidem quis',
    slug: 'Awesome-City-Mug-1',
    added: 1485270740833,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Volcano', 'Fog'],
    price: 17.99,
    name: 'Unbranded Volcano Mug',
    description:
      'laudantium possimus neque magnam qui impedit architecto earum officia recusandae sit ipsam earum id sit',
    slug: 'Unbranded-Volcano-Mug',
    added: 1482939517308,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Waves', 'Water'],
    price: 19.99,
    name: 'Small Water Mug',
    description:
      'in voluptas quod eveniet dolores aspernatur dicta natus sunt ea vero ducimus aut illo sit autem voluptatem et eos minima modi officiis voluptas',
    slug: 'Small-Water-Mug',
    added: 1482978982086,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Architecture'],
    price: 19.99,
    name: 'Gorgeous Architecture Mug',
    description:
      'occaecati itaque vel ea voluptatem beatae necessitatibus ducimus sit deleniti molestiae sed est perferendis alias eaque eum nam voluptatem praesentium sed',
    slug: 'Gorgeous-Architecture-Mug',
    added: 1484593341257,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Cliff', 'Ocean', 'Rocks'],
    price: 13.99,
    name: 'Tasty Rocks Mug',
    description:
      'qui ut est repudiandae ut magni asperiores asperiores amet est asperiores officiis pariatur consequatur incidunt iure non aliquid ut voluptate',
    slug: 'Tasty-Rocks-Mug',
    added: 1483408303914,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Mountains', 'Meadow'],
    price: 13.99,
    name: 'Handmade Mountains Mug',
    description:
      'sed quam explicabo quis veritatis asperiores voluptatem atque molestiae quos labore et',
    slug: 'Handmade-Mountains-Mug',
    added: 1479200720867,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Stunt', 'Fire'],
    price: 10.99,
    name: 'Rustic Fire Mug',
    description:
      'est nam exercitationem quasi doloremque nemo temporibus iure repellendus at inventore est aspernatur modi aut aut ut qui ut deserunt quis quis eum quisquam ut',
    slug: 'Rustic-Fire-Mug',
    added: 1477840927351,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Fog', 'City', 'People'],
    price: 14.99,
    name: 'Handcrafted Fog Mug',
    description:
      'et aut veritatis aperiam quia aut accusamus minima ad excepturi illo odit sint ea ut quia laudantium impedit est ut iure',
    slug: 'Handcrafted-Fog-Mug',
    added: 1478140973599,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Trees', 'Woman', 'People'],
    price: 11.99,
    name: 'Small Sunset Mug',
    description:
      'cupiditate omnis ipsum architecto quis in est culpa praesentium quia sit quibusdam minus occaecati provident perspiciatis odit',
    slug: 'Small-Sunset-Mug-2',
    added: 1484942687514,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Sand'],
    price: 9.99,
    name: 'Unbranded Sand Mug',
    description:
      'architecto molestiae sed quibusdam labore sit facilis eos ut aut nihil similique voluptatum quis perferendis aut nostrum rerum',
    slug: 'Unbranded-Sand-Mug',
    added: 1484541004216,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 14.99,
    name: 'Handcrafted City Mug',
    description:
      'incidunt aut perferendis nihil nostrum optio magnam omnis non voluptatem laboriosam in maiores nobis beatae dolor vel nihil nobis ipsam aperiam et et suscipit quibusdam',
    slug: 'Handcrafted-City-Mug-2',
    added: 1482366704895,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Trees', 'Fog'],
    price: 11.99,
    name: 'Awesome Fog Mug',
    description:
      'sit ipsam dolorum quia accusantium aliquid non animi ut earum unde perspiciatis',
    slug: 'Awesome-Fog-Mug-3',
    added: 1481207250178,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Boat', 'Bird'],
    price: 14.99,
    name: 'Small Boat Mug',
    description:
      'ea enim ea commodi veritatis laborum voluptates et cumque dignissimos sapiente quia voluptas et minima libero ullam et consequatur sunt aut',
    slug: 'Small-Boat-Mug',
    added: 1479223667110,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Pool', 'Jump', 'People'],
    price: 13.99,
    name: 'Awesome Jump Mug',
    description:
      'quisquam doloremque perferendis aut dolorem odio id et sunt eaque minus',
    slug: 'Awesome-Jump-Mug',
    added: 1484546703522,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Desert', 'Car'],
    price: 15.99,
    name: 'Refined Car Mug',
    description:
      'nam in id cum asperiores nostrum corrupti similique laborum quo suscipit blanditiis assumenda sequi delectus adipisci consequatur modi eveniet laboriosam nulla autem placeat sed',
    slug: 'Refined-Car-Mug',
    added: 1485173873445,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'Camping', 'Teepee'],
    price: 12.99,
    name: 'Small Night Mug',
    description:
      'atque nostrum voluptatem sunt iste reprehenderit voluptate provident occaecati sint exercitationem',
    slug: 'Small-Night-Mug',
    added: 1482881276947,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'People'],
    price: 13.99,
    name: 'Refined Ocean Mug',
    description:
      'voluptatem dolores molestiae molestias illo iste molestias rerum voluptas qui',
    slug: 'Refined-Ocean-Mug',
    added: 1484220592852,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Booth', 'Restaurant', 'Table', 'Seats'],
    price: 15.99,
    name: 'Intelligent Seats Mug',
    description:
      'modi tempora harum sint aut voluptas laboriosam id illo facilis cumque aut veritatis rerum sint repudiandae illo magnam',
    slug: 'Intelligent-Seats-Mug',
    added: 1485070498325,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Face', 'Woman'],
    price: 12.99,
    name: 'Gorgeous Woman Mug',
    description:
      'in est et et aut id quia porro ut sed dolorem omnis vitae voluptas blanditiis voluptatem necessitatibus',
    slug: 'Gorgeous-Woman-Mug-1',
    added: 1482722181097,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Lake', 'People'],
    price: 14.99,
    name: 'Gorgeous Lake Mug',
    description:
      'laudantium explicabo omnis quo neque et veniam quam quis architecto',
    slug: 'Gorgeous-Lake-Mug',
    added: 1485669637250,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Man', 'Fog', 'Mountains', 'Lake', 'People'],
    price: 18.99,
    name: 'Awesome Mountains Mug',
    description:
      'omnis et dicta explicabo debitis aut voluptatem consequatur cupiditate ut tenetur fugit molestias explicabo consequatur temporibus fuga ut sed',
    slug: 'Awesome-Mountains-Mug',
    added: 1485398044871,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Spray', 'Ocean', 'Waves', 'Rocks'],
    price: 10.99,
    name: 'Ergonomic Rocks Mug',
    description:
      'ut aut vel cum facilis iusto voluptates voluptatum quo pariatur minima quia ut et odio nemo possimus facilis quia qui sint unde non qui',
    slug: 'Ergonomic-Rocks-Mug-1',
    added: 1485683708767,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Mountains'],
    price: 10.99,
    name: 'Tasty Trees Mug',
    description:
      'excepturi et porro non est excepturi in consequatur quaerat qui beatae eaque atque ut porro',
    slug: 'Tasty-Trees-Mug-1',
    added: 1484337120519,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Waterfall', 'Fog'],
    price: 19.99,
    name: 'Sleek Waterfall Mug',
    description: 'itaque in eveniet amet non et dicta et error porro',
    slug: 'Sleek-Waterfall-Mug',
    added: 1479338869813,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees', 'Cabin'],
    price: 13.99,
    name: 'Tasty Cabin Mug',
    description:
      'nemo placeat aliquam et odio quis ullam laudantium ab consectetur in explicabo consequatur',
    slug: 'Tasty-Cabin-Mug',
    added: 1479673608155,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Buildings', 'City'],
    price: 16.99,
    name: 'Tasty City Mug',
    description:
      'culpa est animi ut alias maxime ut expedita sed quas aut nemo',
    slug: 'Tasty-City-Mug-1',
    added: 1484515995476,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Building', 'Black&white'],
    price: 11.99,
    name: 'Incredible Building Mug',
    description:
      'qui labore illo incidunt sint aut quibusdam est autem provident doloremque dolorem ipsam',
    slug: 'Incredible-Building-Mug',
    added: 1483389724351,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings', 'Architecture'],
    price: 9.99,
    name: 'Ergonomic City Mug',
    description:
      'placeat quibusdam omnis incidunt ducimus dolorem iure aut aut ab ex a quia iste',
    slug: 'Ergonomic-City-Mug',
    added: 1485776555316,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees', 'Forest'],
    price: 9.99,
    name: 'Practical Forest Mug',
    description:
      'et voluptatum pariatur veniam vitae laudantium rem ut laudantium veniam ut voluptas est ducimus in assumenda qui et similique occaecati earum aut',
    slug: 'Practical-Forest-Mug',
    added: 1480389769814,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Van', 'Old', 'Car'],
    price: 13.99,
    name: 'Small Car Mug',
    description:
      'possimus sit totam aliquid et corporis ut enim quas quia quia alias eum et cum odit qui enim modi libero',
    slug: 'Small-Car-Mug',
    added: 1479546238323,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Hands', 'Flower'],
    price: 13.99,
    name: 'Licensed Hands Mug',
    description:
      'voluptatem et corrupti dolor voluptas voluptatum beatae aspernatur in velit quis doloremque aut aut',
    slug: 'Licensed-Hands-Mug',
    added: 1485589166237,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Mountains', 'Lake'],
    price: 15.99,
    name: 'Fantastic Nature Mug',
    description:
      'illo exercitationem voluptatem alias voluptates beatae voluptatem et placeat vel quia aliquid veniam voluptas odit praesentium',
    slug: 'Fantastic-Nature-Mug-1',
    added: 1485400522087,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Building', 'People'],
    price: 15.99,
    name: 'Ergonomic Building Mug',
    description:
      'nostrum qui et corrupti sed assumenda odio libero reprehenderit aut cupiditate ducimus laboriosam enim suscipit laudantium tempore provident ducimus magni',
    slug: 'Ergonomic-Building-Mug-1',
    added: 1484357192619,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Cross', 'Religion'],
    price: 11.99,
    name: 'Small Cross Mug',
    description:
      'voluptas et non voluptatem et aut deleniti quas consequatur tempora rerum fuga ullam qui',
    slug: 'Small-Cross-Mug',
    added: 1481419663067,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Back', 'Person', 'Man', 'Camera', 'Lake'],
    price: 18.99,
    name: 'Awesome Back Mug',
    description:
      'molestiae blanditiis alias voluptates soluta in et neque ullam veritatis nulla asperiores earum rem',
    slug: 'Awesome-Back-Mug',
    added: 1483323740218,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Lime', 'Yellow', 'Green', 'Fruit', 'Citrus', 'Lemon'],
    price: 12.99,
    name: 'Refined Yellow Mug',
    description:
      'adipisci voluptas enim qui qui commodi et aut sit in rerum explicabo',
    slug: 'Refined-Yellow-Mug',
    added: 1484152059277,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees', 'Nature', 'Mountains'],
    price: 12.99,
    name: 'Refined Nature Mug',
    description:
      'debitis dolor et architecto aut nostrum ducimus dolorem excepturi sed facilis reiciendis',
    slug: 'Refined-Nature-Mug',
    added: 1479034706794,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Rock', 'Arch', 'Ocean'],
    price: 16.99,
    name: 'Generic Ocean Mug',
    description:
      'delectus quod illo voluptas vero ut doloribus accusamus quisquam consequuntur dolor ea consequatur sed consequatur non veritatis voluptatem temporibus enim libero molestiae',
    slug: 'Generic-Ocean-Mug',
    added: 1483941052542,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Tiger'],
    price: 9.99,
    name: 'Practical Tiger Mug',
    description:
      'similique numquam harum deleniti tempore laudantium similique autem et qui explicabo autem eveniet facilis',
    slug: 'Practical-Tiger-Mug',
    added: 1479088290344,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'People'],
    price: 14.99,
    name: 'Gorgeous Ocean Mug',
    description:
      'neque possimus quos soluta voluptas omnis tenetur doloribus ullam sequi quos rerum quibusdam deserunt ipsa explicabo sed molestias sit sed',
    slug: 'Gorgeous-Ocean-Mug-1',
    added: 1479389668927,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Birds'],
    price: 17.99,
    name: 'Practical Sky Mug',
    description:
      'doloribus quo quae error ipsa itaque blanditiis at pariatur eveniet eos consectetur et nobis',
    slug: 'Practical-Sky-Mug',
    added: 1482597486938,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Plane', 'Overcast', 'Building', 'Fog'],
    price: 17.99,
    name: 'Gorgeous Fog Mug',
    description:
      'et dolores voluptatem saepe rerum rerum asperiores enim exercitationem qui voluptatibus aut ipsam aperiam aut quisquam commodi',
    slug: 'Gorgeous-Fog-Mug',
    added: 1478015082914,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Hands', 'Office', 'Meeting', 'People'],
    price: 19.99,
    name: 'Rustic People Mug',
    description:
      'aliquam alias nihil consequatur debitis sit natus exercitationem impedit cumque magnam sequi sed corporis illo voluptatem ducimus et hic voluptatem est',
    slug: 'Rustic-People-Mug',
    added: 1482740858331,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Snow'],
    price: 19.99,
    name: 'Refined Snow Mug',
    description:
      'quia similique aliquam inventore et nobis perferendis a magnam facere necessitatibus magni praesentium est ab labore expedita minima asperiores',
    slug: 'Refined-Snow-Mug',
    added: 1481866655476,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'Sand', 'Desert'],
    price: 17.99,
    name: 'Sleek Night Mug',
    description:
      'recusandae quas temporibus sapiente molestiae eos nulla est et non molestias voluptatem fugit architecto ad enim aut enim aut sed quia aspernatur et harum aut',
    slug: 'Sleek-Night-Mug',
    added: 1483507663515,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings'],
    price: 9.99,
    name: 'Intelligent Buildings Mug',
    description:
      'sit ex aspernatur ut id et sint iste aliquam minima cumque sequi natus est magni eos deserunt odit voluptas harum tenetur atque quaerat dolore',
    slug: 'Intelligent-Buildings-Mug',
    added: 1478119907648,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Bridge', 'Forest'],
    price: 14.99,
    name: 'Licensed Bridge Mug',
    description:
      'laboriosam accusantium eum quia est ut et vero omnis earum quas aut exercitationem sunt iure laborum',
    slug: 'Licensed-Bridge-Mug',
    added: 1485583759486,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Shoes', 'Person', 'Feet', 'Railroad'],
    price: 14.99,
    name: 'Generic Feet Mug',
    description:
      'optio repudiandae consectetur tempora rerum fugiat asperiores ut hic necessitatibus error tempora et accusantium enim',
    slug: 'Generic-Feet-Mug',
    added: 1484491077623,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Desert', 'People'],
    price: 9.99,
    name: 'Handcrafted Desert Mug',
    description:
      'qui aut eum natus officiis eaque voluptas in explicabo aut eius alias',
    slug: 'Handcrafted-Desert-Mug',
    added: 1479826930769,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Night'],
    price: 11.99,
    name: 'Tasty Night Mug',
    description:
      'et doloremque non error ut sed est corrupti est nesciunt quidem dolorem qui labore neque aperiam illo ab itaque sunt sunt voluptas',
    slug: 'Tasty-Night-Mug-1',
    added: 1484782749369,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Desert'],
    price: 11.99,
    name: 'Ergonomic Nature Mug',
    description:
      'perspiciatis veritatis eos quia illo et magni tempora natus facilis',
    slug: 'Ergonomic-Nature-Mug',
    added: 1485725994627,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'San Francisco', 'Fog', 'Ocean', 'Metal'],
    price: 17.99,
    name: 'Intelligent Metal Mug',
    description:
      'sit provident voluptate eos et dolorum at voluptates autem neque ea sequi nulla occaecati omnis at qui',
    slug: 'Intelligent-Metal-Mug',
    added: 1486311137342,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Metal', 'Building'],
    price: 13.99,
    name: 'Generic Building Mug',
    description:
      'consequatur veniam cumque atque impedit delectus eos quas atque eaque consequuntur',
    slug: 'Generic-Building-Mug',
    added: 1479124203076,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees'],
    price: 13.99,
    name: 'Rustic Trees Mug',
    description:
      'corrupti et mollitia rerum eveniet nam molestiae esse eos hic eius eum nulla harum',
    slug: 'Rustic-Trees-Mug-1',
    added: 1480021337452,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Smart phone', 'Hands'],
    price: 9.99,
    name: 'Intelligent Smart Phone Mug',
    description:
      'non aperiam ullam iure odit voluptas quae aut ut earum dolore et ipsum laudantium sit velit laborum aut',
    slug: 'Intelligent-Smart-Phone-Mug',
    added: 1481116148865,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Tree', 'Nature', 'Juniper'],
    price: 9.99,
    name: 'Licensed Tree Mug',
    description:
      'sed maiores amet voluptatem velit reprehenderit dolorum quia culpa quasi aspernatur aperiam repudiandae repellat consequatur rerum harum aliquid et ut voluptatem adipisci voluptas sint',
    slug: 'Licensed-Tree-Mug',
    added: 1482301781919,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Abstract'],
    price: 11.99,
    name: 'Small Abstract Mug',
    description:
      'recusandae et magni cumque ut dolorem ut voluptatum asperiores eum alias',
    slug: 'Small-Abstract-Mug',
    added: 1481625695887,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Nature', 'Water', 'Rocks'],
    price: 10.99,
    name: 'Tasty Beach Mug',
    description: 'ea sit error facere quod cumque aut quo aut fugiat',
    slug: 'Tasty-Beach-Mug',
    added: 1478060199479,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Snow', 'Lake'],
    price: 13.99,
    name: 'Small Lake Mug',
    description:
      'ut corrupti necessitatibus tempora rerum consequuntur enim rem sit veniam consequuntur aliquam eos placeat optio voluptas dolor omnis laboriosam',
    slug: 'Small-Lake-Mug-1',
    added: 1481619152419,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Meal', 'Food', 'Table'],
    price: 14.99,
    name: 'Ergonomic Food Mug',
    description:
      'commodi est sapiente quisquam est labore qui nulla hic et quia adipisci laboriosam ea a qui sit est aperiam voluptatum molestias',
    slug: 'Ergonomic-Food-Mug',
    added: 1485279185711,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Storm', 'Clouds'],
    price: 12.99,
    name: 'Sleek Storm Mug',
    description:
      'natus adipisci consequuntur quis culpa in laudantium odio id et tempore architecto esse animi iure dolores ea dolorem autem nisi sequi est et nobis',
    slug: 'Sleek-Storm-Mug',
    added: 1484664794550,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Road'],
    price: 20.99,
    name: 'Intelligent Trees Mug',
    description:
      'sit autem tempora est omnis et quia doloremque explicabo quae fugit quo nostrum perspiciatis at',
    slug: 'Intelligent-Trees-Mug-1',
    added: 1481142211251,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Dark', 'Night', 'Stars'],
    price: 11.99,
    name: 'Small Dark Mug',
    description:
      'fugiat minima a est veniam sed reprehenderit quidem corporis est ipsam voluptates id non velit',
    slug: 'Small-Dark-Mug',
    added: 1485838773211,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Space', 'NASA'],
    price: 14.99,
    name: 'Handmade Space Mug',
    description:
      'alias ratione voluptatem quis aspernatur magnam excepturi odio sint perspiciatis ut odio voluptatibus voluptas explicabo ut ut sed et eum dolor inventore saepe',
    slug: 'Handmade-Space-Mug',
    added: 1479009156596,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Bus', 'City', 'Buildings', 'People'],
    price: 11.99,
    name: 'Awesome People Mug',
    description:
      'voluptate atque repellat eaque excepturi et iste quo rerum nihil placeat',
    slug: 'Awesome-People-Mug',
    added: 1483629009110,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Yak'],
    price: 13.99,
    name: 'Handcrafted Yak Mug',
    description:
      'veritatis et nemo cumque assumenda omnis earum saepe fugit provident dolorem tempore quas quas fugit qui dolor eos ut praesentium ex',
    slug: 'Handcrafted-Yak-Mug',
    added: 1483360479943,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Path', 'Trees', 'Fog'],
    price: 14.99,
    name: 'Small Fog Mug',
    description:
      'occaecati quam non voluptatum et eos enim illum consectetur molestias est et ea eius quia itaque perferendis',
    slug: 'Small-Fog-Mug-1',
    added: 1484667325341,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Boats', 'Ocean', 'Rocks'],
    price: 16.99,
    name: 'Tasty Ocean Mug',
    description:
      'aut ipsam perferendis explicabo laboriosam numquam debitis est placeat qui rerum deleniti nemo cum et',
    slug: 'Tasty-Ocean-Mug-1',
    added: 1485266358714,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Bench', 'Leaves'],
    price: 19.99,
    name: 'Intelligent Bench Mug',
    description:
      'fugiat aut quasi assumenda iure ipsum in nulla odio numquam et deleniti earum quod eos nobis qui aut',
    slug: 'Intelligent-Bench-Mug',
    added: 1477941345097,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Glass', 'Architecture', 'Building'],
    price: 18.99,
    name: 'Licensed Building Mug',
    description:
      'tempore laboriosam voluptas omnis totam vel recusandae ut necessitatibus tempora libero explicabo optio voluptates et iusto ipsa dolor ut sunt',
    slug: 'Licensed-Building-Mug',
    added: 1485031581533,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 14.99,
    name: 'Tasty Fog Mug',
    description:
      'soluta eos quidem ea est in ullam quisquam sint est nostrum nostrum reprehenderit cumque perferendis sunt eos voluptate est rerum et consequuntur',
    slug: 'Tasty-Fog-Mug',
    added: 1485461979373,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 16.99,
    name: 'Handmade Snow Mug',
    description:
      'rerum asperiores voluptates nihil adipisci non rerum omnis assumenda qui illum velit ea doloribus velit',
    slug: 'Handmade-Snow-Mug-1',
    added: 1478525267094,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings'],
    price: 11.99,
    name: 'Ergonomic Buildings Mug',
    description:
      'ipsa sapiente illo eveniet quia nihil ut nihil quo voluptatem incidunt',
    slug: 'Ergonomic-Buildings-Mug',
    added: 1484313766164,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Farmer', 'Farm'],
    price: 19.99,
    name: 'Rustic Person Mug',
    description: 'doloribus totam et ut corporis est ut officia iure facilis',
    slug: 'Rustic-Person-Mug',
    added: 1485549313899,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'Silhouette', 'People'],
    price: 17.99,
    name: 'Handmade Silhouette Mug',
    description:
      'laboriosam soluta odio et dignissimos suscipit nostrum illum nostrum minus omnis aspernatur accusamus rerum exercitationem repudiandae commodi aut incidunt odio iste et eius',
    slug: 'Handmade-Silhouette-Mug',
    added: 1485722059522,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Fog'],
    price: 17.99,
    name: 'Generic Fog Mug',
    description:
      'nisi eum harum excepturi vero consectetur asperiores maiores asperiores ex eos sunt sapiente',
    slug: 'Generic-Fog-Mug-1',
    added: 1484295910475,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Desert'],
    price: 18.99,
    name: 'Rustic Desert Mug',
    description:
      'totam modi perspiciatis voluptatibus quia in qui placeat illum blanditiis aliquam quis qui aspernatur et et ab pariatur dignissimos suscipit iste quia',
    slug: 'Rustic-Desert-Mug',
    added: 1483830271065,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Crater', 'Space'],
    price: 19.99,
    name: 'Small Crater Mug',
    description:
      'eaque nihil nobis consequatur aut ut et neque vitae dolor aperiam explicabo ut fugiat quisquam maiores aliquid id et aut aperiam est optio',
    slug: 'Small-Crater-Mug',
    added: 1484276485646,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Classic', 'Car'],
    price: 17.99,
    name: 'Small Car Mug',
    description:
      'ea eaque cum voluptates quo eos ipsa ex labore magnam ducimus ut quibusdam qui reiciendis quod aspernatur fugit id rerum atque',
    slug: 'Small-Car-Mug-1',
    added: 1479805692576,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Plants'],
    price: 9.99,
    name: 'Handmade Fog Mug',
    description:
      'adipisci quia non quos voluptatibus omnis voluptatem consequatur sit magnam est corporis id facilis asperiores vitae ut dolorum maiores',
    slug: 'Handmade-Fog-Mug-1',
    added: 1486229077488,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 10.99,
    name: 'Handcrafted Snow Mug',
    description:
      'rerum dolorem molestiae ut corrupti omnis sunt dolorum nemo repellendus atque non ullam sint omnis asperiores velit tenetur minus unde',
    slug: 'Handcrafted-Snow-Mug-1',
    added: 1485879172954,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Mountains'],
    price: 14.99,
    name: 'Refined Mountains Mug',
    description:
      'qui et laborum consequuntur impedit harum labore autem inventore temporibus accusantium at sed quod iste aperiam velit qui laboriosam voluptatum',
    slug: 'Refined-Mountains-Mug',
    added: 1477956550475,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Car'],
    price: 17.99,
    name: 'Unbranded City Mug',
    description:
      'nisi earum eius vitae earum nihil soluta et quisquam neque nihil iusto officia nihil dolore exercitationem doloremque commodi enim debitis',
    slug: 'Unbranded-City-Mug',
    added: 1481274141448,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 13.99,
    name: 'Generic Ocean Mug',
    description:
      'id debitis blanditiis odio eligendi et animi voluptas sequi earum temporibus quam et sint aut cupiditate ut et non voluptatem consectetur tempora dolorum deserunt consequatur',
    slug: 'Generic-Ocean-Mug-1',
    added: 1486392864165,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'Bike'],
    price: 18.99,
    name: 'Practical Night Mug',
    description:
      'et ducimus et numquam voluptas odio voluptatem ipsa est quis est voluptatum ut numquam in voluptate exercitationem nulla error laborum repudiandae deleniti excepturi quae eaque',
    slug: 'Practical-Night-Mug',
    added: 1485369657065,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains', 'Ocean'],
    price: 10.99,
    name: 'Incredible Mountains Mug',
    description:
      'dolorem aut ad sit corporis fuga dolore ut perferendis qui ex eveniet sunt voluptate iure',
    slug: 'Incredible-Mountains-Mug',
    added: 1483764340522,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Farm', 'Animals', 'Fog', 'Machine'],
    price: 12.99,
    name: 'Handcrafted Animals Mug',
    description:
      'harum error accusamus odio ea vel explicabo aut quasi alias accusamus delectus mollitia sed sed vitae commodi deserunt',
    slug: 'Handcrafted-Animals-Mug',
    added: 1481138022215,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Church'],
    price: 17.99,
    name: 'Incredible Church Mug',
    description:
      'nulla ipsam quo nemo molestiae omnis quis consectetur eveniet doloribus nobis',
    slug: 'Incredible-Church-Mug',
    added: 1478280203079,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Person', 'Skate park'],
    price: 11.99,
    name: 'Unbranded Skate Park Mug',
    description:
      'accusamus exercitationem rerum quo exercitationem vitae mollitia sequi ut reiciendis minus vel distinctio aliquam impedit ducimus cumque possimus dignissimos dolorem',
    slug: 'Unbranded-Skate-Park-Mug',
    added: 1485353591063,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Mountains'],
    price: 14.99,
    name: 'Sleek Nature Mug',
    description:
      'doloremque sint ipsam eum unde numquam saepe odit doloremque soluta esse quam',
    slug: 'Sleek-Nature-Mug-2',
    added: 1479332067190,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Night', 'Stars'],
    price: 16.99,
    name: 'Tasty Stars Mug',
    description:
      'aut alias vel in sit expedita sunt aspernatur quisquam distinctio doloribus numquam cumque adipisci consectetur in minima hic',
    slug: 'Tasty-Stars-Mug',
    added: 1484130835370,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 19.99,
    name: 'Awesome Trees Mug',
    description:
      'vel doloribus eaque consequatur eos sit labore accusamus asperiores maiores non sit vitae ex tenetur doloremque et ducimus quidem itaque voluptatum maiores nostrum ea',
    slug: 'Awesome-Trees-Mug',
    added: 1484879386817,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Cars', 'City'],
    price: 11.99,
    name: 'Practical City Mug',
    description:
      'nemo et error qui officia iusto id quisquam inventore nihil accusamus vitae reiciendis voluptatem porro consequatur autem id laboriosam',
    slug: 'Practical-City-Mug-1',
    added: 1485671370935,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'San Francisco', 'City'],
    price: 16.99,
    name: 'Licensed Bridge Mug',
    description:
      'ut dolorem rerum quia natus sapiente minus aspernatur autem consequatur dolor aperiam sint dolores quia omnis velit ea eligendi tempora eos dicta tempora',
    slug: 'Licensed-Bridge-Mug-1',
    added: 1486389378880,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Journal', 'Photos'],
    price: 14.99,
    name: 'Small Photos Mug',
    description:
      'tempore qui quaerat et fuga aperiam consequuntur blanditiis in repellat natus dolorem quidem sunt vel excepturi voluptatem',
    slug: 'Small-Photos-Mug',
    added: 1484468069427,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Forest', 'Camera'],
    price: 16.99,
    name: 'Tasty Camera Mug',
    description:
      'dignissimos harum delectus porro tempora quis nihil dolorum dolores sint et modi',
    slug: 'Tasty-Camera-Mug',
    added: 1483012778802,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunrise', 'Nature', 'Fog', 'Mountains'],
    price: 18.99,
    name: 'Licensed Nature Mug',
    description:
      'sed vitae voluptas vitae nemo autem eaque aliquid et sit beatae provident repudiandae rerum earum',
    slug: 'Licensed-Nature-Mug',
    added: 1486333662849,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Arch', 'Architecture'],
    price: 12.99,
    name: 'Unbranded Architecture Mug',
    description:
      'consequatur molestiae pariatur modi illum neque et laboriosam eos voluptatem vero aut',
    slug: 'Unbranded-Architecture-Mug-1',
    added: 1479461134071,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Car'],
    price: 10.99,
    name: 'Fantastic Car Mug',
    description:
      'accusamus deleniti ut et quo est iste cupiditate minus ipsam est exercitationem',
    slug: 'Fantastic-Car-Mug',
    added: 1481559353108,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'Architecture', 'Water'],
    price: 11.99,
    name: 'Awesome Bridge Mug',
    description:
      'nihil aut est voluptates architecto harum repellat et enim rerum omnis omnis eligendi ut blanditiis sunt aut id perspiciatis molestias quia',
    slug: 'Awesome-Bridge-Mug',
    added: 1481449670246,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Boardwalk', 'Beach', 'Ocean', 'People'],
    price: 14.99,
    name: 'Licensed People Mug',
    description:
      'illum aspernatur ut maiores veritatis cupiditate sunt non et doloribus atque eos quam nemo aliquid sint',
    slug: 'Licensed-People-Mug',
    added: 1477979340567,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Scene', 'Props'],
    price: 19.99,
    name: 'Ergonomic Scene Mug',
    description:
      'quidem vel suscipit modi veniam id fugiat ut aut officia ut doloremque enim eaque aut amet repellendus minima repudiandae architecto expedita',
    slug: 'Ergonomic-Scene-Mug',
    added: 1479302469134,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Hot air balloon', 'People'],
    price: 17.99,
    name: 'Rustic Hot Air Balloon Mug',
    description:
      'ut ea est enim dolore ut facilis velit rerum autem quo exercitationem praesentium velit nobis hic quo ea eum necessitatibus unde non numquam',
    slug: 'Rustic-Hot-Air-Balloon-Mug',
    added: 1481137891017,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Pier', 'Ocean'],
    price: 13.99,
    name: 'Ergonomic Beach Mug',
    description:
      'amet eos fugiat omnis aut ipsum quasi qui facilis unde qui cum asperiores magnam animi quo neque commodi voluptatem porro repellendus et eos aperiam',
    slug: 'Ergonomic-Beach-Mug',
    added: 1481060364529,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Pineapple', 'Field', 'Fruit'],
    price: 19.99,
    name: 'Handmade Field Mug',
    description:
      'dolorem dicta mollitia in id tempore enim ducimus possimus reiciendis autem pariatur eius explicabo in qui distinctio qui ullam deserunt error sed',
    slug: 'Handmade-Field-Mug',
    added: 1482964675046,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Nature'],
    price: 13.99,
    name: 'Refined Trees Mug',
    description:
      'ut et nostrum ipsa natus laboriosam aut autem perferendis sunt consequatur ut veritatis error doloremque',
    slug: 'Refined-Trees-Mug',
    added: 1484678623201,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Cars', 'City'],
    price: 10.99,
    name: 'Awesome City Mug',
    description:
      'et omnis sed facere ab doloribus corrupti esse soluta repudiandae exercitationem impedit ipsum magnam omnis totam quo iure fuga quae sint eligendi culpa possimus et',
    slug: 'Awesome-City-Mug-2',
    added: 1481616714312,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Waterfall', 'Nature'],
    price: 19.99,
    name: 'Sleek Waterfall Mug',
    description:
      'corrupti perspiciatis consequatur accusamus ut eveniet neque temporibus ipsam deserunt quia ea placeat mollitia expedita sapiente debitis dolorem molestias a ut dicta sequi',
    slug: 'Sleek-Waterfall-Mug-1',
    added: 1479171165632,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Glass', 'City', 'Reflection', 'People'],
    price: 16.99,
    name: 'Handcrafted Glass Mug',
    description:
      'quia enim sapiente eveniet quia placeat ipsum tempora quam nemo nulla nihil ab deserunt ipsum libero consequatur ut soluta odit unde eaque sit suscipit',
    slug: 'Handcrafted-Glass-Mug',
    added: 1483465875736,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Trees'],
    price: 11.99,
    name: 'Rustic Trees Mug',
    description:
      'ut quibusdam sunt consequuntur voluptatem earum sit ut et quia alias harum quisquam in quo rerum id nisi',
    slug: 'Rustic-Trees-Mug-2',
    added: 1478370537449,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Cross', 'Clouds'],
    price: 9.99,
    name: 'Tasty Cross Mug',
    description:
      'ut eius veritatis deleniti et debitis ea quaerat ad eligendi commodi magni molestiae harum mollitia voluptate ut aliquam alias et iusto',
    slug: 'Tasty-Cross-Mug',
    added: 1479945096616,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 17.99,
    name: 'Unbranded Forest Mug',
    description:
      'expedita quas dolor quis et dolore aspernatur nulla fugit mollitia repudiandae omnis minima est et est sint et quia',
    slug: 'Unbranded-Forest-Mug',
    added: 1481906637729,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Pineapple', 'Summer', 'Fruit'],
    price: 12.99,
    name: 'Small Pineapple Mug',
    description:
      'et quia consectetur assumenda eos quo fugit odit voluptas rem',
    slug: 'Small-Pineapple-Mug',
    added: 1479132387275,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Boat', 'Ocean'],
    price: 20.99,
    name: 'Practical Ocean Mug',
    description:
      'qui recusandae iure dolores debitis blanditiis libero et voluptatem dolorem velit ut error quae',
    slug: 'Practical-Ocean-Mug',
    added: 1480085601078,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Bar', 'Coffee', 'Restaurant'],
    price: 16.99,
    name: 'Unbranded Coffee Mug',
    description: 'eius ad cum doloremque dicta nulla possimus autem earum non',
    slug: 'Unbranded-Coffee-Mug-1',
    added: 1480894614306,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Books', 'Building'],
    price: 9.99,
    name: 'Sleek Building Mug',
    description:
      'consequatur et id voluptatibus tempore et earum at quia magnam alias est dolores quaerat error sint velit',
    slug: 'Sleek-Building-Mug-1',
    added: 1479162028366,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Wood'],
    price: 17.99,
    name: 'Rustic Wood Mug',
    description:
      'aut iste rerum explicabo impedit commodi dignissimos laboriosam ab ut et eius voluptates cumque minus ut corrupti qui et dolorum facere labore sapiente et',
    slug: 'Rustic-Wood-Mug',
    added: 1483871636728,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Abstract'],
    price: 18.99,
    name: 'Rustic Sunset Mug',
    description:
      'doloribus qui alias non nostrum ipsa suscipit consequatur est delectus eos aliquid corrupti omnis quae numquam et aut est a alias dolore enim deserunt',
    slug: 'Rustic-Sunset-Mug',
    added: 1478037693951,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Red', 'Desert', 'Rocks'],
    price: 11.99,
    name: 'Handmade Rocks Mug',
    description:
      'sunt qui impedit autem officiis aut qui dolorem iusto quia vitae ullam odit consequuntur natus voluptas aperiam deleniti rem molestias unde',
    slug: 'Handmade-Rocks-Mug',
    added: 1481565809049,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Brick', 'Building'],
    price: 15.99,
    name: 'Generic Building Mug',
    description:
      'omnis ad aliquam doloremque et quia qui minus dicta veniam voluptas occaecati numquam aut et dolorem recusandae impedit dolorem maiores voluptate sit voluptatum maiores',
    slug: 'Generic-Building-Mug-1',
    added: 1486020952667,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Hand', 'Ocean', 'Underwater', 'Water', 'Surfer'],
    price: 18.99,
    name: 'Sleek Water Mug',
    description:
      'saepe vero ad id est ullam nisi eos aperiam necessitatibus ut et tempora et ad soluta dicta qui voluptatem laboriosam quo est nemo vitae dolorum',
    slug: 'Sleek-Water-Mug',
    added: 1478220854289,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Meadow', 'Fog'],
    price: 11.99,
    name: 'Gorgeous Meadow Mug',
    description:
      'quos est qui et delectus voluptatem ea non consequatur aut explicabo et et sunt rerum itaque possimus laboriosam omnis mollitia cupiditate placeat quo eum iusto',
    slug: 'Gorgeous-Meadow-Mug',
    added: 1477783346452,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Tree', 'Architecture'],
    price: 14.99,
    name: 'Small Tree Mug',
    description:
      'rerum maxime et eum esse accusamus molestiae veniam voluptatem at et qui',
    slug: 'Small-Tree-Mug',
    added: 1484814960005,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Grapes', 'Hands'],
    price: 19.99,
    name: 'Generic Hands Mug',
    description:
      'sint est vel eius ipsa ut deleniti voluptatibus ex laudantium',
    slug: 'Generic-Hands-Mug',
    added: 1484177518326,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Road'],
    price: 17.99,
    name: 'Small Trees Mug',
    description:
      'iure dolore sed cupiditate voluptas officiis corporis est natus et',
    slug: 'Small-Trees-Mug',
    added: 1479823187829,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Car'],
    price: 20.99,
    name: 'Awesome Car Mug',
    description:
      'sunt cum odio ipsum consequatur doloribus sit id itaque tempora fugit velit omnis qui debitis sit officia',
    slug: 'Awesome-Car-Mug',
    added: 1483145266265,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Stars', 'Silhouette'],
    price: 13.99,
    name: 'Tasty Silhouette Mug',
    description:
      'aut nemo harum possimus reiciendis totam sapiente quia quis sit eum voluptatem voluptatibus quod ut ut',
    slug: 'Tasty-Silhouette-Mug',
    added: 1478183971592,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Rain', 'Plants'],
    price: 13.99,
    name: 'Awesome Rain Mug',
    description:
      'reiciendis quam nobis ducimus temporibus ad vel et veritatis laboriosam excepturi',
    slug: 'Awesome-Rain-Mug',
    added: 1479025882062,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Feet', 'People'],
    price: 15.99,
    name: 'Ergonomic Feet Mug',
    description:
      'veritatis ad molestias debitis et vero eaque provident molestiae suscipit',
    slug: 'Ergonomic-Feet-Mug',
    added: 1481613394864,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 13.99,
    name: 'Awesome Architecture Mug',
    description:
      'est et aut veritatis quidem dolorum consequatur harum voluptatem non',
    slug: 'Awesome-Architecture-Mug',
    added: 1479356078615,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Forest'],
    price: 16.99,
    name: 'Sleek Fog Mug',
    description:
      'sit labore animi vel nihil impedit odio saepe nisi ut et vitae deserunt cupiditate beatae ad commodi repellendus quaerat dicta blanditiis deleniti saepe',
    slug: 'Sleek-Fog-Mug',
    added: 1481535183876,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog'],
    price: 16.99,
    name: 'Generic Trees Mug',
    description:
      'aliquid et ut dolores consequatur et sit in adipisci sunt ipsam asperiores quia eligendi totam sed quod rem impedit',
    slug: 'Generic-Trees-Mug',
    added: 1478554203713,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Flora', 'Nature', 'Flower'],
    price: 19.99,
    name: 'Sleek Flora Mug',
    description:
      'voluptatem consequatur quae consequatur repudiandae esse qui eveniet dolores incidunt',
    slug: 'Sleek-Flora-Mug-1',
    added: 1486223866157,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Field', 'Fog'],
    price: 9.99,
    name: 'Fantastic Fog Mug',
    description:
      'eius accusamus non nulla voluptatem vel necessitatibus qui blanditiis est earum ipsa et fugit debitis soluta accusantium iusto nostrum sit',
    slug: 'Fantastic-Fog-Mug-2',
    added: 1484261705613,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Underwater'],
    price: 15.99,
    name: 'Practical Underwater Mug',
    description:
      'dolorem quo vel sed quo fuga atque autem repudiandae nisi et ex optio odio et aut ut voluptatem laudantium iusto et',
    slug: 'Practical-Underwater-Mug',
    added: 1485307798702,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Mountains', 'Road'],
    price: 12.99,
    name: 'Incredible Mountains Mug',
    description:
      'ut qui et dolores molestiae rerum in consequuntur dolore et omnis aliquam nihil ratione libero ullam voluptatem et',
    slug: 'Incredible-Mountains-Mug-1',
    added: 1482345625838,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Book', 'Wood'],
    price: 9.99,
    name: 'Awesome Wood Mug',
    description:
      'tempore perspiciatis quidem autem officia odit aut ea delectus id corporis voluptatum consequatur facilis nihil sit aut cum ea et similique ut corporis ut',
    slug: 'Awesome-Wood-Mug',
    added: 1478145761583,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Night'],
    price: 15.99,
    name: 'Practical Night Mug',
    description:
      'sed architecto id voluptate eligendi et consequatur consequatur quia id minima quidem qui illum modi quo sed tempore ut rem repellendus est laudantium et suscipit',
    slug: 'Practical-Night-Mug-1',
    added: 1484350648323,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 14.99,
    name: 'Sleek Rocks Mug',
    description:
      'sapiente autem nobis error ipsa quisquam accusantium vel adipisci animi sed necessitatibus repellat pariatur quibusdam aliquid et et sint magni perferendis quis nihil',
    slug: 'Sleek-Rocks-Mug',
    added: 1482028183656,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Nature'],
    price: 12.99,
    name: 'Rustic Trees Mug',
    description:
      'ad qui facere provident qui voluptas natus rerum provident voluptatem vel aut possimus est delectus velit culpa occaecati et officiis',
    slug: 'Rustic-Trees-Mug-3',
    added: 1479923921570,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Person', 'Clouds'],
    price: 13.99,
    name: 'Handcrafted Mountain Mug',
    description:
      'commodi officiis aut exercitationem cupiditate veniam sequi molestias repellat totam natus deserunt qui nihil',
    slug: 'Handcrafted-Mountain-Mug',
    added: 1485575166196,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 16.99,
    name: 'Handcrafted Forest Mug',
    description:
      'est voluptatem quia quo accusamus quidem ullam natus suscipit fugit perferendis consequuntur officia',
    slug: 'Handcrafted-Forest-Mug',
    added: 1484402714158,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'Fog', 'Ocean'],
    price: 10.99,
    name: 'Fantastic Fog Mug',
    description:
      'atque deserunt ut deserunt omnis qui optio sed amet qui quia ducimus quod accusantium quis numquam amet',
    slug: 'Fantastic-Fog-Mug-3',
    added: 1483313015293,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Buildings', 'City'],
    price: 11.99,
    name: 'Refined City Mug',
    description:
      'saepe odio aperiam necessitatibus nulla dolore possimus autem odit non',
    slug: 'Refined-City-Mug-1',
    added: 1484039932357,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Lake', 'Wood'],
    price: 20.99,
    name: 'Awesome Lake Mug',
    description:
      'labore quia quam quibusdam amet aspernatur similique similique consequatur suscipit sit et voluptatem optio quis et natus impedit hic et cum sequi at',
    slug: 'Awesome-Lake-Mug',
    added: 1480512317413,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Fire', 'Girl', 'People'],
    price: 18.99,
    name: 'Awesome People Mug',
    description:
      'fuga quo ullam cupiditate ducimus ex magni aut minus aut amet debitis qui quasi iure enim ad ea modi placeat suscipit aliquam',
    slug: 'Awesome-People-Mug-1',
    added: 1483352761970,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Sails', 'Boat'],
    price: 19.99,
    name: 'Rustic Sails Mug',
    description:
      'eaque qui quia nesciunt ut iure blanditiis similique non molestias voluptatum et expedita consectetur accusantium cum et ut vel eum quam consequuntur laborum eum',
    slug: 'Rustic-Sails-Mug',
    added: 1481814563903,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Plane', 'City'],
    price: 19.99,
    name: 'Generic City Mug',
    description:
      'sint consequatur odio id aut eligendi sint rerum architecto omnis id ut sunt magni est iste quo',
    slug: 'Generic-City-Mug',
    added: 1482716675395,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 17.99,
    name: 'Sleek Rocks Mug',
    description:
      'id voluptatem dolor sint deserunt id debitis consequatur praesentium est ratione eum voluptates voluptas sed rem eius ipsam cum reiciendis',
    slug: 'Sleek-Rocks-Mug-1',
    added: 1483540497449,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 10.99,
    name: 'Fantastic Water Mug',
    description:
      'et qui quis accusantium suscipit provident ut tempore blanditiis cupiditate repellat repellendus sequi culpa unde delectus aperiam aperiam fugit libero sapiente est nihil expedita',
    slug: 'Fantastic-Water-Mug',
    added: 1480531975810,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Concert', 'Band', 'People'],
    price: 12.99,
    name: 'Intelligent Band Mug',
    description:
      'neque ipsa modi soluta voluptas architecto autem ad et vel necessitatibus sed recusandae et quasi amet',
    slug: 'Intelligent-Band-Mug',
    added: 1479260858615,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Sand'],
    price: 13.99,
    name: 'Licensed Beach Mug',
    description:
      'architecto ab sit omnis at asperiores eveniet nisi et veritatis dolorem totam voluptatem ipsum asperiores consectetur accusamus id autem perspiciatis est',
    slug: 'Licensed-Beach-Mug',
    added: 1484297792760,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Bicycle'],
    price: 20.99,
    name: 'Practical Architecture Mug',
    description:
      'occaecati dolor ut minus nostrum aut itaque aperiam doloribus harum adipisci voluptatum',
    slug: 'Practical-Architecture-Mug-1',
    added: 1483595482711,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Buildings', 'City'],
    price: 12.99,
    name: 'Refined Buildings Mug',
    description:
      'non quia temporibus aut laudantium praesentium velit enim ea similique recusandae recusandae unde possimus et accusantium maxime voluptatum consequatur debitis ex',
    slug: 'Refined-Buildings-Mug-1',
    added: 1484882072184,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'City', 'Feet'],
    price: 16.99,
    name: 'Rustic City Mug',
    description:
      'veritatis inventore magnam reprehenderit voluptatibus voluptatem consequatur laboriosam voluptatem quos iste suscipit sunt doloremque sit mollitia numquam quae facere quaerat',
    slug: 'Rustic-City-Mug-2',
    added: 1481501846616,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Animal'],
    price: 15.99,
    name: 'Sleek Animal Mug',
    description:
      'quia sed iusto velit impedit voluptatem commodi sit error cumque voluptatem asperiores ex deleniti ut modi vitae nam ipsum vitae distinctio quos ut eius dolorem',
    slug: 'Sleek-Animal-Mug',
    added: 1484542352808,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 13.99,
    name: 'Incredible Mountains Mug',
    description:
      'quia officiis rerum modi ut id voluptas sed ipsam quo eum amet',
    slug: 'Incredible-Mountains-Mug-2',
    added: 1479245725800,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Tree', 'Forest'],
    price: 10.99,
    name: 'Fantastic Tree Mug',
    description:
      'magnam esse molestias totam eius eos mollitia totam reiciendis ut voluptatem et ut reprehenderit hic',
    slug: 'Fantastic-Tree-Mug',
    added: 1479077122872,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['People'],
    price: 10.99,
    name: 'Generic People Mug',
    description:
      'necessitatibus tempore delectus et expedita qui ea fugiat dolorum rerum sapiente non aspernatur voluptas illum nostrum culpa et',
    slug: 'Generic-People-Mug-1',
    added: 1480828044666,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Ocean', 'Rocks'],
    price: 14.99,
    name: 'Tasty Sunset Mug',
    description:
      'nam et sequi possimus nemo nesciunt deleniti reprehenderit quas vitae unde quidem non impedit temporibus ut magnam ipsam',
    slug: 'Tasty-Sunset-Mug',
    added: 1484768085171,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Shoes', 'Person', 'Sidewalk'],
    price: 15.99,
    name: 'Tasty Shoes Mug',
    description:
      'aut esse aliquid aut alias nam est laborum et vero voluptates optio ullam minima nihil voluptatem aperiam fugit aspernatur pariatur a',
    slug: 'Tasty-Shoes-Mug',
    added: 1480637737524,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Metal', 'Bridge'],
    price: 9.99,
    name: 'Handmade Bridge Mug',
    description:
      'sed illo asperiores error minus dicta cum ex atque quidem doloremque voluptatum nemo',
    slug: 'Handmade-Bridge-Mug',
    added: 1478071592671,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Child', 'City', 'People'],
    price: 10.99,
    name: 'Handcrafted City Mug',
    description:
      'esse et quidem saepe praesentium ad officia ipsa ab ut sunt quaerat dignissimos',
    slug: 'Handcrafted-City-Mug-3',
    added: 1484757526317,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'Umbrella', 'People'],
    price: 12.99,
    name: 'Refined Umbrella Mug',
    description:
      'quis et nihil non quia ad pariatur ut officia sed sunt ex ut dolorem rem eum ducimus est excepturi iusto officia voluptatem',
    slug: 'Refined-Umbrella-Mug',
    added: 1480266876769,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Forest'],
    price: 17.99,
    name: 'Incredible Fog Mug',
    description:
      'cum molestiae nesciunt officia autem et autem dicta sint deserunt recusandae iusto quas eaque',
    slug: 'Incredible-Fog-Mug',
    added: 1485956120726,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Bike', 'People'],
    price: 12.99,
    name: 'Small Bike Mug',
    description:
      'mollitia adipisci maxime eligendi possimus inventore delectus nesciunt maxime aliquam similique mollitia voluptatem voluptatem optio dolor aut',
    slug: 'Small-Bike-Mug',
    added: 1478233924485,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Door', 'Building'],
    price: 16.99,
    name: 'Rustic Door Mug',
    description:
      'rem magni quos quasi doloremque delectus consectetur et aut vero doloremque non dolore',
    slug: 'Rustic-Door-Mug',
    added: 1480643203926,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 17.99,
    name: 'Intelligent Beach Mug',
    description:
      'praesentium qui harum ut labore aspernatur voluptas omnis et totam iste vitae quis',
    slug: 'Intelligent-Beach-Mug',
    added: 1478050476249,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Rain'],
    price: 11.99,
    name: 'Unbranded Rain Mug',
    description:
      'eum deleniti et similique facere esse ea consequatur repellat exercitationem vero',
    slug: 'Unbranded-Rain-Mug',
    added: 1483137749817,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Subway', 'Station'],
    price: 9.99,
    name: 'Rustic Person Mug',
    description:
      'ut rerum eaque excepturi iure enim sint blanditiis quo ipsum ut ratione sapiente dolorum voluptatem est aperiam et aliquam et hic dolores rerum voluptatem',
    slug: 'Rustic-Person-Mug-1',
    added: 1477965860706,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains', 'Lake'],
    price: 10.99,
    name: 'Rustic Snow Mug',
    description:
      'sed et aspernatur et aut nemo nostrum sint quo omnis quisquam natus rerum molestiae dolores nihil doloremque quisquam veniam',
    slug: 'Rustic-Snow-Mug',
    added: 1484656530100,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'Fireworks'],
    price: 12.99,
    name: 'Handmade Fireworks Mug',
    description:
      'dicta esse ipsam sit ut aspernatur in et autem numquam pariatur modi vitae cum maxime',
    slug: 'Handmade-Fireworks-Mug',
    added: 1485207393229,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Blueprint', 'Desk'],
    price: 13.99,
    name: 'Ergonomic Desk Mug',
    description:
      'et explicabo quos velit deleniti labore qui quidem explicabo sed consequatur recusandae recusandae',
    slug: 'Ergonomic-Desk-Mug',
    added: 1481414435991,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Glass', 'Building'],
    price: 20.99,
    name: 'Gorgeous Building Mug',
    description:
      'minus voluptatem necessitatibus veritatis vel praesentium iure soluta et recusandae eum aspernatur est',
    slug: 'Gorgeous-Building-Mug-1',
    added: 1478441163892,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Trees'],
    price: 12.99,
    name: 'Tasty River Mug',
    description:
      'corporis ut qui provident dolor illo vero quis suscipit exercitationem excepturi',
    slug: 'Tasty-River-Mug',
    added: 1480648104539,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings', 'Sun'],
    price: 20.99,
    name: 'Ergonomic Buildings Mug',
    description:
      'voluptatem aut velit magnam sint magnam molestiae aut quisquam dolor voluptas eaque minima ipsam sit dolor voluptatem aut autem',
    slug: 'Ergonomic-Buildings-Mug-1',
    added: 1483733684957,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Subway'],
    price: 11.99,
    name: 'Practical Subway Mug',
    description:
      'ratione et numquam natus quia incidunt quam labore deserunt est quaerat nisi aspernatur dolores labore eius et molestias alias',
    slug: 'Practical-Subway-Mug',
    added: 1478146128170,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Boats', 'Ocean'],
    price: 11.99,
    name: 'Sleek Ocean Mug',
    description:
      'quibusdam et omnis exercitationem et autem suscipit assumenda natus laudantium vero magnam consequatur omnis perferendis suscipit facilis repellat cupiditate odio sint',
    slug: 'Sleek-Ocean-Mug-1',
    added: 1485564144007,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Laptop'],
    price: 17.99,
    name: 'Awesome Laptop Mug',
    description:
      'amet enim dolor aut deserunt aliquid qui vitae facilis sapiente accusantium et id eum architecto placeat sit quia adipisci dolorem voluptas deleniti rem distinctio',
    slug: 'Awesome-Laptop-Mug',
    added: 1483690368784,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Boat', 'Lake'],
    price: 13.99,
    name: 'Sleek Lake Mug',
    description:
      'est qui sit pariatur dolores est et et repellat dolores velit quis quaerat dicta et excepturi eum distinctio et occaecati possimus',
    slug: 'Sleek-Lake-Mug',
    added: 1483225390549,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Trees', 'Nature', 'Fog'],
    price: 19.99,
    name: 'Handcrafted Trees Mug',
    description:
      'corrupti quod rerum dolore quia labore veniam tenetur et dicta quo rerum quam nihil ratione facilis quibusdam assumenda excepturi dicta perferendis id nam eum et',
    slug: 'Handcrafted-Trees-Mug-1',
    added: 1481367876417,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Mountains', 'Lake'],
    price: 19.99,
    name: 'Practical Mountains Mug',
    description:
      'commodi vitae commodi adipisci eaque in necessitatibus itaque ad aut est asperiores quaerat modi',
    slug: 'Practical-Mountains-Mug',
    added: 1479105995072,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 13.99,
    name: 'Awesome Snow Mug',
    description:
      'culpa dolor eaque expedita facere et est quia quam repudiandae qui quaerat sit incidunt praesentium optio aut ducimus laborum qui at qui nihil dignissimos sunt',
    slug: 'Awesome-Snow-Mug',
    added: 1483729497248,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Pier'],
    price: 9.99,
    name: 'Small Pier Mug',
    description:
      'debitis beatae ut et officia aut molestiae voluptatum aut molestias non est nulla voluptate eaque dolorum id magni sapiente et amet quibusdam quia iusto quidem',
    slug: 'Small-Pier-Mug',
    added: 1478860447423,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Plants'],
    price: 15.99,
    name: 'Small Plants Mug',
    description:
      'occaecati beatae sequi voluptatem saepe dolore enim voluptatem enim reprehenderit suscipit autem autem molestiae et impedit rem doloribus',
    slug: 'Small-Plants-Mug',
    added: 1484803842274,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Forest', 'Road'],
    price: 20.99,
    name: 'Refined Forest Mug',
    description:
      'sed mollitia quisquam commodi numquam ut ipsum optio aut eum explicabo voluptatem voluptas sint impedit sed sit voluptatem rerum ad magnam labore',
    slug: 'Refined-Forest-Mug',
    added: 1485944364484,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Trees', 'Forest'],
    price: 10.99,
    name: 'Handmade Trees Mug',
    description:
      'velit et quia et et aut at doloribus minus amet ipsa dolor possimus enim ullam at ex sunt quod magnam eius voluptates',
    slug: 'Handmade-Trees-Mug-1',
    added: 1485688924224,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Dock'],
    price: 16.99,
    name: 'Practical Ocean Mug',
    description:
      'porro dolorem vel fuga quia voluptatum reprehenderit rerum non porro et voluptatem totam distinctio voluptate aut id est quam velit',
    slug: 'Practical-Ocean-Mug-1',
    added: 1485106525511,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Boat', 'Ocean'],
    price: 19.99,
    name: 'Incredible Boat Mug',
    description:
      'reiciendis alias quas quisquam consequatur nihil aut sed ipsa sequi soluta possimus distinctio accusamus ipsum et adipisci quis sint temporibus sequi animi amet blanditiis ipsa',
    slug: 'Incredible-Boat-Mug',
    added: 1484099963480,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Space', 'NASA'],
    price: 14.99,
    name: 'Sleek NASA Mug',
    description:
      'aliquid fuga est natus qui ipsam nihil omnis culpa tempore architecto voluptates possimus rerum et necessitatibus aliquam sit explicabo quia consequatur facilis',
    slug: 'Sleek-NASA-Mug',
    added: 1483319721968,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Nature', 'Mountains'],
    price: 12.99,
    name: 'Incredible Mountains Mug',
    description:
      'perspiciatis voluptatem autem sit pariatur voluptas et dolores soluta sapiente est eius consequatur',
    slug: 'Incredible-Mountains-Mug-3',
    added: 1478797273057,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Snow'],
    price: 11.99,
    name: 'Handcrafted Mountain Mug',
    description:
      'aperiam rerum enim architecto cumque quaerat quaerat ipsam qui dicta ea illo consequatur autem',
    slug: 'Handcrafted-Mountain-Mug-1',
    added: 1485164210778,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Flags', 'Fog', 'Mountains', 'Water'],
    price: 19.99,
    name: 'Handmade Mountains Mug',
    description:
      'molestias porro mollitia aut ducimus sed quia possimus qui maiores blanditiis ipsam sint officiis assumenda quos qui natus itaque tenetur qui ducimus impedit dolor et',
    slug: 'Handmade-Mountains-Mug-1',
    added: 1484494909017,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Forest'],
    price: 20.99,
    name: 'Intelligent Fog Mug',
    description:
      'quia quam rerum vel accusantium quasi voluptatem facilis inventore iure aut minima sapiente rerum est harum voluptatem dolorum et id est velit molestiae qui',
    slug: 'Intelligent-Fog-Mug-2',
    added: 1484919520185,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Book'],
    price: 16.99,
    name: 'Fantastic Book Mug',
    description:
      'aliquam non alias ea nihil animi laborum atque atque amet a excepturi recusandae quia',
    slug: 'Fantastic-Book-Mug',
    added: 1481591291687,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest', 'Road'],
    price: 11.99,
    name: 'Rustic Road Mug',
    description:
      'quia quasi voluptas nihil animi officiis recusandae vitae quaerat voluptatum quos itaque maiores sequi modi nemo et voluptate ipsa voluptatem iure sequi nam pariatur',
    slug: 'Rustic-Road-Mug-1',
    added: 1485118545385,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Mountains'],
    price: 20.99,
    name: 'Intelligent Mountains Mug',
    description:
      'sint quam doloremque officia deserunt ex nemo omnis aut voluptas',
    slug: 'Intelligent-Mountains-Mug',
    added: 1482918886605,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Machine', 'Classic', 'Car'],
    price: 15.99,
    name: 'Licensed Classic Mug',
    description:
      'quod reiciendis recusandae ut soluta natus assumenda velit nam voluptatem accusantium quaerat et possimus sapiente fugiat culpa eius id explicabo nihil vel facilis rerum',
    slug: 'Licensed-Classic-Mug-1',
    added: 1483599264774,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees', 'Mountains'],
    price: 14.99,
    name: 'Refined Snow Mug',
    description:
      'labore vero et qui facere quidem necessitatibus id occaecati deserunt quo consequatur ea',
    slug: 'Refined-Snow-Mug-1',
    added: 1486030021145,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Coffee', 'Food'],
    price: 10.99,
    name: 'Handcrafted Food Mug',
    description:
      'voluptatem alias odit eius officia voluptas quae eaque ut non itaque nemo dolore pariatur rerum nihil sit qui suscipit sint qui neque aut a',
    slug: 'Handcrafted-Food-Mug',
    added: 1479733091947,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Jellyfish', 'Ocean'],
    price: 12.99,
    name: 'Practical Ocean Mug',
    description:
      'odio qui nesciunt rerum vel animi non laboriosam quia illum numquam',
    slug: 'Practical-Ocean-Mug-2',
    added: 1484811636614,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Buildings', 'City'],
    price: 11.99,
    name: 'Unbranded Buildings Mug',
    description:
      'accusantium cumque occaecati et saepe a sit omnis vel rem soluta quibusdam quis numquam consectetur',
    slug: 'Unbranded-Buildings-Mug',
    added: 1484293514335,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 10.99,
    name: 'Licensed Building Mug',
    description:
      'sunt eveniet sapiente ut ut provident voluptatem illum architecto quae pariatur occaecati est labore quia nihil unde corrupti',
    slug: 'Licensed-Building-Mug-1',
    added: 1479748814774,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Dog', 'Animal'],
    price: 11.99,
    name: 'Handmade Animal Mug',
    description:
      'asperiores sit eum laborum et ea ratione et molestiae aliquam vero magni a id voluptatem nihil quidem dolor placeat sed enim rerum ut consequuntur ut',
    slug: 'Handmade-Animal-Mug',
    added: 1480404540012,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings'],
    price: 9.99,
    name: 'Handcrafted Buildings Mug',
    description:
      'possimus et aspernatur ipsam commodi rem voluptas veritatis rerum accusantium qui accusantium laboriosam ad velit',
    slug: 'Handcrafted-Buildings-Mug',
    added: 1482404631916,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'People', 'Moutains'],
    price: 20.99,
    name: 'Gorgeous Moutains Mug',
    description:
      'itaque sint vitae occaecati magnam sit rerum vel mollitia est blanditiis voluptatem molestiae',
    slug: 'Gorgeous-Moutains-Mug',
    added: 1477980611343,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Fields', 'People'],
    price: 11.99,
    name: 'Intelligent Fields Mug',
    description:
      'ipsa qui fugiat et sint ea cupiditate quo eum velit magnam perferendis minus repellat quia iusto',
    slug: 'Intelligent-Fields-Mug',
    added: 1485078557991,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Desert', 'Plants'],
    price: 9.99,
    name: 'Tasty Desert Mug',
    description:
      'delectus nostrum molestias eum delectus autem qui deserunt magni blanditiis omnis sit voluptates necessitatibus ducimus qui',
    slug: 'Tasty-Desert-Mug',
    added: 1480227811728,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Road'],
    price: 19.99,
    name: 'Handcrafted Fog Mug',
    description:
      'laudantium expedita cupiditate voluptatibus et maiores nihil sed voluptatem rerum aut sapiente distinctio reprehenderit odio est qui doloribus corrupti quia qui veritatis ut est reiciendis',
    slug: 'Handcrafted-Fog-Mug-1',
    added: 1480950684475,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Hands', 'Woman', 'Fireworks'],
    price: 11.99,
    name: 'Awesome Person Mug',
    description:
      'fuga perspiciatis est voluptatem sed quia dolor et quia error animi nesciunt est fuga quibusdam quas qui architecto',
    slug: 'Awesome-Person-Mug-1',
    added: 1479293228632,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 18.99,
    name: 'Tasty Ocean Mug',
    description:
      'voluptas esse quisquam omnis perferendis consequatur nesciunt molestiae consequatur quidem quod nostrum quam sequi et iste voluptatum voluptatum voluptatem reiciendis',
    slug: 'Tasty-Ocean-Mug-2',
    added: 1478997949966,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Palm trees'],
    price: 12.99,
    name: 'Sleek Palm Trees Mug',
    description:
      'quisquam consequuntur incidunt aperiam praesentium placeat voluptatem ut atque repellendus provident ut commodi dicta consequatur explicabo accusantium distinctio',
    slug: 'Sleek-Palm-Trees-Mug',
    added: 1483135059731,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Boat', 'Ocean', 'Clouds'],
    price: 12.99,
    name: 'Handcrafted Clouds Mug',
    description:
      'dolorem est iste veniam omnis quaerat assumenda accusamus quo quasi esse eveniet id qui quia molestiae atque odit nihil delectus voluptatem dolores sequi necessitatibus et',
    slug: 'Handcrafted-Clouds-Mug',
    added: 1481688347601,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Dog', 'View', 'Person'],
    price: 9.99,
    name: 'Refined Person Mug',
    description:
      'et tempore magnam voluptate pariatur quo numquam sit debitis aliquid recusandae tempore occaecati veritatis neque repellat',
    slug: 'Refined-Person-Mug',
    added: 1483966867688,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Antique', 'Camera'],
    price: 12.99,
    name: 'Generic Camera Mug',
    description:
      'facilis ut dignissimos voluptatibus officiis non nulla sed velit reiciendis incidunt ut sunt repudiandae ut',
    slug: 'Generic-Camera-Mug',
    added: 1481528882043,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Freeway', 'Cars'],
    price: 19.99,
    name: 'Gorgeous Freeway Mug',
    description:
      'voluptatem vero possimus adipisci occaecati quia cum atque eaque et ea soluta voluptatem ipsum non',
    slug: 'Gorgeous-Freeway-Mug',
    added: 1481378863780,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Field', 'Overcast', 'Farm'],
    price: 19.99,
    name: 'Intelligent Farm Mug',
    description:
      'quasi sit aliquam qui possimus animi ullam et inventore et voluptas consectetur aut veritatis aut molestiae',
    slug: 'Intelligent-Farm-Mug',
    added: 1485011627896,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'Boat', 'City', 'Water'],
    price: 15.99,
    name: 'Intelligent Water Mug',
    description:
      'animi reprehenderit et dolores officia aut assumenda aut officia ut temporibus natus repudiandae assumenda delectus quis sed ratione consequuntur sed repellendus nisi omnis et et',
    slug: 'Intelligent-Water-Mug',
    added: 1478589867002,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Fall', 'Trees', 'Forest'],
    price: 12.99,
    name: 'Gorgeous Trees Mug',
    description:
      'quia et voluptatum eos dolores fuga nihil repudiandae iure pariatur nihil aut magni dolores pariatur quam laborum soluta aliquid',
    slug: 'Gorgeous-Trees-Mug-1',
    added: 1483604301718,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Plants', 'Succulents'],
    price: 9.99,
    name: 'Sleek Plants Mug',
    description:
      'ut sit occaecati quod labore culpa atque est ab at cum aut tempore in qui iusto sit quia ad officiis reprehenderit quisquam',
    slug: 'Sleek-Plants-Mug',
    added: 1478869606325,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 11.99,
    name: 'Practical Ocean Mug',
    description:
      'similique quidem et iusto est nobis magni facere laborum odit iure',
    slug: 'Practical-Ocean-Mug-3',
    added: 1482829588521,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Ocean', 'Rocks'],
    price: 11.99,
    name: 'Small Rocks Mug',
    description:
      'quia similique ut amet odit accusamus iste numquam ea cumque officia aut sapiente nihil est saepe architecto numquam fuga et ut sit omnis consequuntur',
    slug: 'Small-Rocks-Mug',
    added: 1480585232526,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Hiking', 'Moutains'],
    price: 19.99,
    name: 'Small Hiking Mug',
    description:
      'soluta assumenda tempore ut vel quos neque aut fuga cumque est quis similique qui sed tenetur accusamus quam',
    slug: 'Small-Hiking-Mug',
    added: 1479245590568,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Flora', 'Flowers'],
    price: 20.99,
    name: 'Rustic Flora Mug',
    description:
      'harum porro est qui earum cupiditate cumque recusandae eos aut omnis laudantium quasi rerum tempora et maiores molestiae dolorem voluptas',
    slug: 'Rustic-Flora-Mug',
    added: 1480298453069,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Building', 'City'],
    price: 18.99,
    name: 'Rustic Sky Mug',
    description:
      'non non repellat aspernatur impedit minus repellendus in et fuga cumque vel voluptatum amet iusto maxime quaerat aut consequatur et',
    slug: 'Rustic-Sky-Mug',
    added: 1481958002685,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Hot air balloon', 'Lake'],
    price: 19.99,
    name: 'Licensed Lake Mug',
    description:
      'asperiores quod nesciunt nam soluta mollitia repellendus quasi dolorem facere qui vel eos et qui a est',
    slug: 'Licensed-Lake-Mug',
    added: 1486340885590,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Ocean', 'Bird', 'Dock', 'Sunset'],
    price: 20.99,
    name: 'Tasty Dock Mug',
    description:
      'omnis voluptas sit et id nam ipsam odio nisi ut reprehenderit dolor alias',
    slug: 'Tasty-Dock-Mug',
    added: 1482980642273,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Bible', 'Person', 'Reading', 'Kid', 'Religion'],
    price: 20.99,
    name: 'Refined Bible Mug',
    description:
      'sequi qui qui esse et odio dignissimos voluptate doloremque et vitae eius aliquid non dolore officia iusto eum',
    slug: 'Refined-Bible-Mug',
    added: 1483193580728,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'Fog', 'Ocean'],
    price: 10.99,
    name: 'Refined Bridge Mug',
    description:
      'dolor tempore esse autem delectus perspiciatis mollitia adipisci natus exercitationem eum aut',
    slug: 'Refined-Bridge-Mug',
    added: 1483371936776,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Beach', 'Ocean', 'Rocks'],
    price: 20.99,
    name: 'Handcrafted Arial Mug',
    description:
      'totam blanditiis atque tempore ipsam aut voluptatem neque suscipit deserunt quod vitae blanditiis illo porro similique accusamus reprehenderit numquam ad reiciendis sit',
    slug: 'Handcrafted-Arial-Mug-2',
    added: 1483663827610,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Lion'],
    price: 15.99,
    name: 'Sleek Lion Mug',
    description:
      'quod ipsa odio laudantium quia odit rerum et quas quia autem unde ut hic deserunt reprehenderit quis quos reiciendis dolorem rerum quia porro in',
    slug: 'Sleek-Lion-Mug',
    added: 1482177486939,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'Trees', 'Forest'],
    price: 9.99,
    name: 'Sleek Bridge Mug',
    description:
      'voluptate consequatur quo dolores sapiente quisquam debitis dolorum quis dolorum esse quo optio temporibus numquam repellendus',
    slug: 'Sleek-Bridge-Mug',
    added: 1480826845828,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Hands', 'City', 'Camera'],
    price: 11.99,
    name: 'Fantastic Person Mug',
    description:
      'et quis ipsam totam nam sit impedit voluptas qui reiciendis ducimus voluptas vel quo cumque veniam enim cupiditate et voluptatum qui sit quidem eum',
    slug: 'Fantastic-Person-Mug',
    added: 1478561454777,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Ice shelf', 'Cold', 'Fog', 'Ocean'],
    price: 13.99,
    name: 'Practical Fog Mug',
    description:
      'asperiores nihil aut magnam perferendis tenetur consequuntur id eum asperiores officia',
    slug: 'Practical-Fog-Mug',
    added: 1485345434823,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Snow', 'Sky', 'Forest'],
    price: 14.99,
    name: 'Handcrafted Snow Mug',
    description:
      'natus necessitatibus odio laborum tenetur deleniti repellendus odit aperiam corrupti delectus',
    slug: 'Handcrafted-Snow-Mug-2',
    added: 1481817229360,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Metal', 'Bridge'],
    price: 15.99,
    name: 'Sleek Metal Mug',
    description:
      'odio aut velit architecto est quia debitis mollitia quo omnis officiis accusamus',
    slug: 'Sleek-Metal-Mug',
    added: 1483874747301,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Sky', 'Silhouette'],
    price: 12.99,
    name: 'Fantastic Sunset Mug',
    description:
      'quia autem reiciendis quas qui quibusdam sunt nulla porro omnis voluptate rerum voluptatem ullam dicta exercitationem earum nobis voluptatem',
    slug: 'Fantastic-Sunset-Mug-3',
    added: 1483724032086,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Fire', 'Camping', 'Wood'],
    price: 13.99,
    name: 'Small Fire Mug',
    description:
      'in illum consequuntur qui dolorum autem suscipit velit laborum est nesciunt quam soluta dolores quia autem quos sit culpa optio voluptas ex molestiae',
    slug: 'Small-Fire-Mug',
    added: 1483070948505,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Waterfall', 'Nature'],
    price: 20.99,
    name: 'Rustic Waterfall Mug',
    description:
      'ratione qui voluptas quae ut corrupti voluptatibus commodi laborum qui a porro ut voluptatem numquam consequatur quis dolores pariatur nesciunt dicta mollitia et',
    slug: 'Rustic-Waterfall-Mug',
    added: 1483009487420,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Rock', 'Ocean'],
    price: 10.99,
    name: 'Small Ocean Mug',
    description:
      'dignissimos commodi est pariatur aspernatur qui unde excepturi et voluptas odit est natus',
    slug: 'Small-Ocean-Mug',
    added: 1484582981226,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Rock', 'Horizon', 'Ocean'],
    price: 16.99,
    name: 'Practical Horizon Mug',
    description:
      'repellat ipsa non et occaecati nemo qui voluptas fuga numquam soluta facere exercitationem dolore dolores ratione distinctio laboriosam deserunt commodi cupiditate reiciendis repellendus atque',
    slug: 'Practical-Horizon-Mug',
    added: 1477973947354,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Mountains'],
    price: 17.99,
    name: 'Licensed Mountains Mug',
    description:
      'placeat sint et rerum ab sint perspiciatis nemo quia tempore earum occaecati ipsam autem perferendis cumque tempora mollitia non',
    slug: 'Licensed-Mountains-Mug-2',
    added: 1486010292571,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings'],
    price: 16.99,
    name: 'Rustic Buildings Mug',
    description:
      'doloremque occaecati consequuntur quos ut occaecati dolorem ea corrupti odio dolor',
    slug: 'Rustic-Buildings-Mug',
    added: 1480171026024,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Wave', 'Ocean', 'Water'],
    price: 13.99,
    name: 'Sleek Water Mug',
    description:
      'recusandae reprehenderit perspiciatis aut commodi et rem et exercitationem aut',
    slug: 'Sleek-Water-Mug-1',
    added: 1482383952707,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Sand', 'Desert'],
    price: 11.99,
    name: 'Gorgeous Sand Mug',
    description:
      'tempore minima placeat et et alias nulla tempora harum rerum dolorum culpa molestiae nam accusamus dolorem voluptatem temporibus quis',
    slug: 'Gorgeous-Sand-Mug',
    added: 1486329988363,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Cars'],
    price: 18.99,
    name: 'Intelligent Cars Mug',
    description:
      'qui dolore ipsam suscipit illo minus quas eveniet non natus ex dolore praesentium distinctio excepturi est est sunt',
    slug: 'Intelligent-Cars-Mug',
    added: 1485301929864,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Rainbow', 'City', 'Buildings'],
    price: 11.99,
    name: 'Awesome Buildings Mug',
    description:
      'architecto corrupti ab hic suscipit incidunt dolor animi inventore et suscipit fugiat provident aliquam quidem',
    slug: 'Awesome-Buildings-Mug',
    added: 1480492882021,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Grass', 'Plant'],
    price: 14.99,
    name: 'Unbranded Plant Mug',
    description:
      'sed aut vel non non sed culpa quia consequatur quo est et magni quod excepturi',
    slug: 'Unbranded-Plant-Mug',
    added: 1480495837974,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 19.99,
    name: 'Ergonomic Architecture Mug',
    description:
      'commodi autem quia ipsum et alias distinctio incidunt consequatur incidunt saepe consequatur non a ea velit mollitia soluta quas quia fugit qui praesentium aliquam',
    slug: 'Ergonomic-Architecture-Mug-1',
    added: 1480955377374,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Leaves', 'Trees'],
    price: 17.99,
    name: 'Practical Trees Mug',
    description:
      'in alias sint perferendis et cupiditate id maiores aperiam vel dolore nisi expedita et totam iure ut error dignissimos',
    slug: 'Practical-Trees-Mug-1',
    added: 1483943371272,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Cameras', 'Antique'],
    price: 15.99,
    name: 'Generic Cameras Mug',
    description:
      'sint magnam laboriosam dicta possimus facere exercitationem qui enim officiis culpa quo cumque',
    slug: 'Generic-Cameras-Mug',
    added: 1484348265274,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Stars', 'Silhouette'],
    price: 11.99,
    name: 'Rustic Silhouette Mug',
    description:
      'debitis vero dolorem laudantium vel sed repudiandae porro ab rem autem temporibus',
    slug: 'Rustic-Silhouette-Mug',
    added: 1480354965341,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Bridge', 'Beach', 'Ocean'],
    price: 15.99,
    name: 'Gorgeous Bridge Mug',
    description:
      'sit numquam harum rerum ut alias facere asperiores odit voluptatibus odit sapiente minus voluptatem',
    slug: 'Gorgeous-Bridge-Mug',
    added: 1479328689085,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Mountains'],
    price: 14.99,
    name: 'Small Trees Mug',
    description:
      'natus tenetur nobis omnis odio nihil molestiae quia est quo vero inventore ut magnam eaque reiciendis quo repudiandae',
    slug: 'Small-Trees-Mug-1',
    added: 1478935011387,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Sunrise', 'Mountains'],
    price: 11.99,
    name: 'Fantastic Mountains Mug',
    description:
      'quam nihil quae alias labore dolor dolor et ab mollitia nostrum rerum qui et in magnam',
    slug: 'Fantastic-Mountains-Mug',
    added: 1482795840499,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Highway', 'Road', 'Car'],
    price: 20.99,
    name: 'Sleek Road Mug',
    description:
      'iusto ut molestiae et doloremque eligendi soluta voluptates impedit magni a saepe laudantium aut',
    slug: 'Sleek-Road-Mug',
    added: 1485575128535,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Mountains', 'Lake'],
    price: 16.99,
    name: 'Small Lake Mug',
    description:
      'iusto quibusdam doloribus sed autem at officiis ipsam voluptate aliquam voluptatem eligendi',
    slug: 'Small-Lake-Mug-2',
    added: 1485413289140,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 16.99,
    name: 'Gorgeous Beach Mug',
    description:
      'neque id asperiores nulla quae est expedita inventore et dolorem unde corrupti adipisci veritatis ea eius enim',
    slug: 'Gorgeous-Beach-Mug',
    added: 1481550970478,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Person', 'Water'],
    price: 11.99,
    name: 'Gorgeous Person Mug',
    description:
      'et explicabo adipisci dolorem vero id cum sed at dicta voluptatem sit reiciendis quod explicabo voluptas ut voluptatibus quasi',
    slug: 'Gorgeous-Person-Mug',
    added: 1478231020714,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'City'],
    price: 9.99,
    name: 'Intelligent Night Mug',
    description:
      'corporis ea quibusdam delectus itaque velit voluptatem vitae alias harum ab sit aut sequi doloremque non quae illum iure voluptas quis eum voluptas est consectetur',
    slug: 'Intelligent-Night-Mug',
    added: 1481713086527,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Boat', 'Ocean'],
    price: 15.99,
    name: 'Gorgeous Snow Mug',
    description:
      'nesciunt delectus ipsum ut quas dolorum aliquam numquam quia corrupti in dolores maiores aspernatur eligendi neque porro vero fugit in eaque nostrum neque placeat libero',
    slug: 'Gorgeous-Snow-Mug',
    added: 1478240164717,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Sunset'],
    price: 15.99,
    name: 'Intelligent Sunset Mug',
    description:
      'maiores veritatis vel laborum soluta facilis ut hic autem dolores minima sunt explicabo odit corrupti repellat cum ea molestiae est aspernatur ullam fuga perferendis',
    slug: 'Intelligent-Sunset-Mug-1',
    added: 1481719394245,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Surfboard', 'Person', 'Fog'],
    price: 10.99,
    name: 'Awesome Fog Mug',
    description:
      'dolor earum eum qui at animi blanditiis iusto quidem aliquid rerum qui ipsa et quam ipsum',
    slug: 'Awesome-Fog-Mug-4',
    added: 1482039147425,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Pier', 'People'],
    price: 11.99,
    name: 'Fantastic Pier Mug',
    description:
      'sint nam rem quis error minus laudantium dolores exercitationem voluptatem eius ut quo exercitationem officiis architecto et dolorem placeat voluptatem temporibus',
    slug: 'Fantastic-Pier-Mug',
    added: 1485238856180,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Desert'],
    price: 15.99,
    name: 'Rustic Desert Mug',
    description:
      'labore voluptatum recusandae nulla reiciendis ab illo aut qui ea vitae quas officiis omnis laudantium beatae qui molestias voluptatem sed explicabo quo fuga velit aspernatur',
    slug: 'Rustic-Desert-Mug-1',
    added: 1481526024075,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Dog', 'Person', 'Man'],
    price: 17.99,
    name: 'Rustic Man Mug',
    description:
      'voluptas iure voluptatibus voluptates et voluptatum iste cupiditate velit esse ducimus nemo et qui doloribus sit molestias perferendis dolore',
    slug: 'Rustic-Man-Mug',
    added: 1483945131006,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Flora', 'Nature', 'Flower'],
    price: 17.99,
    name: 'Awesome Flora Mug',
    description:
      'alias hic sed omnis dignissimos natus ut quas eum voluptatem in qui quisquam dolor',
    slug: 'Awesome-Flora-Mug',
    added: 1484832014901,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Rose', 'Plant', 'Flower', 'Botanical', 'Flora'],
    price: 10.99,
    name: 'Refined Plant Mug',
    description:
      'nostrum exercitationem sit eveniet sint animi placeat aut et et nihil corporis temporibus totam consequuntur',
    slug: 'Refined-Plant-Mug',
    added: 1485202197268,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Dog', 'Animal'],
    price: 19.99,
    name: 'Generic Dog Mug',
    description:
      'vero consequatur rem dolorem sequi sint vel corrupti libero velit repudiandae laboriosam iste quo velit soluta occaecati consequatur aut sint voluptatibus ab nisi saepe consequatur',
    slug: 'Generic-Dog-Mug',
    added: 1484730961065,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Dog', 'Animal'],
    price: 19.99,
    name: 'Refined Dog Mug',
    description:
      'temporibus voluptatum iste voluptas rem corporis nam tempore laudantium molestias aut ea dolor',
    slug: 'Refined-Dog-Mug',
    added: 1478078063781,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Mountains', 'Lake'],
    price: 17.99,
    name: 'Refined Lake Mug',
    description:
      'labore consectetur id illo ex quibusdam eum iste laborum ea ut est',
    slug: 'Refined-Lake-Mug',
    added: 1484055435730,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Ice', 'Road'],
    price: 20.99,
    name: 'Rustic Ice Mug',
    description:
      'adipisci quia quia cum molestiae repellat at illum itaque vitae illo sint',
    slug: 'Rustic-Ice-Mug',
    added: 1483766251500,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Cliffs', 'Rocks'],
    price: 20.99,
    name: 'Handcrafted Ocean Mug',
    description:
      'rerum ea non veniam laborum quam autem est doloremque sed architecto molestiae dolore officiis et qui soluta',
    slug: 'Handcrafted-Ocean-Mug-2',
    added: 1484618523809,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['People', 'City'],
    price: 14.99,
    name: 'Small City Mug',
    description:
      'deleniti accusantium veritatis possimus enim nemo autem cumque tempore veniam voluptatem aut illum nesciunt delectus dolores ullam quia alias est expedita et magni',
    slug: 'Small-City-Mug-1',
    added: 1486153418417,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Tools', 'Antique', 'Wood'],
    price: 12.99,
    name: 'Awesome Wood Mug',
    description:
      'pariatur voluptatibus sint eveniet quasi eos aspernatur molestiae laboriosam et optio non ipsam et odio quaerat cum aut quod consequatur sunt explicabo',
    slug: 'Awesome-Wood-Mug-1',
    added: 1481922394467,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Dog', 'Animal', 'Puppy'],
    price: 19.99,
    name: 'Handcrafted Animal Mug',
    description:
      'incidunt quia error eos libero ea nesciunt sint cupiditate commodi labore soluta et ipsam illum',
    slug: 'Handcrafted-Animal-Mug-1',
    added: 1480839027680,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Water'],
    price: 17.99,
    name: 'Small River Mug',
    description:
      'explicabo consequuntur et enim ipsam veritatis in rem et quae excepturi ducimus iste',
    slug: 'Small-River-Mug-1',
    added: 1481833118562,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Skyline', 'Machine', 'Ocean', 'City'],
    price: 12.99,
    name: 'Fantastic Skyline Mug',
    description:
      'quasi laborum facere quis quisquam voluptas et ipsam culpa earum modi harum sit nam et qui et quo sit ut',
    slug: 'Fantastic-Skyline-Mug',
    added: 1478957798540,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Buildings'],
    price: 12.99,
    name: 'Fantastic Buildings Mug',
    description:
      'molestias ea et similique voluptates quis quod dicta reiciendis repellendus eos at error',
    slug: 'Fantastic-Buildings-Mug-1',
    added: 1478914585954,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Man', 'Hands'],
    price: 19.99,
    name: 'Small Man Mug',
    description:
      'nihil explicabo sit voluptate dolore aut itaque consequuntur fugiat sit dolore',
    slug: 'Small-Man-Mug',
    added: 1480912258137,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Building'],
    price: 11.99,
    name: 'Unbranded Architecture Mug',
    description:
      'soluta tenetur et assumenda ad molestiae laboriosam repudiandae et molestias consequuntur voluptas dolorum voluptas aliquid nemo',
    slug: 'Unbranded-Architecture-Mug-2',
    added: 1483637620268,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Animals'],
    price: 9.99,
    name: 'Sleek Sunset Mug',
    description:
      'nisi est ipsum ipsam sed excepturi nisi quaerat ea qui quia sed qui eos atque sapiente dolore fuga suscipit',
    slug: 'Sleek-Sunset-Mug',
    added: 1479006253486,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Satellite', 'Space', 'NASA'],
    price: 16.99,
    name: 'Unbranded NASA Mug',
    description:
      'repudiandae reiciendis sit distinctio eum ducimus illum beatae dolores maiores voluptas est enim sit beatae vel quisquam voluptas consequuntur',
    slug: 'Unbranded-NASA-Mug',
    added: 1477796917003,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Beach'],
    price: 15.99,
    name: 'Fantastic Beach Mug',
    description:
      'quasi minus atque voluptatem est quia debitis nam sed ea doloremque eos',
    slug: 'Fantastic-Beach-Mug',
    added: 1484318317097,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['People'],
    price: 16.99,
    name: 'Practical People Mug',
    description:
      'dolores velit illo blanditiis magnam adipisci eius pariatur quis pariatur quae eos',
    slug: 'Practical-People-Mug',
    added: 1484943434782,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Night', 'Stars', 'Abstrct'],
    price: 9.99,
    name: 'Small Abstrct Mug',
    description:
      'aut provident repellendus dolores nisi eos sed quae et et voluptatibus assumenda rerum voluptatem quisquam et',
    slug: 'Small-Abstrct-Mug',
    added: 1478162110357,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 13.99,
    name: 'Awesome Ocean Mug',
    description:
      'accusamus cumque ipsam molestiae ex accusantium eos eos nobis quo facilis quia doloribus aut et recusandae excepturi velit nobis voluptas ipsam dolorem porro et aut',
    slug: 'Awesome-Ocean-Mug-3',
    added: 1479665711278,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Beach', 'Ocean'],
    price: 16.99,
    name: 'Generic Ocean Mug',
    description:
      'dolorem eius velit vel temporibus libero rem aut ut quibusdam dolore placeat eum ullam nostrum est illum sit ratione aut neque voluptatem nulla consequatur sapiente',
    slug: 'Generic-Ocean-Mug-2',
    added: 1481611276009,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Trees', 'Railroad'],
    price: 9.99,
    name: 'Practical Fog Mug',
    description:
      'id accusantium omnis sed porro tenetur accusantium repudiandae possimus doloribus esse perspiciatis est perferendis et et nihil aut doloribus quas ullam labore',
    slug: 'Practical-Fog-Mug-1',
    added: 1482444209472,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Architecture'],
    price: 9.99,
    name: 'Intelligent Architecture Mug',
    description:
      'sunt rerum dolores et et excepturi quae quia debitis at omnis doloremque sit eos labore perspiciatis et dolore nesciunt',
    slug: 'Intelligent-Architecture-Mug',
    added: 1479709717851,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Watch', 'Person', 'Hand'],
    price: 18.99,
    name: 'Generic Person Mug',
    description:
      'assumenda maxime pariatur iste in omnis excepturi et harum consequatur repellat velit',
    slug: 'Generic-Person-Mug',
    added: 1483234983479,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 14.99,
    name: 'Fantastic Rocks Mug',
    description:
      'ut asperiores qui qui minus qui itaque impedit aut enim autem necessitatibus sequi odit iure ad debitis illo ut fugiat quod aut',
    slug: 'Fantastic-Rocks-Mug',
    added: 1481890870332,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Trees'],
    price: 17.99,
    name: 'Incredible Trees Mug',
    description:
      'et iure sed reprehenderit explicabo qui assumenda dignissimos ut aut molestiae ipsum quia iure rerum quisquam porro iure ea et quaerat voluptas',
    slug: 'Incredible-Trees-Mug',
    added: 1480834508355,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Abstract', 'Architecture', 'Stairs'],
    price: 11.99,
    name: 'Handmade Architecture Mug',
    description:
      'qui voluptatem accusamus voluptatem dolorem et consequatur et perferendis nihil et rerum consequuntur asperiores corrupti architecto rerum molestiae id velit quia dolor tempore voluptatem magnam',
    slug: 'Handmade-Architecture-Mug',
    added: 1484082452214,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Horse'],
    price: 9.99,
    name: 'Incredible Horse Mug',
    description:
      'ipsa est quia dolores autem nihil necessitatibus voluptatem libero incidunt incidunt optio odit nesciunt minima nam dolorem laudantium rerum dignissimos voluptatem ratione',
    slug: 'Incredible-Horse-Mug',
    added: 1486408829481,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Kiss', 'Love', 'Romance', 'People'],
    price: 9.99,
    name: 'Licensed Kiss Mug',
    description:
      'quibusdam fugit sit exercitationem vero tempore impedit qui assumenda modi reprehenderit ipsa sint eligendi suscipit eius dicta laborum nisi culpa',
    slug: 'Licensed-Kiss-Mug',
    added: 1482451766606,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Trees'],
    price: 17.99,
    name: 'Small Trees Mug',
    description:
      'commodi dolorem occaecati architecto hic iste sunt est et voluptatem similique amet quam mollitia atque est est',
    slug: 'Small-Trees-Mug-2',
    added: 1485634998776,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Trees', 'Nature', 'Mountains'],
    price: 13.99,
    name: 'Licensed Nature Mug',
    description:
      'molestiae dolorum architecto accusamus similique et et ipsa inventore rerum quaerat architecto voluptates sit',
    slug: 'Licensed-Nature-Mug-1',
    added: 1481885357837,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Tunnel', 'Road'],
    price: 20.99,
    name: 'Generic Road Mug',
    description:
      'odio suscipit omnis nisi itaque natus voluptas aut labore aut repudiandae et atque incidunt doloribus velit quia atque expedita sit iusto qui doloremque ipsam explicabo',
    slug: 'Generic-Road-Mug',
    added: 1483243260021,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Woman', 'Lake', 'Canoe'],
    price: 9.99,
    name: 'Handmade Person Mug',
    description:
      'sit animi architecto voluptatum id quibusdam aperiam optio minus mollitia aut dolore',
    slug: 'Handmade-Person-Mug',
    added: 1479557430681,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Sky', 'Ocean'],
    price: 17.99,
    name: 'Gorgeous Ocean Mug',
    description:
      'numquam qui ab provident consequatur quia velit quis non ut ullam dicta officiis molestiae aliquid voluptatem odio architecto illo aut dolorem',
    slug: 'Gorgeous-Ocean-Mug-2',
    added: 1482519619718,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Night', 'Mountains', 'Stars'],
    price: 15.99,
    name: 'Practical Stars Mug',
    description:
      'quam et voluptas qui est ipsa quis est distinctio cumque repellat nesciunt enim autem',
    slug: 'Practical-Stars-Mug-1',
    added: 1479291331983,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'City', 'Buildings'],
    price: 19.99,
    name: 'Handcrafted Buildings Mug',
    description:
      'consequatur voluptates voluptatem odio sint hic itaque aut ab tempore incidunt qui aut saepe in aut similique autem dignissimos impedit eligendi aut',
    slug: 'Handcrafted-Buildings-Mug-1',
    added: 1485978823204,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Fog', 'Mountains'],
    price: 9.99,
    name: 'Tasty Snow Mug',
    description:
      'et quidem non et eveniet doloremque aliquam labore pariatur quia omnis quis omnis soluta ducimus animi est dolore vitae',
    slug: 'Tasty-Snow-Mug-1',
    added: 1484717828306,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Mountains', 'Lake'],
    price: 15.99,
    name: 'Awesome Lake Mug',
    description:
      'omnis incidunt et quam nihil corporis a reiciendis assumenda aperiam tenetur nemo ut totam natus nihil rerum',
    slug: 'Awesome-Lake-Mug-1',
    added: 1479035319865,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'Stars', 'NASA'],
    price: 10.99,
    name: 'Generic Stars Mug',
    description:
      'sit cupiditate omnis quod ratione nam quibusdam placeat sed voluptatem voluptatum',
    slug: 'Generic-Stars-Mug',
    added: 1483268608279,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Ferris wheel', 'Carnival', 'Amusement park'],
    price: 11.99,
    name: 'Awesome Carnival Mug',
    description:
      'quis quis deserunt ad quo aut et ducimus commodi laudantium dolorum recusandae saepe quos quae libero reiciendis voluptas dolorem dolores nesciunt',
    slug: 'Awesome-Carnival-Mug',
    added: 1479034680318,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Forrest', 'Fog'],
    price: 20.99,
    name: 'Sleek Mountain Mug',
    description:
      'illo est quasi tempora fugiat velit natus enim nam placeat voluptatem velit',
    slug: 'Sleek-Mountain-Mug',
    added: 1484408730990,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Streetcar', 'City', 'People'],
    price: 16.99,
    name: 'Incredible Streetcar Mug',
    description:
      'assumenda soluta ut quibusdam voluptatem vel non aut itaque expedita',
    slug: 'Incredible-Streetcar-Mug',
    added: 1482643304130,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Barn', 'Tools'],
    price: 18.99,
    name: 'Practical Tools Mug',
    description:
      'ad enim ut cumque eius ducimus et error dignissimos atque nemo amet ut qui',
    slug: 'Practical-Tools-Mug',
    added: 1481394271620,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Clouds'],
    price: 14.99,
    name: 'Rustic Clouds Mug',
    description:
      'commodi qui accusamus neque dolores animi iste minima delectus blanditiis laborum',
    slug: 'Rustic-Clouds-Mug',
    added: 1478608266545,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Clouds'],
    price: 10.99,
    name: 'Incredible Clouds Mug',
    description:
      'quas qui dolorem aut nesciunt expedita magnam optio rerum aut maiores perferendis rerum aliquid recusandae officiis earum consequuntur autem',
    slug: 'Incredible-Clouds-Mug',
    added: 1480224021013,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Church', 'Nature', 'Mountains'],
    price: 20.99,
    name: 'Unbranded Mountains Mug',
    description:
      'ipsum dolores eligendi rerum porro sint nostrum reprehenderit harum cupiditate tempora illum illum necessitatibus eaque et enim harum dolorem ipsum doloremque',
    slug: 'Unbranded-Mountains-Mug',
    added: 1481366828982,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Wave', 'Ocean', 'Water'],
    price: 13.99,
    name: 'Licensed Ocean Mug',
    description:
      'incidunt fugiat aut commodi voluptatem rerum esse et facere hic animi error ut inventore velit aliquid nesciunt in totam et voluptatibus',
    slug: 'Licensed-Ocean-Mug',
    added: 1485595267314,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Plant', 'Macro'],
    price: 18.99,
    name: 'Unbranded Macro Mug',
    description:
      'voluptate dolor mollitia repellat minus maxime fugit sint eius non illum provident reprehenderit sequi eveniet in dolor',
    slug: 'Unbranded-Macro-Mug',
    added: 1480614828273,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Child', 'City', 'Boy', 'People', 'Dog', 'Stone', 'Animal'],
    price: 17.99,
    name: 'Tasty Dog Mug',
    description:
      'dolores quo ea distinctio et et sequi veniam natus aut repellat sed vitae culpa repudiandae itaque soluta assumenda odio est accusantium error laboriosam accusantium eos',
    slug: 'Tasty-Dog-Mug',
    added: 1485150252013,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Sky', 'Forrest', 'Trees'],
    price: 10.99,
    name: 'Handmade Sky Mug',
    description:
      'maxime at sunt quis sunt eveniet nostrum adipisci facilis beatae commodi quia tempore necessitatibus ullam',
    slug: 'Handmade-Sky-Mug',
    added: 1478375238872,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Lighthouse', 'Stars'],
    price: 20.99,
    name: 'Tasty Stars Mug',
    description:
      'illum laborum voluptatem mollitia et officiis iste rerum sint voluptatem velit aliquam quo quidem vel impedit enim eos accusamus voluptatem recusandae laudantium',
    slug: 'Tasty-Stars-Mug-1',
    added: 1481383278218,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Lake'],
    price: 19.99,
    name: 'Sleek Fog Mug',
    description:
      'rerum nisi molestiae ex eveniet asperiores ad nobis deserunt aut ipsa quia doloremque quos quisquam eum consequatur molestiae',
    slug: 'Sleek-Fog-Mug-1',
    added: 1480580311895,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Boats', 'Fog', 'Ocean'],
    price: 15.99,
    name: 'Refined Boats Mug',
    description:
      'quos libero facilis neque omnis ipsam sapiente expedita ducimus voluptatem perspiciatis accusamus quae',
    slug: 'Refined-Boats-Mug',
    added: 1480833170348,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Meadow', 'Plants'],
    price: 20.99,
    name: 'Incredible Plants Mug',
    description:
      'consectetur facilis reprehenderit et id unde voluptatem consequuntur quidem est ea praesentium expedita ex voluptate id id inventore sed sit',
    slug: 'Incredible-Plants-Mug',
    added: 1482153331950,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Barn', 'Trees'],
    price: 15.99,
    name: 'Refined Trees Mug',
    description:
      'rerum rerum quas magnam ut nihil nesciunt suscipit cumque hic deleniti nobis amet voluptatibus consectetur et hic dolor ut perferendis ea',
    slug: 'Refined-Trees-Mug-1',
    added: 1485286297787,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Ocean'],
    price: 17.99,
    name: 'Practical Ocean Mug',
    description:
      'sed aspernatur molestias perferendis magnam ipsam odio nam praesentium harum reiciendis vitae voluptatem et et sit non repudiandae',
    slug: 'Practical-Ocean-Mug-4',
    added: 1479811591224,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Lantern', 'Ethnic'],
    price: 19.99,
    name: 'Sleek Ethnic Mug',
    description:
      'vero sed sed quis earum similique molestiae temporibus iure est autem aperiam est est sunt illo',
    slug: 'Sleek-Ethnic-Mug',
    added: 1477843146323,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Church', 'Building'],
    price: 13.99,
    name: 'Tasty Architecture Mug',
    description:
      'consequatur nostrum et quo numquam porro aut saepe repellat necessitatibus occaecati atque assumenda maxime labore commodi quo ea',
    slug: 'Tasty-Architecture-Mug-1',
    added: 1485131595067,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Sunny', 'Ocean', 'Flowers'],
    price: 10.99,
    name: 'Ergonomic Flowers Mug',
    description:
      'velit consequatur libero blanditiis est excepturi quaerat accusantium aut quia quia sint inventore fuga deserunt quibusdam sunt provident autem optio in doloremque dolores quae iste',
    slug: 'Ergonomic-Flowers-Mug',
    added: 1479004404105,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings', 'Rain'],
    price: 17.99,
    name: 'Incredible City Mug',
    description:
      'non libero vel non dolorem officia est deserunt rerum sed ea delectus',
    slug: 'Incredible-City-Mug-1',
    added: 1481951853551,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Stadium', 'Event', 'Sports', 'People', 'Football'],
    price: 18.99,
    name: 'Unbranded Sports Mug',
    description:
      'minus optio culpa aut necessitatibus natus et nobis rerum adipisci sed exercitationem voluptates ea',
    slug: 'Unbranded-Sports-Mug',
    added: 1478271177209,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Man', 'Railroad'],
    price: 15.99,
    name: 'Fantastic Man Mug',
    description:
      'dolore ut in neque voluptatem quae nostrum aperiam est assumenda veniam aut ut recusandae sed officia totam consequuntur magnam quos repudiandae magnam ipsum',
    slug: 'Fantastic-Man-Mug',
    added: 1483081099213,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Northern lights', 'Snow', 'Trees'],
    price: 9.99,
    name: 'Sleek Northern Lights Mug',
    description:
      'nihil ut atque impedit iure alias voluptatem et quo quod assumenda atque iusto ut accusantium neque molestiae',
    slug: 'Sleek-Northern-Lights-Mug',
    added: 1485481071561,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Car', 'Building'],
    price: 9.99,
    name: 'Fantastic Building Mug',
    description:
      'voluptatem corrupti provident officiis quaerat labore blanditiis enim id sed optio minus impedit consequuntur modi voluptates molestiae consequuntur laboriosam asperiores dolores',
    slug: 'Fantastic-Building-Mug',
    added: 1482900343537,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Nature'],
    price: 10.99,
    name: 'Fantastic Nature Mug',
    description:
      'eos soluta aut vitae nulla aliquam consectetur iure ab facilis',
    slug: 'Fantastic-Nature-Mug-2',
    added: 1482024135884,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings', 'People'],
    price: 10.99,
    name: 'Rustic City Mug',
    description:
      'quo omnis id sint aut nemo qui non qui quo magni et et minus doloremque reiciendis eos',
    slug: 'Rustic-City-Mug-3',
    added: 1482047567703,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'Desert', 'Stars'],
    price: 10.99,
    name: 'Rustic Stars Mug',
    description:
      'veritatis quis qui aut ea eum dicta et nesciunt voluptatum qui eveniet iusto eligendi qui at exercitationem voluptatem ipsa consequatur voluptatem magni illum',
    slug: 'Rustic-Stars-Mug',
    added: 1482225427381,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Cars', 'Freeway'],
    price: 16.99,
    name: 'Incredible Cars Mug',
    description:
      'dolorum quas expedita itaque fugit dolores sed aperiam quasi consequuntur quis beatae temporibus repudiandae laborum consequatur iure vero delectus cumque voluptates facilis magni voluptatem',
    slug: 'Incredible-Cars-Mug',
    added: 1482899711246,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Surfboard', 'Person', 'Silhouette'],
    price: 11.99,
    name: 'Small Silhouette Mug',
    description:
      'sit possimus minima minus est rem quia dolor itaque consectetur voluptatem soluta hic',
    slug: 'Small-Silhouette-Mug',
    added: 1481768393238,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Bridge', 'City', 'Building'],
    price: 14.99,
    name: 'Refined Bridge Mug',
    description:
      'sequi sint et eos eligendi incidunt repudiandae error ea qui et quisquam enim doloribus vitae ipsa',
    slug: 'Refined-Bridge-Mug-1',
    added: 1485805231118,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'Stars', 'Rocks'],
    price: 11.99,
    name: 'Handcrafted Stars Mug',
    description:
      'expedita omnis dicta consequatur qui mollitia est illo est sed vel molestiae ipsa illum sed facere qui inventore ex eveniet eum necessitatibus ut',
    slug: 'Handcrafted-Stars-Mug-1',
    added: 1479280652226,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Fog'],
    price: 20.99,
    name: 'Handmade Mountain Mug',
    description: 'voluptate alias est hic dicta quia fuga sequi maiores vitae',
    slug: 'Handmade-Mountain-Mug',
    added: 1479510126515,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Concert', 'Band', 'People'],
    price: 12.99,
    name: 'Unbranded People Mug',
    description:
      'totam quo velit magnam dolor omnis velit blanditiis quo quis sed cumque sint occaecati aliquid ipsam ea totam ipsa rerum rerum possimus doloribus',
    slug: 'Unbranded-People-Mug',
    added: 1482110242235,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings'],
    price: 13.99,
    name: 'Practical Buildings Mug',
    description:
      'in vitae aut et laborum eligendi perspiciatis eligendi autem eos',
    slug: 'Practical-Buildings-Mug',
    added: 1479529159844,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Rocks'],
    price: 18.99,
    name: 'Ergonomic Beach Mug',
    description:
      'aut et ipsa doloremque aspernatur et error dolor dolores corporis sed provident quae est voluptas ut quia repellat',
    slug: 'Ergonomic-Beach-Mug-1',
    added: 1484065279139,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Berries', 'Frozen', 'Food'],
    price: 15.99,
    name: 'Intelligent Frozen Mug',
    description:
      'quis libero deserunt earum consequatur optio iste neque impedit sint placeat',
    slug: 'Intelligent-Frozen-Mug',
    added: 1484354947780,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Fog'],
    price: 15.99,
    name: 'Handmade Fog Mug',
    description:
      'error et necessitatibus pariatur ut voluptas deleniti libero nesciunt ipsum perferendis est dolor sapiente aut',
    slug: 'Handmade-Fog-Mug-2',
    added: 1485669893251,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Stairs', 'Feet', 'People'],
    price: 14.99,
    name: 'Licensed Stairs Mug',
    description:
      'omnis et quas molestiae sint et sit ducimus id sequi ipsam exercitationem maiores tempora pariatur quod maiores cumque',
    slug: 'Licensed-Stairs-Mug',
    added: 1479523315135,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Mountains', 'People'],
    price: 16.99,
    name: 'Generic Mountains Mug',
    description:
      'nihil molestias quisquam alias quos est id officiis voluptas qui quia et tempore in quod enim cupiditate quas culpa rerum ut est consequatur error',
    slug: 'Generic-Mountains-Mug-1',
    added: 1479504208789,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Old', 'Building'],
    price: 20.99,
    name: 'Handmade Building Mug',
    description:
      'ut in facilis iure possimus adipisci iure id alias eaque omnis sed dolore earum voluptatem nobis provident deserunt omnis repudiandae quam ut itaque neque eos',
    slug: 'Handmade-Building-Mug',
    added: 1483638296349,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Hands', 'Plant'],
    price: 17.99,
    name: 'Small Plant Mug',
    description:
      'provident voluptate earum vel minus ipsa modi voluptatum cumque ab at non qui cumque tempore eos ut est vel repudiandae',
    slug: 'Small-Plant-Mug',
    added: 1479749131518,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Sunrise', 'Metro', 'City'],
    price: 20.99,
    name: 'Intelligent City Mug',
    description:
      'quae autem iste nemo nemo odio placeat assumenda aut provident qui magni illum consequuntur voluptatum ut dolores aliquam et velit odio',
    slug: 'Intelligent-City-Mug-1',
    added: 1481387342834,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Jellyfish', 'Ocean'],
    price: 13.99,
    name: 'Refined Ocean Mug',
    description:
      'omnis aspernatur ipsa sapiente ab fuga ullam numquam magnam dolor repellat facere necessitatibus ex quo consectetur culpa sit in',
    slug: 'Refined-Ocean-Mug-1',
    added: 1485534580404,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Field', 'Trees', 'Fog'],
    price: 19.99,
    name: 'Rustic Field Mug',
    description:
      'aut cum quia explicabo quia excepturi qui cum sit et iste quam illum quidem velit velit cupiditate voluptatibus rerum molestias ut ut',
    slug: 'Rustic-Field-Mug',
    added: 1478395290906,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Desert', 'Sun'],
    price: 15.99,
    name: 'Awesome Sun Mug',
    description:
      'aperiam et temporibus eum repellat optio deserunt totam occaecati libero repudiandae doloribus et non iusto ipsum est sit et',
    slug: 'Awesome-Sun-Mug',
    added: 1482971711332,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Wood'],
    price: 11.99,
    name: 'Small Sunset Mug',
    description:
      'autem porro ipsa aut labore vel laborum maiores voluptatem ut ex sed quibusdam similique dolorem tempora quos',
    slug: 'Small-Sunset-Mug-3',
    added: 1480370693697,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Tea', 'Bed'],
    price: 18.99,
    name: 'Unbranded Bed Mug',
    description:
      'nulla numquam amet soluta omnis debitis doloribus rerum reiciendis asperiores iure necessitatibus',
    slug: 'Unbranded-Bed-Mug',
    added: 1479477401594,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Underwater'],
    price: 19.99,
    name: 'Rustic Underwater Mug',
    description:
      'quos dolor ab omnis modi inventore consequatur nobis sequi omnis nisi illum omnis ea minima',
    slug: 'Rustic-Underwater-Mug',
    added: 1479218100145,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings', 'Architecture'],
    price: 13.99,
    name: 'Rustic City Mug',
    description:
      'quasi modi quia dolor dolorem animi nihil totam inventore eum dicta iusto nesciunt ipsa maxime quia amet aut optio quo error corrupti ut delectus facilis',
    slug: 'Rustic-City-Mug-4',
    added: 1483305256177,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Beach', 'Ocean'],
    price: 13.99,
    name: 'Rustic Beach Mug',
    description:
      'vel consectetur dolor consectetur necessitatibus repudiandae aut corrupti aut aliquid non consequuntur quam maxime aut magnam est earum itaque quae itaque',
    slug: 'Rustic-Beach-Mug-1',
    added: 1482578464390,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Ocean', 'Dock'],
    price: 12.99,
    name: 'Awesome Sunset Mug',
    description:
      'vero impedit consequuntur sed qui maxime autem facilis rem et nostrum incidunt consectetur maxime assumenda sed',
    slug: 'Awesome-Sunset-Mug',
    added: 1478973783610,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Trees', 'Mountains'],
    price: 18.99,
    name: 'Generic Trees Mug',
    description:
      'perferendis voluptatem molestias sit quo quidem magni qui odit aspernatur ut consequatur minima ut veritatis placeat et dolorum ea',
    slug: 'Generic-Trees-Mug-1',
    added: 1484876962852,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Rocks'],
    price: 10.99,
    name: 'Generic Beach Mug',
    description:
      'ab sunt vitae eos possimus dolor eum nostrum quasi aliquid perferendis id ratione voluptas facere labore reiciendis libero non eveniet cum quos qui',
    slug: 'Generic-Beach-Mug',
    added: 1482112478866,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Blueberries', 'Fruit'],
    price: 16.99,
    name: 'Fantastic Blueberries Mug',
    description:
      'modi autem debitis vel sit laboriosam nihil error ad voluptatem inventore itaque magnam est sit rerum vel quisquam deleniti omnis quos',
    slug: 'Fantastic-Blueberries-Mug',
    added: 1483122262287,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Building'],
    price: 9.99,
    name: 'Awesome Architecture Mug',
    description:
      'voluptatem eligendi excepturi assumenda placeat corrupti et sed tempore et corrupti qui numquam sed vero beatae corporis qui alias',
    slug: 'Awesome-Architecture-Mug-1',
    added: 1485540894666,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Field', 'Stadium', 'Soccer'],
    price: 10.99,
    name: 'Sleek Soccer Mug',
    description:
      'voluptatem voluptatem doloremque est aspernatur velit illo consequatur fuga enim sunt sit sit est quia odit dolores accusamus quos non ipsum accusantium',
    slug: 'Sleek-Soccer-Mug',
    added: 1481688280808,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Fog', 'Rocks'],
    price: 9.99,
    name: 'Tasty River Mug',
    description:
      'a harum facilis sed occaecati tempore sint quo tempore quisquam sapiente cupiditate temporibus est et maxime ut vel hic ut aut ipsam',
    slug: 'Tasty-River-Mug-1',
    added: 1481659083256,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 9.99,
    name: 'Small Trees Mug',
    description:
      'repellat culpa veritatis hic atque soluta veniam in molestiae id',
    slug: 'Small-Trees-Mug-3',
    added: 1482437326611,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Macro', 'Leaves'],
    price: 19.99,
    name: 'Tasty Macro Mug',
    description:
      'quos corrupti aspernatur sed quo aliquam tempora aliquam quis cumque quo consectetur totam ut voluptatem atque veritatis et est ut aut ipsa',
    slug: 'Tasty-Macro-Mug',
    added: 1479513969956,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Night', 'Nature', 'Mountains'],
    price: 9.99,
    name: 'Tasty Night Mug',
    description:
      'et fugiat cum ea modi minima asperiores quia quod quis amet et et rerum ut aliquam mollitia quia possimus eos',
    slug: 'Tasty-Night-Mug-2',
    added: 1485673160384,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Buildings', 'City'],
    price: 11.99,
    name: 'Handmade Buildings Mug',
    description:
      'sed omnis eligendi fugiat consequatur porro voluptas omnis est accusantium itaque quaerat nemo quasi laborum perferendis voluptatem nihil maxime eligendi nostrum qui debitis delectus',
    slug: 'Handmade-Buildings-Mug',
    added: 1478151852241,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Dew', 'Spider web'],
    price: 17.99,
    name: 'Fantastic Spider Web Mug',
    description:
      'repudiandae nesciunt quia ipsam necessitatibus assumenda et necessitatibus ut id voluptatum aperiam voluptatibus voluptatibus cupiditate',
    slug: 'Fantastic-Spider-Web-Mug',
    added: 1485727023993,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Tree', 'Plant', 'Rain', 'Leaves'],
    price: 15.99,
    name: 'Incredible Leaves Mug',
    description:
      'animi voluptatem ut nihil provident in incidunt est explicabo voluptates perferendis',
    slug: 'Incredible-Leaves-Mug',
    added: 1482893671148,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Plants'],
    price: 15.99,
    name: 'Unbranded Sunset Mug',
    description:
      'qui temporibus odit dolores quia rerum qui quis amet dolore soluta',
    slug: 'Unbranded-Sunset-Mug',
    added: 1479070176329,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Stairs', 'People'],
    price: 11.99,
    name: 'Intelligent People Mug',
    description:
      'qui voluptatum est voluptatibus eaque libero culpa quidem culpa id perspiciatis inventore est facere alias aspernatur amet natus quia in aut dolores molestiae',
    slug: 'Intelligent-People-Mug',
    added: 1481400052900,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Hills', 'Fog'],
    price: 18.99,
    name: 'Licensed Hills Mug',
    description:
      'nemo unde quo ratione repellat exercitationem delectus rerum cupiditate beatae quaerat incidunt',
    slug: 'Licensed-Hills-Mug',
    added: 1483904645813,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Waterfall', 'Valley', 'Nature'],
    price: 13.99,
    name: 'Incredible Valley Mug',
    description:
      'quo quos enim officia ut consequatur aut voluptatibus iure provident omnis laudantium',
    slug: 'Incredible-Valley-Mug',
    added: 1481911921058,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog'],
    price: 15.99,
    name: 'Tasty Trees Mug',
    description:
      'recusandae rerum asperiores sit neque eveniet deserunt sequi sunt laboriosam et aut at consequatur excepturi dolore',
    slug: 'Tasty-Trees-Mug-2',
    added: 1481930534001,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Cactus'],
    price: 17.99,
    name: 'Small Cactus Mug',
    description:
      'in ad exercitationem rerum et eligendi nam sit officia facere a dolores amet mollitia dignissimos quia qui quam distinctio corporis voluptate',
    slug: 'Small-Cactus-Mug',
    added: 1486008083759,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Bear'],
    price: 12.99,
    name: 'Refined Bear Mug',
    description:
      'vitae totam et sit qui quas eos repudiandae adipisci quaerat minus eos corrupti eligendi dolores',
    slug: 'Refined-Bear-Mug',
    added: 1478050078892,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Surfer', 'Person', 'Man', 'Ocean'],
    price: 17.99,
    name: 'Fantastic Ocean Mug',
    description:
      'minima nemo illum recusandae ad maiores doloremque dolore quo sit assumenda suscipit quia consequatur aut id veritatis',
    slug: 'Fantastic-Ocean-Mug-1',
    added: 1486291179404,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Forest', 'Sun'],
    price: 10.99,
    name: 'Unbranded Forest Mug',
    description:
      'eveniet placeat velit ut voluptas qui qui eaque quod voluptas quia iusto ad voluptas ut vitae',
    slug: 'Unbranded-Forest-Mug-1',
    added: 1483317950131,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Trees'],
    price: 12.99,
    name: 'Sleek Trees Mug',
    description:
      'aut reprehenderit et voluptas rerum iusto et animi est et sed nisi aspernatur nulla voluptas quisquam natus officia aut similique sequi sit culpa quam perspiciatis',
    slug: 'Sleek-Trees-Mug',
    added: 1481422353431,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Night', 'Stars', 'Space'],
    price: 9.99,
    name: 'Sleek Stars Mug',
    description:
      'ipsa quia quaerat hic vel voluptatem eaque consequatur qui expedita ipsum delectus',
    slug: 'Sleek-Stars-Mug',
    added: 1482066633787,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Island', 'Ocean'],
    price: 19.99,
    name: 'Handcrafted Island Mug',
    description:
      'omnis eveniet ipsa minima sed sint possimus exercitationem ea perspiciatis sed quisquam debitis eaque non possimus incidunt sapiente',
    slug: 'Handcrafted-Island-Mug',
    added: 1481308513250,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Boat', 'Ocean', 'People'],
    price: 17.99,
    name: 'Tasty People Mug',
    description:
      'non est dolorem aut maiores voluptatum perspiciatis totam omnis illo dolor molestiae est sunt et voluptate',
    slug: 'Tasty-People-Mug-2',
    added: 1483464104058,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 18.99,
    name: 'Fantastic City Mug',
    description:
      'ut quibusdam quia accusantium aut nostrum est dolorem facere maiores',
    slug: 'Fantastic-City-Mug',
    added: 1484353156938,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Tree', 'Orange', 'Fruit'],
    price: 9.99,
    name: 'Handmade Tree Mug',
    description:
      'aut inventore illum aperiam laudantium et est voluptatum ad quos explicabo natus',
    slug: 'Handmade-Tree-Mug',
    added: 1483478190823,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Night', 'Fireworks'],
    price: 19.99,
    name: 'Ergonomic Sunset Mug',
    description:
      'esse rerum autem exercitationem odit exercitationem sapiente itaque omnis minus at illum ex',
    slug: 'Ergonomic-Sunset-Mug-1',
    added: 1485535890521,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Keyboard', 'Computer'],
    price: 19.99,
    name: 'Sleek Desk Mug',
    description:
      'architecto voluptatem corrupti consequatur eius eaque tenetur fuga eum maiores minus ex voluptas optio in vel',
    slug: 'Sleek-Desk-Mug-1',
    added: 1479878000537,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Water', 'People'],
    price: 16.99,
    name: 'Gorgeous Water Mug',
    description:
      'possimus odio quo enim deserunt ea omnis explicabo impedit nam corrupti necessitatibus minus amet id',
    slug: 'Gorgeous-Water-Mug-1',
    added: 1482927407703,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Tree'],
    price: 16.99,
    name: 'Fantastic Sunset Mug',
    description:
      'repellendus assumenda eos libero eaque explicabo excepturi alias aliquam sit exercitationem est sunt dignissimos consequuntur qui aliquam quos sed ut soluta voluptas',
    slug: 'Fantastic-Sunset-Mug-4',
    added: 1480519413922,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Plants', 'Leaves'],
    price: 13.99,
    name: 'Unbranded Plants Mug',
    description:
      'cum a animi magnam autem sint qui nihil voluptatum perferendis aliquam molestiae enim architecto sit rerum ea necessitatibus voluptas rerum',
    slug: 'Unbranded-Plants-Mug-1',
    added: 1486268898831,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Flowers', 'Food'],
    price: 19.99,
    name: 'Rustic Flowers Mug',
    description:
      'ea quia quis vel rem quidem non molestiae quo asperiores aperiam unde facilis libero quas ullam nihil inventore dolor voluptatum',
    slug: 'Rustic-Flowers-Mug',
    added: 1483467075611,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Office', 'Laptop'],
    price: 15.99,
    name: 'Unbranded Laptop Mug',
    description:
      'voluptatem facilis minima consequuntur aut quaerat eaque earum omnis quisquam tempora accusamus est cumque in qui iure ea aut laborum illum molestiae qui cum',
    slug: 'Unbranded-Laptop-Mug',
    added: 1484342780938,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Dirt', 'Road'],
    price: 9.99,
    name: 'Unbranded Dirt Mug',
    description:
      'rerum quo fugiat recusandae corrupti consequatur quos vel nemo fugiat ratione pariatur asperiores suscipit excepturi in',
    slug: 'Unbranded-Dirt-Mug',
    added: 1482934755208,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Child', 'City', 'People'],
    price: 10.99,
    name: 'Incredible People Mug',
    description:
      'reiciendis magnam dolor praesentium quaerat velit fugiat cumque cum iusto',
    slug: 'Incredible-People-Mug-2',
    added: 1478430692921,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Ocean', 'Bird'],
    price: 15.99,
    name: 'Ergonomic Mountain Mug',
    description:
      'sit laudantium corporis vel commodi cumque dolor blanditiis est pariatur laborum enim dolore ducimus quo aut optio voluptatem',
    slug: 'Ergonomic-Mountain-Mug',
    added: 1482463604278,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Building'],
    price: 14.99,
    name: 'Incredible Building Mug',
    description:
      'sit nemo et dignissimos iusto quis quis cumque sed magni aut non fuga nam optio eum',
    slug: 'Incredible-Building-Mug-1',
    added: 1482241378031,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset'],
    price: 12.99,
    name: 'Rustic Sunset Mug',
    description:
      'similique doloremque magni deserunt omnis quae praesentium adipisci voluptate fuga voluptatem',
    slug: 'Rustic-Sunset-Mug-1',
    added: 1485373038397,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Flowers'],
    price: 17.99,
    name: 'Small Flowers Mug',
    description:
      'assumenda aspernatur et minima facilis eveniet enim sit laboriosam impedit ex aut explicabo perferendis eum odit eius',
    slug: 'Small-Flowers-Mug-1',
    added: 1481759759640,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Night', 'City', 'Railroad'],
    price: 16.99,
    name: 'Handmade City Mug',
    description:
      'qui est veniam illo maxime necessitatibus aliquam dolorum necessitatibus placeat',
    slug: 'Handmade-City-Mug',
    added: 1485980938103,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 12.99,
    name: 'Handcrafted City Mug',
    description:
      'quisquam dignissimos ut illum accusamus dolorem fugit earum veniam illo',
    slug: 'Handcrafted-City-Mug-4',
    added: 1478019469043,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Dog', 'Animal', 'Husky'],
    price: 17.99,
    name: 'Awesome Animal Mug',
    description:
      'quibusdam omnis laudantium atque molestiae rerum est et quisquam consequatur aliquam officiis facere suscipit natus ab non tempora dignissimos et',
    slug: 'Awesome-Animal-Mug',
    added: 1479893740926,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 20.99,
    name: 'Incredible Snow Mug',
    description:
      'fuga eum ex sed sequi eligendi repellat voluptas eum dolor libero nesciunt deserunt nemo voluptatem nihil earum',
    slug: 'Incredible-Snow-Mug',
    added: 1482380320661,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Woman'],
    price: 18.99,
    name: 'Rustic Person Mug',
    description:
      'qui doloribus rem qui iusto sed cupiditate eligendi fuga laboriosam ipsam velit cupiditate nam cupiditate quod delectus quo consequuntur',
    slug: 'Rustic-Person-Mug-2',
    added: 1481439329383,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Horizon', 'Ocean'],
    price: 11.99,
    name: 'Handcrafted Ocean Mug',
    description:
      'sapiente magni ut dolor dignissimos fuga ut rerum sint aut reiciendis cumque aut architecto laboriosam illum ipsam adipisci rerum',
    slug: 'Handcrafted-Ocean-Mug-3',
    added: 1486140610407,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Dock', 'Lake'],
    price: 19.99,
    name: 'Tasty Dock Mug',
    description:
      'quis aspernatur possimus magni molestiae ut dolorem incidunt quo eos ullam occaecati maxime molestiae et iure cupiditate et animi quia voluptatem delectus ea',
    slug: 'Tasty-Dock-Mug-1',
    added: 1486014942804,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Waves', 'Water'],
    price: 14.99,
    name: 'Handmade Beach Mug',
    description:
      'numquam ut modi molestiae error perspiciatis deserunt suscipit esse et nam pariatur eveniet cupiditate non molestiae repudiandae amet consequatur beatae porro pariatur est ut odio',
    slug: 'Handmade-Beach-Mug-1',
    added: 1478491541430,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Horizon', 'Ocean'],
    price: 15.99,
    name: 'Practical Horizon Mug',
    description:
      'adipisci autem neque nostrum quae dolores accusamus hic et assumenda pariatur aliquid sint quis quisquam incidunt alias incidunt optio tempora',
    slug: 'Practical-Horizon-Mug-1',
    added: 1481311548859,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Person'],
    price: 10.99,
    name: 'Tasty Person Mug',
    description:
      'culpa in est possimus ipsum esse ad impedit cum saepe et rerum voluptate temporibus dolorem dicta',
    slug: 'Tasty-Person-Mug',
    added: 1485547492743,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Winter', 'Snow', 'Frost'],
    price: 15.99,
    name: 'Unbranded Winter Mug',
    description:
      'culpa fugit at fugit velit sed tenetur consequatur facilis rem nihil itaque et consequatur sit',
    slug: 'Unbranded-Winter-Mug',
    added: 1482041856996,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Lights', 'City', 'Buildings'],
    price: 12.99,
    name: 'Fantastic City Mug',
    description:
      'voluptas dignissimos laborum eaque aut assumenda architecto eos asperiores ducimus autem impedit vitae dolore maiores blanditiis omnis laboriosam inventore quo non',
    slug: 'Fantastic-City-Mug-1',
    added: 1481401066092,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'City'],
    price: 11.99,
    name: 'Intelligent City Mug',
    description:
      'temporibus inventore et molestiae illum repudiandae voluptatem pariatur explicabo beatae suscipit autem rem esse laborum sed libero et velit minima aperiam',
    slug: 'Intelligent-City-Mug-2',
    added: 1480535403073,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Nature', 'Road', 'Water'],
    price: 19.99,
    name: 'Handmade Nature Mug',
    description:
      'quaerat quas ut occaecati et nihil ipsum culpa assumenda qui dolores quod sunt et corporis doloribus corrupti soluta',
    slug: 'Handmade-Nature-Mug',
    added: 1485084851510,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Glass', 'Architecture'],
    price: 20.99,
    name: 'Gorgeous Glass Mug',
    description:
      'at saepe omnis nesciunt ipsam nulla voluptatem repellat quod praesentium culpa molestias non ut mollitia aliquam reiciendis qui non',
    slug: 'Gorgeous-Glass-Mug',
    added: 1481597011088,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Bus', 'Machine'],
    price: 14.99,
    name: 'Generic Machine Mug',
    description:
      'voluptatem dolor maiores optio quibusdam repellat molestiae rem quam ut magnam beatae laboriosam doloremque amet harum laborum et sit sint',
    slug: 'Generic-Machine-Mug',
    added: 1482868930762,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Trees'],
    price: 13.99,
    name: 'Rustic Sunset Mug',
    description:
      'iste perspiciatis corporis ab culpa error rem fuga fugit quas',
    slug: 'Rustic-Sunset-Mug-2',
    added: 1485263869776,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Boats', 'Ocean'],
    price: 10.99,
    name: 'Fantastic Boats Mug',
    description:
      'temporibus autem adipisci provident cupiditate molestias nihil necessitatibus iure sunt rerum dolore aut iure fuga fuga qui dolorem',
    slug: 'Fantastic-Boats-Mug',
    added: 1483396346722,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Space', 'NASA', 'Mars'],
    price: 20.99,
    name: 'Intelligent Mars Mug',
    description:
      'accusamus aspernatur nulla ab laudantium quia eum repudiandae reiciendis sint laboriosam excepturi beatae quia ut libero qui facilis et asperiores quia voluptatum exercitationem ut libero',
    slug: 'Intelligent-Mars-Mug',
    added: 1478759842233,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Mountains'],
    price: 13.99,
    name: 'Ergonomic Mountains Mug',
    description:
      'dicta quam ipsum dolorem aspernatur quos inventore omnis perspiciatis repellendus molestiae nobis exercitationem repudiandae modi atque eum',
    slug: 'Ergonomic-Mountains-Mug-3',
    added: 1485134184062,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Plane'],
    price: 20.99,
    name: 'Tasty Plane Mug',
    description:
      'ut voluptas eveniet et laboriosam natus doloremque enim voluptas rerum dicta sit soluta perspiciatis voluptatem ducimus explicabo voluptatum reprehenderit quas',
    slug: 'Tasty-Plane-Mug',
    added: 1485596031417,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Boat'],
    price: 17.99,
    name: 'Practical Boat Mug',
    description:
      'odio iure voluptatum inventore est non voluptatibus ab voluptas quis',
    slug: 'Practical-Boat-Mug',
    added: 1483757532612,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Ocean'],
    price: 20.99,
    name: 'Fantastic Ocean Mug',
    description:
      'facere aut iste rerum officia eius ut modi quidem ad omnis maiores aperiam quasi autem eligendi tempora beatae dolores ab nulla earum',
    slug: 'Fantastic-Ocean-Mug-2',
    added: 1480146103391,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Sand', 'Pebble'],
    price: 10.99,
    name: 'Rustic Pebble Mug',
    description:
      'illum nam itaque facilis saepe illum omnis laboriosam ad expedita vel sit aliquid rerum maiores tenetur sint nulla consequatur',
    slug: 'Rustic-Pebble-Mug',
    added: 1479731545465,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Aerial', 'Cars', 'Road'],
    price: 13.99,
    name: 'Gorgeous Road Mug',
    description: 'et accusamus est aut et et dolore incidunt qui saepe debitis',
    slug: 'Gorgeous-Road-Mug',
    added: 1484553607137,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Ocean'],
    price: 14.99,
    name: 'Practical Ocean Mug',
    description:
      'et veniam quis aut ut qui quod beatae quaerat et rem doloribus accusamus consequuntur qui aliquam accusantium repudiandae ipsam quae soluta provident quas voluptatibus',
    slug: 'Practical-Ocean-Mug-5',
    added: 1482354479384,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Books', 'Library'],
    price: 10.99,
    name: 'Fantastic Library Mug',
    description:
      'impedit vitae aperiam sint ipsum mollitia velit repellendus cumque enim suscipit',
    slug: 'Fantastic-Library-Mug',
    added: 1483232587660,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset'],
    price: 16.99,
    name: 'Sleek Sunset Mug',
    description:
      'tempore quia neque non et id commodi nihil laborum dolor incidunt illo voluptatem consectetur quia quia officiis fugiat veniam magni dignissimos eveniet et minima',
    slug: 'Sleek-Sunset-Mug-1',
    added: 1483968282647,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 19.99,
    name: 'Licensed Abstract Mug',
    description:
      'itaque natus ut eum sint maxime qui quas totam blanditiis deserunt doloribus nisi explicabo qui sed aut necessitatibus minima sunt id et officia et',
    slug: 'Licensed-Abstract-Mug',
    added: 1483229972296,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Nature', 'Forest'],
    price: 11.99,
    name: 'Incredible Nature Mug',
    description:
      'et pariatur atque vel ea eveniet sit et et doloribus blanditiis tempora facere',
    slug: 'Incredible-Nature-Mug',
    added: 1485691195965,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Beans', 'Coffee'],
    price: 18.99,
    name: 'Ergonomic Coffee Mug',
    description: 'cum quam dolorum iste voluptas at aut et et asperiores',
    slug: 'Ergonomic-Coffee-Mug',
    added: 1482660327323,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Coffee', 'Paper', 'Book'],
    price: 14.99,
    name: 'Small Book Mug',
    description:
      'ut id facilis a qui sequi autem iure id consectetur et culpa eveniet voluptatem a dolor quam autem praesentium molestiae',
    slug: 'Small-Book-Mug',
    added: 1483374459938,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 12.99,
    name: 'Practical Ocean Mug',
    description:
      'est dolorem quae quo expedita corrupti sint vel soluta sapiente sit ab eveniet nesciunt qui cupiditate temporibus',
    slug: 'Practical-Ocean-Mug-6',
    added: 1481385188033,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Aerial', 'Bridge', 'Cars', 'Meatal'],
    price: 19.99,
    name: 'Fantastic Aerial Mug',
    description:
      'expedita voluptatem ipsam ut architecto illum sed unde facilis architecto similique error commodi autem in non consequatur sed aspernatur ut nisi aperiam officia totam est',
    slug: 'Fantastic-Aerial-Mug',
    added: 1479131495147,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 9.99,
    name: 'Practical Office Mug',
    description:
      'quod nobis soluta sunt tempore alias quod rerum consequuntur voluptas et',
    slug: 'Practical-Office-Mug',
    added: 1485032695558,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Man', 'City', 'Coffee shop', 'People'],
    price: 11.99,
    name: 'Refined City Mug',
    description:
      'dolore quia sapiente nostrum odio ab modi aut non voluptatem modi iste voluptatum veritatis ut quas qui non deserunt et',
    slug: 'Refined-City-Mug-2',
    added: 1479800605509,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Water', 'Cliffs'],
    price: 18.99,
    name: 'Small Cliffs Mug',
    description:
      'et vel eius qui cupiditate molestiae reiciendis reprehenderit voluptatem labore magnam voluptatem possimus atque eius molestias error magnam et maxime ea ducimus',
    slug: 'Small-Cliffs-Mug',
    added: 1482952643631,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 10.99,
    name: 'Rustic Snow Mug',
    description:
      'voluptate voluptatem itaque non cumque in maiores harum deserunt nihil occaecati',
    slug: 'Rustic-Snow-Mug-1',
    added: 1479668303362,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Car', 'Vehicle'],
    price: 13.99,
    name: 'Ergonomic Vehicle Mug',
    description:
      'ut nam et voluptatem velit consequatur omnis omnis nostrum iusto corrupti sint quo aut architecto repudiandae sunt molestiae reiciendis magnam hic provident possimus repellendus non',
    slug: 'Ergonomic-Vehicle-Mug',
    added: 1481514696900,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Cars', 'City', 'Buildings'],
    price: 20.99,
    name: 'Ergonomic Buildings Mug',
    description:
      'omnis maxime quis ullam commodi qui sit nulla consectetur dolorem doloremque sit',
    slug: 'Ergonomic-Buildings-Mug-2',
    added: 1478483429463,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Coffee bar', 'Brew', 'Coffee'],
    price: 10.99,
    name: 'Ergonomic Coffee Bar Mug',
    description:
      'eligendi qui atque nostrum et accusamus adipisci amet et doloremque eos magni ex qui quidem architecto esse odit quam sit',
    slug: 'Ergonomic-Coffee-Bar-Mug',
    added: 1479646959353,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Trees', 'Forest', 'Water', 'River'],
    price: 14.99,
    name: 'Intelligent River Mug',
    description:
      'eius dolorem pariatur voluptatibus exercitationem harum doloribus est aut et quidem nulla quas',
    slug: 'Intelligent-River-Mug',
    added: 1481100198111,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Buildings'],
    price: 12.99,
    name: 'Intelligent Buildings Mug',
    description:
      'quo temporibus in sint recusandae quia ratione occaecati et ut alias consectetur asperiores et sapiente nisi et mollitia amet modi inventore quam',
    slug: 'Intelligent-Buildings-Mug-1',
    added: 1478455124138,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog'],
    price: 14.99,
    name: 'Ergonomic Fog Mug',
    description:
      'nisi nobis sint et ipsam expedita assumenda ad occaecati est dolor tempora sint sunt facilis molestiae natus',
    slug: 'Ergonomic-Fog-Mug',
    added: 1482793183505,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Night', 'Mountains', 'Stars'],
    price: 12.99,
    name: 'Unbranded Stars Mug',
    description:
      'deleniti nam maxime natus quasi voluptate aut fugit enim quod numquam minus nam eligendi laborum saepe odit vel',
    slug: 'Unbranded-Stars-Mug',
    added: 1477972112783,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Fog'],
    price: 11.99,
    name: 'Incredible Sky Mug',
    description:
      'soluta perferendis quos recusandae ratione delectus harum omnis consequatur impedit sit quae provident dolore commodi perferendis aliquam consequuntur pariatur quo dolor et totam reprehenderit',
    slug: 'Incredible-Sky-Mug',
    added: 1479322017938,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Night', 'Stars'],
    price: 16.99,
    name: 'Refined Night Mug',
    description:
      'omnis enim eius velit placeat distinctio in quisquam repellat reiciendis cupiditate accusantium qui reiciendis occaecati ea vel quia',
    slug: 'Refined-Night-Mug',
    added: 1478865646488,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Trees'],
    price: 11.99,
    name: 'Practical Arial Mug',
    description:
      'occaecati nisi molestiae voluptatem aliquid voluptates aut dolorum dolorem iusto quia aliquid aperiam repellendus nemo accusamus',
    slug: 'Practical-Arial-Mug',
    added: 1484725595679,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Bridge'],
    price: 12.99,
    name: 'Handcrafted Bridge Mug',
    description:
      'ex ipsa mollitia molestiae soluta omnis ex laboriosam eos facere',
    slug: 'Handcrafted-Bridge-Mug-1',
    added: 1484132907181,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Clock'],
    price: 10.99,
    name: 'Unbranded Clock Mug',
    description:
      'est voluptates quia in voluptatem doloremque corrupti minima distinctio vel sit quas',
    slug: 'Unbranded-Clock-Mug',
    added: 1486151865611,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Sunrise', 'Forest'],
    price: 15.99,
    name: 'Unbranded Trees Mug',
    description:
      'excepturi quis mollitia minus quasi autem illo odit quidem tempora voluptas et aut',
    slug: 'Unbranded-Trees-Mug-1',
    added: 1478801209475,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Buildings'],
    price: 18.99,
    name: 'Handcrafted Buildings Mug',
    description:
      'explicabo veritatis aperiam voluptates aperiam id est nihil culpa nulla harum quis adipisci quod vero placeat doloremque non odio',
    slug: 'Handcrafted-Buildings-Mug-2',
    added: 1483047065033,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Lake'],
    price: 10.99,
    name: 'Gorgeous Lake Mug',
    description:
      'sint iure temporibus nostrum omnis nulla a ut ratione assumenda consectetur consectetur ipsam molestiae magnam facere repellat eius architecto aliquam quos expedita vel eum',
    slug: 'Gorgeous-Lake-Mug-1',
    added: 1482492245919,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Hiker', 'Person', 'Woman'],
    price: 13.99,
    name: 'Awesome Woman Mug',
    description:
      'sit et eos perspiciatis incidunt voluptatem et fuga et voluptatem libero qui et esse nostrum similique',
    slug: 'Awesome-Woman-Mug',
    added: 1483876045316,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Silhouette'],
    price: 15.99,
    name: 'Small Sunset Mug',
    description:
      'nihil eos nesciunt voluptates et neque saepe non natus harum deleniti',
    slug: 'Small-Sunset-Mug-4',
    added: 1485551597239,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Cars', 'City', 'Buildings'],
    price: 10.99,
    name: 'Generic Buildings Mug',
    description:
      'commodi natus sed autem soluta alias rerum qui dolor quia ut at quos doloribus enim assumenda aut',
    slug: 'Generic-Buildings-Mug',
    added: 1481659565829,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Water'],
    price: 14.99,
    name: 'Sleek Water Mug',
    description:
      'voluptatem accusantium nihil nesciunt qui nihil quis facere ipsa ratione non voluptatem',
    slug: 'Sleek-Water-Mug-2',
    added: 1486067855420,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 16.99,
    name: 'Unbranded Water Mug',
    description:
      'et ducimus nesciunt vel repellendus veniam cum quia molestiae alias deserunt et placeat sit unde a ut quas hic',
    slug: 'Unbranded-Water-Mug-1',
    added: 1478738840342,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Desert', 'People'],
    price: 13.99,
    name: 'Awesome Desert Mug',
    description:
      'est possimus consequatur voluptate qui nesciunt amet dicta sequi dolor sed eos',
    slug: 'Awesome-Desert-Mug',
    added: 1485698951636,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Mountains'],
    price: 12.99,
    name: 'Incredible Mountains Mug',
    description:
      'quas ut est eum ut iure quia possimus unde fuga facere dolorem et expedita provident veniam at ex sequi error earum corporis qui quam',
    slug: 'Incredible-Mountains-Mug-4',
    added: 1481553849076,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Forest'],
    price: 12.99,
    name: 'Handcrafted Forest Mug',
    description:
      'id ea nam a iusto ullam dolorem aliquam quisquam qui ratione vel eligendi eum eos quia laudantium repudiandae aspernatur quo',
    slug: 'Handcrafted-Forest-Mug-1',
    added: 1486314908984,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Child', 'Man', 'People'],
    price: 9.99,
    name: 'Refined Man Mug',
    description:
      'magnam eveniet occaecati ipsam et aliquam voluptas distinctio deleniti pariatur quia et',
    slug: 'Refined-Man-Mug',
    added: 1478413738622,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Fog', 'Mountains'],
    price: 20.99,
    name: 'Gorgeous Fog Mug',
    description:
      'possimus eum ab et consequuntur aut numquam incidunt ex quae veritatis rem similique temporibus',
    slug: 'Gorgeous-Fog-Mug-1',
    added: 1484647203848,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Cliff', 'Ocean', 'Rocks'],
    price: 17.99,
    name: 'Refined Ocean Mug',
    description:
      'ut aspernatur et illum saepe nostrum molestiae sit enim aliquam doloremque possimus eveniet nobis sed iusto aliquam',
    slug: 'Refined-Ocean-Mug-2',
    added: 1480691696016,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Woman', 'Sleeping'],
    price: 9.99,
    name: 'Handmade Sleeping Mug',
    description:
      'consequatur magni voluptates doloribus nemo impedit accusamus debitis veniam praesentium eos incidunt commodi ad deserunt delectus placeat sequi eos veritatis est optio aut inventore necessitatibus',
    slug: 'Handmade-Sleeping-Mug',
    added: 1484491537324,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Fog', 'City'],
    price: 11.99,
    name: 'Sleek Fog Mug',
    description:
      'voluptate in beatae earum autem architecto quo rem dolores qui necessitatibus molestiae doloremque quas incidunt unde nesciunt itaque atque in a voluptate',
    slug: 'Sleek-Fog-Mug-2',
    added: 1484623710662,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 15.99,
    name: 'Ergonomic Building Mug',
    description:
      'et officia possimus quia delectus autem magni sed sint commodi iusto aut voluptatem amet fuga',
    slug: 'Ergonomic-Building-Mug-2',
    added: 1479126405535,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Trees', 'Mountains', 'Forest'],
    price: 13.99,
    name: 'Generic Trees Mug',
    description:
      'earum hic eos nesciunt explicabo expedita nulla aliquid distinctio iusto similique non nihil eveniet harum voluptatibus quisquam alias vitae aut voluptatibus quas',
    slug: 'Generic-Trees-Mug-2',
    added: 1480890675676,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Plants', 'Flowers'],
    price: 15.99,
    name: 'Fantastic Plants Mug',
    description:
      'id vel quidem expedita aperiam est cumque voluptatum sed ut at et enim voluptatum in cum dolores et error ut',
    slug: 'Fantastic-Plants-Mug',
    added: 1480346388005,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Boardwalk', 'Beach', 'People'],
    price: 20.99,
    name: 'Practical Boardwalk Mug',
    description:
      'sit explicabo ea quae illum provident eos saepe velit quis ut sed',
    slug: 'Practical-Boardwalk-Mug',
    added: 1483267009391,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Succulent', 'Nature', 'Plant'],
    price: 17.99,
    name: 'Gorgeous Nature Mug',
    description:
      'quos a rerum eos quia quaerat facilis et minima ullam qui voluptas nam hic dicta maxime deserunt architecto atque',
    slug: 'Gorgeous-Nature-Mug',
    added: 1485834845268,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'People'],
    price: 15.99,
    name: 'Gorgeous People Mug',
    description:
      'perspiciatis sit recusandae rerum numquam ut qui animi mollitia omnis vero id vero ut dolores repellendus',
    slug: 'Gorgeous-People-Mug',
    added: 1478714181637,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Mountains', 'Dock', 'Lake'],
    price: 15.99,
    name: 'Unbranded Dock Mug',
    description:
      'fugiat est sint aliquid et officiis est reiciendis ipsam recusandae dolor',
    slug: 'Unbranded-Dock-Mug',
    added: 1486394423949,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Rocks'],
    price: 15.99,
    name: 'Licensed Rocks Mug',
    description:
      'eos dolores vel praesentium omnis deleniti est sed optio quidem hic ea qui debitis qui ex hic modi amet ex incidunt quis cum',
    slug: 'Licensed-Rocks-Mug',
    added: 1485348316704,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Frost', 'Train'],
    price: 20.99,
    name: 'Small Frost Mug',
    description:
      'possimus rerum eveniet ea nihil atque quia ut quasi sunt explicabo odio molestiae numquam omnis quis sint',
    slug: 'Small-Frost-Mug',
    added: 1486063018436,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 16.99,
    name: 'Tasty Building Mug',
    description:
      'inventore quisquam eum ratione occaecati ullam itaque et nesciunt explicabo dolore est natus nesciunt sint iste excepturi corrupti nobis sint at',
    slug: 'Tasty-Building-Mug',
    added: 1479687576596,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Lake', 'Cabin'],
    price: 17.99,
    name: 'Ergonomic Trees Mug',
    description:
      'cupiditate adipisci cum repudiandae neque et et a aut debitis consequatur ut ipsa rerum ut vel exercitationem ab ut',
    slug: 'Ergonomic-Trees-Mug',
    added: 1486148333044,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Woman', 'People'],
    price: 10.99,
    name: 'Ergonomic People Mug',
    description:
      'quo dolorem et modi vel laborum aliquam natus iste perferendis excepturi ut aut et minus aut eum',
    slug: 'Ergonomic-People-Mug-1',
    added: 1482160900705,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Flowers', 'Plants'],
    price: 15.99,
    name: 'Small Flowers Mug',
    description:
      'et aliquid vero odit voluptatem veniam vero et pariatur quisquam veritatis',
    slug: 'Small-Flowers-Mug-2',
    added: 1484297539244,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Architecture', 'Station', 'People'],
    price: 10.99,
    name: 'Generic Station Mug',
    description:
      'qui quia hic nam itaque dolor ab sint ut reiciendis fuga porro explicabo aliquam ut et provident facere',
    slug: 'Generic-Station-Mug-1',
    added: 1479160159284,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Horse'],
    price: 18.99,
    name: 'Incredible Animal Mug',
    description:
      'aut eos enim dolorem sit sit explicabo molestiae commodi eligendi dolorem aut facilis modi vel aut',
    slug: 'Incredible-Animal-Mug',
    added: 1480538752343,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Boat', 'Ocean'],
    price: 16.99,
    name: 'Tasty Boat Mug',
    description:
      'ut ratione corporis eum qui veniam voluptas possimus culpa ipsam est praesentium architecto',
    slug: 'Tasty-Boat-Mug',
    added: 1482658486965,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Metal', 'Bridge', 'City'],
    price: 11.99,
    name: 'Incredible City Mug',
    description:
      'occaecati cum aut temporibus consequuntur ad repellat aut et iusto blanditiis minima suscipit',
    slug: 'Incredible-City-Mug-2',
    added: 1480963360902,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Sunset', 'Trees', 'Mountains'],
    price: 19.99,
    name: 'Tasty Mountains Mug',
    description:
      'ullam eius accusantium corrupti doloremque ab fugiat deleniti cumque laborum omnis dolores quam quidem qui ut',
    slug: 'Tasty-Mountains-Mug-2',
    added: 1481628480330,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Ocean'],
    price: 11.99,
    name: 'Awesome Ocean Mug',
    description:
      'alias natus quidem aut quidem consequuntur eius praesentium dolor nobis est error quia iste nulla dicta',
    slug: 'Awesome-Ocean-Mug-4',
    added: 1479565068757,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Sky', 'Volcano', 'Night'],
    price: 12.99,
    name: 'Intelligent Night Mug',
    description:
      'laboriosam aliquam laudantium aut vero maxime tempora modi occaecati et harum voluptates officia esse temporibus non delectus ipsa voluptatem',
    slug: 'Intelligent-Night-Mug-1',
    added: 1485772070828,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Kindle', 'Ereader'],
    price: 19.99,
    name: 'Ergonomic Kindle Mug',
    description:
      'perferendis fuga sint distinctio sunt consequatur distinctio aut ea consequuntur sint',
    slug: 'Ergonomic-Kindle-Mug',
    added: 1480212461363,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Trees', 'Cars', 'Building'],
    price: 19.99,
    name: 'Tasty Cars Mug',
    description:
      'sit neque iusto illum sed veniam enim aperiam optio at natus doloremque ratione vel velit consequatur',
    slug: 'Tasty-Cars-Mug',
    added: 1482699410854,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Lights', 'City'],
    price: 10.99,
    name: 'Refined City Mug',
    description:
      'aut repellat et nam ut incidunt ut animi distinctio voluptatum magni temporibus dignissimos quidem delectus id sit',
    slug: 'Refined-City-Mug-3',
    added: 1481335381977,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Fog', 'Mountains'],
    price: 15.99,
    name: 'Tasty Mountains Mug',
    description:
      'molestiae illum est modi enim sed dolores et sequi eum voluptatem laudantium ducimus sit nesciunt dolorem vero sit ab ea modi possimus ab quos',
    slug: 'Tasty-Mountains-Mug-3',
    added: 1481060823023,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Abstract', 'Glass', 'Building'],
    price: 12.99,
    name: 'Handcrafted Building Mug',
    description:
      'esse non qui accusantium aut aliquam debitis eum error voluptatem quisquam ut vero quod',
    slug: 'Handcrafted-Building-Mug',
    added: 1483479036003,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Surf', 'Beach', 'Ocean'],
    price: 15.99,
    name: 'Gorgeous Surf Mug',
    description:
      'iusto eius consequatur ipsum iste ullam consequatur magnam rerum modi accusamus impedit itaque dolore maiores sequi suscipit quaerat asperiores',
    slug: 'Gorgeous-Surf-Mug',
    added: 1479016837067,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean', 'Buildings'],
    price: 9.99,
    name: 'Ergonomic Ocean Mug',
    description: 'culpa aut eum ut qui nisi quia culpa labore neque',
    slug: 'Ergonomic-Ocean-Mug-1',
    added: 1479172787570,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Clothes', 'Tshirt', 'Retail'],
    price: 19.99,
    name: 'Ergonomic Tshirt Mug',
    description:
      'dolores aut nulla ex perspiciatis aut id iusto veritatis qui qui veritatis quo quo quae',
    slug: 'Ergonomic-Tshirt-Mug',
    added: 1480081392010,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Road'],
    price: 20.99,
    name: 'Sleek Road Mug',
    description:
      'minima ratione illo doloremque perspiciatis vel aperiam dolores vitae voluptate rerum at aliquam harum eos placeat quo eligendi quo minima maxime autem aut in itaque',
    slug: 'Sleek-Road-Mug-1',
    added: 1486112871787,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Cars', 'Streets', 'City', 'Architecture'],
    price: 10.99,
    name: 'Rustic City Mug',
    description:
      'eum dolore aliquam aut sint nam voluptas dolorem architecto in provident perspiciatis sed magnam quaerat asperiores consequatur et nihil dolores',
    slug: 'Rustic-City-Mug-5',
    added: 1480282976525,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Waterfall', 'Trees', 'Nature'],
    price: 17.99,
    name: 'Gorgeous Nature Mug',
    description:
      'rerum corrupti aliquid dolor occaecati facilis eligendi quia sequi animi laborum nulla qui',
    slug: 'Gorgeous-Nature-Mug-1',
    added: 1483810540400,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Water'],
    price: 15.99,
    name: 'Refined Animal Mug',
    description:
      'autem et tempore cupiditate delectus ratione perferendis et quae recusandae sapiente dicta tempora expedita aperiam recusandae eos et adipisci delectus et et omnis',
    slug: 'Refined-Animal-Mug',
    added: 1483733907958,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['River', 'Ice'],
    price: 20.99,
    name: 'Handmade River Mug',
    description:
      'consequatur architecto id culpa beatae placeat nam recusandae adipisci omnis quos et dolorem id sit reiciendis et amet rerum voluptate incidunt aut sed',
    slug: 'Handmade-River-Mug',
    added: 1480376923073,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Tulip', 'Flower'],
    price: 15.99,
    name: 'Gorgeous Tulip Mug',
    description:
      'eveniet a neque repudiandae ad quia vel repudiandae ut repellendus animi nihil quidem et non ipsa sint quibusdam necessitatibus sint tempora vitae rerum veritatis necessitatibus',
    slug: 'Gorgeous-Tulip-Mug',
    added: 1486035449611,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Silhouette'],
    price: 9.99,
    name: 'Practical Sunset Mug',
    description:
      'omnis qui ipsam voluptatibus unde quam inventore et maiores alias hic ducimus ut natus',
    slug: 'Practical-Sunset-Mug',
    added: 1481758799150,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Field', 'Person', 'Car'],
    price: 16.99,
    name: 'Generic Field Mug',
    description:
      'maxime sit et enim ducimus non et dolores voluptatibus animi molestias veritatis ut deserunt dolor',
    slug: 'Generic-Field-Mug',
    added: 1480132389058,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 15.99,
    name: 'Fantastic Beach Mug',
    description:
      'sit repellendus quam sunt voluptas sint est dicta assumenda eum sit ut fugiat quo',
    slug: 'Fantastic-Beach-Mug-1',
    added: 1485333424142,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Sand', 'Desert', 'People'],
    price: 14.99,
    name: 'Refined Desert Mug',
    description:
      'earum quasi possimus illum minima quas et perferendis sint veniam quibusdam quia veniam',
    slug: 'Refined-Desert-Mug',
    added: 1484411839541,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Hands', 'Office', 'Laptop'],
    price: 18.99,
    name: 'Ergonomic Office Mug',
    description:
      'repellat excepturi magnam sunt tempora nostrum vero fugit possimus ullam voluptatem fugiat',
    slug: 'Ergonomic-Office-Mug',
    added: 1483765569068,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Child', 'Person', 'Man', 'Father', 'Dad'],
    price: 11.99,
    name: 'Unbranded Person Mug',
    description:
      'a repudiandae ea iure quos qui porro sint quas quae quo aut debitis numquam quae asperiores et quis quaerat ab voluptatibus',
    slug: 'Unbranded-Person-Mug',
    added: 1485376040758,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Person', 'Night'],
    price: 14.99,
    name: 'Awesome Person Mug',
    description:
      'aut aut ut quidem laudantium voluptatibus omnis maxime ratione quo consectetur pariatur',
    slug: 'Awesome-Person-Mug-2',
    added: 1479706854249,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 12.99,
    name: 'Incredible Snow Mug',
    description:
      'aspernatur consequatur provident facilis ducimus voluptas nam qui dolore nulla consectetur',
    slug: 'Incredible-Snow-Mug-1',
    added: 1480573240099,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 10.99,
    name: 'Sleek Office Mug',
    description:
      'iusto aliquam voluptatum sed veniam voluptas beatae dignissimos et debitis delectus aliquid vel cum aliquam repellendus architecto doloribus ut',
    slug: 'Sleek-Office-Mug',
    added: 1478284099491,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Trees'],
    price: 14.99,
    name: 'Small Trees Mug',
    description:
      'voluptas similique id ullam repellat sapiente rerum sit cum amet illum quas voluptatem nesciunt sunt eaque sed modi mollitia velit est pariatur facilis',
    slug: 'Small-Trees-Mug-4',
    added: 1479428545949,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Alley', 'Brick'],
    price: 12.99,
    name: 'Sleek Alley Mug',
    description:
      'ducimus id esse omnis voluptatum voluptatum debitis et minima aliquam cumque eum voluptas fuga velit voluptatem sunt quo facilis ut ut',
    slug: 'Sleek-Alley-Mug',
    added: 1484635408884,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Desert'],
    price: 14.99,
    name: 'Awesome Desert Mug',
    description:
      'dolores voluptatem esse culpa consequatur amet non provident consequatur ut iusto',
    slug: 'Awesome-Desert-Mug-1',
    added: 1479331939695,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Sunset', 'Road'],
    price: 19.99,
    name: 'Small Road Mug',
    description:
      'animi aut aliquam molestiae fugit sed dolores qui placeat ea velit tenetur autem sit',
    slug: 'Small-Road-Mug',
    added: 1483360320814,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['City', 'People'],
    price: 13.99,
    name: 'Intelligent People Mug',
    description:
      'consequatur delectus repellat non voluptatem molestiae nemo quis odio quibusdam sapiente nihil distinctio labore est laborum ut qui minus cum earum labore quia nobis',
    slug: 'Intelligent-People-Mug-1',
    added: 1481166104805,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Man', 'Hands', 'Lake', 'People'],
    price: 13.99,
    name: 'Intelligent Lake Mug',
    description:
      'omnis corporis autem nulla maxime error aliquam occaecati qui minus a voluptatem voluptatem exercitationem consequatur',
    slug: 'Intelligent-Lake-Mug',
    added: 1481972151967,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Train', 'Railroad'],
    price: 10.99,
    name: 'Handmade Railroad Mug',
    description:
      'corporis nesciunt et rem laboriosam est iste distinctio non vero at laudantium molestiae id excepturi dolor officia odit et',
    slug: 'Handmade-Railroad-Mug',
    added: 1478289703127,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Leopard'],
    price: 10.99,
    name: 'Small Animal Mug',
    description:
      'eum recusandae commodi dignissimos eaque reiciendis accusantium veritatis porro blanditiis voluptas et ad quam velit adipisci',
    slug: 'Small-Animal-Mug-1',
    added: 1483754660899,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Nature', 'Mountains'],
    price: 15.99,
    name: 'Handmade Snow Mug',
    description:
      'non odit corrupti ipsa excepturi aliquam rem natus quasi enim vitae perferendis rerum itaque quibusdam deserunt voluptatem officia illo facilis',
    slug: 'Handmade-Snow-Mug-2',
    added: 1483458846532,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Arch', 'Abstract', 'Architecture'],
    price: 16.99,
    name: 'Sleek Abstract Mug',
    description:
      'necessitatibus voluptatum similique nostrum iure possimus corrupti perferendis beatae consequuntur amet rerum porro eos',
    slug: 'Sleek-Abstract-Mug',
    added: 1480167768490,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Man', 'City'],
    price: 13.99,
    name: 'Ergonomic City Mug',
    description:
      'qui praesentium consectetur facere nam nesciunt temporibus maxime facilis aut consequatur ad quibusdam fugiat excepturi voluptatibus sint',
    slug: 'Ergonomic-City-Mug-1',
    added: 1482149322845,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Field', 'Farm'],
    price: 12.99,
    name: 'Refined Field Mug',
    description:
      'maiores animi voluptatibus accusamus minus sunt repellendus blanditiis maiores eum id distinctio molestiae velit blanditiis',
    slug: 'Refined-Field-Mug',
    added: 1478103512265,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Night', 'Stars', 'Silhouette'],
    price: 13.99,
    name: 'Practical Silhouette Mug',
    description:
      'cumque aut tenetur voluptatem doloribus sint incidunt dolor et eum rerum officiis excepturi non et sit quis dicta et suscipit aut laudantium enim unde temporibus',
    slug: 'Practical-Silhouette-Mug',
    added: 1479559128701,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Transportation', 'Railroad', 'Train'],
    price: 18.99,
    name: 'Small Transportation Mug',
    description:
      'provident voluptatem nesciunt labore ex ratione beatae expedita facere temporibus',
    slug: 'Small-Transportation-Mug',
    added: 1480561849489,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'City', 'Buildings'],
    price: 15.99,
    name: 'Small Sunset Mug',
    description:
      'fugiat velit rerum minus qui reiciendis reprehenderit impedit mollitia autem qui labore ut sit ipsam',
    slug: 'Small-Sunset-Mug-5',
    added: 1480474820751,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Hands', 'Piano', 'People'],
    price: 16.99,
    name: 'Intelligent People Mug',
    description:
      'iusto facere minus dolorem sit et quas totam ratione sit placeat voluptas molestias',
    slug: 'Intelligent-People-Mug-2',
    added: 1480289197518,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Building'],
    price: 16.99,
    name: 'Awesome Building Mug',
    description:
      'ut sapiente quo dolores consequatur et quasi similique reprehenderit sint eveniet esse autem quae corrupti et illo explicabo sunt eius',
    slug: 'Awesome-Building-Mug-1',
    added: 1480120411833,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Beach', 'People'],
    price: 12.99,
    name: 'Fantastic People Mug',
    description:
      'qui odio itaque est est dolore ipsam dolores eveniet similique omnis ab et sit provident nihil est dolorem aut',
    slug: 'Fantastic-People-Mug',
    added: 1486256575764,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Cloud', 'Antique'],
    price: 17.99,
    name: 'Generic Cloud Mug',
    description:
      'voluptates totam voluptates adipisci quia voluptas aperiam asperiores nobis quod voluptatem vero modi quia asperiores repellendus ullam',
    slug: 'Generic-Cloud-Mug',
    added: 1484861513518,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Animal', 'Cat'],
    price: 10.99,
    name: 'Licensed Cat Mug',
    description:
      'necessitatibus modi et facilis vel dicta suscipit aut sit quo iste dolorem iste fuga cum voluptatum iure consequuntur velit facilis eum unde impedit',
    slug: 'Licensed-Cat-Mug',
    added: 1481805522019,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 17.99,
    name: 'Gorgeous Fog Mug',
    description:
      'veniam velit ea natus optio et assumenda assumenda esse et et fugit quia ut unde reiciendis natus',
    slug: 'Gorgeous-Fog-Mug-2',
    added: 1482036660998,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'People'],
    price: 12.99,
    name: 'Small Fog Mug',
    description:
      'velit soluta perspiciatis nihil sed qui aliquid commodi esse ut',
    slug: 'Small-Fog-Mug-2',
    added: 1484772528166,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Machine', 'Stars', 'Space'],
    price: 15.99,
    name: 'Sleek Space Mug',
    description:
      'dolorem quo ea dolores dolorum voluptas qui non voluptatem debitis voluptatum',
    slug: 'Sleek-Space-Mug',
    added: 1482804501366,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest', 'Railroad'],
    price: 12.99,
    name: 'Incredible Forest Mug',
    description:
      'dolorum provident blanditiis dolor soluta doloribus consectetur facilis aliquid sint',
    slug: 'Incredible-Forest-Mug',
    added: 1484824930111,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Person', 'Fog'],
    price: 18.99,
    name: 'Intelligent Snow Mug',
    description:
      'tempore ratione rerum excepturi ullam ipsam eveniet in quas unde iste quisquam eum voluptates perferendis soluta ut cum consequatur',
    slug: 'Intelligent-Snow-Mug',
    added: 1481013859620,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Strawberries', 'Food', 'Fruit'],
    price: 19.99,
    name: 'Small Fruit Mug',
    description:
      'fuga quis incidunt tempora beatae error ipsa qui rerum consectetur deleniti aperiam qui',
    slug: 'Small-Fruit-Mug',
    added: 1484531802533,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Nature', 'Forest'],
    price: 16.99,
    name: 'Unbranded Nature Mug',
    description:
      'nisi laudantium aut quod rem placeat ipsum molestiae atque quis voluptatum omnis nostrum itaque facilis ea aliquam doloribus fugit a est vitae sequi',
    slug: 'Unbranded-Nature-Mug-1',
    added: 1484573287058,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Scuba dive', 'Diver', 'People'],
    price: 10.99,
    name: 'Practical People Mug',
    description:
      'qui quibusdam harum tenetur aspernatur accusantium consequatur atque eaque aliquid necessitatibus error sint totam amet non nostrum vitae magnam debitis',
    slug: 'Practical-People-Mug-1',
    added: 1478261470204,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Railroad'],
    price: 10.99,
    name: 'Refined Railroad Mug',
    description:
      'qui praesentium repellat quos aut accusantium qui aspernatur ducimus rerum minima et saepe enim vel dolor',
    slug: 'Refined-Railroad-Mug',
    added: 1483753836475,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Snow', 'Trees'],
    price: 12.99,
    name: 'Handmade Trees Mug',
    description:
      'natus omnis veniam vitae voluptates et est eligendi deserunt veniam non commodi tempore sequi exercitationem temporibus',
    slug: 'Handmade-Trees-Mug-2',
    added: 1485918130865,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Ferris wheel', 'Machine'],
    price: 9.99,
    name: 'Licensed Ferris Wheel Mug',
    description:
      'ratione vel iste eaque et sequi aut eius facilis odio eos eaque ullam quae consectetur adipisci est quis delectus excepturi cum atque pariatur',
    slug: 'Licensed-Ferris-Wheel-Mug',
    added: 1485759574277,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Hands', 'Map'],
    price: 14.99,
    name: 'Intelligent Hands Mug',
    description:
      'sit aut ipsa porro at enim dolorum et repellendus beatae earum molestias perspiciatis quisquam suscipit magni quod et sint velit',
    slug: 'Intelligent-Hands-Mug',
    added: 1480300927120,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Sunset', 'Clouds'],
    price: 13.99,
    name: 'Generic Sunset Mug',
    description:
      'ab sed numquam doloribus optio et excepturi distinctio vel praesentium sint sunt aliquid id odio omnis consequuntur sit quia unde qui amet temporibus illum quidem',
    slug: 'Generic-Sunset-Mug-1',
    added: 1479450069773,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Hands', 'Woman', 'Camera'],
    price: 16.99,
    name: 'Fantastic Woman Mug',
    description:
      'fuga adipisci asperiores sed omnis sit consectetur voluptatem voluptas asperiores sequi voluptas aliquid aut rerum ea totam facere beatae velit',
    slug: 'Fantastic-Woman-Mug',
    added: 1485268853534,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Old', 'Car'],
    price: 14.99,
    name: 'Sleek Car Mug',
    description:
      'ullam non et recusandae accusamus fugit quasi suscipit inventore nostrum est id sint perspiciatis sint commodi aspernatur molestiae quod dignissimos commodi corrupti doloribus exercitationem',
    slug: 'Sleek-Car-Mug',
    added: 1479234904523,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Waterfall', 'Nature', 'Rocks'],
    price: 9.99,
    name: 'Gorgeous Rocks Mug',
    description:
      'quia autem hic tempore nemo asperiores eveniet iusto voluptatibus esse sint voluptatem adipisci quas delectus sed officiis maxime omnis',
    slug: 'Gorgeous-Rocks-Mug',
    added: 1483533976089,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Mountains'],
    price: 19.99,
    name: 'Awesome Sky Mug',
    description:
      'fugiat tempora possimus ullam vel minus qui alias consequatur deserunt magni',
    slug: 'Awesome-Sky-Mug',
    added: 1485193456302,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Lake'],
    price: 16.99,
    name: 'Tasty Lake Mug',
    description:
      'necessitatibus placeat sit sunt perferendis ad dolor ut suscipit quaerat debitis',
    slug: 'Tasty-Lake-Mug',
    added: 1481103719249,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Food'],
    price: 14.99,
    name: 'Sleek Food Mug',
    description:
      'ipsam non praesentium quo assumenda sunt ab aut at aut dolorem consequatur',
    slug: 'Sleek-Food-Mug',
    added: 1479966366266,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Mountains', 'Road'],
    price: 16.99,
    name: 'Tasty Fog Mug',
    description:
      'quas sed repellat quisquam sunt ad perspiciatis qui tempore nam eum non eum vitae quo fugiat dicta architecto corporis porro ab aut fuga',
    slug: 'Tasty-Fog-Mug-1',
    added: 1484253778305,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Antique', 'Typewriter', 'Machine'],
    price: 16.99,
    name: 'Sleek Typewriter Mug',
    description:
      'aliquid reiciendis ab sit enim ut fugiat quia cupiditate ut sit sunt ad aspernatur quam culpa',
    slug: 'Sleek-Typewriter-Mug',
    added: 1478330763440,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Light'],
    price: 15.99,
    name: 'Generic Person Mug',
    description:
      'ex nulla cumque qui eveniet veritatis est voluptas quisquam sint qui sunt tempore quod debitis et fugit accusantium delectus repellat voluptatem voluptatem tenetur quis nulla',
    slug: 'Generic-Person-Mug-1',
    added: 1478931230678,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Waves', 'Water'],
    price: 17.99,
    name: 'Unbranded Water Mug',
    description:
      'similique officiis est possimus vitae numquam dolore occaecati aliquid optio doloribus tempora ducimus qui ut qui et ab similique omnis ea quos provident sit repellendus',
    slug: 'Unbranded-Water-Mug-2',
    added: 1479366703940,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Shoes', 'Person', 'Feet'],
    price: 20.99,
    name: 'Awesome Person Mug',
    description:
      'libero corrupti aliquam sint voluptatem incidunt velit nemo accusamus delectus sit impedit ea sint impedit et aut odio provident',
    slug: 'Awesome-Person-Mug-3',
    added: 1479168380075,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['City', 'People'],
    price: 12.99,
    name: 'Rustic People Mug',
    description:
      'et aut at similique nostrum nisi repellat repellat voluptatem repudiandae at quia',
    slug: 'Rustic-People-Mug-1',
    added: 1485209606003,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Field'],
    price: 17.99,
    name: 'Ergonomic Field Mug',
    description:
      'qui repudiandae ea consequatur sapiente qui beatae facere delectus pariatur fugit odio cumque illo deleniti consequatur exercitationem ut aut',
    slug: 'Ergonomic-Field-Mug',
    added: 1484618297123,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Road'],
    price: 11.99,
    name: 'Licensed Trees Mug',
    description:
      'suscipit ipsa sit amet rerum voluptatem facere eveniet mollitia veniam ut aliquid rerum asperiores quas harum quis necessitatibus veniam incidunt sunt ipsum aut eaque',
    slug: 'Licensed-Trees-Mug',
    added: 1478323599695,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Meadow', 'Flowers'],
    price: 9.99,
    name: 'Rustic Meadow Mug',
    description:
      'sint recusandae culpa eos tempora eos excepturi consectetur ipsa aut quisquam voluptatem',
    slug: 'Rustic-Meadow-Mug',
    added: 1485298702561,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Person', 'Lake'],
    price: 10.99,
    name: 'Awesome Mountain Mug',
    description:
      'id reiciendis vitae corrupti et aut ad aut saepe atque aut provident et ea inventore eveniet nam quia et error quidem omnis voluptas',
    slug: 'Awesome-Mountain-Mug',
    added: 1480625588251,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Nature', 'Mountains', 'Road', 'Clouds'],
    price: 10.99,
    name: 'Gorgeous Nature Mug',
    description:
      'id vero excepturi iure quaerat qui quidem voluptas aperiam et perferendis est repellendus ut ut quibusdam expedita vel aut debitis labore',
    slug: 'Gorgeous-Nature-Mug-2',
    added: 1481968858016,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Night', 'Stars'],
    price: 20.99,
    name: 'Incredible Stars Mug',
    description:
      'deserunt quod repellendus tempore rerum odio rerum qui alias quam laboriosam officiis sed maxime dolor natus aut et consequuntur et blanditiis minima',
    slug: 'Incredible-Stars-Mug',
    added: 1483658806378,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Person', 'Coffee', 'Book', 'Camera'],
    price: 11.99,
    name: 'Tasty Coffee Mug',
    description:
      'laudantium laboriosam amet error suscipit ut voluptatem omnis quae recusandae placeat voluptate saepe eaque',
    slug: 'Tasty-Coffee-Mug',
    added: 1480928859618,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Flower'],
    price: 19.99,
    name: 'Intelligent Flower Mug',
    description:
      'alias ipsa pariatur sed dolor laboriosam labore laboriosam unde esse consequatur voluptas ad earum quod aut cupiditate harum',
    slug: 'Intelligent-Flower-Mug',
    added: 1485645005756,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Trees', 'Fog'],
    price: 10.99,
    name: 'Sleek Trees Mug',
    description:
      'ratione incidunt et ipsam molestias modi earum nesciunt consequatur et velit hic molestiae qui vero aperiam commodi velit totam',
    slug: 'Sleek-Trees-Mug-1',
    added: 1481592646789,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 10.99,
    name: 'Rustic Office Mug',
    description:
      'explicabo ipsam cupiditate omnis magnam ut voluptatum voluptatem dolorum sed enim saepe eligendi porro aspernatur tempore sit occaecati',
    slug: 'Rustic-Office-Mug-1',
    added: 1485292640715,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Macro', 'Bamboo'],
    price: 18.99,
    name: 'Generic Bamboo Mug',
    description:
      'quam et laudantium expedita iusto ex ut asperiores dolor blanditiis aut velit repudiandae et quos officiis incidunt beatae eius itaque quis quae asperiores dolorem sit',
    slug: 'Generic-Bamboo-Mug',
    added: 1482866094395,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Dog', 'Animal', 'Puppy'],
    price: 16.99,
    name: 'Licensed Puppy Mug',
    description:
      'at pariatur aut sit sunt et suscipit illum illum repellat quo aut ut deserunt distinctio eius asperiores',
    slug: 'Licensed-Puppy-Mug',
    added: 1479594656243,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['City', 'Buildings'],
    price: 11.99,
    name: 'Incredible City Mug',
    description:
      'sint maxime molestiae facere eum accusantium quis blanditiis impedit aliquam quia adipisci atque ex minus deserunt voluptas dolorem dolor',
    slug: 'Incredible-City-Mug-3',
    added: 1479378536705,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Tree', 'Fog'],
    price: 20.99,
    name: 'Handmade Tree Mug',
    description:
      'corporis enim sit a dolores distinctio omnis a fugiat dicta asperiores qui mollitia',
    slug: 'Handmade-Tree-Mug-1',
    added: 1482749360110,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Sky', 'Night'],
    price: 14.99,
    name: 'Incredible Sky Mug',
    description:
      'numquam atque rerum ex nulla voluptatem non non soluta vitae recusandae aspernatur et provident nobis ut ut et quis molestiae reiciendis tempore rerum sit distinctio',
    slug: 'Incredible-Sky-Mug-1',
    added: 1480750864903,
    manufacturer: 'OHara-Group',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 9.99,
    name: 'Awesome Snow Mug',
    description:
      'non distinctio ipsum et delectus porro voluptas facilis placeat voluptatem a architecto est qui fugit culpa rerum',
    slug: 'Awesome-Snow-Mug-1',
    added: 1482040693203,
    manufacturer: 'Metz---Kautzer',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 11.99,
    name: 'Incredible Water Mug',
    description:
      'facere sint eius eum cupiditate molestiae non sit dolorem rerum laudantium facilis quia qui sint perspiciatis dolores maiores voluptatem corrupti repudiandae architecto corrupti aliquam',
    slug: 'Incredible-Water-Mug',
    added: 1480794134896,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Nature', 'Fog'],
    price: 19.99,
    name: 'Sleek Fog Mug',
    description:
      'numquam nam quisquam enim velit dolor nesciunt sunt quia reprehenderit voluptatibus mollitia unde minima vel qui autem aut voluptatem',
    slug: 'Sleek-Fog-Mug-3',
    added: 1481807180426,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'mug',
  },
  {
    tags: ['Plants', 'Succulents'],
    price: 16.99,
    name: 'Fantastic Succulents Mug',
    description:
      'aut tenetur quia sed dolore quo ipsum porro cumque temporibus exercitationem a ut numquam pariatur',
    slug: 'Fantastic-Succulents-Mug',
    added: 1480093327643,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Wave', 'Ocean', 'Water'],
    price: 13.99,
    name: 'Gorgeous Water Mug',
    description:
      'reiciendis explicabo velit itaque ipsum repellat non ut voluptatem a repellendus fugit quia ullam est molestias',
    slug: 'Gorgeous-Water-Mug-2',
    added: 1479318838064,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Person', 'Mountains', 'Silhouette'],
    price: 14.99,
    name: 'Sleek Person Mug',
    description:
      'soluta earum non aut nam officia voluptatem sunt voluptatum quae reiciendis deserunt inventore autem aut reprehenderit voluptate et porro nisi',
    slug: 'Sleek-Person-Mug',
    added: 1485130975799,
    manufacturer: 'Boyle-LLC',
    itemType: 'mug',
  },
  {
    tags: ['Hand', 'Night'],
    price: 17.99,
    name: 'Small Hand Mug',
    description:
      'iusto alias laboriosam temporibus cumque saepe et perspiciatis sunt minus vitae sapiente doloremque sint qui expedita',
    slug: 'Small-Hand-Mug',
    added: 1482284576465,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Terminal', 'Stairs'],
    price: 13.99,
    name: 'Practical Terminal Mug',
    description:
      'dolorem odit maiores veniam pariatur minus error fugiat voluptas totam sunt corporis excepturi consectetur rem expedita',
    slug: 'Practical-Terminal-Mug',
    added: 1480805315086,
    manufacturer: 'Rice-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Fog', 'Water'],
    price: 15.99,
    name: 'Handcrafted Water Mug',
    description:
      'aut debitis rerum magnam delectus quod sint tenetur odit ut neque sit id',
    slug: 'Handcrafted-Water-Mug',
    added: 1482941232461,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Snow', 'Mountains'],
    price: 13.99,
    name: 'Refined Mountains Mug',
    description:
      'omnis cupiditate quaerat illo omnis culpa repellat ipsam vel quos asperiores culpa voluptatem aperiam',
    slug: 'Refined-Mountains-Mug-1',
    added: 1482739482434,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 14.99,
    name: 'Intelligent Snow Mug',
    description:
      'earum veritatis recusandae dolores et dolor laboriosam in voluptas quia laborum et qui temporibus',
    slug: 'Intelligent-Snow-Mug-1',
    added: 1481915385031,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'mug',
  },
  {
    tags: ['Arial', 'Forest'],
    price: 15.99,
    name: 'Rustic Forest Mug',
    description:
      'cumque facere nostrum quae atque sed voluptatum quaerat voluptates laudantium dolores enim quas quo reprehenderit omnis molestiae ipsum officia ipsa magni laudantium',
    slug: 'Rustic-Forest-Mug',
    added: 1485707608788,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Sunset', 'Dock', 'Ocean'],
    price: 11.99,
    name: 'Ergonomic Ocean Mug',
    description:
      'porro a nulla nihil est corrupti dolorum temporibus sed et illum voluptatum ut ab',
    slug: 'Ergonomic-Ocean-Mug-2',
    added: 1481247501747,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'mug',
  },
  {
    tags: ['Snow', 'Animal', 'Wolf'],
    price: 19.99,
    name: 'Practical Snow Mug',
    description:
      'omnis consequatur quas aut consectetur enim tempora fugiat consequatur fuga quis eaque excepturi necessitatibus',
    slug: 'Practical-Snow-Mug',
    added: 1483662150857,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 9.99,
    name: 'Fantastic Trees Mug',
    description:
      'praesentium fuga sit velit rerum laborum earum non officiis incidunt delectus debitis',
    slug: 'Fantastic-Trees-Mug',
    added: 1478487274133,
    manufacturer: 'Bernier-Hane',
    itemType: 'mug',
  },
  {
    tags: ['Desert', 'Road'],
    price: 12.99,
    name: 'Handmade Desert Mug',
    description:
      'asperiores fuga dolorem ipsam ab corporis adipisci assumenda earum quia',
    slug: 'Handmade-Desert-Mug',
    added: 1479713722871,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Bird', 'Water'],
    price: 12.99,
    name: 'Handcrafted Ocean Mug',
    description:
      'est quis nulla aut aliquid aut et sit totam vitae ipsum doloribus similique quia eos porro ratione est hic fugiat molestias velit iste repellendus',
    slug: 'Handcrafted-Ocean-Mug-4',
    added: 1481005364810,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'mug',
  },
  {
    tags: ['Food'],
    price: 18.99,
    name: 'Licensed Food Mug',
    description:
      'illo ipsa aperiam laudantium enim animi id sed possimus aspernatur nesciunt quos aliquid molestiae deserunt quo porro quam velit laboriosam nisi voluptates corporis',
    slug: 'Licensed-Food-Mug',
    added: 1483944905788,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Cars'],
    price: 13.99,
    name: 'Rustic Cars Mug',
    description:
      'minima quis perspiciatis eos suscipit enim facere accusamus quis provident cupiditate sed nihil ea rerum cupiditate ut ipsum eius',
    slug: 'Rustic-Cars-Mug',
    added: 1481026075988,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Typewriter', 'Paper', 'Book'],
    price: 11.99,
    name: 'Handmade Paper Mug',
    description:
      'ea corrupti dolorem velit laborum ut sapiente dolore hic eum rerum deleniti quas et modi et ipsa quis ut dolorem velit occaecati',
    slug: 'Handmade-Paper-Mug',
    added: 1479423050974,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Ocean', 'Cliffs'],
    price: 19.99,
    name: 'Practical Ocean Mug',
    description:
      'expedita corporis deserunt odit voluptate hic iure beatae omnis distinctio voluptas itaque quo ut omnis',
    slug: 'Practical-Ocean-Mug-7',
    added: 1486233137811,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'mug',
  },
  {
    tags: ['Volcano', 'Nature', 'Desert'],
    price: 20.99,
    name: 'Unbranded Nature Mug',
    description:
      'eum aut sit incidunt quos qui aut autem vel nemo reprehenderit',
    slug: 'Unbranded-Nature-Mug-2',
    added: 1479780345774,
    manufacturer: 'Konopelski-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 14.99,
    name: 'Gorgeous Office Mug',
    description:
      'adipisci harum et consectetur nemo quidem at eos earum nostrum eveniet ut mollitia qui inventore modi sed nulla eos',
    slug: 'Gorgeous-Office-Mug',
    added: 1481415556875,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'mug',
  },
  {
    tags: ['Bridge'],
    price: 12.99,
    name: 'Unbranded Bridge Mug',
    description:
      'nemo rem perspiciatis in ut asperiores nulla atque et ipsum voluptatem voluptatem est repellat hic corrupti veritatis et rerum voluptatem vel nostrum',
    slug: 'Unbranded-Bridge-Mug',
    added: 1484783118468,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'mug',
  },
  {
    tags: ['Coffee', 'Hands'],
    price: 19.99,
    name: 'Refined Hands Mug',
    description:
      'sed ipsum illo temporibus perferendis nobis voluptate sit doloremque fugiat nihil voluptas repellendus voluptatem dicta optio excepturi',
    slug: 'Refined-Hands-Mug',
    added: 1485249135518,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Desk', 'Office', 'Laptop'],
    price: 18.99,
    name: 'Sleek Desk Mug',
    description:
      'tempora sit vero ut quia veniam numquam voluptatem vero laborum fugiat et sunt asperiores distinctio aut nesciunt perspiciatis non nihil dolorum omnis iusto perferendis',
    slug: 'Sleek-Desk-Mug-2',
    added: 1479194380484,
    manufacturer: 'Sipes-Inc',
    itemType: 'mug',
  },
  {
    tags: ['Pipe', 'Fog'],
    price: 16.99,
    name: 'Intelligent Fog Mug',
    description:
      'dolore non quia consequatur ad suscipit assumenda placeat reiciendis tenetur omnis recusandae est repudiandae non libero id qui fugit sunt nam rerum fugiat',
    slug: 'Intelligent-Fog-Mug-3',
    added: 1478012555556,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'mug',
  },
  {
    tags: ['Walrus', 'Animal'],
    price: 13.99,
    name: 'Rustic Animal Mug',
    description:
      'velit amet voluptatibus porro ad autem voluptatem blanditiis aliquid qui atque',
    slug: 'Rustic-Animal-Mug',
    added: 1481541281856,
    manufacturer: 'Konopelski-Group',
    itemType: 'mug',
  },
  {
    tags: ['Mountain', 'Snow', 'Fog'],
    price: 11.99,
    name: 'Licensed Snow Mug',
    description:
      'et tenetur voluptatibus dolores eaque sed cumque et qui veniam eius saepe qui perspiciatis est expedita et est est eaque',
    slug: 'Licensed-Snow-Mug-1',
    added: 1481646647343,
    manufacturer: 'Dickens-Franecki',
    itemType: 'mug',
  },
  {
    tags: ['Trees'],
    price: 12.99,
    name: 'Intelligent Trees Shirt',
    description:
      'quaerat laboriosam esse ducimus deleniti commodi aspernatur perferendis earum hic numquam eos dolorum reiciendis minus ut rem vel molestias vel voluptatem atque ipsam nisi omnis',
    slug: 'Intelligent-Trees-Shirt',
    added: 1480356635933,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Water'],
    price: 15.99,
    name: 'Incredible Ocean Shirt',
    description:
      'quia deleniti illo numquam a non tempore veritatis expedita error vitae sint dolorum amet est voluptatum dolorum voluptas sit',
    slug: 'Incredible-Ocean-Shirt',
    added: 1483750456982,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Bear'],
    price: 10.99,
    name: 'Sleek Bear Shirt',
    description:
      'sed velit asperiores aspernatur natus impedit incidunt dolorem est consequatur qui modi ut aut quaerat aut aperiam repellat voluptas sit aut',
    slug: 'Sleek-Bear-Shirt',
    added: 1479151122535,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Road'],
    price: 18.99,
    name: 'Rustic Road Shirt',
    description:
      'est ut eveniet libero earum reprehenderit unde rerum repudiandae ea quas et quia ad dolores maxime facere',
    slug: 'Rustic-Road-Shirt',
    added: 1478869293019,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 11.99,
    name: 'Rustic Ocean Shirt',
    description:
      'rerum voluptatum sit sed suscipit ut voluptatum nobis eaque velit vel voluptatem assumenda et',
    slug: 'Rustic-Ocean-Shirt',
    added: 1484706213243,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Beach', 'Ocean'],
    price: 15.99,
    name: 'Incredible Sunset Shirt',
    description:
      'omnis ratione aut nulla quam sunt voluptatem tempora ullam corporis officia qui aut amet officiis et accusamus optio ut non perferendis hic minima tenetur',
    slug: 'Incredible-Sunset-Shirt',
    added: 1484952769395,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Rust', 'Old', 'Car'],
    price: 18.99,
    name: 'Incredible Old Shirt',
    description:
      'id nobis sint quidem quisquam id quia est facere doloribus voluptatibus molestiae sequi esse dolores quam tenetur voluptas veniam',
    slug: 'Incredible-Old-Shirt',
    added: 1479337580576,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Coffee'],
    price: 14.99,
    name: 'Incredible Coffee Shirt',
    description:
      'ut et amet consequatur enim fugit sit qui quisquam molestiae libero qui voluptas ea minima neque aspernatur id consectetur aliquam nam rerum non qui suscipit',
    slug: 'Incredible-Coffee-Shirt',
    added: 1481073778093,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'People'],
    price: 13.99,
    name: 'Handmade Fog Shirt',
    description:
      'consequatur nulla qui voluptatibus in laudantium illum consequatur facilis consequatur iusto aut eius tempore sequi laudantium qui tempora ipsam amet',
    slug: 'Handmade-Fog-Shirt',
    added: 1483606023558,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Ocean', 'Dock'],
    price: 11.99,
    name: 'Awesome Ocean Shirt',
    description:
      'nihil cupiditate quos perspiciatis saepe quae ad in omnis voluptatem rerum rerum accusamus aspernatur ut veniam',
    slug: 'Awesome-Ocean-Shirt',
    added: 1479597660159,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Hills', 'Animals', 'Sheep'],
    price: 20.99,
    name: 'Intelligent Animals Shirt',
    description:
      'vel harum error quibusdam iste consequatur asperiores hic voluptate culpa mollitia',
    slug: 'Intelligent-Animals-Shirt',
    added: 1483035620498,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Lake', 'Water'],
    price: 17.99,
    name: 'Awesome Fog Shirt',
    description:
      'nihil at sed occaecati rem sed iste optio ea minus vel nihil excepturi quia impedit ipsam sapiente vero minus',
    slug: 'Awesome-Fog-Shirt',
    added: 1482701983172,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Fog'],
    price: 13.99,
    name: 'Ergonomic Person Shirt',
    description:
      'omnis maiores quia optio qui alias quia est deleniti quasi voluptatum molestias',
    slug: 'Ergonomic-Person-Shirt',
    added: 1484826807613,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Building', 'Metal'],
    price: 12.99,
    name: 'Tasty Metal Shirt',
    description:
      'sequi magnam unde dolor accusamus fugit aperiam repellendus alias magnam ut',
    slug: 'Tasty-Metal-Shirt',
    added: 1483867925587,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Person', 'Woman', 'Meadow'],
    price: 18.99,
    name: 'Tasty Person Shirt',
    description:
      'enim consectetur omnis omnis officia atque occaecati vel consectetur tenetur quaerat praesentium illo cum rerum aliquid debitis reprehenderit atque',
    slug: 'Tasty-Person-Shirt',
    added: 1484925086682,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Coffee'],
    price: 20.99,
    name: 'Practical Coffee Shirt',
    description:
      'id doloremque sit vel nulla aut minima et officia corporis unde voluptatibus ipsam facilis doloremque totam saepe',
    slug: 'Practical-Coffee-Shirt',
    added: 1480484445426,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Road'],
    price: 13.99,
    name: 'Licensed Road Shirt',
    description: 'et unde dignissimos minima debitis autem sunt sed eum dolor',
    slug: 'Licensed-Road-Shirt',
    added: 1477857193335,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Windows', 'Architecture', 'Building'],
    price: 19.99,
    name: 'Intelligent Architecture Shirt',
    description:
      'sit qui amet minus ea aliquam possimus rem ut ab reiciendis iste dolore sit cupiditate dolor',
    slug: 'Intelligent-Architecture-Shirt',
    added: 1482072062061,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['House', 'Trees', 'Fog', 'Secluded'],
    price: 9.99,
    name: 'Fantastic Secluded Shirt',
    description:
      'aut sit id enim aut voluptas molestiae distinctio et ut quis quod magnam odit ut libero et vel dolor laborum provident cupiditate ducimus qui',
    slug: 'Fantastic-Secluded-Shirt',
    added: 1486332178759,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Wall'],
    price: 16.99,
    name: 'Incredible Architecture Shirt',
    description:
      'magni deserunt dolores voluptas dolorum necessitatibus sit vel maxime in',
    slug: 'Incredible-Architecture-Shirt',
    added: 1485504977840,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Surf', 'Ocean', 'Waves'],
    price: 18.99,
    name: 'Handmade Surf Shirt',
    description:
      'impedit nostrum quam rem ut nobis culpa qui consequatur maiores dolor sunt provident in numquam eius vitae esse',
    slug: 'Handmade-Surf-Shirt',
    added: 1481952971518,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Bike', 'City', 'People'],
    price: 15.99,
    name: 'Licensed City Shirt',
    description:
      'officiis laborum ex quia sunt laudantium dignissimos saepe nihil voluptatem dolorum eos animi a et quis autem',
    slug: 'Licensed-City-Shirt',
    added: 1485662022500,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Fog'],
    price: 12.99,
    name: 'Unbranded Fog Shirt',
    description:
      'sed debitis placeat debitis corporis vitae autem odit voluptatem ratione officia unde adipisci quas ea explicabo aut ut beatae illo',
    slug: 'Unbranded-Fog-Shirt',
    added: 1486346779480,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Rust', 'Machine', 'Car'],
    price: 11.99,
    name: 'Handmade Machine Shirt',
    description:
      'iure sunt officiis ad quis ullam minus doloremque ut dolorem ut impedit odio aliquid consectetur voluptas nam aperiam rem velit est omnis explicabo id',
    slug: 'Handmade-Machine-Shirt',
    added: 1485822187963,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Fur', 'Monkey'],
    price: 11.99,
    name: 'Intelligent Animal Shirt',
    description:
      'perferendis voluptas itaque sint dolorum consequatur ex vel quaerat ipsum ab et consectetur et et reiciendis error rerum enim sapiente',
    slug: 'Intelligent-Animal-Shirt',
    added: 1486202035491,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Machine', 'Ocean'],
    price: 15.99,
    name: 'Generic Machine Shirt',
    description:
      'sed quod corporis praesentium voluptas provident sequi fugit illo adipisci soluta non quasi pariatur quod veniam et et consequuntur magni quaerat',
    slug: 'Generic-Machine-Shirt',
    added: 1486198647908,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Planes', 'Sun', 'Clouds'],
    price: 12.99,
    name: 'Gorgeous Sun Shirt',
    description:
      'accusantium vel ipsam et ipsam vel odio unde vel ea dolor amet labore voluptatibus modi nihil autem nisi consectetur odit',
    slug: 'Gorgeous-Sun-Shirt',
    added: 1478727015797,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Television', 'Tv'],
    price: 16.99,
    name: 'Licensed Beach Shirt',
    description:
      'quod quia sit quaerat ea sint atque odio et quaerat laborum labore iusto quo et minus assumenda qui aut sapiente ut',
    slug: 'Licensed-Beach-Shirt',
    added: 1479964262166,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Grass', 'Meadow', 'Plants'],
    price: 10.99,
    name: 'Small Grass Shirt',
    description:
      'velit quos assumenda voluptate qui ipsa ratione non dolorem quia recusandae vero non voluptas est debitis ut illum',
    slug: 'Small-Grass-Shirt',
    added: 1480135105936,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['People'],
    price: 13.99,
    name: 'Unbranded People Shirt',
    description:
      'eius ex totam voluptas hic qui et repellendus quas ipsam vitae et aliquid voluptas commodi',
    slug: 'Unbranded-People-Shirt',
    added: 1484998281228,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 18.99,
    name: 'Gorgeous Beach Shirt',
    description:
      'atque praesentium qui aut modi enim omnis magni sint quaerat eum ab totam est et dicta quo explicabo quia velit nostrum quo vero',
    slug: 'Gorgeous-Beach-Shirt',
    added: 1485902810431,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['American', 'Sky', 'Patriotic', 'Flag'],
    price: 18.99,
    name: 'Fantastic Patriotic Shirt',
    description:
      'cumque qui qui quod quia deleniti corrupti eius qui dolore delectus placeat illo',
    slug: 'Fantastic-Patriotic-Shirt',
    added: 1480175013839,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 12.99,
    name: 'Refined Desk Shirt',
    description:
      'eaque similique natus maiores minima laborum ut quod ullam fuga ipsum rerum saepe laudantium pariatur autem accusamus enim totam nihil',
    slug: 'Refined-Desk-Shirt',
    added: 1486176936772,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Building'],
    price: 14.99,
    name: 'Incredible Building Shirt',
    description:
      'delectus maxime rerum ut sed sequi ea ut harum odio sit accusamus neque reprehenderit repellendus reprehenderit totam sit dolore dicta',
    slug: 'Incredible-Building-Shirt',
    added: 1480341679068,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Mugs', 'Coffee', 'Wood'],
    price: 10.99,
    name: 'Handmade Coffee Shirt',
    description:
      'repellat rerum similique laborum distinctio sit atque officiis sed quia',
    slug: 'Handmade-Coffee-Shirt',
    added: 1485960513191,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Tree', 'Plant', 'Flowers'],
    price: 15.99,
    name: 'Handcrafted Plant Shirt',
    description:
      'deserunt incidunt est sed dolorem nesciunt aut qui corrupti aliquid mollitia dolor labore quo alias omnis',
    slug: 'Handcrafted-Plant-Shirt',
    added: 1484974576810,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Metal', 'Bridge', 'People'],
    price: 20.99,
    name: 'Fantastic Bridge Shirt',
    description:
      'et deleniti perspiciatis fugiat iusto dolorem illo aliquam aut esse maxime temporibus in molestiae velit quos voluptate quos',
    slug: 'Fantastic-Bridge-Shirt',
    added: 1478990610596,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Ocean', 'Hillside'],
    price: 12.99,
    name: 'Handmade Nature Shirt',
    description:
      'laborum placeat rerum soluta voluptatibus incidunt est quaerat sit quos ex voluptate et',
    slug: 'Handmade-Nature-Shirt',
    added: 1485740380811,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Raindrops', 'Hand'],
    price: 20.99,
    name: 'Incredible Hand Shirt',
    description:
      'voluptatem aut rerum qui adipisci ut ducimus assumenda asperiores velit a quo sed aut tenetur',
    slug: 'Incredible-Hand-Shirt',
    added: 1483326968126,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Chair lift', 'Ski', 'Snowboard', 'Mountain'],
    price: 18.99,
    name: 'Refined Ski Shirt',
    description:
      'corporis voluptates odit et animi nihil totam ut iure placeat officiis quas asperiores',
    slug: 'Refined-Ski-Shirt',
    added: 1479773857785,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Waves'],
    price: 17.99,
    name: 'Rustic Ocean Shirt',
    description:
      'dignissimos quo eligendi voluptatem dignissimos earum odio consequatur dolorum numquam non sit et ut at amet labore nisi voluptas nesciunt itaque nam pariatur quibusdam',
    slug: 'Rustic-Ocean-Shirt-1',
    added: 1483457095756,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Person', 'Reflection'],
    price: 14.99,
    name: 'Ergonomic Snow Shirt',
    description:
      'doloribus aut voluptatibus corporis animi officia unde nobis autem sit ipsum qui',
    slug: 'Ergonomic-Snow-Shirt',
    added: 1479448387247,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Buildings', 'City'],
    price: 19.99,
    name: 'Gorgeous Buildings Shirt',
    description:
      'voluptatem quisquam dignissimos consequuntur voluptatum perspiciatis nisi minus voluptate qui dolor libero labore accusantium adipisci iure quae saepe est et',
    slug: 'Gorgeous-Buildings-Shirt',
    added: 1485494097865,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'City'],
    price: 15.99,
    name: 'Tasty City Shirt',
    description:
      'quibusdam aspernatur omnis perferendis fugiat dolorem sint necessitatibus nulla id molestiae est exercitationem vero eligendi et quia dolores',
    slug: 'Tasty-City-Shirt',
    added: 1480763412155,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Italy', 'Building'],
    price: 12.99,
    name: 'Tasty Architecture Shirt',
    description:
      'libero dolor ratione deleniti dolorem tenetur numquam voluptates enim repellat voluptatem temporibus occaecati explicabo sed autem minima est et atque reiciendis',
    slug: 'Tasty-Architecture-Shirt',
    added: 1485111742153,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Night', 'Stars'],
    price: 19.99,
    name: 'Intelligent Stars Shirt',
    description:
      'voluptatem nulla quidem consectetur ea ut officia aut laboriosam voluptatem vel asperiores ut quis',
    slug: 'Intelligent-Stars-Shirt',
    added: 1477809614797,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Forest'],
    price: 13.99,
    name: 'Rustic Fog Shirt',
    description:
      'repellendus sint nulla esse aut inventore minima dolorem consequatur blanditiis totam non asperiores',
    slug: 'Rustic-Fog-Shirt',
    added: 1483356993795,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Surf', 'Ocean', 'Waves'],
    price: 12.99,
    name: 'Incredible Ocean Shirt',
    description:
      'vel repellendus blanditiis ut deleniti optio laboriosam veritatis autem porro voluptatem cumque sed omnis quas ex tempore aut iste accusantium nemo architecto facere dolor',
    slug: 'Incredible-Ocean-Shirt-1',
    added: 1480376352272,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Flowers', 'People'],
    price: 13.99,
    name: 'Small Flowers Shirt',
    description:
      'quia rem laboriosam in ut eos non debitis quaerat et voluptatem ea',
    slug: 'Small-Flowers-Shirt',
    added: 1484142829862,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Wave', 'Ocean'],
    price: 11.99,
    name: 'Gorgeous Sunset Shirt',
    description:
      'aut deserunt repellendus deserunt animi quae itaque ut consequatur exercitationem dolor rerum iste temporibus sequi voluptatem voluptatibus iusto voluptatum culpa tempore ea aut qui sunt',
    slug: 'Gorgeous-Sunset-Shirt',
    added: 1483253563076,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Fog', 'Mountains', 'Bird'],
    price: 14.99,
    name: 'Fantastic Snow Shirt',
    description:
      'placeat et quos eligendi et quisquam quibusdam necessitatibus officiis qui voluptatum exercitationem at numquam accusamus aliquid molestias et est blanditiis et',
    slug: 'Fantastic-Snow-Shirt',
    added: 1481675599555,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees', 'Mountains'],
    price: 14.99,
    name: 'Gorgeous Trees Shirt',
    description:
      'possimus ex rerum maxime occaecati nesciunt inventore doloribus repellat minus incidunt quibusdam iste ad rem sed dolorem animi nihil magni iusto labore consequatur et',
    slug: 'Gorgeous-Trees-Shirt',
    added: 1478759324941,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Buildings'],
    price: 13.99,
    name: 'Ergonomic Ocean Shirt',
    description:
      'ullam qui incidunt nulla possimus consequuntur alias quia quod nihil eius nihil sint',
    slug: 'Ergonomic-Ocean-Shirt',
    added: 1485011304127,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Park', 'Swings'],
    price: 17.99,
    name: 'Small Park Shirt',
    description:
      'sint sit quia nobis vel odit illo deserunt repellat excepturi nam consequuntur sed aut deserunt inventore necessitatibus possimus aut eaque natus et eligendi et ipsum',
    slug: 'Small-Park-Shirt',
    added: 1485254716055,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Flowers'],
    price: 18.99,
    name: 'Generic Flowers Shirt',
    description:
      'quae et eum assumenda quos autem est rerum debitis ut natus deserunt eos suscipit cumque omnis',
    slug: 'Generic-Flowers-Shirt',
    added: 1478404207770,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Forest'],
    price: 13.99,
    name: 'Refined Fog Shirt',
    description:
      'quasi facere voluptas libero vitae recusandae quas nemo quae aliquid temporibus voluptas',
    slug: 'Refined-Fog-Shirt',
    added: 1485805152986,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Animals', 'Meadow', 'Cows'],
    price: 19.99,
    name: 'Tasty Meadow Shirt',
    description:
      'quibusdam repellendus atque dicta perferendis dignissimos veritatis veritatis illo neque officia aut veritatis quidem possimus officiis nobis sit voluptatibus rerum dolores vero sed voluptatem quos',
    slug: 'Tasty-Meadow-Shirt',
    added: 1479845307240,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Lights', 'Night', 'City', 'Phonebooth'],
    price: 18.99,
    name: 'Fantastic Lights Shirt',
    description:
      'velit quis fugiat saepe aliquam reprehenderit porro expedita et aut nam et eaque temporibus',
    slug: 'Fantastic-Lights-Shirt',
    added: 1485744148585,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 19.99,
    name: 'Ergonomic Snow Shirt',
    description:
      'repellendus qui beatae at impedit odit et doloremque optio nobis sit nemo doloribus sit',
    slug: 'Ergonomic-Snow-Shirt-1',
    added: 1484196944942,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 16.99,
    name: 'Ergonomic Fog Shirt',
    description:
      'officia sequi dicta numquam cupiditate voluptate vel esse natus blanditiis incidunt enim aut laborum sed ea',
    slug: 'Ergonomic-Fog-Shirt',
    added: 1480665845785,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Castle'],
    price: 10.99,
    name: 'Sleek Castle Shirt',
    description:
      'occaecati beatae nobis non cumque illum molestiae praesentium vel sit nulla nobis eveniet omnis laboriosam quo',
    slug: 'Sleek-Castle-Shirt',
    added: 1481196747887,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 12.99,
    name: 'Rustic Architecture Shirt',
    description:
      'sapiente illo hic ipsam architecto sapiente qui hic sit repudiandae tempora optio explicabo ut expedita quaerat ut maiores eius ut officia qui illum minus magni',
    slug: 'Rustic-Architecture-Shirt',
    added: 1481160350590,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'Fog', 'City'],
    price: 11.99,
    name: 'Incredible Fog Shirt',
    description:
      'laborum sint mollitia quia consequatur dignissimos consequatur occaecati similique a est eveniet aut asperiores pariatur quo repellendus',
    slug: 'Incredible-Fog-Shirt',
    added: 1481018956155,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 12.99,
    name: 'Incredible Ocean Shirt',
    description:
      'accusamus quaerat quia qui assumenda ratione at amet deserunt porro corrupti voluptas',
    slug: 'Incredible-Ocean-Shirt-2',
    added: 1485510659480,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Wolf', 'Forest'],
    price: 13.99,
    name: 'Tasty Wolf Shirt',
    description:
      'deserunt suscipit eum et rerum vitae consectetur omnis quisquam et quaerat quibusdam qui aut distinctio harum nihil omnis corrupti ut',
    slug: 'Tasty-Wolf-Shirt',
    added: 1481250025404,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Forest', 'Road', 'Trees'],
    price: 19.99,
    name: 'Generic Trees Shirt',
    description:
      'et architecto sint porro velit nesciunt hic voluptas suscipit recusandae repudiandae nulla est reiciendis et officiis praesentium consequuntur et a molestiae itaque optio vel',
    slug: 'Generic-Trees-Shirt',
    added: 1484535579794,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Abstract', 'Buildings'],
    price: 10.99,
    name: 'Handmade Sky Shirt',
    description:
      'quis fugiat provident aspernatur soluta et fugit iusto perferendis aperiam at',
    slug: 'Handmade-Sky-Shirt',
    added: 1482610895618,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees', 'Macro'],
    price: 13.99,
    name: 'Awesome Snow Shirt',
    description:
      'sequi debitis et quibusdam molestiae voluptatem eligendi soluta iusto in qui excepturi optio mollitia ab',
    slug: 'Awesome-Snow-Shirt',
    added: 1478204687343,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Sand', 'Desert'],
    price: 9.99,
    name: 'Unbranded Desert Shirt',
    description:
      'laboriosam minus nemo et reiciendis quasi eaque ut omnis rerum nihil suscipit nihil exercitationem expedita voluptates dolorem voluptatum sit',
    slug: 'Unbranded-Desert-Shirt',
    added: 1478045742987,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Central Park', 'City', 'Buildings', 'New York'],
    price: 12.99,
    name: 'Fantastic Central Park Shirt',
    description:
      'voluptates praesentium ex ad accusamus maiores error vel cupiditate dolorem tenetur rem sunt assumenda ea ut est aspernatur',
    slug: 'Fantastic-Central-Park-Shirt',
    added: 1483297810328,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Meadow', 'Flowers'],
    price: 19.99,
    name: 'Unbranded Flowers Shirt',
    description:
      'error eaque expedita adipisci atque consectetur sed quaerat pariatur omnis velit nostrum fugiat',
    slug: 'Unbranded-Flowers-Shirt',
    added: 1483173529445,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset'],
    price: 14.99,
    name: 'Handmade Sunset Shirt',
    description:
      'suscipit debitis saepe doloribus est deleniti exercitationem consequatur dolorum autem ut cumque sed nostrum inventore exercitationem dolores adipisci impedit voluptatibus asperiores esse aut est aut',
    slug: 'Handmade-Sunset-Shirt',
    added: 1480672019930,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Ocean', 'Rocks'],
    price: 16.99,
    name: 'Awesome Ocean Shirt',
    description:
      'quaerat omnis inventore esse quas tenetur corporis corporis qui facere et ipsa quia voluptatem',
    slug: 'Awesome-Ocean-Shirt-1',
    added: 1483340832157,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Sunrise', 'Meadow'],
    price: 19.99,
    name: 'Sleek Sunrise Shirt',
    description:
      'quia debitis mollitia illum qui aut nihil voluptate cum hic sed ea sed officiis autem sed optio laudantium at temporibus',
    slug: 'Sleek-Sunrise-Shirt',
    added: 1484375785542,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Forest', 'Trees', 'Fog'],
    price: 13.99,
    name: 'Ergonomic Forest Shirt',
    description:
      'consequatur enim facere id asperiores blanditiis est nemo sequi sint quidem vero hic qui voluptas illum cumque et ut',
    slug: 'Ergonomic-Forest-Shirt',
    added: 1482269976635,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Pool', 'Person', 'Water', 'Swimming'],
    price: 18.99,
    name: 'Handmade Person Shirt',
    description:
      'non excepturi aut blanditiis voluptatibus deleniti dicta illo reprehenderit animi et placeat non sit',
    slug: 'Handmade-Person-Shirt',
    added: 1482038099796,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Green beans', 'Vegetables', 'Food'],
    price: 12.99,
    name: 'Handmade Vegetables Shirt',
    description:
      'hic iure magnam autem molestiae quibusdam ex minus aut hic voluptatum iure labore illum qui dolores iusto consequatur cumque ea dicta autem perferendis suscipit',
    slug: 'Handmade-Vegetables-Shirt',
    added: 1480520994020,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains', 'Water', 'Clouds'],
    price: 12.99,
    name: 'Sleek Water Shirt',
    description:
      'commodi fuga praesentium ex tempore sit tenetur sunt ut velit sit officia iure quidem nisi natus',
    slug: 'Sleek-Water-Shirt',
    added: 1478896136368,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Station', 'People'],
    price: 19.99,
    name: 'Handcrafted People Shirt',
    description: 'earum est nostrum eos quibusdam enim labore at maxime ut cum',
    slug: 'Handcrafted-People-Shirt',
    added: 1482573613732,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Buildings', 'Architecture'],
    price: 19.99,
    name: 'Tasty Buildings Shirt',
    description:
      'minima et dolorem dolorem id ea error esse totam in maiores vel',
    slug: 'Tasty-Buildings-Shirt',
    added: 1481182348086,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'People'],
    price: 16.99,
    name: 'Generic People Shirt',
    description:
      'molestias et quia iusto consequuntur rerum facilis aut cupiditate quibusdam quisquam',
    slug: 'Generic-People-Shirt',
    added: 1480545557427,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Fog', 'Mountains'],
    price: 16.99,
    name: 'Generic Mountains Shirt',
    description:
      'impedit neque et ad quo autem nulla est qui impedit id aut iusto hic perspiciatis a similique delectus saepe harum quaerat consectetur',
    slug: 'Generic-Mountains-Shirt',
    added: 1484820291093,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Flower', 'Plants'],
    price: 13.99,
    name: 'Handmade Plants Shirt',
    description:
      'eum beatae rerum adipisci et similique sit cupiditate voluptates id sequi aliquam facere aspernatur ut et earum esse fugiat laboriosam cupiditate',
    slug: 'Handmade-Plants-Shirt',
    added: 1485965506025,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Hands', 'Phone'],
    price: 17.99,
    name: 'Licensed Sunset Shirt',
    description:
      'et corrupti laborum optio illo perferendis nam officia consequatur aliquid laborum rerum porro nostrum ut atque tenetur vel temporibus optio excepturi maiores voluptatum deleniti',
    slug: 'Licensed-Sunset-Shirt',
    added: 1483486552608,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Airplane', 'Clouds'],
    price: 14.99,
    name: 'Fantastic Sunset Shirt',
    description:
      'quia molestiae laboriosam vitae a animi est officiis sit minus asperiores suscipit veniam qui eius',
    slug: 'Fantastic-Sunset-Shirt',
    added: 1481743837911,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Deer'],
    price: 15.99,
    name: 'Ergonomic Deer Shirt',
    description:
      'eum reprehenderit et voluptatum quisquam vero nisi consequuntur dolor non nulla quod placeat et libero vel ut',
    slug: 'Ergonomic-Deer-Shirt',
    added: 1479889995267,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Bird'],
    price: 11.99,
    name: 'Handcrafted Bird Shirt',
    description:
      'non suscipit omnis amet qui suscipit expedita fuga delectus eum aliquid consequatur',
    slug: 'Handcrafted-Bird-Shirt',
    added: 1485965943841,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Train', 'Railroad', 'Freeway'],
    price: 14.99,
    name: 'Handcrafted Sunset Shirt',
    description:
      'blanditiis ad sequi quis iure vitae vel vitae autem autem porro officiis excepturi odio ea',
    slug: 'Handcrafted-Sunset-Shirt',
    added: 1481297795219,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['House', 'Pool'],
    price: 17.99,
    name: 'Intelligent House Shirt',
    description:
      'sequi sed rerum assumenda expedita sed doloremque velit quod sapiente amet fuga',
    slug: 'Intelligent-House-Shirt',
    added: 1483255600587,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Building'],
    price: 9.99,
    name: 'Fantastic Building Shirt',
    description:
      'cum similique sunt omnis adipisci quo nesciunt eum quibusdam mollitia veritatis aut corrupti iure unde velit maiores voluptas ad qui fugiat nisi tenetur veniam eveniet',
    slug: 'Fantastic-Building-Shirt',
    added: 1484752925623,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Space', 'NASA'],
    price: 16.99,
    name: 'Small NASA Shirt',
    description:
      'exercitationem cupiditate molestiae consectetur ut et cupiditate dolores asperiores deserunt quia pariatur tempore',
    slug: 'Small-NASA-Shirt',
    added: 1478163662935,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Mountains', 'Lake'],
    price: 9.99,
    name: 'Licensed Lake Shirt',
    description:
      'ipsa natus voluptas ducimus blanditiis autem dicta quaerat accusantium molestias qui sint ducimus aut quia impedit non enim in blanditiis reiciendis ea',
    slug: 'Licensed-Lake-Shirt',
    added: 1485664003700,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Bird', 'Water'],
    price: 10.99,
    name: 'Intelligent Animal Shirt',
    description:
      'nemo commodi voluptatum eius beatae facilis eum dolorem eos ab recusandae molestiae quo aliquam architecto quod a nemo qui',
    slug: 'Intelligent-Animal-Shirt-1',
    added: 1484851418870,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Winter', 'Snow', 'Trees', 'Mountains'],
    price: 9.99,
    name: 'Small Winter Shirt',
    description:
      'eos deleniti vitae et quaerat beatae est itaque quia fuga accusamus quia a molestiae suscipit sapiente eius',
    slug: 'Small-Winter-Shirt',
    added: 1484305217354,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Mountains', 'Rocks'],
    price: 12.99,
    name: 'Awesome Rocks Shirt',
    description:
      'quia unde voluptate neque omnis doloremque occaecati repudiandae dolor et',
    slug: 'Awesome-Rocks-Shirt',
    added: 1484914359834,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Statue of liberty', 'Architecture', 'Monument'],
    price: 20.99,
    name: 'Licensed Statue Of Liberty Shirt',
    description:
      'vel itaque aliquid fugit accusamus reiciendis autem earum necessitatibus sit veritatis dignissimos corporis eius dolor quam autem nam temporibus perspiciatis dolorem error aut et',
    slug: 'Licensed-Statue-Of-Liberty-Shirt',
    added: 1482957890518,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Rust', 'Car'],
    price: 15.99,
    name: 'Refined Rust Shirt',
    description:
      'nostrum eos voluptatum eveniet est voluptatem molestiae voluptatem commodi porro harum corrupti quibusdam',
    slug: 'Refined-Rust-Shirt',
    added: 1479843403876,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Married', 'Wedding', 'Bride'],
    price: 20.99,
    name: 'Practical Wedding Shirt',
    description:
      'saepe minus libero voluptatem dolor ex eum culpa vel minima omnis molestias minus incidunt vitae reiciendis possimus omnis est',
    slug: 'Practical-Wedding-Shirt',
    added: 1484414073704,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Plants', 'Cactus'],
    price: 12.99,
    name: 'Fantastic Cactus Shirt',
    description:
      'quaerat minima qui voluptas assumenda optio ut aliquam nam quo nobis amet',
    slug: 'Fantastic-Cactus-Shirt',
    added: 1484706658780,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Dock'],
    price: 15.99,
    name: 'Practical Ocean Shirt',
    description:
      'et rerum quidem voluptas rem eum maiores nobis quidem nam animi pariatur recusandae accusamus ullam est numquam esse voluptas ut',
    slug: 'Practical-Ocean-Shirt',
    added: 1481331464836,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Mountains', 'Meadow'],
    price: 12.99,
    name: 'Intelligent Nature Shirt',
    description:
      'ipsum voluptatum beatae et sit et rerum necessitatibus ipsa adipisci quaerat sit ut consequatur',
    slug: 'Intelligent-Nature-Shirt',
    added: 1486132476655,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Northern lights', 'Snow', 'Night'],
    price: 19.99,
    name: 'Handmade Night Shirt',
    description: 'cumque et delectus incidunt libero ut quo at quis atque id',
    slug: 'Handmade-Night-Shirt',
    added: 1482976152762,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Field', 'Person'],
    price: 13.99,
    name: 'Practical Sunset Shirt',
    description:
      'eum excepturi beatae ut soluta pariatur ea sunt cum facere dolores voluptas rerum ullam distinctio qui expedita et pariatur id placeat accusantium nulla',
    slug: 'Practical-Sunset-Shirt',
    added: 1483502617232,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Mountains', 'Lake'],
    price: 19.99,
    name: 'Sleek Lake Shirt',
    description:
      'ducimus ab fugit et assumenda ut quisquam dolore fuga nobis earum fuga',
    slug: 'Sleek-Lake-Shirt',
    added: 1483745401451,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Clothing', 'Person'],
    price: 20.99,
    name: 'Fantastic Person Shirt',
    description:
      'totam non est tempora maiores eum voluptas voluptate repudiandae quasi dolorem dolorem sit odio corrupti molestiae ea labore iure quae est rerum ut pariatur',
    slug: 'Fantastic-Person-Shirt',
    added: 1482428556413,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Hands', 'People'],
    price: 13.99,
    name: 'Intelligent Hands Shirt',
    description:
      'maiores voluptatum aut autem nobis recusandae nam sunt vel vitae quas at perferendis praesentium sint quos eligendi id sit rerum',
    slug: 'Intelligent-Hands-Shirt',
    added: 1477816311257,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Mountains'],
    price: 16.99,
    name: 'Unbranded Trees Shirt',
    description:
      'ea et deleniti vitae veniam blanditiis nesciunt beatae qui non doloribus illum consequuntur sed asperiores',
    slug: 'Unbranded-Trees-Shirt',
    added: 1478763888411,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees', 'Fog'],
    price: 14.99,
    name: 'Refined Fog Shirt',
    description:
      'quia eos et et alias ut voluptas velit aut libero vitae autem fugit',
    slug: 'Refined-Fog-Shirt-1',
    added: 1484829044711,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Mountains', 'Forest'],
    price: 20.99,
    name: 'Refined Mountains Shirt',
    description:
      'tempora culpa molestiae adipisci voluptatibus non quas non eos quia ab itaque accusantium fuga accusantium qui quo quia voluptas',
    slug: 'Refined-Mountains-Shirt',
    added: 1479508086628,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Plant', 'Flower', 'Macro'],
    price: 9.99,
    name: 'Rustic Plant Shirt',
    description:
      'praesentium omnis eum et excepturi qui ut doloremque deleniti omnis esse eos dolore accusamus magni nihil ex id excepturi',
    slug: 'Rustic-Plant-Shirt',
    added: 1479444525865,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Woman', 'Desert'],
    price: 15.99,
    name: 'Generic Desert Shirt',
    description:
      'perspiciatis est fuga mollitia et sunt sed eveniet voluptatem blanditiis perspiciatis sint culpa',
    slug: 'Generic-Desert-Shirt',
    added: 1486090594885,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Sunset', 'Forrest'],
    price: 18.99,
    name: 'Ergonomic Mountain Shirt',
    description:
      'suscipit sit eveniet illo repellat et eligendi aut dolorum veritatis possimus voluptate amet dignissimos amet illum nobis et cupiditate in quos tempore vel ratione',
    slug: 'Ergonomic-Mountain-Shirt',
    added: 1481337555326,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Jelly fish', 'Ocean'],
    price: 17.99,
    name: 'Gorgeous Jelly Fish Shirt',
    description:
      'sit est et officiis consequatur architecto ut enim sint recusandae',
    slug: 'Gorgeous-Jelly-Fish-Shirt',
    added: 1481473681652,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Flora', 'Flowers'],
    price: 20.99,
    name: 'Ergonomic Flora Shirt',
    description:
      'atque in aut voluptas mollitia molestiae sapiente repellendus soluta error qui eveniet enim quia non eveniet et et sapiente et est doloremque quo dignissimos',
    slug: 'Ergonomic-Flora-Shirt',
    added: 1480044309764,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings'],
    price: 17.99,
    name: 'Tasty Buildings Shirt',
    description:
      'sit deleniti voluptatem placeat qui voluptas vel saepe nemo consequatur repellat iste doloremque ad ad recusandae occaecati sint iste provident vitae',
    slug: 'Tasty-Buildings-Shirt-1',
    added: 1481358946339,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Ocean', 'Rocks'],
    price: 19.99,
    name: 'Sleek Rocks Shirt',
    description:
      'veniam doloremque pariatur in reiciendis omnis perspiciatis voluptatem et nemo necessitatibus totam',
    slug: 'Sleek-Rocks-Shirt',
    added: 1483030920359,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Plants'],
    price: 19.99,
    name: 'Licensed Ocean Shirt',
    description:
      'impedit pariatur est cum magnam ab dolorum impedit alias aut neque',
    slug: 'Licensed-Ocean-Shirt',
    added: 1486207209416,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Mountains'],
    price: 13.99,
    name: 'Handcrafted Trees Shirt',
    description:
      'sequi qui voluptatem consequatur accusantium delectus cum nostrum et dolore non earum distinctio incidunt molestias mollitia consequatur reprehenderit est sit',
    slug: 'Handcrafted-Trees-Shirt',
    added: 1481490689571,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Stairs'],
    price: 16.99,
    name: 'Awesome Fog Shirt',
    description:
      'iusto rerum expedita mollitia perspiciatis minima suscipit ut voluptatem commodi eos beatae unde odit in sint aperiam eligendi voluptatem voluptatibus rerum ullam consequuntur deserunt',
    slug: 'Awesome-Fog-Shirt-1',
    added: 1481723925352,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Stars', 'Space'],
    price: 17.99,
    name: 'Incredible Person Shirt',
    description:
      'voluptas odit ut doloribus fugiat hic et molestiae vel ullam autem vel sed et natus esse praesentium rerum deserunt quia architecto iusto',
    slug: 'Incredible-Person-Shirt',
    added: 1478210527058,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Sunrise', 'Forest'],
    price: 10.99,
    name: 'Gorgeous Sunrise Shirt',
    description:
      'nam voluptatum numquam nihil incidunt rerum libero nobis ut ipsam laudantium numquam aspernatur',
    slug: 'Gorgeous-Sunrise-Shirt',
    added: 1479699974027,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Nature', 'Mountains'],
    price: 20.99,
    name: 'Rustic Nature Shirt',
    description:
      'velit atque magnam veritatis et iure rerum dolorem aliquam qui eligendi nam deleniti sit id ad aut nemo dolores quam ad rerum',
    slug: 'Rustic-Nature-Shirt',
    added: 1479515232781,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Abstract', 'Fabric', 'Antler'],
    price: 19.99,
    name: 'Generic Fabric Shirt',
    description:
      'corporis qui consequatur ut inventore perspiciatis incidunt libero repellat et rem enim ab',
    slug: 'Generic-Fabric-Shirt',
    added: 1485382065496,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Snow'],
    price: 12.99,
    name: 'Awesome Mountain Shirt',
    description:
      'dolor delectus nesciunt vero sed est molestiae veniam fugit ducimus et ipsum quis blanditiis atque ut eum numquam consectetur',
    slug: 'Awesome-Mountain-Shirt',
    added: 1478933189505,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Building'],
    price: 9.99,
    name: 'Handcrafted Building Shirt',
    description:
      'qui quis harum et et totam ab adipisci modi maiores voluptate repellendus iure unde',
    slug: 'Handcrafted-Building-Shirt',
    added: 1481186086569,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains'],
    price: 18.99,
    name: 'Fantastic Mountains Shirt',
    description:
      'rerum provident dolor et dolorum architecto fugiat corrupti sunt similique tempore deserunt voluptates qui dolores beatae rem voluptatem',
    slug: 'Fantastic-Mountains-Shirt',
    added: 1483153178319,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Clouds'],
    price: 11.99,
    name: 'Sleek Clouds Shirt',
    description:
      'recusandae et qui alias veritatis alias aut beatae et possimus qui debitis molestias dicta laborum at placeat explicabo voluptatem hic et',
    slug: 'Sleek-Clouds-Shirt',
    added: 1484044814514,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Trees', 'Mist', 'Fog'],
    price: 20.99,
    name: 'Generic Fog Shirt',
    description:
      'non ducimus explicabo fuga qui nobis libero fugiat distinctio placeat ipsam suscipit sapiente provident reprehenderit laboriosam molestiae et quae',
    slug: 'Generic-Fog-Shirt',
    added: 1482047274070,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Dog', 'Animal'],
    price: 18.99,
    name: 'Awesome Animal Shirt',
    description:
      'voluptatem voluptate ut expedita vel qui ullam magni iste soluta similique optio',
    slug: 'Awesome-Animal-Shirt',
    added: 1483595544136,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Road', 'Trail'],
    price: 20.99,
    name: 'Tasty Road Shirt',
    description:
      'eligendi rem non ipsam nihil a quibusdam facere esse quidem autem et deserunt eos',
    slug: 'Tasty-Road-Shirt',
    added: 1482947707952,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Cup', 'Bed'],
    price: 18.99,
    name: 'Handmade Cup Shirt',
    description:
      'sed quibusdam et id labore dolore et hic et tenetur harum et atque doloremque consequatur omnis quae eos ullam maxime',
    slug: 'Handmade-Cup-Shirt',
    added: 1477916096078,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Dock', 'People'],
    price: 9.99,
    name: 'Small People Shirt',
    description:
      'ut nihil fuga dolore ex autem ipsum eum quas dolores quo quasi veniam',
    slug: 'Small-People-Shirt',
    added: 1479708131396,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Road'],
    price: 14.99,
    name: 'Ergonomic Road Shirt',
    description:
      'voluptatem harum quia aut blanditiis ex consequatur possimus aut aliquam asperiores iste porro sed tempore nemo tenetur quae optio vero labore odit eligendi voluptas',
    slug: 'Ergonomic-Road-Shirt',
    added: 1483633534510,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 19.99,
    name: 'Awesome Trees Shirt',
    description:
      'quos eos temporibus voluptatum consequatur fuga voluptatem quibusdam ullam numquam et dolor eligendi quidem doloremque expedita',
    slug: 'Awesome-Trees-Shirt',
    added: 1482143808671,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Farms'],
    price: 20.99,
    name: 'Small Farms Shirt',
    description:
      'repudiandae sed velit non deleniti quasi et praesentium autem aliquid voluptate aperiam modi repudiandae eos magni aut et',
    slug: 'Small-Farms-Shirt',
    added: 1479585906137,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Cliff', 'Lighthouse', 'Ocean'],
    price: 17.99,
    name: 'Practical Lighthouse Shirt',
    description:
      'nobis cumque sit mollitia provident dolor totam aut error dolore quia amet ea qui consectetur quo cupiditate voluptas laudantium labore vel minus',
    slug: 'Practical-Lighthouse-Shirt',
    added: 1483235573776,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'Night'],
    price: 19.99,
    name: 'Handcrafted Night Shirt',
    description:
      'occaecati blanditiis sit sit eum optio praesentium atque consequatur similique',
    slug: 'Handcrafted-Night-Shirt',
    added: 1479928558807,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'City', 'Building'],
    price: 11.99,
    name: 'Gorgeous Building Shirt',
    description:
      'enim iusto et iusto minus quam incidunt voluptatem reiciendis velit distinctio itaque ut debitis tenetur ut est aliquid ut dolores et quae corrupti ipsum consequuntur',
    slug: 'Gorgeous-Building-Shirt',
    added: 1478613171412,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Grass', 'Ocean'],
    price: 9.99,
    name: 'Rustic Ocean Shirt',
    description:
      'cupiditate aut ex ut autem et ipsum illum quaerat ducimus eum nobis dolorem atque hic ea vitae fugiat repudiandae dolorem',
    slug: 'Rustic-Ocean-Shirt-2',
    added: 1479994928044,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Plant', 'Table', 'Blue'],
    price: 14.99,
    name: 'Generic Table Shirt',
    description:
      'minus laudantium magnam non pariatur est ipsum earum aut corporis quia ut',
    slug: 'Generic-Table-Shirt',
    added: 1481163977210,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Valley', 'Fog', 'Mountains'],
    price: 15.99,
    name: 'Handcrafted Fog Shirt',
    description:
      'totam minus quisquam temporibus est voluptatem dolor vitae maiores nemo ducimus',
    slug: 'Handcrafted-Fog-Shirt',
    added: 1485955935673,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains'],
    price: 9.99,
    name: 'Ergonomic Mountains Shirt',
    description:
      'eum ex nisi quod ex officia consequatur possimus voluptatem aut fuga',
    slug: 'Ergonomic-Mountains-Shirt',
    added: 1483258084824,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Lights', 'City', 'Buildings', 'River'],
    price: 18.99,
    name: 'Generic River Shirt',
    description:
      'iure et est placeat sed aut tenetur qui et quisquam et nam ipsam sit qui aut provident id doloribus expedita necessitatibus',
    slug: 'Generic-River-Shirt',
    added: 1480910241337,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Classic', 'Car'],
    price: 9.99,
    name: 'Practical Car Shirt',
    description:
      'earum optio modi facilis iure nulla eius necessitatibus reiciendis non error non sit vel maxime ipsam',
    slug: 'Practical-Car-Shirt',
    added: 1480032793890,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Ocean', 'Rocks'],
    price: 19.99,
    name: 'Handmade Rocks Shirt',
    description:
      'sit sunt quod et voluptatem et odit eos praesentium fuga odio et',
    slug: 'Handmade-Rocks-Shirt',
    added: 1481151382830,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Meadow', 'Plants'],
    price: 15.99,
    name: 'Fantastic Meadow Shirt',
    description:
      'est nihil autem consectetur temporibus porro aut et sit excepturi quo nesciunt eum itaque quisquam quidem sapiente quasi et pariatur architecto',
    slug: 'Fantastic-Meadow-Shirt',
    added: 1482257699247,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 12.99,
    name: 'Generic Ocean Shirt',
    description:
      'voluptatibus omnis quo culpa et iste occaecati at rerum in cumque',
    slug: 'Generic-Ocean-Shirt',
    added: 1484305092344,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'City', 'Buildings', 'People'],
    price: 19.99,
    name: 'Sleek City Shirt',
    description:
      'vitae consequatur quo facilis nihil fugit facere aut aut sapiente pariatur eos commodi aut qui vero omnis neque adipisci sed',
    slug: 'Sleek-City-Shirt',
    added: 1483879120843,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Chairs', 'Office', 'Table'],
    price: 10.99,
    name: 'Ergonomic Office Shirt',
    description:
      'quia facilis doloremque voluptas ut modi odit quam in error aut praesentium dignissimos tenetur veniam veritatis',
    slug: 'Ergonomic-Office-Shirt',
    added: 1480022113572,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Alaska'],
    price: 15.99,
    name: 'Refined Alaska Shirt',
    description:
      'fuga deserunt sunt assumenda sit ut voluptas velit asperiores et rem natus minus nihil exercitationem quo harum in',
    slug: 'Refined-Alaska-Shirt',
    added: 1484389764305,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Nature', 'Ocean'],
    price: 12.99,
    name: 'Small Ocean Shirt',
    description:
      'suscipit et ea impedit maxime dolorem natus et libero veritatis dolorum eum vel deleniti libero sit consequuntur et consectetur est laboriosam',
    slug: 'Small-Ocean-Shirt',
    added: 1485214813819,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Brick'],
    price: 9.99,
    name: 'Practical Brick Shirt',
    description:
      'id tempore itaque delectus veritatis repellendus nisi odit nihil quae ducimus',
    slug: 'Practical-Brick-Shirt',
    added: 1479023265396,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Coffee'],
    price: 19.99,
    name: 'Handcrafted Coffee Shirt',
    description:
      'omnis corrupti iste modi dolor et sed culpa numquam modi iusto cum alias tempore eius vitae sunt sit est omnis explicabo corporis officiis',
    slug: 'Handcrafted-Coffee-Shirt',
    added: 1477973770256,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Glass', 'Architecture', 'Ceiling'],
    price: 17.99,
    name: 'Awesome Architecture Shirt',
    description:
      'quaerat provident quia debitis distinctio sunt voluptas est doloribus aut eos quos quae et autem non cupiditate sed',
    slug: 'Awesome-Architecture-Shirt',
    added: 1478501689399,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Snow', 'Person', 'Valley'],
    price: 11.99,
    name: 'Sleek River Shirt',
    description:
      'aspernatur voluptatem consequatur quae eaque optio aspernatur molestiae ex aliquam quo cumque beatae eius quo ut dolorem ullam quis ducimus nihil',
    slug: 'Sleek-River-Shirt',
    added: 1485361058163,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Trees'],
    price: 19.99,
    name: 'Intelligent Trees Shirt',
    description:
      'in expedita est deserunt qui aliquid repellat molestiae repellendus quae delectus distinctio non temporibus eaque explicabo cum earum',
    slug: 'Intelligent-Trees-Shirt-1',
    added: 1478244587760,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings', 'People'],
    price: 14.99,
    name: 'Tasty City Shirt',
    description:
      'soluta rerum sapiente impedit rerum eveniet incidunt rerum expedita quo quidem adipisci est aut repellat neque sed voluptatem omnis velit quasi',
    slug: 'Tasty-City-Shirt-1',
    added: 1478420614200,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees', 'Fog'],
    price: 16.99,
    name: 'Licensed Fog Shirt',
    description:
      'a aspernatur adipisci repellendus recusandae iste ipsum ut nobis cumque facere laboriosam officia ratione occaecati',
    slug: 'Licensed-Fog-Shirt',
    added: 1478853497651,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Statue of libery', 'Monument'],
    price: 11.99,
    name: 'Practical Statue Of Libery Shirt',
    description:
      'expedita enim vero necessitatibus tenetur consequatur voluptas qui saepe at deleniti commodi',
    slug: 'Practical-Statue-Of-Libery-Shirt',
    added: 1484232201447,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Mountains'],
    price: 19.99,
    name: 'Sleek Fog Shirt',
    description:
      'quo suscipit et perferendis nisi sed facilis sed consequatur ea ut quia placeat debitis placeat nobis rerum corrupti voluptate eos',
    slug: 'Sleek-Fog-Shirt',
    added: 1479156492106,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Island', 'Ocean'],
    price: 11.99,
    name: 'Fantastic Island Shirt',
    description:
      'fugiat enim omnis iusto rem inventore similique debitis eos eaque doloribus dolores unde est assumenda blanditiis alias',
    slug: 'Fantastic-Island-Shirt',
    added: 1483500741915,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Flora', 'Nature', 'Plants'],
    price: 17.99,
    name: 'Incredible Nature Shirt',
    description:
      'quos voluptatibus blanditiis quasi doloribus ipsam nisi debitis quasi dolorem sint rerum esse voluptate nostrum voluptatem placeat sit eveniet culpa maxime officia',
    slug: 'Incredible-Nature-Shirt',
    added: 1483189133468,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Bear'],
    price: 14.99,
    name: 'Rustic Animal Shirt',
    description:
      'laboriosam nobis in deserunt eum ad quae sequi repudiandae omnis provident aut',
    slug: 'Rustic-Animal-Shirt',
    added: 1482507487251,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'City'],
    price: 20.99,
    name: 'Tasty City Shirt',
    description:
      'vel inventore corporis quisquam sed saepe quae est recusandae fugit ea corrupti porro enim soluta sunt officiis corporis suscipit impedit quidem',
    slug: 'Tasty-City-Shirt-2',
    added: 1480622342075,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Mountains', 'Water'],
    price: 18.99,
    name: 'Intelligent Nature Shirt',
    description:
      'et sit soluta asperiores reprehenderit quasi quidem enim dolores et autem nihil occaecati et',
    slug: 'Intelligent-Nature-Shirt-1',
    added: 1481310283694,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Baby', 'People'],
    price: 14.99,
    name: 'Practical Baby Shirt',
    description:
      'sit ut culpa recusandae quis nihil illo voluptatem ex iste id qui voluptate',
    slug: 'Practical-Baby-Shirt',
    added: 1486000777374,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains'],
    price: 9.99,
    name: 'Refined Mountains Shirt',
    description:
      'eos quod dolorem vero et illum ea occaecati amet ducimus velit optio rerum cum vitae ab molestias reiciendis perferendis dolores et suscipit doloremque',
    slug: 'Refined-Mountains-Shirt-1',
    added: 1484687590047,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings', 'Architecture'],
    price: 19.99,
    name: 'Sleek Buildings Shirt',
    description:
      'officia beatae laudantium minima et facilis quos voluptatem fugiat debitis voluptatem dicta sit sit',
    slug: 'Sleek-Buildings-Shirt',
    added: 1481011622321,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 12.99,
    name: 'Intelligent Snow Shirt',
    description:
      'ipsum quidem perspiciatis dolores aut eos numquam minus iste magni doloremque voluptates rerum dolorem sunt possimus placeat perferendis est',
    slug: 'Intelligent-Snow-Shirt',
    added: 1479908915453,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Rain'],
    price: 13.99,
    name: 'Ergonomic Person Shirt',
    description:
      'laboriosam fugiat et et in vel quia et architecto assumenda quis dignissimos aut reprehenderit sint ea quidem sunt dolor officia et ex possimus quaerat',
    slug: 'Ergonomic-Person-Shirt-1',
    added: 1478796902221,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Boats', 'Food', 'People'],
    price: 14.99,
    name: 'Sleek Boats Shirt',
    description:
      'nobis asperiores qui cumque est quia sint dolores aut iste praesentium at ratione aut amet quae et voluptatibus',
    slug: 'Sleek-Boats-Shirt',
    added: 1479581564593,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office', 'Laptop'],
    price: 12.99,
    name: 'Tasty Desk Shirt',
    description:
      'mollitia ad unde expedita aut tempore quis vero doloribus ullam est inventore',
    slug: 'Tasty-Desk-Shirt',
    added: 1485549420605,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Meadow', 'Wood'],
    price: 20.99,
    name: 'Gorgeous Wood Shirt',
    description:
      'ut quas distinctio delectus inventore voluptatem temporibus et voluptatem veniam dolore',
    slug: 'Gorgeous-Wood-Shirt',
    added: 1486150873804,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Lake', 'Water'],
    price: 20.99,
    name: 'Refined Lake Shirt',
    description:
      'qui quo architecto ad debitis aut et qui aut placeat deleniti placeat quisquam',
    slug: 'Refined-Lake-Shirt',
    added: 1482084165714,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Beach', 'Fish'],
    price: 20.99,
    name: 'Fantastic Beach Shirt',
    description:
      'sequi reiciendis quidem consequuntur nemo molestiae ut quos nostrum velit veniam asperiores alias ut amet ea voluptatem',
    slug: 'Fantastic-Beach-Shirt',
    added: 1485482980896,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog'],
    price: 12.99,
    name: 'Small Fog Shirt',
    description:
      'et hic commodi incidunt veniam delectus incidunt quia reprehenderit aliquid quo nulla aspernatur expedita veniam veritatis quasi id dolor quisquam eos incidunt',
    slug: 'Small-Fog-Shirt',
    added: 1482432564017,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Pier', 'Dock'],
    price: 12.99,
    name: 'Rustic Pier Shirt',
    description:
      'fugiat quia aliquam et qui aut qui hic iusto quia non natus consequatur sint accusantium',
    slug: 'Rustic-Pier-Shirt',
    added: 1478209248588,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Space', 'NASA'],
    price: 13.99,
    name: 'Small NASA Shirt',
    description:
      'quis totam id saepe omnis quia dicta nulla molestiae quis qui',
    slug: 'Small-NASA-Shirt-1',
    added: 1484545453425,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'People'],
    price: 20.99,
    name: 'Fantastic Ocean Shirt',
    description:
      'vero deserunt dolor aspernatur voluptatibus iure saepe porro nemo sint facere ipsum consectetur aut animi asperiores et nihil accusamus perferendis quo recusandae impedit quaerat',
    slug: 'Fantastic-Ocean-Shirt',
    added: 1478919066553,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Nature', 'Ocean'],
    price: 11.99,
    name: 'Handcrafted Beach Shirt',
    description:
      'quibusdam alias architecto incidunt magnam soluta necessitatibus id omnis pariatur non temporibus quae molestiae aliquam nemo sunt',
    slug: 'Handcrafted-Beach-Shirt',
    added: 1484434537250,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Pool', 'Night', 'Ocean', 'Water'],
    price: 12.99,
    name: 'Handcrafted Ocean Shirt',
    description:
      'ea eius officia ex illum ipsum non et cumque illum non qui veritatis laudantium animi ut',
    slug: 'Handcrafted-Ocean-Shirt',
    added: 1483890428723,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Car', 'People'],
    price: 10.99,
    name: 'Intelligent Car Shirt',
    description:
      'minus qui ut fugit autem aut ab sit recusandae aut omnis repellat consectetur et fuga minima aut ut ut repellendus',
    slug: 'Intelligent-Car-Shirt',
    added: 1484571056028,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Bus', 'Transit', 'People'],
    price: 19.99,
    name: 'Handmade Bus Shirt',
    description:
      'qui odit tempore fugit odio praesentium impedit recusandae deleniti porro laboriosam corrupti ab et eum earum ex',
    slug: 'Handmade-Bus-Shirt',
    added: 1486083025150,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Ocean'],
    price: 16.99,
    name: 'Ergonomic Arial Shirt',
    description:
      'error distinctio veniam esse eos sint iusto harum architecto facilis facilis iste amet eveniet',
    slug: 'Ergonomic-Arial-Shirt',
    added: 1481742514496,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Beach'],
    price: 14.99,
    name: 'Small Beach Shirt',
    description:
      'qui est itaque id culpa ex voluptate ex nobis dolor omnis quod sit eos ut aut',
    slug: 'Small-Beach-Shirt',
    added: 1483422358984,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean'],
    price: 20.99,
    name: 'Incredible Ocean Shirt',
    description:
      'eos maxime nostrum inventore repellat suscipit reiciendis omnis est officia qui est ducimus recusandae consequuntur qui',
    slug: 'Incredible-Ocean-Shirt-3',
    added: 1485641497037,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Utah', 'Sand', 'Desert'],
    price: 11.99,
    name: 'Unbranded Desert Shirt',
    description:
      'autem quos alias impedit iusto aspernatur cupiditate aut ipsam alias enim consequatur deleniti saepe',
    slug: 'Unbranded-Desert-Shirt-1',
    added: 1484584429841,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Bicycle'],
    price: 11.99,
    name: 'Rustic Person Shirt',
    description:
      'unde et rerum esse ducimus doloremque distinctio atque cupiditate veritatis voluptas minus',
    slug: 'Rustic-Person-Shirt',
    added: 1479412318489,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Hands', 'Tea'],
    price: 9.99,
    name: 'Ergonomic Tea Shirt',
    description:
      'et dignissimos tempora veniam aut incidunt inventore labore blanditiis vitae commodi molestias aperiam eos eos occaecati mollitia',
    slug: 'Ergonomic-Tea-Shirt',
    added: 1482518414676,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 14.99,
    name: 'Ergonomic Water Shirt',
    description:
      'quisquam et ea soluta provident molestiae vel rerum eius voluptatem aut possimus quae laboriosam qui rem ex vel qui vel beatae placeat ut voluptatem ipsa',
    slug: 'Ergonomic-Water-Shirt',
    added: 1479020272831,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Lake', 'Fog'],
    price: 16.99,
    name: 'Generic Fog Shirt',
    description:
      'distinctio et maxime veniam nam sit ipsa quidem magni eveniet vero harum eum sit',
    slug: 'Generic-Fog-Shirt-1',
    added: 1479133752824,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 9.99,
    name: 'Awesome Trees Shirt',
    description:
      'saepe autem vitae illo autem doloribus ex fugit temporibus amet accusamus sit dolor suscipit fuga asperiores',
    slug: 'Awesome-Trees-Shirt-1',
    added: 1484983712664,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Forest'],
    price: 19.99,
    name: 'Tasty Forest Shirt',
    description:
      'error omnis porro expedita accusamus et debitis porro atque quia aperiam voluptas vero non',
    slug: 'Tasty-Forest-Shirt',
    added: 1484065700233,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 13.99,
    name: 'Sleek Ocean Shirt',
    description:
      'qui accusantium at ut aut consequatur aut ut beatae aliquid qui omnis mollitia incidunt dolor provident esse temporibus quia quo ex rerum nihil',
    slug: 'Sleek-Ocean-Shirt',
    added: 1480407118346,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Grass', 'Flowers', 'Plants'],
    price: 9.99,
    name: 'Tasty Flowers Shirt',
    description:
      'perferendis consectetur assumenda itaque qui vel neque voluptas inventore ut dicta recusandae quia',
    slug: 'Tasty-Flowers-Shirt',
    added: 1482370357342,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings'],
    price: 9.99,
    name: 'Small City Shirt',
    description:
      'architecto voluptates laudantium neque aut earum consequuntur ratione reiciendis quam natus soluta ipsam sit aut quas',
    slug: 'Small-City-Shirt',
    added: 1486007606661,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Waterfall', 'Fog', 'Mountains'],
    price: 17.99,
    name: 'Licensed Mountains Shirt',
    description:
      'consequuntur totam aut dolores commodi facere tempore suscipit id rem sed unde vitae illum dolores est dolorum qui magnam excepturi neque',
    slug: 'Licensed-Mountains-Shirt',
    added: 1481943328741,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Machine', 'Antique', 'Camera'],
    price: 13.99,
    name: 'Generic Antique Shirt',
    description:
      'eos dolorem similique aut quia est sunt voluptas sunt rerum similique fugiat consequatur et tenetur laboriosam quo illum',
    slug: 'Generic-Antique-Shirt',
    added: 1478197862051,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Guitar'],
    price: 15.99,
    name: 'Unbranded Guitar Shirt',
    description:
      'veniam aut omnis optio placeat nam provident aliquid hic vel reprehenderit consectetur nisi cupiditate impedit eos explicabo',
    slug: 'Unbranded-Guitar-Shirt',
    added: 1483916184437,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings', 'Architecture'],
    price: 18.99,
    name: 'Generic Buildings Shirt',
    description:
      'quia incidunt fugit velit rerum est ea tempore saepe animi ducimus incidunt facere aspernatur odio autem et odit et harum culpa cumque',
    slug: 'Generic-Buildings-Shirt',
    added: 1480670357420,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Night'],
    price: 10.99,
    name: 'Small Night Shirt',
    description:
      'commodi laudantium est voluptas est voluptates ea molestiae pariatur qui',
    slug: 'Small-Night-Shirt',
    added: 1483420713747,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Trees', 'Nature', 'Mountains'],
    price: 20.99,
    name: 'Awesome River Shirt',
    description:
      'non nihil consequatur mollitia ab modi modi nisi enim tempora quo necessitatibus qui vel velit ipsum alias cupiditate',
    slug: 'Awesome-River-Shirt',
    added: 1480317362529,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains', 'Sun'],
    price: 19.99,
    name: 'Handmade Sun Shirt',
    description:
      'error explicabo dignissimos quibusdam excepturi ut nesciunt quod voluptatibus tempora sed sunt fugit in voluptatem eum inventore',
    slug: 'Handmade-Sun-Shirt',
    added: 1479626165103,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Shoes', 'Person', 'Water'],
    price: 12.99,
    name: 'Gorgeous Water Shirt',
    description:
      'quo id atque et quaerat corrupti eligendi quo magnam nesciunt et et voluptatem est id',
    slug: 'Gorgeous-Water-Shirt',
    added: 1481587941856,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Hot air balloons', 'Plateau'],
    price: 10.99,
    name: 'Incredible Sunset Shirt',
    description:
      'cumque veritatis minima vero assumenda repellat molestias sunt adipisci rerum quibusdam sit laboriosam vel tempora rerum',
    slug: 'Incredible-Sunset-Shirt-1',
    added: 1478035769751,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Forrest', 'Sunrise', 'Flowers'],
    price: 10.99,
    name: 'Handcrafted Forrest Shirt',
    description:
      'facilis assumenda rerum atque in fugit natus reiciendis cum expedita',
    slug: 'Handcrafted-Forrest-Shirt',
    added: 1481790985782,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Mountains', 'Desert'],
    price: 16.99,
    name: 'Small Nature Shirt',
    description:
      'ullam animi quos voluptatem dolorem eum rerum earum mollitia sed laudantium sed odit minus esse odio alias aut quibusdam porro nisi',
    slug: 'Small-Nature-Shirt',
    added: 1477942062446,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Night'],
    price: 16.99,
    name: 'Handmade Snow Shirt',
    description:
      'ad est soluta porro quasi sit labore dolor officiis ullam adipisci est possimus magni eveniet ut labore ducimus sint totam enim quia porro',
    slug: 'Handmade-Snow-Shirt',
    added: 1481865774990,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Birds', 'Ocean'],
    price: 16.99,
    name: 'Sleek Birds Shirt',
    description:
      'et sunt doloremque omnis voluptatum quis sapiente facilis ipsam perferendis at ratione accusantium neque fugit atque expedita iusto nisi eveniet enim tempora ullam beatae minus',
    slug: 'Sleek-Birds-Shirt',
    added: 1485009513421,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Tent', 'Mountains'],
    price: 13.99,
    name: 'Licensed Snow Shirt',
    description:
      'rerum non qui quaerat dolores iure est sequi consequatur ut iure dolore fugit qui',
    slug: 'Licensed-Snow-Shirt',
    added: 1478742055972,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Bridge', 'Ocean'],
    price: 11.99,
    name: 'Awesome Bridge Shirt',
    description:
      'accusantium debitis amet asperiores non rerum eaque aut quo fugit ab est facere aperiam',
    slug: 'Awesome-Bridge-Shirt',
    added: 1481030019073,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Trail', 'Meadow'],
    price: 12.99,
    name: 'Practical Meadow Shirt',
    description:
      'quidem fuga tempora praesentium et qui nihil beatae tempora non aut cumque non',
    slug: 'Practical-Meadow-Shirt',
    added: 1482111547539,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'Fog'],
    price: 11.99,
    name: 'Incredible Bridge Shirt',
    description:
      'cumque veritatis unde est iusto vero odio et culpa quia consequatur officiis similique aut aspernatur cumque necessitatibus aut cumque aperiam eveniet',
    slug: 'Incredible-Bridge-Shirt',
    added: 1478751108050,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains', 'People'],
    price: 15.99,
    name: 'Ergonomic Mountains Shirt',
    description:
      'accusantium in nemo doloribus consectetur ullam minus et et ea et dolore quam ex illum voluptas quis enim quo est',
    slug: 'Ergonomic-Mountains-Shirt-1',
    added: 1483091632685,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Bird'],
    price: 17.99,
    name: 'Tasty Bird Shirt',
    description:
      'quia facere consequuntur alias voluptatem unde architecto possimus modi nostrum',
    slug: 'Tasty-Bird-Shirt',
    added: 1477888957258,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Nature'],
    price: 19.99,
    name: 'Unbranded Trees Shirt',
    description:
      'molestias eveniet velit nobis consectetur qui nemo doloremque ea in eum dolor distinctio laborum',
    slug: 'Unbranded-Trees-Shirt-1',
    added: 1478506712562,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Photos', 'Vintage'],
    price: 18.99,
    name: 'Practical Vintage Shirt',
    description:
      'voluptatum est dolor sed doloribus quia dignissimos cupiditate impedit et impedit accusantium accusantium maiores labore veritatis',
    slug: 'Practical-Vintage-Shirt',
    added: 1479086668277,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Peru', 'Fog', 'Mountains', 'Ruins'],
    price: 12.99,
    name: 'Awesome Fog Shirt',
    description:
      'ea reprehenderit alias sed ea nulla aut maxime dolorem quod et quasi aspernatur ad enim animi doloremque sunt placeat aperiam animi',
    slug: 'Awesome-Fog-Shirt-2',
    added: 1484699567261,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office'],
    price: 15.99,
    name: 'Ergonomic Office Shirt',
    description:
      'modi autem error sint perspiciatis aut velit culpa voluptatem maiores ea in voluptatem magni et quos dolor',
    slug: 'Ergonomic-Office-Shirt-1',
    added: 1483500105295,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Mountains'],
    price: 15.99,
    name: 'Handcrafted Trees Shirt',
    description:
      'esse officia nam saepe asperiores dignissimos ea recusandae nihil et veniam et laborum laborum quos expedita',
    slug: 'Handcrafted-Trees-Shirt-1',
    added: 1481941489372,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Blindfold', 'Person', 'Fabric'],
    price: 13.99,
    name: 'Small Fabric Shirt',
    description:
      'et maiores corporis sapiente eius esse minima nam nobis quas rerum commodi sed et autem atque vel rerum dolorem',
    slug: 'Small-Fabric-Shirt',
    added: 1482992838919,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'People'],
    price: 18.99,
    name: 'Sleek Snow Shirt',
    description:
      'nemo eligendi eveniet necessitatibus qui deleniti recusandae quis praesentium qui quisquam',
    slug: 'Sleek-Snow-Shirt',
    added: 1482780475397,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest', 'Woman'],
    price: 11.99,
    name: 'Gorgeous Forest Shirt',
    description:
      'omnis culpa maxime assumenda beatae veniam tempore qui temporibus nesciunt voluptatum',
    slug: 'Gorgeous-Forest-Shirt',
    added: 1480851452051,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 16.99,
    name: 'Handmade Snow Shirt',
    description:
      'recusandae ullam adipisci laboriosam ipsum tempore quas eveniet asperiores nulla temporibus nobis nisi natus laborum voluptatem',
    slug: 'Handmade-Snow-Shirt-1',
    added: 1482019675381,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Forest'],
    price: 15.99,
    name: 'Generic Forest Shirt',
    description:
      'sint atque atque voluptatem commodi est voluptatem voluptatem nihil sunt debitis dolorum similique qui ullam aspernatur vel nemo autem numquam et voluptatem',
    slug: 'Generic-Forest-Shirt',
    added: 1482577371589,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Moutains'],
    price: 14.99,
    name: 'Unbranded Moutains Shirt',
    description:
      'dolor veniam odio possimus repellat corrupti repudiandae amet cumque numquam molestias',
    slug: 'Unbranded-Moutains-Shirt',
    added: 1483183620767,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Tea'],
    price: 19.99,
    name: 'Handmade Tea Shirt',
    description:
      'molestiae maiores qui autem molestias nesciunt tenetur ducimus sit error atque quam',
    slug: 'Handmade-Tea-Shirt',
    added: 1478840403937,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Machine', 'Antique'],
    price: 13.99,
    name: 'Small Antique Shirt',
    description:
      'ut sapiente ipsum culpa rem mollitia sint non consequuntur numquam repellendus quia labore architecto dolor aperiam et porro dicta temporibus maiores sed',
    slug: 'Small-Antique-Shirt',
    added: 1477848106178,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 17.99,
    name: 'Fantastic Ocean Shirt',
    description:
      'recusandae fugiat nisi officiis culpa rem consectetur explicabo et et nemo',
    slug: 'Fantastic-Ocean-Shirt-1',
    added: 1485209194065,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains', 'Lake', 'Clouds'],
    price: 20.99,
    name: 'Unbranded Mountains Shirt',
    description:
      'sed libero voluptate deserunt ratione sint quia vel vero voluptatum',
    slug: 'Unbranded-Mountains-Shirt',
    added: 1480056337890,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 9.99,
    name: 'Handcrafted Architecture Shirt',
    description:
      'ipsa praesentium enim eveniet sunt non saepe soluta doloribus et saepe dolorem voluptas atque minus magni ducimus assumenda dignissimos sed rerum unde aperiam',
    slug: 'Handcrafted-Architecture-Shirt',
    added: 1483190962614,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Breakfast', 'Strawberry', 'Food'],
    price: 14.99,
    name: 'Ergonomic Strawberry Shirt',
    description:
      'dolorem magnam repellat aut voluptas laborum sint ullam animi sit id commodi dignissimos recusandae magnam quam est',
    slug: 'Ergonomic-Strawberry-Shirt',
    added: 1483796888142,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Beach', 'Surf', 'Ocean'],
    price: 19.99,
    name: 'Ergonomic Beach Shirt',
    description:
      'amet voluptatibus natus qui voluptatem aut ad numquam maiores cupiditate praesentium corrupti voluptates fugiat',
    slug: 'Ergonomic-Beach-Shirt',
    added: 1479866633475,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Pier'],
    price: 13.99,
    name: 'Ergonomic Pier Shirt',
    description:
      'et ad enim voluptatum libero quaerat atque excepturi placeat nemo odit dolorem nesciunt voluptatem inventore molestias pariatur optio tempora et omnis aperiam qui',
    slug: 'Ergonomic-Pier-Shirt',
    added: 1483023468900,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Shoes', 'Person', 'Feet'],
    price: 15.99,
    name: 'Fantastic Feet Shirt',
    description:
      'pariatur at qui delectus voluptatem qui voluptas voluptatem et dicta odio esse voluptatem aliquam temporibus totam qui ipsam veritatis est occaecati iure itaque molestias dolores',
    slug: 'Fantastic-Feet-Shirt',
    added: 1483960048547,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 11.99,
    name: 'Sleek Abstract Shirt',
    description:
      'quia nostrum nemo quo quae placeat totam molestiae quia ullam',
    slug: 'Sleek-Abstract-Shirt',
    added: 1485798002591,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Tree', 'Reflection', 'Water'],
    price: 11.99,
    name: 'Gorgeous Water Shirt',
    description:
      'nostrum non cumque nobis voluptate unde magni ipsam et ut similique non a consequatur corrupti quo fugit distinctio aut praesentium saepe dolorem et',
    slug: 'Gorgeous-Water-Shirt-1',
    added: 1484545928007,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Autumn', 'Fall', 'Nature', 'Leaves'],
    price: 18.99,
    name: 'Handcrafted Fall Shirt',
    description:
      'est et et odio sed ducimus provident amet perferendis tenetur',
    slug: 'Handcrafted-Fall-Shirt',
    added: 1478020483479,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'City', 'Building'],
    price: 12.99,
    name: 'Awesome Building Shirt',
    description:
      'aperiam ut ab et et blanditiis et voluptatem quaerat eos ab provident totam necessitatibus non officia enim similique quam et',
    slug: 'Awesome-Building-Shirt',
    added: 1481486159042,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Building', 'Ocean', 'Architecture', 'Sun'],
    price: 16.99,
    name: 'Sleek Architecture Shirt',
    description:
      'ut quis saepe autem qui reprehenderit totam voluptas ut dignissimos saepe eligendi alias omnis odio debitis',
    slug: 'Sleek-Architecture-Shirt',
    added: 1477890708177,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'San Francisco', 'Fog'],
    price: 12.99,
    name: 'Licensed Bridge Shirt',
    description:
      'qui vel nostrum ipsam voluptatem sunt est occaecati sint maiores et cupiditate eaque placeat voluptas aut unde laborum repudiandae',
    slug: 'Licensed-Bridge-Shirt',
    added: 1485052045722,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Wave', 'Ocean'],
    price: 11.99,
    name: 'Fantastic Ocean Shirt',
    description:
      'voluptatem tempora explicabo sed quidem qui perspiciatis reprehenderit aut hic optio animi eos',
    slug: 'Fantastic-Ocean-Shirt-2',
    added: 1480996084892,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Lake'],
    price: 9.99,
    name: 'Incredible Trees Shirt',
    description:
      'sint qui voluptas enim enim eos id dolor numquam sapiente quia molestiae ab modi earum',
    slug: 'Incredible-Trees-Shirt',
    added: 1480398659153,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Stairs', 'Indoors'],
    price: 14.99,
    name: 'Unbranded Architecture Shirt',
    description:
      'ipsam laudantium et praesentium nemo recusandae aut qui odio et maxime quas',
    slug: 'Unbranded-Architecture-Shirt',
    added: 1485272916473,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Stairs', 'People'],
    price: 11.99,
    name: 'Handcrafted People Shirt',
    description:
      'corporis ad officiis et non tempore autem autem possimus sit fugiat et',
    slug: 'Handcrafted-People-Shirt-1',
    added: 1477958518940,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Cliff', 'Water', 'Rocks'],
    price: 17.99,
    name: 'Awesome Cliff Shirt',
    description:
      'minus dolores pariatur saepe nemo id sint laudantium eum qui tempore',
    slug: 'Awesome-Cliff-Shirt',
    added: 1480920591796,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Nature', 'Bike'],
    price: 16.99,
    name: 'Generic Person Shirt',
    description:
      'officiis qui nobis et ab dolorum placeat eos nihil temporibus et est unde enim cum',
    slug: 'Generic-Person-Shirt',
    added: 1478614001471,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Clock', 'Antique'],
    price: 15.99,
    name: 'Handmade Antique Shirt',
    description:
      'sit voluptas distinctio dicta fuga consequuntur est voluptatum quia ea enim magnam quis velit',
    slug: 'Handmade-Antique-Shirt',
    added: 1482703380425,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Alarm'],
    price: 15.99,
    name: 'Ergonomic Alarm Shirt',
    description:
      'doloremque veniam quod assumenda quas quos sed vero nihil est dolores possimus iure eveniet inventore quisquam illo dolorem temporibus velit voluptatem voluptatum',
    slug: 'Ergonomic-Alarm-Shirt',
    added: 1484571347917,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 20.99,
    name: 'Rustic Architecture Shirt',
    description:
      'et ullam dolorem asperiores qui sed suscipit eligendi harum non quas autem',
    slug: 'Rustic-Architecture-Shirt-1',
    added: 1480112759359,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Lifeguard'],
    price: 16.99,
    name: 'Incredible Ocean Shirt',
    description:
      'debitis sit temporibus quia doloremque et non vitae quis ex quidem quasi recusandae ipsa sit',
    slug: 'Incredible-Ocean-Shirt-4',
    added: 1481412793178,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees'],
    price: 9.99,
    name: 'Gorgeous Trees Shirt',
    description:
      'odit distinctio odit sed et minima quae nihil vitae nostrum ipsam quia enim ipsam et quos fugit vero',
    slug: 'Gorgeous-Trees-Shirt-1',
    added: 1483935673199,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Animals'],
    price: 13.99,
    name: 'Licensed Animals Shirt',
    description:
      'a corrupti deleniti temporibus omnis dolores fugit libero quam accusamus qui numquam impedit facilis aut aut a libero esse',
    slug: 'Licensed-Animals-Shirt',
    added: 1485229642972,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Doors'],
    price: 16.99,
    name: 'Sleek Doors Shirt',
    description:
      'ea cum nobis sit adipisci iste sint non quo est quia molestiae voluptates numquam velit nam veniam non expedita aut sint est',
    slug: 'Sleek-Doors-Shirt',
    added: 1485487586629,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains', 'Trees', 'Fog'],
    price: 11.99,
    name: 'Practical Trees Shirt',
    description:
      'adipisci minus temporibus eos et rerum laudantium autem reprehenderit doloribus qui animi voluptatem sequi non laboriosam laboriosam aut quis eligendi aut error iste voluptatem veritatis',
    slug: 'Practical-Trees-Shirt',
    added: 1485858757167,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Cars', 'City'],
    price: 13.99,
    name: 'Handmade City Shirt',
    description:
      'quaerat amet sint sunt quae in laudantium similique occaecati hic corrupti similique porro soluta debitis harum veniam qui',
    slug: 'Handmade-City-Shirt',
    added: 1484014805588,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Mountains', 'Silhouette'],
    price: 10.99,
    name: 'Sleek Mountains Shirt',
    description:
      'aut totam eveniet cupiditate esse nemo omnis sint sequi magni et est voluptatum vitae vitae officia',
    slug: 'Sleek-Mountains-Shirt',
    added: 1481429156044,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 11.99,
    name: 'Practical Abstract Shirt',
    description:
      'et saepe quae ut ut sit ratione perferendis id corporis repudiandae exercitationem soluta qui dolorem ut aut accusamus eum nisi qui in sint quidem',
    slug: 'Practical-Abstract-Shirt',
    added: 1483824968730,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Animals', 'Wild'],
    price: 12.99,
    name: 'Small Wild Shirt',
    description:
      'et sint qui minus sunt eligendi architecto corrupti dolores consequatur nemo ad enim',
    slug: 'Small-Wild-Shirt',
    added: 1485690363184,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office'],
    price: 19.99,
    name: 'Awesome Desk Shirt',
    description:
      'non voluptates inventore non fuga quaerat velit qui iure eveniet aut sed et iure repellat eum omnis ab ipsam autem recusandae maxime facilis',
    slug: 'Awesome-Desk-Shirt',
    added: 1479369880011,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Shells', 'Beach'],
    price: 16.99,
    name: 'Unbranded Beach Shirt',
    description:
      'voluptatem quam blanditiis totam eum quos repudiandae aliquam veniam a non corrupti culpa nobis ipsam modi voluptatum',
    slug: 'Unbranded-Beach-Shirt',
    added: 1479367101306,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Trees', 'Forest'],
    price: 19.99,
    name: 'Refined Person Shirt',
    description:
      'libero perferendis sit maiores qui quae minima voluptatibus ut et aut inventore adipisci quidem',
    slug: 'Refined-Person-Shirt',
    added: 1479934333971,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'City', 'Buildings'],
    price: 20.99,
    name: 'Incredible Buildings Shirt',
    description:
      'ad quos optio est ullam est consequuntur consectetur praesentium voluptas at debitis neque repellendus sunt molestiae ut quas incidunt architecto ut eos soluta vitae delectus',
    slug: 'Incredible-Buildings-Shirt',
    added: 1477993240025,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Forest', 'Rocks'],
    price: 18.99,
    name: 'Tasty Forest Shirt',
    description:
      'nulla fugit consequuntur architecto fuga porro dolor et sed veritatis minima ab aspernatur rerum maiores excepturi quis',
    slug: 'Tasty-Forest-Shirt-1',
    added: 1482193777325,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Fog', 'Mountains'],
    price: 9.99,
    name: 'Sleek Fog Shirt',
    description:
      'illo sed velit libero sed autem ad assumenda aliquid nulla eveniet sequi sint temporibus optio eum aperiam dolorem voluptatibus voluptatum est vel possimus at qui',
    slug: 'Sleek-Fog-Shirt-1',
    added: 1478933634810,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office'],
    price: 18.99,
    name: 'Unbranded Office Shirt',
    description:
      'commodi ut nihil quidem enim accusamus eligendi soluta a est maiores ratione iste nam deleniti ipsa architecto et delectus magnam repellendus non',
    slug: 'Unbranded-Office-Shirt',
    added: 1483824827245,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Waterfall', 'Person', 'Nature'],
    price: 16.99,
    name: 'Gorgeous Nature Shirt',
    description:
      'voluptas praesentium reprehenderit error voluptas incidunt illo iure sint itaque dignissimos ut qui impedit culpa ut rerum maxime',
    slug: 'Gorgeous-Nature-Shirt',
    added: 1483890217746,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 18.99,
    name: 'Handcrafted Water Shirt',
    description:
      'sint ipsum rerum nostrum ut sunt ut accusantium dignissimos nesciunt alias ad',
    slug: 'Handcrafted-Water-Shirt',
    added: 1485013315325,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Forrest', 'Mushroom'],
    price: 9.99,
    name: 'Incredible Mushroom Shirt',
    description:
      'ut ea et consequatur sit consectetur possimus odio et qui quia quo voluptatem aspernatur alias similique sunt nihil eos et mollitia sunt',
    slug: 'Incredible-Mushroom-Shirt',
    added: 1479439476890,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings'],
    price: 13.99,
    name: 'Unbranded City Shirt',
    description:
      'reprehenderit laudantium incidunt asperiores qui odit repellendus cumque sed accusantium quo quia aspernatur eos',
    slug: 'Unbranded-City-Shirt',
    added: 1485411610112,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 15.99,
    name: 'Practical Building Shirt',
    description:
      'rerum dolore minus sunt omnis quasi dolore temporibus maiores et iste accusamus explicabo aut omnis saepe saepe eligendi',
    slug: 'Practical-Building-Shirt',
    added: 1483225765365,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Barn'],
    price: 10.99,
    name: 'Generic Barn Shirt',
    description: 'quidem nihil fuga eaque est et sed et tempora rem',
    slug: 'Generic-Barn-Shirt',
    added: 1483803896838,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 9.99,
    name: 'Incredible Fog Shirt',
    description:
      'placeat aut veniam esse ex cupiditate dolorem velit blanditiis a placeat excepturi sit voluptas delectus architecto vel numquam iusto dolorem quis eum officiis',
    slug: 'Incredible-Fog-Shirt-1',
    added: 1484849021603,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Desert', 'Flowers'],
    price: 20.99,
    name: 'Rustic Flowers Shirt',
    description:
      'quibusdam quas dolore vitae nam aperiam ut placeat ad voluptatem praesentium similique architecto pariatur nostrum ducimus itaque veniam id iste ut sunt doloremque ea',
    slug: 'Rustic-Flowers-Shirt',
    added: 1482205343929,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['City'],
    price: 19.99,
    name: 'Rustic City Shirt',
    description:
      'pariatur nisi voluptates qui molestiae esse optio aspernatur quia voluptate provident sed ut ut voluptate ut inventore deserunt velit eveniet est',
    slug: 'Rustic-City-Shirt',
    added: 1483198927837,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Volcano', 'Fog'],
    price: 18.99,
    name: 'Fantastic Mountain Shirt',
    description:
      'a voluptatem aut id ut ipsam unde consectetur ut nihil est odio numquam excepturi velit sint fuga',
    slug: 'Fantastic-Mountain-Shirt',
    added: 1483526582927,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Waves', 'Water'],
    price: 17.99,
    name: 'Handcrafted Waves Shirt',
    description:
      'et sed aut fugit reprehenderit pariatur vel ratione iure nihil est sit et ut',
    slug: 'Handcrafted-Waves-Shirt',
    added: 1484334312488,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Architecture'],
    price: 15.99,
    name: 'Licensed Architecture Shirt',
    description:
      'est commodi placeat quo vero et voluptatem error ut quod reiciendis officiis similique necessitatibus ut quidem maxime quis excepturi fuga adipisci cumque et quia aspernatur',
    slug: 'Licensed-Architecture-Shirt',
    added: 1484611659771,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Cliff', 'Ocean', 'Rocks'],
    price: 14.99,
    name: 'Unbranded Cliff Shirt',
    description:
      'exercitationem inventore animi quos et veritatis odio aut blanditiis dolorem qui vel molestiae voluptates qui molestias laboriosam sint minima quidem ipsa',
    slug: 'Unbranded-Cliff-Shirt',
    added: 1478862585799,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains', 'Meadow'],
    price: 18.99,
    name: 'Practical Meadow Shirt',
    description:
      'eum libero est architecto tempora praesentium iste culpa et voluptatum consequuntur sit nostrum nemo',
    slug: 'Practical-Meadow-Shirt-1',
    added: 1486280133429,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Stunt', 'Fire'],
    price: 11.99,
    name: 'Sleek Person Shirt',
    description:
      'aut perferendis ea et suscipit illum sunt id quo vel doloribus error magnam eveniet culpa nisi ut optio qui eaque nemo',
    slug: 'Sleek-Person-Shirt',
    added: 1478045675594,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Fog', 'City', 'People'],
    price: 10.99,
    name: 'Awesome City Shirt',
    description:
      'quia suscipit adipisci eos tenetur voluptatum cupiditate rerum et enim dolor',
    slug: 'Awesome-City-Shirt',
    added: 1479063413440,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Trees', 'Woman', 'People'],
    price: 14.99,
    name: 'Incredible People Shirt',
    description:
      'quidem soluta tempora tempore et cumque sit aliquid dolor aut ipsam',
    slug: 'Incredible-People-Shirt',
    added: 1482174041308,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Sand'],
    price: 16.99,
    name: 'Sleek Sand Shirt',
    description:
      'officia veritatis nihil architecto beatae cumque molestiae officia iste totam labore aut dolorem eligendi consequatur eveniet',
    slug: 'Sleek-Sand-Shirt',
    added: 1481379676461,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 14.99,
    name: 'Rustic Building Shirt',
    description:
      'tenetur consectetur laboriosam cum ipsa deleniti ut doloribus eius ad consequuntur quas',
    slug: 'Rustic-Building-Shirt',
    added: 1485979166071,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Trees', 'Fog'],
    price: 17.99,
    name: 'Rustic Mountain Shirt',
    description:
      'tempora nesciunt delectus excepturi porro omnis mollitia occaecati saepe cumque reiciendis aut voluptas et sed deserunt ut aut est laudantium numquam est voluptatem impedit',
    slug: 'Rustic-Mountain-Shirt',
    added: 1485769814062,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Boat', 'Bird'],
    price: 16.99,
    name: 'Incredible Bird Shirt',
    description:
      'sed ea et dignissimos voluptatem architecto quidem velit quia non sed suscipit voluptatum nihil consequuntur voluptatibus sapiente velit dicta consequatur',
    slug: 'Incredible-Bird-Shirt',
    added: 1483171244441,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Pool', 'Jump', 'People'],
    price: 14.99,
    name: 'Fantastic People Shirt',
    description:
      'pariatur minima rem quia quae sunt voluptatem fuga optio ipsam est voluptatem',
    slug: 'Fantastic-People-Shirt',
    added: 1483249855255,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Desert', 'Car'],
    price: 15.99,
    name: 'Ergonomic Desert Shirt',
    description:
      'modi ab impedit accusamus tempora dignissimos repellendus neque magnam eos ut et inventore a',
    slug: 'Ergonomic-Desert-Shirt',
    added: 1484023903237,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'Camping', 'Teepee'],
    price: 19.99,
    name: 'Licensed Night Shirt',
    description:
      'animi in quo quisquam vitae cupiditate temporibus nihil sint accusamus saepe ut',
    slug: 'Licensed-Night-Shirt',
    added: 1482459131224,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'People'],
    price: 11.99,
    name: 'Sleek People Shirt',
    description:
      'exercitationem non earum laudantium quo dolor quaerat eaque cumque velit soluta magnam nulla omnis sit omnis aut officiis dolor aliquam et',
    slug: 'Sleek-People-Shirt',
    added: 1480438774952,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Booth', 'Restaurant', 'Table', 'Seats'],
    price: 19.99,
    name: 'Ergonomic Restaurant Shirt',
    description:
      'dolor ut enim voluptate et dolores cum ut cupiditate consequatur ut est ut',
    slug: 'Ergonomic-Restaurant-Shirt',
    added: 1481033760983,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Face', 'Woman'],
    price: 11.99,
    name: 'Small Woman Shirt',
    description:
      'sunt incidunt dolore ut expedita aut quia natus laboriosam rerum et',
    slug: 'Small-Woman-Shirt',
    added: 1478462156705,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Lake', 'People'],
    price: 15.99,
    name: 'Incredible Fog Shirt',
    description:
      'minima nemo odit totam fugiat sit provident eum ad rerum nemo consequatur',
    slug: 'Incredible-Fog-Shirt-2',
    added: 1481025114780,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Man', 'Fog', 'Mountains', 'Lake', 'People'],
    price: 18.99,
    name: 'Sleek Man Shirt',
    description:
      'distinctio ipsum quia mollitia quia sint deserunt mollitia odio alias doloremque cumque ipsa ducimus sint ad laboriosam quia ipsa quas repudiandae odio quaerat iste repellat',
    slug: 'Sleek-Man-Shirt',
    added: 1479595690736,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Spray', 'Ocean', 'Waves', 'Rocks'],
    price: 9.99,
    name: 'Licensed Ocean Shirt',
    description:
      'rerum ut incidunt dicta quo autem vero ut at recusandae est deserunt qui qui laboriosam maxime rerum blanditiis aut id architecto alias nulla qui illum',
    slug: 'Licensed-Ocean-Shirt-1',
    added: 1484363971794,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Mountains'],
    price: 13.99,
    name: 'Generic Trees Shirt',
    description:
      'at alias enim expedita ut reprehenderit quibusdam cupiditate aspernatur quam autem deleniti mollitia perspiciatis voluptatem',
    slug: 'Generic-Trees-Shirt-1',
    added: 1482486099318,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Waterfall', 'Fog'],
    price: 20.99,
    name: 'Tasty Waterfall Shirt',
    description:
      'quia aut et necessitatibus assumenda facilis vel asperiores similique fuga deserunt eveniet corrupti',
    slug: 'Tasty-Waterfall-Shirt',
    added: 1480662526711,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees', 'Cabin'],
    price: 10.99,
    name: 'Sleek Trees Shirt',
    description:
      'laboriosam perspiciatis exercitationem sint quod veniam dolorum porro temporibus rerum error accusantium',
    slug: 'Sleek-Trees-Shirt',
    added: 1483669552579,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Buildings', 'City'],
    price: 11.99,
    name: 'Rustic City Shirt',
    description:
      'inventore debitis voluptates aut nulla quia consectetur dolores et ut qui molestiae delectus tempora odit minima laborum praesentium maiores delectus necessitatibus impedit molestiae voluptatem',
    slug: 'Rustic-City-Shirt-1',
    added: 1485854621662,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Building', 'Black&white'],
    price: 15.99,
    name: 'Ergonomic Building Shirt',
    description:
      'et dolore veniam ratione aut molestiae officiis labore fuga sit cum unde eum commodi quo ipsam tempora nesciunt exercitationem ullam est aliquam quaerat incidunt',
    slug: 'Ergonomic-Building-Shirt',
    added: 1485894020431,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings', 'Architecture'],
    price: 11.99,
    name: 'Refined Buildings Shirt',
    description:
      'excepturi perspiciatis delectus animi dolore maiores exercitationem id quis non ut',
    slug: 'Refined-Buildings-Shirt',
    added: 1483168135339,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees', 'Forest'],
    price: 13.99,
    name: 'Handcrafted Snow Shirt',
    description:
      'recusandae quos error quam repellat placeat debitis est minus illum',
    slug: 'Handcrafted-Snow-Shirt',
    added: 1485313033562,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Van', 'Old', 'Car'],
    price: 11.99,
    name: 'Intelligent Car Shirt',
    description:
      'consequuntur mollitia sapiente perferendis totam error pariatur recusandae porro quaerat voluptas',
    slug: 'Intelligent-Car-Shirt-1',
    added: 1481317135279,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Hands', 'Flower'],
    price: 20.99,
    name: 'Awesome Hands Shirt',
    description:
      'ab non consequatur accusantium nam modi consequatur dolorem excepturi in minima ut deserunt deleniti optio sed dolorem velit',
    slug: 'Awesome-Hands-Shirt',
    added: 1481483249217,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Mountains', 'Lake'],
    price: 17.99,
    name: 'Sleek Mountains Shirt',
    description:
      'est totam sed vel officiis dicta aut voluptates saepe itaque et recusandae',
    slug: 'Sleek-Mountains-Shirt-1',
    added: 1480597413884,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Building', 'People'],
    price: 15.99,
    name: 'Awesome Building Shirt',
    description:
      'in et perspiciatis odit vero corrupti rem voluptate enim aut animi eos magnam asperiores accusamus deleniti est perspiciatis est quibusdam doloribus quas aut',
    slug: 'Awesome-Building-Shirt-1',
    added: 1485002889815,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Cross', 'Religion'],
    price: 11.99,
    name: 'Refined Snow Shirt',
    description:
      'provident delectus voluptatem voluptas enim consequatur deleniti ut sit neque ut atque accusamus autem quia dolores quaerat corporis et quod modi natus eos',
    slug: 'Refined-Snow-Shirt',
    added: 1479639823638,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Back', 'Person', 'Man', 'Camera', 'Lake'],
    price: 9.99,
    name: 'Gorgeous Camera Shirt',
    description:
      'ea nostrum quibusdam sint temporibus reprehenderit mollitia non provident asperiores consequatur dolorum officia tenetur qui aut ut voluptatem odit mollitia repellat',
    slug: 'Gorgeous-Camera-Shirt',
    added: 1481977268233,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Lime', 'Yellow', 'Green', 'Fruit', 'Citrus', 'Lemon'],
    price: 13.99,
    name: 'Rustic Yellow Shirt',
    description:
      'esse architecto fugiat asperiores at nihil sit aut recusandae autem temporibus deserunt nihil adipisci',
    slug: 'Rustic-Yellow-Shirt',
    added: 1480251859525,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees', 'Nature', 'Mountains'],
    price: 17.99,
    name: 'Rustic Snow Shirt',
    description:
      'debitis temporibus culpa nam qui occaecati numquam impedit libero optio illum id incidunt debitis culpa ut dolor voluptatum nisi',
    slug: 'Rustic-Snow-Shirt',
    added: 1484181237340,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Rock', 'Arch', 'Ocean'],
    price: 11.99,
    name: 'Small Arch Shirt',
    description:
      'ratione et qui aut perferendis nihil soluta quo cumque enim qui ex dolorem repellat tenetur atque cum est totam dolorum',
    slug: 'Small-Arch-Shirt',
    added: 1480539455061,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Tiger'],
    price: 12.99,
    name: 'Intelligent Animal Shirt',
    description:
      'adipisci amet occaecati architecto quas optio omnis voluptas beatae quia qui et maxime et odit natus ipsam et expedita qui quo non',
    slug: 'Intelligent-Animal-Shirt-2',
    added: 1479025610095,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'People'],
    price: 17.99,
    name: 'Small Ocean Shirt',
    description:
      'nisi illo est nihil explicabo eos hic alias provident non molestias sint facere aut rerum',
    slug: 'Small-Ocean-Shirt-1',
    added: 1481310156462,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Birds'],
    price: 18.99,
    name: 'Unbranded Sky Shirt',
    description:
      'alias aut repudiandae beatae reiciendis rerum ut nam aliquam iste iure perferendis magnam',
    slug: 'Unbranded-Sky-Shirt',
    added: 1483913688702,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Plane', 'Overcast', 'Building', 'Fog'],
    price: 19.99,
    name: 'Gorgeous Plane Shirt',
    description:
      'eius nam itaque quia velit reprehenderit quaerat at vero possimus doloremque explicabo quam necessitatibus ducimus natus voluptas illum et dolor dolorum consequatur modi',
    slug: 'Gorgeous-Plane-Shirt',
    added: 1480143628483,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Hands', 'Office', 'Meeting', 'People'],
    price: 14.99,
    name: 'Unbranded Office Shirt',
    description:
      'unde ratione sed fuga et id commodi atque occaecati quis aut earum harum inventore',
    slug: 'Unbranded-Office-Shirt-1',
    added: 1485030332786,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Snow'],
    price: 14.99,
    name: 'Gorgeous Snow Shirt',
    description:
      'rerum numquam officia libero dignissimos et fugit nihil reprehenderit maxime nam nesciunt voluptatem vel eum dolorem',
    slug: 'Gorgeous-Snow-Shirt',
    added: 1480733629841,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'Sand', 'Desert'],
    price: 10.99,
    name: 'Small Sand Shirt',
    description:
      'molestiae autem harum voluptas praesentium assumenda ut vel quibusdam earum nulla et fugiat nisi error dolorem pariatur tenetur magnam odio molestiae ratione',
    slug: 'Small-Sand-Shirt',
    added: 1481151825857,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings'],
    price: 17.99,
    name: 'Rustic City Shirt',
    description:
      'eos et provident odit autem non dolores eum magni commodi quibusdam voluptate voluptas eos in repudiandae',
    slug: 'Rustic-City-Shirt-2',
    added: 1484582845299,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Bridge', 'Forest'],
    price: 19.99,
    name: 'Sleek Arial Shirt',
    description:
      'ipsum culpa fugiat nostrum sunt dignissimos fugiat consectetur assumenda qui',
    slug: 'Sleek-Arial-Shirt',
    added: 1478457785663,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Shoes', 'Person', 'Feet', 'Railroad'],
    price: 12.99,
    name: 'Incredible Shoes Shirt',
    description:
      'velit corporis nesciunt harum qui eos quidem voluptatem expedita provident iusto non et et quae sed dolores modi reiciendis itaque saepe optio',
    slug: 'Incredible-Shoes-Shirt',
    added: 1482837020499,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Desert', 'People'],
    price: 13.99,
    name: 'Intelligent Desert Shirt',
    description:
      'ea nobis ea ducimus repudiandae totam ipsa possimus recusandae blanditiis unde ratione ipsum velit ab est qui tenetur',
    slug: 'Intelligent-Desert-Shirt',
    added: 1481849845717,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Night'],
    price: 18.99,
    name: 'Gorgeous Night Shirt',
    description:
      'voluptas labore quia molestiae facilis ea consequatur ipsa sed unde voluptas dignissimos mollitia harum',
    slug: 'Gorgeous-Night-Shirt',
    added: 1478189601851,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Desert'],
    price: 9.99,
    name: 'Ergonomic Desert Shirt',
    description:
      'est quia officia maxime velit aut inventore natus ut molestiae non doloribus sit doloribus modi repellendus',
    slug: 'Ergonomic-Desert-Shirt-1',
    added: 1483902055920,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'San Francisco', 'Fog', 'Ocean', 'Metal'],
    price: 9.99,
    name: 'Handmade Metal Shirt',
    description:
      'quibusdam eos sapiente ipsam velit quia quaerat dolores placeat vero sunt placeat voluptas non ea a',
    slug: 'Handmade-Metal-Shirt',
    added: 1480285343398,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Metal', 'Building'],
    price: 15.99,
    name: 'Rustic Building Shirt',
    description:
      'fuga mollitia accusantium eius et error quia velit illum quo quia a dolores odio aut consequatur quibusdam ipsa hic',
    slug: 'Rustic-Building-Shirt-1',
    added: 1482400295011,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Trees'],
    price: 9.99,
    name: 'Ergonomic Trees Shirt',
    description:
      'incidunt est et eveniet nihil animi dolorem eum dolore excepturi sint inventore odit expedita dolor quia nobis laboriosam voluptatem minus recusandae repellat assumenda rerum ducimus',
    slug: 'Ergonomic-Trees-Shirt',
    added: 1484358359416,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Smart phone', 'Hands'],
    price: 20.99,
    name: 'Refined Hands Shirt',
    description:
      'dolorem doloremque dolorem quia doloremque aliquam nesciunt optio qui eius incidunt voluptatem sed',
    slug: 'Refined-Hands-Shirt',
    added: 1484154522464,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Tree', 'Nature', 'Juniper'],
    price: 9.99,
    name: 'Awesome Tree Shirt',
    description:
      'in vitae dolores quis qui nam quo sint quis suscipit ullam molestias',
    slug: 'Awesome-Tree-Shirt',
    added: 1478742784182,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Abstract'],
    price: 10.99,
    name: 'Tasty Person Shirt',
    description:
      'eos asperiores fuga quia et aut doloribus suscipit qui ut provident dolores facere animi ut provident culpa',
    slug: 'Tasty-Person-Shirt-1',
    added: 1486107475370,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Nature', 'Water', 'Rocks'],
    price: 12.99,
    name: 'Awesome Rocks Shirt',
    description:
      'dolorum placeat molestiae fugit maiores corporis debitis eaque numquam praesentium aut velit ut voluptatem unde rerum',
    slug: 'Awesome-Rocks-Shirt-1',
    added: 1485106707411,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Snow', 'Lake'],
    price: 10.99,
    name: 'Handcrafted Lake Shirt',
    description:
      'quia incidunt voluptatem esse consequatur architecto et aut laborum sunt laborum placeat et perspiciatis omnis ut maiores ut eveniet nesciunt laborum veniam sapiente eum',
    slug: 'Handcrafted-Lake-Shirt',
    added: 1482833314974,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Meal', 'Food', 'Table'],
    price: 14.99,
    name: 'Handmade Food Shirt',
    description:
      'non totam et consequatur accusamus in et corrupti nobis reiciendis eum et voluptas itaque possimus praesentium dolor sit rerum consequuntur repellat',
    slug: 'Handmade-Food-Shirt',
    added: 1486134274059,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Storm', 'Clouds'],
    price: 13.99,
    name: 'Sleek Clouds Shirt',
    description:
      'ad corrupti quia deserunt quasi temporibus dicta rem amet quaerat perspiciatis accusantium ea illo et voluptatem aut qui omnis id omnis',
    slug: 'Sleek-Clouds-Shirt-1',
    added: 1480817064432,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Road'],
    price: 12.99,
    name: 'Small Road Shirt',
    description:
      'officia eos doloremque qui accusamus ullam praesentium quis commodi ullam est et dolor officiis ut recusandae ducimus qui minima qui perferendis',
    slug: 'Small-Road-Shirt',
    added: 1482924881417,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Dark', 'Night', 'Stars'],
    price: 15.99,
    name: 'Small Night Shirt',
    description:
      'impedit voluptates qui minima totam autem vel natus est possimus non numquam deleniti qui ut saepe non id',
    slug: 'Small-Night-Shirt-1',
    added: 1485389779946,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Space', 'NASA'],
    price: 17.99,
    name: 'Ergonomic Space Shirt',
    description:
      'velit possimus maxime voluptatem beatae eos alias repellat veritatis aliquid quae est numquam quis eligendi qui perspiciatis consequatur quae at atque et eum impedit',
    slug: 'Ergonomic-Space-Shirt',
    added: 1483618597143,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Bus', 'City', 'Buildings', 'People'],
    price: 9.99,
    name: 'Rustic People Shirt',
    description:
      'incidunt consequuntur quod dolorum ut quibusdam sed perspiciatis aliquam numquam libero in qui non maxime nulla',
    slug: 'Rustic-People-Shirt',
    added: 1480889410820,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Yak'],
    price: 19.99,
    name: 'Intelligent Yak Shirt',
    description:
      'nemo est nam consequatur minus aliquam ut dolorum similique aut molestiae fugit earum laboriosam quia est vero quisquam est earum voluptate amet',
    slug: 'Intelligent-Yak-Shirt',
    added: 1483431074699,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Path', 'Trees', 'Fog'],
    price: 14.99,
    name: 'Handmade Fog Shirt',
    description:
      'qui velit ut omnis omnis est quas voluptatem commodi quia ducimus eos velit ut et ratione nulla minima harum illum quis',
    slug: 'Handmade-Fog-Shirt-1',
    added: 1482818400686,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Boats', 'Ocean', 'Rocks'],
    price: 17.99,
    name: 'Rustic Ocean Shirt',
    description:
      'soluta tenetur distinctio culpa quo molestiae et esse sed laborum quidem',
    slug: 'Rustic-Ocean-Shirt-3',
    added: 1481556808669,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Bench', 'Leaves'],
    price: 20.99,
    name: 'Practical Leaves Shirt',
    description:
      'maxime esse eius corporis in rerum dignissimos et totam voluptatem harum cumque et numquam similique mollitia voluptatum',
    slug: 'Practical-Leaves-Shirt',
    added: 1484191617619,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Glass', 'Architecture', 'Building'],
    price: 19.99,
    name: 'Ergonomic Architecture Shirt',
    description:
      'id aut aliquid provident enim reiciendis voluptatem omnis voluptas asperiores quis in',
    slug: 'Ergonomic-Architecture-Shirt',
    added: 1480575479493,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 20.99,
    name: 'Rustic Fog Shirt',
    description:
      'harum nemo quas earum quisquam animi ratione voluptatum temporibus omnis ratione sequi sed deleniti ut iure similique',
    slug: 'Rustic-Fog-Shirt-1',
    added: 1484295622087,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 19.99,
    name: 'Generic Mountains Shirt',
    description:
      'sed maxime quibusdam facere sunt pariatur assumenda ut accusamus quos tempore autem qui est',
    slug: 'Generic-Mountains-Shirt-1',
    added: 1481190845139,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings'],
    price: 11.99,
    name: 'Awesome City Shirt',
    description:
      'officia cumque ducimus ut quia asperiores voluptas earum cum assumenda ut qui blanditiis reiciendis vel nulla minima itaque consequuntur animi ratione animi aperiam',
    slug: 'Awesome-City-Shirt-1',
    added: 1485724813314,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Farmer', 'Farm'],
    price: 19.99,
    name: 'Rustic Farm Shirt',
    description:
      'et corporis laudantium deserunt minima quo odit ut at vel et et id',
    slug: 'Rustic-Farm-Shirt',
    added: 1482137214265,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'Silhouette', 'People'],
    price: 17.99,
    name: 'Awesome Night Shirt',
    description:
      'accusantium quidem adipisci in cupiditate vel nihil ducimus enim molestiae voluptatibus maiores autem veritatis dolor nostrum sint',
    slug: 'Awesome-Night-Shirt',
    added: 1484003502087,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Fog'],
    price: 19.99,
    name: 'Rustic Fog Shirt',
    description:
      'asperiores et labore sed veritatis autem aliquam totam ducimus quas aliquam commodi corrupti',
    slug: 'Rustic-Fog-Shirt-2',
    added: 1482401394785,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Desert'],
    price: 14.99,
    name: 'Practical Desert Shirt',
    description:
      'aut qui harum laudantium minima laborum explicabo qui reiciendis quidem quasi aperiam in aliquid tempore omnis',
    slug: 'Practical-Desert-Shirt',
    added: 1478018324658,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Crater', 'Space'],
    price: 9.99,
    name: 'Handcrafted Space Shirt',
    description:
      'eveniet sed non est aut eum dicta consequatur velit consequatur eius magnam excepturi quia nostrum error nulla totam eaque ex rerum qui',
    slug: 'Handcrafted-Space-Shirt',
    added: 1483393361958,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Classic', 'Car'],
    price: 17.99,
    name: 'Handcrafted Car Shirt',
    description:
      'aut reiciendis veniam quia dolorem corporis iste praesentium id quia ut quod recusandae voluptatum sed',
    slug: 'Handcrafted-Car-Shirt',
    added: 1478172219386,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Plants'],
    price: 17.99,
    name: 'Fantastic Fog Shirt',
    description:
      'repellendus tempore error quia nostrum nisi ut quo voluptatibus iure deleniti ducimus ut mollitia animi',
    slug: 'Fantastic-Fog-Shirt',
    added: 1482326344911,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 12.99,
    name: 'Intelligent Mountains Shirt',
    description:
      'odit sit earum est ex et quas optio quo ullam ducimus ipsum nihil aut repudiandae dolores iusto minus non occaecati',
    slug: 'Intelligent-Mountains-Shirt',
    added: 1481469196641,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains'],
    price: 19.99,
    name: 'Small Mountains Shirt',
    description:
      'unde quod vitae nisi quo deleniti omnis vel eaque ut a officia laborum qui modi mollitia ratione',
    slug: 'Small-Mountains-Shirt',
    added: 1481728042662,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Car'],
    price: 19.99,
    name: 'Gorgeous Car Shirt',
    description:
      'quam debitis quis soluta eos voluptatem ab maxime optio ab porro recusandae laborum dignissimos explicabo perferendis iusto soluta autem earum sed eius soluta',
    slug: 'Gorgeous-Car-Shirt',
    added: 1485094541021,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 20.99,
    name: 'Unbranded Beach Shirt',
    description:
      'mollitia quae sunt ea earum aut voluptatem voluptatum magnam excepturi magni asperiores quia beatae consequatur quo quibusdam iste sit dolores',
    slug: 'Unbranded-Beach-Shirt-1',
    added: 1483953037505,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'Bike'],
    price: 10.99,
    name: 'Small Night Shirt',
    description:
      'doloremque tempora deleniti adipisci et tenetur est sunt rerum exercitationem doloremque sit consequatur iure voluptas',
    slug: 'Small-Night-Shirt-2',
    added: 1485749859634,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains', 'Ocean'],
    price: 11.99,
    name: 'Small Mountains Shirt',
    description:
      'eos ipsum dolorum quis consequatur quia et rem consequuntur porro officia corrupti praesentium',
    slug: 'Small-Mountains-Shirt-1',
    added: 1480450191463,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Farm', 'Animals', 'Fog', 'Machine'],
    price: 19.99,
    name: 'Practical Animals Shirt',
    description:
      'et quia culpa enim magni sint velit at esse qui facere illo ratione culpa ipsam quod',
    slug: 'Practical-Animals-Shirt',
    added: 1484424578460,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Church'],
    price: 10.99,
    name: 'Sleek Church Shirt',
    description:
      'atque perspiciatis nam ipsum aut quas nesciunt maiores tenetur assumenda qui dolor',
    slug: 'Sleek-Church-Shirt',
    added: 1478658455117,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Person', 'Skate park'],
    price: 18.99,
    name: 'Generic Skate Park Shirt',
    description:
      'accusantium dolorem alias ut vero distinctio ut magnam ipsum aut',
    slug: 'Generic-Skate-Park-Shirt',
    added: 1481396657037,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Mountains'],
    price: 18.99,
    name: 'Intelligent Mountains Shirt',
    description:
      'enim ut laudantium qui deserunt vel modi ad qui alias aut cupiditate similique voluptatem est non odit omnis non dolorem et distinctio rerum',
    slug: 'Intelligent-Mountains-Shirt-1',
    added: 1479962635783,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Night', 'Stars'],
    price: 14.99,
    name: 'Tasty Night Shirt',
    description:
      'deserunt tenetur maxime vero quia quisquam fugiat voluptas enim ut ad consequatur a sunt ab eaque qui velit suscipit enim',
    slug: 'Tasty-Night-Shirt',
    added: 1479654947188,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 11.99,
    name: 'Small Trees Shirt',
    description: 'ut ea nesciunt provident aut ut atque nam officia aut ea',
    slug: 'Small-Trees-Shirt',
    added: 1482012089824,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Cars', 'City'],
    price: 14.99,
    name: 'Handmade City Shirt',
    description: 'cupiditate aut ea aut dicta nobis rem aut perferendis ex est',
    slug: 'Handmade-City-Shirt-1',
    added: 1480070045328,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'San Francisco', 'City'],
    price: 9.99,
    name: 'Unbranded San Francisco Shirt',
    description:
      'eos vitae dolore voluptas id id asperiores consequatur distinctio expedita dolorum ipsa facilis nostrum omnis eos possimus velit non qui nulla minus',
    slug: 'Unbranded-San-Francisco-Shirt',
    added: 1481233795088,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Journal', 'Photos'],
    price: 11.99,
    name: 'Tasty Photos Shirt',
    description:
      'tempora incidunt consequatur iure cum vitae corrupti necessitatibus repellendus consectetur dicta in ea voluptatem qui qui',
    slug: 'Tasty-Photos-Shirt',
    added: 1486106112956,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Forest', 'Camera'],
    price: 19.99,
    name: 'Sleek Camera Shirt',
    description:
      'ipsa molestias pariatur et illo dicta corporis excepturi autem et nobis nemo tenetur qui sit deserunt et eligendi neque quae',
    slug: 'Sleek-Camera-Shirt',
    added: 1479997558356,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Sunrise', 'Nature', 'Fog', 'Mountains'],
    price: 12.99,
    name: 'Intelligent Sunrise Shirt',
    description:
      'quia repellendus in voluptatum architecto quo tenetur error necessitatibus sequi ut ad iure animi maiores et voluptas autem eos molestiae voluptas repellendus porro',
    slug: 'Intelligent-Sunrise-Shirt',
    added: 1483006549437,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Arch', 'Architecture'],
    price: 17.99,
    name: 'Handcrafted Architecture Shirt',
    description:
      'sequi temporibus sint modi cupiditate est autem vitae rem corporis excepturi et odio corporis vitae enim magni amet quisquam aut quasi error modi beatae',
    slug: 'Handcrafted-Architecture-Shirt-1',
    added: 1479160180375,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Car'],
    price: 16.99,
    name: 'Unbranded Car Shirt',
    description:
      'aut dolores voluptas et eius a at qui aut maiores dolorum quaerat nulla sed laboriosam qui consequuntur autem nostrum natus sunt repellat',
    slug: 'Unbranded-Car-Shirt',
    added: 1483944557192,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'Architecture', 'Water'],
    price: 10.99,
    name: 'Ergonomic Water Shirt',
    description:
      'fuga optio ea cupiditate hic possimus minus ut esse omnis exercitationem non autem veritatis nam unde quisquam repellendus voluptatem iusto ducimus dolores veniam magnam',
    slug: 'Ergonomic-Water-Shirt-1',
    added: 1483294366075,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Boardwalk', 'Beach', 'Ocean', 'People'],
    price: 9.99,
    name: 'Unbranded Ocean Shirt',
    description:
      'aspernatur iure consequatur et aut quia molestias quos error sapiente',
    slug: 'Unbranded-Ocean-Shirt',
    added: 1485424671911,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Scene', 'Props'],
    price: 10.99,
    name: 'Handcrafted Scene Shirt',
    description:
      'delectus aperiam illum blanditiis consectetur sed hic commodi ut blanditiis tenetur sapiente atque maxime ullam',
    slug: 'Handcrafted-Scene-Shirt',
    added: 1480821108347,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Hot air balloon', 'People'],
    price: 17.99,
    name: 'Tasty People Shirt',
    description:
      'et sit dignissimos qui sapiente quod aperiam eius vel et accusantium praesentium aliquid quas vitae blanditiis quas nesciunt non ratione',
    slug: 'Tasty-People-Shirt',
    added: 1482446380038,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Pier', 'Ocean'],
    price: 17.99,
    name: 'Sleek Beach Shirt',
    description:
      'velit nihil enim dolorem blanditiis nihil quasi eum quam quia nostrum odit quis accusamus maiores non voluptas',
    slug: 'Sleek-Beach-Shirt',
    added: 1482422390899,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Pineapple', 'Field', 'Fruit'],
    price: 15.99,
    name: 'Handmade Pineapple Shirt',
    description:
      'corrupti nobis eos minus aut placeat dignissimos et enim quia',
    slug: 'Handmade-Pineapple-Shirt',
    added: 1478863687935,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Nature'],
    price: 20.99,
    name: 'Fantastic Trees Shirt',
    description:
      'ut molestiae id tenetur ut eaque et labore rem voluptas tempora rem id est aut sit et dolor',
    slug: 'Fantastic-Trees-Shirt',
    added: 1480572969626,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Cars', 'City'],
    price: 17.99,
    name: 'Licensed City Shirt',
    description:
      'aspernatur nihil saepe quaerat molestias consectetur ex voluptatem voluptas ut eum neque et molestias consequatur sapiente labore necessitatibus et',
    slug: 'Licensed-City-Shirt-1',
    added: 1479597225333,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Waterfall', 'Nature'],
    price: 19.99,
    name: 'Generic Nature Shirt',
    description:
      'nam repellat mollitia rerum et et qui sint ex reprehenderit enim et et ipsa',
    slug: 'Generic-Nature-Shirt',
    added: 1485700855394,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Glass', 'City', 'Reflection', 'People'],
    price: 19.99,
    name: 'Intelligent Glass Shirt',
    description:
      'quam amet eos eum modi ipsam consequatur quo laudantium et non',
    slug: 'Intelligent-Glass-Shirt',
    added: 1477854157442,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees'],
    price: 16.99,
    name: 'Intelligent Trees Shirt',
    description:
      'non accusamus perferendis ab aliquam id incidunt at earum ut laudantium quisquam occaecati dolorum aliquam necessitatibus quia hic alias architecto culpa quia inventore ut',
    slug: 'Intelligent-Trees-Shirt-2',
    added: 1483559106010,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Cross', 'Clouds'],
    price: 20.99,
    name: 'Rustic Clouds Shirt',
    description:
      'dolorum consectetur ut recusandae nam voluptates modi aut aliquam unde in esse enim beatae sequi id ut natus a quo fugit sint quidem',
    slug: 'Rustic-Clouds-Shirt',
    added: 1481425810032,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 10.99,
    name: 'Ergonomic Forest Shirt',
    description:
      'temporibus amet assumenda ullam aut dolores atque omnis eveniet minus corporis incidunt quia possimus ut nemo qui doloribus repellat reprehenderit nisi necessitatibus officia consectetur',
    slug: 'Ergonomic-Forest-Shirt-1',
    added: 1479599948271,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Pineapple', 'Summer', 'Fruit'],
    price: 11.99,
    name: 'Practical Summer Shirt',
    description:
      'ducimus explicabo autem odit odio tempora dignissimos deleniti quos non vero eaque sapiente deleniti rerum vel ut reiciendis rerum rerum quasi adipisci cupiditate natus quia',
    slug: 'Practical-Summer-Shirt',
    added: 1482815251778,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Boat', 'Ocean'],
    price: 20.99,
    name: 'Rustic Ocean Shirt',
    description:
      'facere fugit nisi magnam qui voluptas omnis eveniet optio quae',
    slug: 'Rustic-Ocean-Shirt-4',
    added: 1483244116875,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Bar', 'Coffee', 'Restaurant'],
    price: 18.99,
    name: 'Incredible Bar Shirt',
    description:
      'cum enim culpa molestiae saepe cumque quidem nostrum aut quam',
    slug: 'Incredible-Bar-Shirt',
    added: 1479309648839,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Books', 'Building'],
    price: 9.99,
    name: 'Practical Building Shirt',
    description:
      'a sequi voluptate amet provident molestiae exercitationem quos quae quasi sunt ad dolorem asperiores error enim aut dolorem sed ab sunt neque debitis',
    slug: 'Practical-Building-Shirt-1',
    added: 1481743597127,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Wood'],
    price: 18.99,
    name: 'Small Wood Shirt',
    description:
      'voluptatem blanditiis est aut deserunt error esse provident aut qui omnis aliquam est eveniet',
    slug: 'Small-Wood-Shirt',
    added: 1479304088889,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Abstract'],
    price: 20.99,
    name: 'Handcrafted Sunset Shirt',
    description:
      'ab aut iure voluptatem cumque laudantium quia et consectetur eligendi alias earum consectetur eos quo delectus consequatur non in voluptas et blanditiis nobis sint',
    slug: 'Handcrafted-Sunset-Shirt-1',
    added: 1484536009314,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Red', 'Desert', 'Rocks'],
    price: 10.99,
    name: 'Incredible Desert Shirt',
    description:
      'tenetur fugit corporis voluptatem quibusdam amet ipsa ea et nulla qui corporis sunt enim exercitationem iure mollitia sunt eius aut',
    slug: 'Incredible-Desert-Shirt',
    added: 1482745050116,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Brick', 'Building'],
    price: 19.99,
    name: 'Small Building Shirt',
    description:
      'consequuntur aut cum perspiciatis harum cumque omnis nemo dolores quasi accusantium est dolores esse rerum ex dolorum earum aliquid',
    slug: 'Small-Building-Shirt',
    added: 1484314418588,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Hand', 'Ocean', 'Underwater', 'Water', 'Surfer'],
    price: 17.99,
    name: 'Handmade Hand Shirt',
    description:
      'alias officiis architecto omnis autem et molestias magnam libero mollitia qui vitae odio asperiores',
    slug: 'Handmade-Hand-Shirt',
    added: 1478969957335,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Meadow', 'Fog'],
    price: 12.99,
    name: 'Practical Meadow Shirt',
    description:
      'laborum et corrupti labore dolor et rerum labore consectetur impedit sit quibusdam',
    slug: 'Practical-Meadow-Shirt-2',
    added: 1482785294235,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Tree', 'Architecture'],
    price: 13.99,
    name: 'Gorgeous Architecture Shirt',
    description:
      'autem et debitis eos dolorem eum et facilis ut id porro a dignissimos sunt ut ut error',
    slug: 'Gorgeous-Architecture-Shirt',
    added: 1480756948766,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Grapes', 'Hands'],
    price: 15.99,
    name: 'Small Hands Shirt',
    description:
      'molestias dolores ipsam ab omnis et qui facilis quis harum perspiciatis quis deserunt',
    slug: 'Small-Hands-Shirt',
    added: 1479655304213,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Road'],
    price: 15.99,
    name: 'Unbranded Road Shirt',
    description:
      'blanditiis et suscipit et inventore aut non quia quisquam quia et aut vitae ipsa consequatur corrupti',
    slug: 'Unbranded-Road-Shirt',
    added: 1484809589242,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Car'],
    price: 17.99,
    name: 'Small Car Shirt',
    description:
      'enim velit corrupti error sunt sequi aut quis recusandae doloremque et ipsum molestiae non quibusdam suscipit qui iusto qui deleniti deserunt',
    slug: 'Small-Car-Shirt',
    added: 1485788518678,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Stars', 'Silhouette'],
    price: 17.99,
    name: 'Licensed Sky Shirt',
    description:
      'placeat sequi vel consectetur ut architecto voluptatem veniam veniam ea explicabo et',
    slug: 'Licensed-Sky-Shirt',
    added: 1482398864132,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Rain', 'Plants'],
    price: 10.99,
    name: 'Refined Rain Shirt',
    description:
      'et suscipit non vitae quia eligendi veritatis hic perspiciatis accusantium optio corporis ut nam adipisci non ducimus',
    slug: 'Refined-Rain-Shirt',
    added: 1481816380352,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Feet', 'People'],
    price: 20.99,
    name: 'Handcrafted People Shirt',
    description:
      'a non minima voluptatem quasi et et cumque blanditiis possimus sint maxime voluptatibus',
    slug: 'Handcrafted-People-Shirt-2',
    added: 1482459189348,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 12.99,
    name: 'Handcrafted Abstract Shirt',
    description:
      'quia molestiae itaque itaque suscipit molestiae consequatur eos et et dolorem nostrum quia consectetur maxime eum ut eveniet architecto',
    slug: 'Handcrafted-Abstract-Shirt',
    added: 1481978390051,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Forest'],
    price: 10.99,
    name: 'Unbranded Trees Shirt',
    description:
      'sit cumque deleniti delectus aut reprehenderit eligendi accusantium enim ut sint autem maiores quas quia repudiandae omnis suscipit minus repellat perspiciatis',
    slug: 'Unbranded-Trees-Shirt-2',
    added: 1480026143463,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog'],
    price: 17.99,
    name: 'Sleek Fog Shirt',
    description:
      'ipsa quidem est vero nostrum consequatur est consequatur architecto quia veritatis architecto quod minus labore omnis nostrum enim',
    slug: 'Sleek-Fog-Shirt-2',
    added: 1484497119145,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Flora', 'Nature', 'Flower'],
    price: 18.99,
    name: 'Refined Nature Shirt',
    description:
      'earum placeat aut dolor quisquam consequuntur illum maiores id expedita iusto ullam soluta quisquam soluta possimus aspernatur qui',
    slug: 'Refined-Nature-Shirt',
    added: 1484195288979,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Field', 'Fog'],
    price: 12.99,
    name: 'Refined Fog Shirt',
    description:
      'aliquid in porro dolorem eveniet dolore excepturi fugiat nisi temporibus culpa et',
    slug: 'Refined-Fog-Shirt-2',
    added: 1484464441283,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Underwater'],
    price: 17.99,
    name: 'Generic Person Shirt',
    description:
      'qui dolorum fuga impedit quibusdam ut ipsam non aliquam sint aut tenetur est quia aliquam et debitis molestias at reprehenderit cum',
    slug: 'Generic-Person-Shirt-1',
    added: 1482368459731,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains', 'Road'],
    price: 10.99,
    name: 'Refined Road Shirt',
    description:
      'optio nam ut doloremque adipisci pariatur earum aut provident voluptatem optio modi nam facere minus est dolor',
    slug: 'Refined-Road-Shirt',
    added: 1480348929141,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Book', 'Wood'],
    price: 20.99,
    name: 'Ergonomic Wood Shirt',
    description:
      'consequatur quod incidunt aut hic ex eius velit sunt unde consequatur sed molestiae quis est voluptatem at qui quos est maxime quas',
    slug: 'Ergonomic-Wood-Shirt',
    added: 1485525555416,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Night'],
    price: 19.99,
    name: 'Handmade Night Shirt',
    description:
      'voluptate dolores quidem recusandae itaque quaerat modi quibusdam qui incidunt recusandae dolorem repellat doloremque ut voluptatem numquam',
    slug: 'Handmade-Night-Shirt-1',
    added: 1485846330193,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 15.99,
    name: 'Ergonomic Ocean Shirt',
    description:
      'consequuntur est quos magnam ut in molestias molestiae sapiente eum minus et',
    slug: 'Ergonomic-Ocean-Shirt-1',
    added: 1480658774223,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Nature'],
    price: 10.99,
    name: 'Rustic Nature Shirt',
    description:
      'soluta ex iste et provident rerum modi aut omnis veritatis mollitia',
    slug: 'Rustic-Nature-Shirt-1',
    added: 1478649237057,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Person', 'Clouds'],
    price: 18.99,
    name: 'Licensed Person Shirt',
    description:
      'exercitationem quaerat ad laboriosam explicabo et ea deleniti exercitationem facilis vero sed voluptatem quod repellat possimus dolorem corporis vero eos totam vitae quia',
    slug: 'Licensed-Person-Shirt',
    added: 1483492655009,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 12.99,
    name: 'Rustic Trees Shirt',
    description:
      'nostrum praesentium sapiente temporibus omnis illo deleniti aut nihil ad architecto doloremque',
    slug: 'Rustic-Trees-Shirt',
    added: 1485750960071,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'Fog', 'Ocean'],
    price: 20.99,
    name: 'Licensed Bridge Shirt',
    description:
      'eveniet deserunt quo id quis at velit non sed assumenda temporibus quam quis ipsum eos quos sed quia quasi inventore quia',
    slug: 'Licensed-Bridge-Shirt-1',
    added: 1484000250825,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Buildings', 'City'],
    price: 20.99,
    name: 'Refined Buildings Shirt',
    description:
      'itaque ipsa et enim qui sunt velit et facere ab maxime est rerum voluptate',
    slug: 'Refined-Buildings-Shirt-1',
    added: 1484784849549,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Lake', 'Wood'],
    price: 19.99,
    name: 'Tasty Wood Shirt',
    description:
      'provident nesciunt distinctio et quo tempore corporis qui eos nihil accusantium sed recusandae sint et culpa quia qui quibusdam sit',
    slug: 'Tasty-Wood-Shirt',
    added: 1479988757605,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Fire', 'Girl', 'People'],
    price: 13.99,
    name: 'Rustic People Shirt',
    description:
      'quasi amet molestiae magnam similique consequatur velit exercitationem cumque et non cupiditate aspernatur officia aut hic quia ut voluptatem ut fugit dignissimos a',
    slug: 'Rustic-People-Shirt-1',
    added: 1486297089778,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sails', 'Boat'],
    price: 20.99,
    name: 'Rustic Sails Shirt',
    description:
      'eveniet placeat modi quae et quisquam necessitatibus in temporibus eum reiciendis',
    slug: 'Rustic-Sails-Shirt',
    added: 1483167861964,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Plane', 'City'],
    price: 9.99,
    name: 'Awesome City Shirt',
    description:
      'laborum veritatis quisquam et ut asperiores eligendi error nihil qui deserunt et occaecati eos voluptatem consequatur hic vitae',
    slug: 'Awesome-City-Shirt-2',
    added: 1484609469315,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 10.99,
    name: 'Practical Rocks Shirt',
    description:
      'voluptas autem dolorem et ut ut officiis qui corrupti dolores qui voluptatem vitae sint nisi aut est ea error tempore',
    slug: 'Practical-Rocks-Shirt',
    added: 1483166887138,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 10.99,
    name: 'Unbranded Water Shirt',
    description:
      'tempora dolor dolores amet deserunt labore cupiditate consequatur repellat est quis laborum rerum quidem molestias excepturi eos velit',
    slug: 'Unbranded-Water-Shirt',
    added: 1479267138985,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Concert', 'Band', 'People'],
    price: 11.99,
    name: 'Incredible Band Shirt',
    description:
      'omnis officiis minima quidem occaecati voluptas placeat a ut quaerat cum non dolores omnis est sed',
    slug: 'Incredible-Band-Shirt',
    added: 1486397093775,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Sand'],
    price: 15.99,
    name: 'Intelligent Sand Shirt',
    description:
      'cupiditate amet rem aut voluptatum qui exercitationem et et neque optio architecto sunt aut',
    slug: 'Intelligent-Sand-Shirt',
    added: 1478187615537,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Bicycle'],
    price: 19.99,
    name: 'Sleek Bicycle Shirt',
    description: 'placeat et qui neque tenetur nobis iure et vero repellat',
    slug: 'Sleek-Bicycle-Shirt',
    added: 1481766040998,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Buildings', 'City'],
    price: 10.99,
    name: 'Tasty Buildings Shirt',
    description:
      'at eligendi cupiditate repudiandae soluta qui ea dolor totam et itaque voluptas ut ipsam qui laudantium quo ut',
    slug: 'Tasty-Buildings-Shirt-2',
    added: 1482203656080,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'City', 'Feet'],
    price: 20.99,
    name: 'Rustic City Shirt',
    description: 'cumque ipsa iste et rerum placeat fuga velit iusto fugit',
    slug: 'Rustic-City-Shirt-3',
    added: 1478644125929,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Animal'],
    price: 18.99,
    name: 'Practical Animal Shirt',
    description:
      'placeat dolores exercitationem ut praesentium explicabo asperiores minus quia aut eum quibusdam eveniet et voluptatem ut molestias facilis distinctio placeat architecto iure',
    slug: 'Practical-Animal-Shirt',
    added: 1483447480650,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 11.99,
    name: 'Ergonomic Mountains Shirt',
    description:
      'quas voluptas ea veritatis natus minus nihil pariatur assumenda libero sit ut aut placeat',
    slug: 'Ergonomic-Mountains-Shirt-2',
    added: 1482962188521,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Tree', 'Forest'],
    price: 14.99,
    name: 'Rustic Tree Shirt',
    description:
      'blanditiis qui quo necessitatibus pariatur harum illo et accusamus provident fuga debitis distinctio minima cumque nihil aut quo',
    slug: 'Rustic-Tree-Shirt',
    added: 1479822338108,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['People'],
    price: 16.99,
    name: 'Incredible People Shirt',
    description:
      'quasi magni deleniti atque aliquam iste deleniti ad deserunt et',
    slug: 'Incredible-People-Shirt-1',
    added: 1482167389332,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Ocean', 'Rocks'],
    price: 9.99,
    name: 'Ergonomic Rocks Shirt',
    description:
      'eos et qui laudantium excepturi quibusdam maxime ut neque cum porro illum iure',
    slug: 'Ergonomic-Rocks-Shirt',
    added: 1478601683458,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Shoes', 'Person', 'Sidewalk'],
    price: 9.99,
    name: 'Ergonomic Sidewalk Shirt',
    description:
      'itaque rerum nihil cumque omnis quaerat laboriosam blanditiis iusto eum inventore',
    slug: 'Ergonomic-Sidewalk-Shirt',
    added: 1478770599497,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Metal', 'Bridge'],
    price: 13.99,
    name: 'Generic Bridge Shirt',
    description:
      'autem sit atque accusantium exercitationem impedit quis sint tempore quam sequi ipsum cupiditate ut dolorem quod voluptas rerum aut',
    slug: 'Generic-Bridge-Shirt',
    added: 1482676659985,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Child', 'City', 'People'],
    price: 14.99,
    name: 'Refined People Shirt',
    description:
      'quis voluptas qui at voluptatum natus sit unde et voluptate quibusdam provident iusto quam sint necessitatibus totam non tempora odit quibusdam qui est',
    slug: 'Refined-People-Shirt',
    added: 1481036823363,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'Umbrella', 'People'],
    price: 17.99,
    name: 'Handmade People Shirt',
    description:
      'amet temporibus quisquam ducimus est numquam nisi id quia dolorum',
    slug: 'Handmade-People-Shirt',
    added: 1481405993168,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Forest'],
    price: 11.99,
    name: 'Practical Fog Shirt',
    description:
      'alias et dolores nobis voluptatem qui ut et iusto veritatis officiis rem rerum et dolor sequi doloremque illum vero rerum nostrum reiciendis ut',
    slug: 'Practical-Fog-Shirt',
    added: 1480699550914,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Bike', 'People'],
    price: 14.99,
    name: 'Sleek Bike Shirt',
    description:
      'ut et eos praesentium et numquam dicta quasi atque quis fugit sed iure tempora ab et dolorem',
    slug: 'Sleek-Bike-Shirt',
    added: 1486270816399,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Door', 'Building'],
    price: 10.99,
    name: 'Handmade Building Shirt',
    description:
      'molestiae distinctio ut consequatur est non voluptatem et maxime atque aut qui perferendis asperiores quis qui nihil aut occaecati ipsum dolor',
    slug: 'Handmade-Building-Shirt',
    added: 1479443833223,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 14.99,
    name: 'Generic Ocean Shirt',
    description:
      'neque accusantium laborum id reiciendis consequatur aut deserunt molestiae repellat',
    slug: 'Generic-Ocean-Shirt-1',
    added: 1485765751435,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Rain'],
    price: 14.99,
    name: 'Handmade Nature Shirt',
    description:
      'qui sit rerum recusandae voluptatem repellendus nihil voluptas incidunt et architecto fuga pariatur fuga',
    slug: 'Handmade-Nature-Shirt-1',
    added: 1483455639251,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Subway', 'Station'],
    price: 12.99,
    name: 'Handmade Station Shirt',
    description:
      'doloremque vitae nam qui ipsam fugit enim dolor sit voluptas iure saepe expedita nulla omnis velit consequatur dolorum vel et laudantium corporis accusamus sequi',
    slug: 'Handmade-Station-Shirt',
    added: 1485702746231,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains', 'Lake'],
    price: 10.99,
    name: 'Small Mountains Shirt',
    description:
      'modi rem est omnis ut molestias quibusdam delectus fuga qui eum iure sed tempora incidunt fuga',
    slug: 'Small-Mountains-Shirt-2',
    added: 1481988613242,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'Fireworks'],
    price: 17.99,
    name: 'Ergonomic Night Shirt',
    description:
      'blanditiis laudantium aut asperiores officiis aut culpa rem totam nihil eum ut',
    slug: 'Ergonomic-Night-Shirt',
    added: 1485595730986,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Blueprint', 'Desk'],
    price: 16.99,
    name: 'Intelligent Blueprint Shirt',
    description:
      'est asperiores similique dolores qui porro est est dolorum nobis nihil porro',
    slug: 'Intelligent-Blueprint-Shirt',
    added: 1485178841591,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Glass', 'Building'],
    price: 9.99,
    name: 'Practical Glass Shirt',
    description:
      'in facere labore quaerat saepe possimus nobis voluptate non eveniet occaecati dicta fuga rem dolorem sit perspiciatis aperiam minima dolores',
    slug: 'Practical-Glass-Shirt',
    added: 1478670733607,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Trees'],
    price: 10.99,
    name: 'Tasty Trees Shirt',
    description:
      'quaerat natus quia non voluptatum perferendis fugiat rerum et enim illo cumque provident',
    slug: 'Tasty-Trees-Shirt',
    added: 1477780621289,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings', 'Sun'],
    price: 12.99,
    name: 'Refined Buildings Shirt',
    description:
      'veritatis vitae commodi perspiciatis fuga deleniti quis minus laudantium vero sapiente fuga est qui dolores quos molestiae',
    slug: 'Refined-Buildings-Shirt-2',
    added: 1480558133704,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Subway'],
    price: 20.99,
    name: 'Sleek Person Shirt',
    description:
      'optio aperiam rerum sunt vitae ea et corrupti aut ducimus velit laboriosam molestiae soluta dolorem nostrum non ea consequatur sint dolorem',
    slug: 'Sleek-Person-Shirt-1',
    added: 1483483467102,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Boats', 'Ocean'],
    price: 14.99,
    name: 'Intelligent Boats Shirt',
    description:
      'ut ipsa quisquam aut provident et neque consectetur consectetur est velit neque doloribus hic aspernatur vitae enim tempora omnis expedita porro aperiam dignissimos culpa amet',
    slug: 'Intelligent-Boats-Shirt',
    added: 1479989311341,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Laptop'],
    price: 16.99,
    name: 'Refined Laptop Shirt',
    description:
      'et nihil laboriosam sint aut ut quibusdam fugit sit aliquid voluptates eligendi sit qui corporis facere aspernatur',
    slug: 'Refined-Laptop-Shirt',
    added: 1486402114699,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Boat', 'Lake'],
    price: 15.99,
    name: 'Practical Lake Shirt',
    description:
      'ducimus fugiat rem aliquam quis soluta vel qui sunt quis quos',
    slug: 'Practical-Lake-Shirt',
    added: 1478676794668,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Trees', 'Nature', 'Fog'],
    price: 17.99,
    name: 'Fantastic River Shirt',
    description:
      'eius sit voluptatem nobis laborum ducimus aperiam dolore nihil nisi possimus non fugit possimus tempora nostrum ipsum ut non explicabo nihil ut earum ut ut',
    slug: 'Fantastic-River-Shirt',
    added: 1480852613564,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Mountains', 'Lake'],
    price: 15.99,
    name: 'Practical Mountains Shirt',
    description:
      'minus perferendis ipsa nihil aut dignissimos ipsa maxime nulla aliquam enim repellendus vero ex voluptatem et necessitatibus distinctio in ea eligendi inventore adipisci rerum at',
    slug: 'Practical-Mountains-Shirt',
    added: 1481156053464,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 10.99,
    name: 'Intelligent Mountains Shirt',
    description:
      'exercitationem delectus eligendi porro officia possimus excepturi dolore fugiat fugiat facere et perspiciatis qui alias nihil omnis eius adipisci deleniti quaerat',
    slug: 'Intelligent-Mountains-Shirt-2',
    added: 1483648912715,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Pier'],
    price: 13.99,
    name: 'Rustic Ocean Shirt',
    description:
      'blanditiis aspernatur temporibus odit est ut aut id tempore quibusdam aut explicabo atque nihil et facilis tempore perspiciatis',
    slug: 'Rustic-Ocean-Shirt-5',
    added: 1478315693048,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Plants'],
    price: 14.99,
    name: 'Refined Plants Shirt',
    description:
      'dolorem quia suscipit qui provident illo est est sunt quod id est libero quia ea culpa dicta totam tenetur reprehenderit amet fugit id et',
    slug: 'Refined-Plants-Shirt',
    added: 1479388101798,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Forest', 'Road'],
    price: 20.99,
    name: 'Generic Road Shirt',
    description:
      'perspiciatis cum porro tempora nesciunt est culpa et beatae commodi possimus et assumenda et alias',
    slug: 'Generic-Road-Shirt',
    added: 1485270115567,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Trees', 'Forest'],
    price: 12.99,
    name: 'Generic River Shirt',
    description:
      'qui molestiae repellendus debitis eum nobis et qui illo quis ut animi',
    slug: 'Generic-River-Shirt-1',
    added: 1480267532649,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Dock'],
    price: 13.99,
    name: 'Ergonomic Dock Shirt',
    description:
      'illum harum voluptas autem assumenda occaecati explicabo eum tenetur at voluptas numquam vero',
    slug: 'Ergonomic-Dock-Shirt',
    added: 1484926621576,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Boat', 'Ocean'],
    price: 19.99,
    name: 'Fantastic Ocean Shirt',
    description:
      'molestiae ab eveniet tenetur repellendus consectetur facilis porro distinctio aut cum',
    slug: 'Fantastic-Ocean-Shirt-3',
    added: 1482998776685,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Space', 'NASA'],
    price: 15.99,
    name: 'Generic NASA Shirt',
    description:
      'ut et aut quis iusto placeat aut autem et omnis dolorem deleniti',
    slug: 'Generic-NASA-Shirt',
    added: 1481962848396,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Nature', 'Mountains'],
    price: 12.99,
    name: 'Awesome Nature Shirt',
    description:
      'illo animi molestiae quidem consequatur voluptatum atque aliquid quia deserunt incidunt expedita atque cum est',
    slug: 'Awesome-Nature-Shirt',
    added: 1484308892827,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Snow'],
    price: 16.99,
    name: 'Handmade Mountain Shirt',
    description:
      'ullam eos iure est ea nulla nisi nam excepturi sint dicta vero reiciendis qui deserunt eligendi deserunt non et beatae aut illum est cupiditate',
    slug: 'Handmade-Mountain-Shirt',
    added: 1480310141401,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Flags', 'Fog', 'Mountains', 'Water'],
    price: 15.99,
    name: 'Practical Water Shirt',
    description:
      'nesciunt voluptatum voluptatem dignissimos labore adipisci voluptas aut provident labore quasi vel aut ullam rerum vel voluptas ad quae voluptatibus',
    slug: 'Practical-Water-Shirt',
    added: 1485538257138,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Forest'],
    price: 20.99,
    name: 'Rustic Forest Shirt',
    description:
      'magni corrupti molestiae tenetur ut est consequuntur aperiam dolorem molestias aut aut quidem dolores ut',
    slug: 'Rustic-Forest-Shirt',
    added: 1485455866657,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Book'],
    price: 12.99,
    name: 'Small Book Shirt',
    description: 'et quia amet harum nobis corrupti quod dolorum debitis ab',
    slug: 'Small-Book-Shirt',
    added: 1485707330224,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest', 'Road'],
    price: 18.99,
    name: 'Incredible Forest Shirt',
    description:
      'quia sed et quam autem ut est laborum impedit dolor minus quaerat id rerum',
    slug: 'Incredible-Forest-Shirt',
    added: 1480674893188,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains'],
    price: 14.99,
    name: 'Handcrafted Mountains Shirt',
    description:
      'omnis aut et ut omnis et quis aut laudantium adipisci omnis libero tempora asperiores eos et doloribus suscipit quia',
    slug: 'Handcrafted-Mountains-Shirt',
    added: 1486305398707,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Machine', 'Classic', 'Car'],
    price: 9.99,
    name: 'Awesome Car Shirt',
    description:
      'at illo veniam officia velit praesentium in ex asperiores soluta quo quas et in alias quia vel quisquam ea rerum',
    slug: 'Awesome-Car-Shirt',
    added: 1481942690974,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees', 'Mountains'],
    price: 15.99,
    name: 'Refined Snow Shirt',
    description:
      'molestias aut sit et aliquam nulla dignissimos rerum sed dignissimos et exercitationem quaerat in aspernatur',
    slug: 'Refined-Snow-Shirt-1',
    added: 1484486278987,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Coffee', 'Food'],
    price: 19.99,
    name: 'Tasty Coffee Shirt',
    description:
      'dolorum eum atque excepturi pariatur commodi harum autem ducimus laboriosam alias fuga',
    slug: 'Tasty-Coffee-Shirt',
    added: 1480542934118,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Jellyfish', 'Ocean'],
    price: 14.99,
    name: 'Practical Jellyfish Shirt',
    description:
      'ipsa quibusdam ad facilis error fuga modi perspiciatis repudiandae voluptas qui est et ut',
    slug: 'Practical-Jellyfish-Shirt',
    added: 1483915966277,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Buildings', 'City'],
    price: 11.99,
    name: 'Intelligent City Shirt',
    description:
      'esse error ratione occaecati dolorem accusantium aut voluptas est omnis voluptatem',
    slug: 'Intelligent-City-Shirt',
    added: 1484337033687,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 16.99,
    name: 'Awesome City Shirt',
    description:
      'nihil nulla tempore sunt sunt eum fugiat non quibusdam aliquid placeat et est laborum sunt beatae minus cumque',
    slug: 'Awesome-City-Shirt-3',
    added: 1479331425554,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Dog', 'Animal'],
    price: 10.99,
    name: 'Incredible Dog Shirt',
    description:
      'libero fugiat fugit et facilis aut illo et fuga vel reiciendis magnam ea magnam quia similique sequi non esse itaque nam et optio et',
    slug: 'Incredible-Dog-Shirt',
    added: 1478238877248,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings'],
    price: 9.99,
    name: 'Fantastic Buildings Shirt',
    description:
      'est et ipsa architecto sed impedit aperiam ex at et vel omnis eaque dolores numquam dolores amet inventore aut perspiciatis iure tempora',
    slug: 'Fantastic-Buildings-Shirt',
    added: 1485998589570,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'People', 'Moutains'],
    price: 17.99,
    name: 'Awesome Fog Shirt',
    description:
      'sed temporibus velit aspernatur aut sed hic eligendi odio fuga a',
    slug: 'Awesome-Fog-Shirt-3',
    added: 1485864157213,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Fields', 'People'],
    price: 10.99,
    name: 'Licensed Fields Shirt',
    description:
      'exercitationem magnam eligendi quae eius quis accusamus et aut et laborum quas voluptatem dicta perferendis velit quas iusto enim sint dolores ut fugiat natus',
    slug: 'Licensed-Fields-Shirt',
    added: 1479780553397,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Desert', 'Plants'],
    price: 9.99,
    name: 'Unbranded Desert Shirt',
    description:
      'cum velit distinctio nostrum dignissimos ducimus quis amet sunt nihil consequuntur natus repellat aliquid beatae veritatis a quo nulla sed quasi at',
    slug: 'Unbranded-Desert-Shirt-2',
    added: 1478137223128,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Road'],
    price: 14.99,
    name: 'Handcrafted Fog Shirt',
    description:
      'illum qui officiis dolorum amet saepe doloremque esse veritatis quaerat sit accusantium illo commodi at voluptate in aliquam magni omnis quo exercitationem',
    slug: 'Handcrafted-Fog-Shirt-1',
    added: 1484453557199,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Hands', 'Woman', 'Fireworks'],
    price: 15.99,
    name: 'Handmade Woman Shirt',
    description:
      'sit officiis quam nostrum quia reiciendis inventore delectus commodi excepturi natus non harum in est in ut rem dolor consequuntur optio qui omnis',
    slug: 'Handmade-Woman-Shirt',
    added: 1484363076625,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 11.99,
    name: 'Handcrafted Water Shirt',
    description:
      'sunt nihil quidem est corporis quasi consectetur sint itaque non omnis quaerat dolores voluptas saepe eos voluptatem',
    slug: 'Handcrafted-Water-Shirt-1',
    added: 1483225226094,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Palm trees'],
    price: 17.99,
    name: 'Unbranded Palm Trees Shirt',
    description:
      'quasi delectus est quos aut eius officia aut explicabo et at temporibus occaecati error quae ullam repellendus a iure labore repudiandae autem dolor dicta',
    slug: 'Unbranded-Palm-Trees-Shirt',
    added: 1482730916129,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Boat', 'Ocean', 'Clouds'],
    price: 11.99,
    name: 'Unbranded Ocean Shirt',
    description:
      'magnam minus quas qui voluptates enim iure est est accusantium fuga',
    slug: 'Unbranded-Ocean-Shirt-1',
    added: 1477818384591,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Dog', 'View', 'Person'],
    price: 11.99,
    name: 'Incredible Dog Shirt',
    description:
      'quae est adipisci iusto rerum veniam ad soluta accusamus delectus facere illum dolores hic id aut vero recusandae sed quidem nihil in',
    slug: 'Incredible-Dog-Shirt-1',
    added: 1482662089532,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Antique', 'Camera'],
    price: 9.99,
    name: 'Ergonomic Antique Shirt',
    description:
      'est dolorem natus qui et temporibus adipisci consectetur sint fugiat recusandae facilis natus dolores odit',
    slug: 'Ergonomic-Antique-Shirt',
    added: 1485833794200,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Freeway', 'Cars'],
    price: 15.99,
    name: 'Tasty Freeway Shirt',
    description:
      'qui labore quod debitis veritatis cupiditate est repellat tempore consequuntur sed',
    slug: 'Tasty-Freeway-Shirt',
    added: 1478276057369,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Field', 'Overcast', 'Farm'],
    price: 20.99,
    name: 'Rustic Farm Shirt',
    description:
      'voluptatem enim debitis delectus perferendis officia sequi tempora ullam laudantium qui voluptas minus harum dolorem laborum neque cupiditate sit',
    slug: 'Rustic-Farm-Shirt-1',
    added: 1480038858401,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'Boat', 'City', 'Water'],
    price: 13.99,
    name: 'Handmade City Shirt',
    description:
      'harum et voluptatum exercitationem maxime harum et inventore suscipit corrupti omnis debitis itaque animi ratione ut et harum est',
    slug: 'Handmade-City-Shirt-2',
    added: 1485850945598,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Fall', 'Trees', 'Forest'],
    price: 18.99,
    name: 'Incredible Trees Shirt',
    description:
      'sunt ratione exercitationem laborum voluptate ad voluptas sed aut et optio omnis maiores perspiciatis ex',
    slug: 'Incredible-Trees-Shirt-1',
    added: 1480198631923,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Plants', 'Succulents'],
    price: 13.99,
    name: 'Handmade Plants Shirt',
    description:
      'ipsum enim facere assumenda occaecati ut quia fuga fugit distinctio nemo eos et laborum quasi et',
    slug: 'Handmade-Plants-Shirt-1',
    added: 1482681765687,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 14.99,
    name: 'Refined Beach Shirt',
    description:
      'ut est dolores minus sequi quae exercitationem modi rem et fuga eum expedita rerum fugit eligendi quidem',
    slug: 'Refined-Beach-Shirt',
    added: 1479793104193,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Ocean', 'Rocks'],
    price: 13.99,
    name: 'Generic Rocks Shirt',
    description:
      'laudantium sunt temporibus aliquam id est quo id dolores laborum tempore quis exercitationem eum consectetur assumenda',
    slug: 'Generic-Rocks-Shirt',
    added: 1486387918185,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Hiking', 'Moutains'],
    price: 14.99,
    name: 'Handcrafted Person Shirt',
    description:
      'voluptatibus ut accusamus saepe tempore laudantium ut quasi optio odit',
    slug: 'Handcrafted-Person-Shirt',
    added: 1477938518711,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Flora', 'Flowers'],
    price: 14.99,
    name: 'Unbranded Flowers Shirt',
    description:
      'dolor ipsum saepe praesentium at quia est voluptas sunt aut voluptatem cum labore asperiores ut et dolorem',
    slug: 'Unbranded-Flowers-Shirt-1',
    added: 1478709514577,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Building', 'City'],
    price: 16.99,
    name: 'Incredible Building Shirt',
    description:
      'libero nulla illum explicabo quo quasi molestiae est voluptatem delectus quos nisi quaerat debitis iste saepe sed ut non',
    slug: 'Incredible-Building-Shirt-1',
    added: 1479425044556,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Hot air balloon', 'Lake'],
    price: 9.99,
    name: 'Handmade Lake Shirt',
    description:
      'aut perspiciatis quibusdam at dicta quis quia quis qui qui rerum dolorem voluptates dolores voluptatem accusantium veniam ut ratione velit',
    slug: 'Handmade-Lake-Shirt',
    added: 1483383707823,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Ocean', 'Bird', 'Dock', 'Sunset'],
    price: 9.99,
    name: 'Fantastic Sunset Shirt',
    description:
      'molestiae debitis repellendus quos architecto impedit ut sit quia harum possimus reiciendis eaque aspernatur ea exercitationem',
    slug: 'Fantastic-Sunset-Shirt-1',
    added: 1483051698505,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Bible', 'Person', 'Reading', 'Kid', 'Religion'],
    price: 18.99,
    name: 'Handmade Reading Shirt',
    description:
      'ut totam quis sit dignissimos nisi fugiat qui nulla sit ipsum enim qui minima rerum aut expedita aut',
    slug: 'Handmade-Reading-Shirt',
    added: 1483758128287,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'Fog', 'Ocean'],
    price: 16.99,
    name: 'Practical Bridge Shirt',
    description:
      'sint vel fuga pariatur ea error quia ullam quos cum magni totam eius voluptas porro sequi impedit',
    slug: 'Practical-Bridge-Shirt',
    added: 1484775542831,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Beach', 'Ocean', 'Rocks'],
    price: 9.99,
    name: 'Awesome Ocean Shirt',
    description:
      'voluptatem vitae doloribus voluptatum cupiditate ullam fugiat facere ea quo harum delectus suscipit labore',
    slug: 'Awesome-Ocean-Shirt-2',
    added: 1482871023935,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Lion'],
    price: 14.99,
    name: 'Intelligent Lion Shirt',
    description:
      'aut deleniti ipsa sint corporis modi quis quis deleniti sunt rem sint quo consectetur ea vero facilis dolores officia et dignissimos eveniet',
    slug: 'Intelligent-Lion-Shirt',
    added: 1482233416504,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'Trees', 'Forest'],
    price: 17.99,
    name: 'Handmade Forest Shirt',
    description:
      'itaque et inventore quia est in adipisci maiores saepe cum pariatur nisi consequatur iste at perspiciatis',
    slug: 'Handmade-Forest-Shirt',
    added: 1484049477370,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Hands', 'City', 'Camera'],
    price: 18.99,
    name: 'Awesome City Shirt',
    description:
      'molestiae qui adipisci aperiam praesentium ratione natus et vitae explicabo voluptate nihil',
    slug: 'Awesome-City-Shirt-4',
    added: 1484092709949,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Ice shelf', 'Cold', 'Fog', 'Ocean'],
    price: 13.99,
    name: 'Incredible Ice Shelf Shirt',
    description:
      'enim sit ad itaque molestiae sed reiciendis enim doloremque perspiciatis animi dolores quo sequi quos accusamus explicabo ab molestiae harum velit molestiae est officiis',
    slug: 'Incredible-Ice-Shelf-Shirt',
    added: 1478637906104,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Snow', 'Sky', 'Forest'],
    price: 12.99,
    name: 'Incredible Sky Shirt',
    description:
      'rerum fuga aut non sit dolores cum facilis amet qui neque nobis accusamus optio',
    slug: 'Incredible-Sky-Shirt',
    added: 1486064853688,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Metal', 'Bridge'],
    price: 13.99,
    name: 'Fantastic Bridge Shirt',
    description:
      'dolores consequatur voluptas voluptate omnis placeat nostrum dolorum suscipit assumenda veniam velit eligendi ut harum odio ipsa libero corporis nihil qui culpa itaque',
    slug: 'Fantastic-Bridge-Shirt-1',
    added: 1483379464324,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Sky', 'Silhouette'],
    price: 18.99,
    name: 'Rustic Sunset Shirt',
    description:
      'a voluptatem id debitis iusto omnis et quos aut libero magnam earum et doloribus ullam ipsam facere aut quasi aperiam',
    slug: 'Rustic-Sunset-Shirt',
    added: 1486335127859,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Fire', 'Camping', 'Wood'],
    price: 10.99,
    name: 'Intelligent Fire Shirt',
    description:
      'asperiores autem eum ad sunt voluptas vitae dolorem dolor quo qui doloremque deleniti',
    slug: 'Intelligent-Fire-Shirt',
    added: 1482416635472,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Waterfall', 'Nature'],
    price: 19.99,
    name: 'Generic Nature Shirt',
    description: 'autem non odit vel dolor itaque aut ex earum deserunt et id',
    slug: 'Generic-Nature-Shirt-1',
    added: 1482613397796,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Rock', 'Ocean'],
    price: 17.99,
    name: 'Generic Ocean Shirt',
    description:
      'dolorem illo et perspiciatis quibusdam voluptas dolore minus quae quasi architecto omnis id ea ex',
    slug: 'Generic-Ocean-Shirt-2',
    added: 1479826003163,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Rock', 'Horizon', 'Ocean'],
    price: 19.99,
    name: 'Tasty Sunset Shirt',
    description:
      'rerum est dolore commodi quam quam voluptatem saepe rerum facere hic perferendis',
    slug: 'Tasty-Sunset-Shirt',
    added: 1482929110074,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains'],
    price: 9.99,
    name: 'Licensed Mountains Shirt',
    description:
      'nemo voluptatum est iusto exercitationem vero ut et illum non libero autem qui ullam id eius sit odio sequi vero reiciendis quia et',
    slug: 'Licensed-Mountains-Shirt-1',
    added: 1485412945137,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings'],
    price: 20.99,
    name: 'Tasty City Shirt',
    description:
      'non eveniet alias dolorem ut omnis qui nemo rem voluptate tenetur aperiam maxime',
    slug: 'Tasty-City-Shirt-3',
    added: 1478388933367,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Wave', 'Ocean', 'Water'],
    price: 10.99,
    name: 'Unbranded Ocean Shirt',
    description:
      'reiciendis recusandae iste cumque nobis ea quia ipsam ab sint',
    slug: 'Unbranded-Ocean-Shirt-2',
    added: 1479287418645,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sand', 'Desert'],
    price: 17.99,
    name: 'Refined Sand Shirt',
    description:
      'earum est est est minima ducimus et dolore sint animi aspernatur omnis',
    slug: 'Refined-Sand-Shirt',
    added: 1478518984876,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Cars'],
    price: 9.99,
    name: 'Handcrafted Snow Shirt',
    description:
      'ab deserunt soluta quibusdam praesentium reprehenderit in dolores ut qui et expedita omnis nam',
    slug: 'Handcrafted-Snow-Shirt-1',
    added: 1484095291074,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Rainbow', 'City', 'Buildings'],
    price: 16.99,
    name: 'Tasty City Shirt',
    description:
      'repellat voluptates expedita error libero ut voluptas aut expedita magni id atque qui similique velit at libero et aperiam',
    slug: 'Tasty-City-Shirt-4',
    added: 1484234696658,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Grass', 'Plant'],
    price: 9.99,
    name: 'Fantastic Plant Shirt',
    description:
      'iste nesciunt eos modi est doloremque beatae nihil iure inventore at dolorem et vel et temporibus nisi sint nostrum non sunt et',
    slug: 'Fantastic-Plant-Shirt',
    added: 1479770149357,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 9.99,
    name: 'Tasty Abstract Shirt',
    description:
      'aut recusandae officia sit hic illum beatae quis aut qui tempora quibusdam pariatur alias debitis et',
    slug: 'Tasty-Abstract-Shirt',
    added: 1481056284870,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Leaves', 'Trees'],
    price: 9.99,
    name: 'Gorgeous Trees Shirt',
    description:
      'aut id exercitationem quisquam assumenda fugiat commodi quo molestiae natus sequi architecto enim itaque dolore qui qui consequatur molestiae nisi neque',
    slug: 'Gorgeous-Trees-Shirt-2',
    added: 1482889025769,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Cameras', 'Antique'],
    price: 15.99,
    name: 'Unbranded Antique Shirt',
    description:
      'non id eos asperiores ullam optio laboriosam a dignissimos consectetur quae qui cumque perspiciatis qui accusantium iure ut et fugiat animi',
    slug: 'Unbranded-Antique-Shirt',
    added: 1481875716046,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Stars', 'Silhouette'],
    price: 14.99,
    name: 'Sleek Person Shirt',
    description:
      'consequatur consectetur eum velit quidem ratione qui ut vel dolor voluptates tenetur sed voluptatem consequuntur provident nihil sunt beatae sint rem corrupti voluptatem porro',
    slug: 'Sleek-Person-Shirt-2',
    added: 1484196698627,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Bridge', 'Beach', 'Ocean'],
    price: 9.99,
    name: 'Gorgeous Beach Shirt',
    description:
      'rerum aut voluptas quam quo ab est consequuntur repellendus rerum doloremque non est impedit',
    slug: 'Gorgeous-Beach-Shirt-1',
    added: 1484624354355,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Mountains'],
    price: 19.99,
    name: 'Refined Mountains Shirt',
    description:
      'voluptate alias ipsum eius aperiam laboriosam illum magni quia et a a',
    slug: 'Refined-Mountains-Shirt-2',
    added: 1481251659591,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Sunrise', 'Mountains'],
    price: 18.99,
    name: 'Fantastic Sunrise Shirt',
    description:
      'qui sunt error eos odit deleniti totam aut ipsam omnis corrupti non ducimus sed aspernatur et ipsa voluptas impedit fugiat eaque',
    slug: 'Fantastic-Sunrise-Shirt',
    added: 1484714248605,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Highway', 'Road', 'Car'],
    price: 18.99,
    name: 'Handmade Trees Shirt',
    description:
      'dolor voluptatem quo inventore quo natus vel qui rerum libero voluptatum voluptatem nisi quo corporis laborum sint vel',
    slug: 'Handmade-Trees-Shirt',
    added: 1485703717936,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Mountains', 'Lake'],
    price: 16.99,
    name: 'Ergonomic Nature Shirt',
    description:
      'quas unde quia est est aut dolores molestiae similique consequuntur eum',
    slug: 'Ergonomic-Nature-Shirt',
    added: 1485430959124,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 18.99,
    name: 'Handmade Ocean Shirt',
    description:
      'fugit voluptates nemo sit quod reprehenderit a voluptas libero quod eos tenetur dolores numquam magnam odio earum',
    slug: 'Handmade-Ocean-Shirt',
    added: 1483880866364,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Person', 'Water'],
    price: 18.99,
    name: 'Practical Sunset Shirt',
    description:
      'alias repellat doloribus id soluta autem accusamus tenetur aperiam provident omnis libero ut distinctio accusantium et pariatur ipsa vel eos dolores vero aut dolores quis',
    slug: 'Practical-Sunset-Shirt-1',
    added: 1478302022070,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'City'],
    price: 18.99,
    name: 'Intelligent Night Shirt',
    description:
      'architecto ut veniam at aliquam culpa saepe rerum rerum officia accusamus asperiores',
    slug: 'Intelligent-Night-Shirt',
    added: 1484712162855,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Boat', 'Ocean'],
    price: 12.99,
    name: 'Handcrafted Boat Shirt',
    description:
      'enim ab et voluptatem consectetur aut nulla ut et ut et odit ut officiis magni inventore reiciendis est est sed nulla',
    slug: 'Handcrafted-Boat-Shirt',
    added: 1483392511882,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset'],
    price: 19.99,
    name: 'Licensed Sunset Shirt',
    description:
      'suscipit atque voluptas id ratione quia laudantium est itaque aut nihil corporis sed ut voluptatem doloremque eos',
    slug: 'Licensed-Sunset-Shirt-1',
    added: 1484361737270,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Surfboard', 'Person', 'Fog'],
    price: 17.99,
    name: 'Licensed Person Shirt',
    description:
      'magni optio laboriosam qui sequi iure alias accusamus voluptatibus id recusandae et consequuntur expedita',
    slug: 'Licensed-Person-Shirt-1',
    added: 1481532454839,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Pier', 'People'],
    price: 16.99,
    name: 'Incredible Pier Shirt',
    description:
      'quibusdam dolorum est et temporibus dolor officia nulla eligendi sequi itaque autem atque soluta facilis consequatur exercitationem voluptatem',
    slug: 'Incredible-Pier-Shirt',
    added: 1481130239310,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Desert'],
    price: 9.99,
    name: 'Unbranded Desert Shirt',
    description:
      'velit error ut minus voluptatem qui eaque tempora amet temporibus autem inventore repellendus architecto exercitationem eum dolore incidunt',
    slug: 'Unbranded-Desert-Shirt-3',
    added: 1482704108635,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Dog', 'Person', 'Man'],
    price: 17.99,
    name: 'Rustic Person Shirt',
    description:
      'ex ut illum ea dolorem itaque nobis quo quam minus in corporis',
    slug: 'Rustic-Person-Shirt-1',
    added: 1478632321677,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Flora', 'Nature', 'Flower'],
    price: 10.99,
    name: 'Tasty Flower Shirt',
    description:
      'velit aspernatur et aliquam consequatur minus ratione consequatur rerum voluptatem consectetur laborum accusantium sunt tenetur impedit repellendus ut laudantium amet amet non a consequatur',
    slug: 'Tasty-Flower-Shirt',
    added: 1483122500477,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Rose', 'Plant', 'Flower', 'Botanical', 'Flora'],
    price: 15.99,
    name: 'Small Flora Shirt',
    description:
      'ut atque et consectetur vel omnis eaque animi sint ad ipsa et nihil quaerat voluptas ut quia eum qui iusto quod hic et molestiae',
    slug: 'Small-Flora-Shirt',
    added: 1486232416154,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Dog', 'Animal'],
    price: 13.99,
    name: 'Handmade Dog Shirt',
    description:
      'dolorum sed aut voluptatibus mollitia rerum dicta laboriosam itaque libero pariatur et ea eaque repellendus atque inventore sint necessitatibus nobis voluptatem molestiae non illo',
    slug: 'Handmade-Dog-Shirt',
    added: 1481829078060,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Dog', 'Animal'],
    price: 13.99,
    name: 'Practical Dog Shirt',
    description:
      'aut non voluptate numquam et dolore et temporibus quos et et dolorem repellendus eveniet voluptas fugiat fugit facilis ratione quam',
    slug: 'Practical-Dog-Shirt',
    added: 1480613695952,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains', 'Lake'],
    price: 9.99,
    name: 'Licensed Mountains Shirt',
    description:
      'consequatur et voluptas aut natus nulla nisi perspiciatis accusantium aspernatur vitae distinctio quia atque distinctio mollitia aperiam',
    slug: 'Licensed-Mountains-Shirt-2',
    added: 1481183435093,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Ice', 'Road'],
    price: 15.99,
    name: 'Ergonomic Snow Shirt',
    description:
      'modi quaerat ut maiores ullam exercitationem sed omnis possimus soluta maiores nesciunt et voluptas dolores nobis sint repudiandae',
    slug: 'Ergonomic-Snow-Shirt-2',
    added: 1485419800510,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Cliffs', 'Rocks'],
    price: 10.99,
    name: 'Handcrafted Rocks Shirt',
    description:
      'autem quia minima qui sequi qui hic asperiores aut dolorem libero accusamus sunt iusto modi rerum sit atque',
    slug: 'Handcrafted-Rocks-Shirt',
    added: 1486071592879,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['People', 'City'],
    price: 10.99,
    name: 'Fantastic City Shirt',
    description:
      'atque qui quaerat cumque numquam sed sint ipsum veniam quibusdam possimus ea eligendi libero expedita debitis dolore quisquam ad quis dolores harum tenetur pariatur',
    slug: 'Fantastic-City-Shirt',
    added: 1486100145040,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Tools', 'Antique', 'Wood'],
    price: 16.99,
    name: 'Handmade Tools Shirt',
    description:
      'vero incidunt voluptatem minima dolor vitae magnam repellat ut dolores dolores culpa',
    slug: 'Handmade-Tools-Shirt',
    added: 1485800076112,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Dog', 'Animal', 'Puppy'],
    price: 20.99,
    name: 'Handmade Dog Shirt',
    description:
      'quo deleniti et deleniti a aut sunt quisquam quasi vel est in est non rerum aut',
    slug: 'Handmade-Dog-Shirt-1',
    added: 1479735371311,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Water'],
    price: 12.99,
    name: 'Generic River Shirt',
    description:
      'earum quam sed iusto eos non reprehenderit laboriosam dolorem fugit',
    slug: 'Generic-River-Shirt-2',
    added: 1482175060646,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Skyline', 'Machine', 'Ocean', 'City'],
    price: 16.99,
    name: 'Incredible Skyline Shirt',
    description:
      'vitae error ut sint ipsam facere sed eos doloribus odio alias sint et doloribus illo voluptas nihil molestias sit reprehenderit neque aut',
    slug: 'Incredible-Skyline-Shirt',
    added: 1481849381743,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Buildings'],
    price: 16.99,
    name: 'Generic Buildings Shirt',
    description:
      'cupiditate neque exercitationem tempora odio ea accusantium consequuntur sed omnis sint placeat est debitis ut reprehenderit debitis',
    slug: 'Generic-Buildings-Shirt-1',
    added: 1478499373480,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Man', 'Hands'],
    price: 9.99,
    name: 'Small Hands Shirt',
    description:
      'voluptatum quis perspiciatis enim sed ratione ex repellendus iusto officiis quidem corporis veniam veniam illo nemo sit adipisci reprehenderit modi ducimus rem facilis',
    slug: 'Small-Hands-Shirt-1',
    added: 1483383458433,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Building'],
    price: 13.99,
    name: 'Handcrafted Architecture Shirt',
    description:
      'voluptatem nihil assumenda sit perferendis rem reiciendis perferendis animi ad enim voluptatem eveniet voluptatem ut nemo',
    slug: 'Handcrafted-Architecture-Shirt-2',
    added: 1483144058411,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Animals'],
    price: 9.99,
    name: 'Incredible Sunset Shirt',
    description:
      'omnis odit quia iusto blanditiis non rem ut placeat vero libero repudiandae adipisci a tenetur ipsam magnam et dolor molestias porro minima dolorem dolorem',
    slug: 'Incredible-Sunset-Shirt-2',
    added: 1481403661848,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Satellite', 'Space', 'NASA'],
    price: 14.99,
    name: 'Gorgeous Satellite Shirt',
    description:
      'minus repellendus porro enim quam asperiores et quia fugit tempore perspiciatis excepturi et nemo omnis ut fugit ipsam porro voluptates nostrum quasi',
    slug: 'Gorgeous-Satellite-Shirt',
    added: 1478776640613,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Beach'],
    price: 19.99,
    name: 'Refined Beach Shirt',
    description:
      'voluptas ipsum ea sit eum totam dolor eum sint nam rerum dolor aliquam et voluptatem eum quia molestiae modi eum',
    slug: 'Refined-Beach-Shirt-1',
    added: 1483789554844,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['People'],
    price: 19.99,
    name: 'Handmade People Shirt',
    description:
      'est qui repellat et eveniet dolore in fugit ea est quo architecto veritatis animi voluptatibus esse voluptatibus modi animi eum',
    slug: 'Handmade-People-Shirt-1',
    added: 1480938199744,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Night', 'Stars', 'Abstrct'],
    price: 12.99,
    name: 'Practical Snow Shirt',
    description:
      'eius qui harum autem enim enim quos esse placeat accusamus ullam a et possimus',
    slug: 'Practical-Snow-Shirt',
    added: 1484420501060,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 16.99,
    name: 'Gorgeous Beach Shirt',
    description:
      'sint debitis aspernatur quo omnis excepturi qui saepe molestiae recusandae aut a voluptatem',
    slug: 'Gorgeous-Beach-Shirt-2',
    added: 1478125044087,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Beach', 'Ocean'],
    price: 17.99,
    name: 'Rustic Sunset Shirt',
    description:
      'consequatur impedit laudantium vitae ut nihil ut aut maiores ratione',
    slug: 'Rustic-Sunset-Shirt-1',
    added: 1480524371661,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Trees', 'Railroad'],
    price: 17.99,
    name: 'Licensed Trees Shirt',
    description:
      'distinctio fuga occaecati repellendus molestiae ipsum vitae dolore voluptates in sunt quo ipsum aut inventore sit',
    slug: 'Licensed-Trees-Shirt',
    added: 1483316840058,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture'],
    price: 17.99,
    name: 'Licensed Architecture Shirt',
    description:
      'aut deleniti a aliquam sit dolorem veniam sit rerum deserunt amet aut alias',
    slug: 'Licensed-Architecture-Shirt-1',
    added: 1480067426353,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Watch', 'Person', 'Hand'],
    price: 18.99,
    name: 'Handcrafted Hand Shirt',
    description:
      'vero dolorum hic aut tenetur magni reprehenderit sint est laboriosam cumque et vel provident nisi nisi praesentium',
    slug: 'Handcrafted-Hand-Shirt',
    added: 1482670995764,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Rocks'],
    price: 13.99,
    name: 'Tasty Ocean Shirt',
    description:
      'amet consectetur quis magni tenetur officiis qui voluptatem magni error rem quo blanditiis quidem recusandae accusantium et voluptate accusantium qui',
    slug: 'Tasty-Ocean-Shirt',
    added: 1478113865430,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Trees'],
    price: 11.99,
    name: 'Gorgeous Trees Shirt',
    description:
      'consequatur rerum facere omnis et modi sed rerum asperiores ea atque perferendis vel et iste cum recusandae qui rerum cupiditate voluptas accusantium',
    slug: 'Gorgeous-Trees-Shirt-3',
    added: 1482499351620,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Abstract', 'Architecture', 'Stairs'],
    price: 10.99,
    name: 'Generic Stairs Shirt',
    description:
      'expedita eius dolorem temporibus nihil incidunt consequatur esse veritatis est corporis aut autem nemo quis commodi hic facilis numquam aut omnis consequatur commodi et aperiam',
    slug: 'Generic-Stairs-Shirt',
    added: 1480988665911,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Horse'],
    price: 15.99,
    name: 'Handcrafted Horse Shirt',
    description:
      'modi sed minus iste maiores a facilis neque ab minima earum dolores dolores consequatur ducimus beatae facere explicabo dolor soluta',
    slug: 'Handcrafted-Horse-Shirt',
    added: 1483650542088,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Kiss', 'Love', 'Romance', 'People'],
    price: 16.99,
    name: 'Rustic People Shirt',
    description:
      'vel eum quis odit et dolorem autem blanditiis eligendi porro qui aliquid et doloribus voluptatibus omnis accusantium molestiae placeat vero totam',
    slug: 'Rustic-People-Shirt-2',
    added: 1485917427257,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Trees'],
    price: 15.99,
    name: 'Handmade Sunset Shirt',
    description:
      'dolorem doloribus illo aut sed facilis eaque harum magnam velit',
    slug: 'Handmade-Sunset-Shirt-1',
    added: 1486120557264,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Trees', 'Nature', 'Mountains'],
    price: 20.99,
    name: 'Awesome Nature Shirt',
    description:
      'quidem officiis qui quis fugit et magni voluptas iste quia laboriosam ut earum at ad',
    slug: 'Awesome-Nature-Shirt-1',
    added: 1485784773774,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Tunnel', 'Road'],
    price: 19.99,
    name: 'Handcrafted Road Shirt',
    description:
      'cupiditate sit illo quibusdam voluptas harum ut praesentium recusandae eligendi a recusandae accusantium temporibus sit',
    slug: 'Handcrafted-Road-Shirt',
    added: 1483337520494,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Woman', 'Lake', 'Canoe'],
    price: 14.99,
    name: 'Refined Person Shirt',
    description:
      'quaerat velit vitae est enim autem tenetur facilis autem quia inventore aspernatur adipisci illo possimus neque inventore nulla sequi nulla ratione ratione',
    slug: 'Refined-Person-Shirt-1',
    added: 1485616202382,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Sky', 'Ocean'],
    price: 18.99,
    name: 'Handcrafted Sky Shirt',
    description:
      'veniam rerum qui distinctio quo ex nemo non est dolorum qui aut dolor harum consequuntur nihil et laudantium asperiores magnam corrupti esse',
    slug: 'Handcrafted-Sky-Shirt',
    added: 1485846229861,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Night', 'Mountains', 'Stars'],
    price: 10.99,
    name: 'Sleek Stars Shirt',
    description:
      'repudiandae unde aspernatur maiores iusto architecto assumenda quasi eum libero illum voluptas aliquid doloribus commodi',
    slug: 'Sleek-Stars-Shirt',
    added: 1480889951738,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'City', 'Buildings'],
    price: 9.99,
    name: 'Practical Arial Shirt',
    description:
      'ut animi iusto et aspernatur corporis sunt sint in cumque delectus necessitatibus perferendis similique quia soluta est voluptatibus porro recusandae',
    slug: 'Practical-Arial-Shirt',
    added: 1482015628995,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Fog', 'Mountains'],
    price: 18.99,
    name: 'Gorgeous Fog Shirt',
    description:
      'numquam libero voluptate dolor sint deleniti ipsum aut repellendus fuga consequatur quibusdam fuga unde quos est asperiores atque nostrum labore rerum consectetur sunt libero',
    slug: 'Gorgeous-Fog-Shirt',
    added: 1480488430886,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains', 'Lake'],
    price: 20.99,
    name: 'Rustic Mountains Shirt',
    description:
      'quo voluptates quos vero magnam nostrum modi ut molestias rerum ut et laudantium qui vitae laudantium at vel',
    slug: 'Rustic-Mountains-Shirt',
    added: 1479306792341,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'Stars', 'NASA'],
    price: 14.99,
    name: 'Small Stars Shirt',
    description:
      'doloremque fugiat quam nihil voluptatem vel eum sit eligendi a neque excepturi mollitia nihil quia dolore saepe quibusdam provident',
    slug: 'Small-Stars-Shirt',
    added: 1479297264962,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ferris wheel', 'Carnival', 'Amusement park'],
    price: 13.99,
    name: 'Ergonomic Ferris Wheel Shirt',
    description:
      'necessitatibus sed suscipit qui est occaecati vitae doloremque dolorem cupiditate voluptas asperiores quibusdam error perspiciatis assumenda suscipit molestiae aliquid aspernatur consequatur quis autem cum',
    slug: 'Ergonomic-Ferris-Wheel-Shirt',
    added: 1484445142591,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Forrest', 'Fog'],
    price: 15.99,
    name: 'Tasty Fog Shirt',
    description:
      'omnis ea rerum dolor unde ut earum blanditiis magni rerum ex doloremque et iste quo necessitatibus sint',
    slug: 'Tasty-Fog-Shirt',
    added: 1480744306408,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Streetcar', 'City', 'People'],
    price: 16.99,
    name: 'Fantastic City Shirt',
    description:
      'aut eaque rerum nam quod consequuntur modi enim molestiae velit delectus',
    slug: 'Fantastic-City-Shirt-1',
    added: 1482878022022,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Barn', 'Tools'],
    price: 20.99,
    name: 'Tasty Tools Shirt',
    description:
      'est magni impedit ipsum quia ut quia in reiciendis numquam non aut mollitia perspiciatis repellat quos ut sapiente culpa',
    slug: 'Tasty-Tools-Shirt',
    added: 1477815230797,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Clouds'],
    price: 10.99,
    name: 'Handcrafted Clouds Shirt',
    description:
      'et reiciendis ea aliquam voluptatem ipsam libero laborum dolor est at voluptatem exercitationem esse delectus voluptatem perferendis doloribus eius ut quae eos dolorem qui',
    slug: 'Handcrafted-Clouds-Shirt',
    added: 1484506098995,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Clouds'],
    price: 13.99,
    name: 'Awesome Sky Shirt',
    description:
      'harum accusantium fuga qui nemo dolor facilis modi nostrum qui et maxime porro aut similique et rerum ab et odit libero dolores',
    slug: 'Awesome-Sky-Shirt',
    added: 1484170595780,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Church', 'Nature', 'Mountains'],
    price: 11.99,
    name: 'Incredible Mountains Shirt',
    description:
      'voluptatum delectus modi rerum ullam perspiciatis dolores necessitatibus adipisci et facere recusandae aut commodi eum exercitationem',
    slug: 'Incredible-Mountains-Shirt',
    added: 1484551418678,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Wave', 'Ocean', 'Water'],
    price: 16.99,
    name: 'Intelligent Water Shirt',
    description:
      'dolor quo enim tempora facere est fugiat mollitia officiis accusantium molestiae dolor vel asperiores',
    slug: 'Intelligent-Water-Shirt',
    added: 1484612255690,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Plant', 'Macro'],
    price: 12.99,
    name: 'Gorgeous Macro Shirt',
    description:
      'harum dolorum quaerat quam iusto ea omnis tempore eaque ex aut quis ut est nostrum libero laboriosam ad dolorem deleniti earum aut',
    slug: 'Gorgeous-Macro-Shirt',
    added: 1483565907483,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Child', 'City', 'Boy', 'People', 'Dog', 'Stone', 'Animal'],
    price: 18.99,
    name: 'Refined Boy Shirt',
    description:
      'omnis culpa et eaque beatae culpa aut cum deleniti non doloremque rerum recusandae deleniti nihil modi aut cum qui animi',
    slug: 'Refined-Boy-Shirt',
    added: 1485409506883,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Sky', 'Forrest', 'Trees'],
    price: 19.99,
    name: 'Fantastic Snow Shirt',
    description:
      'sed nostrum et asperiores voluptatibus aut doloribus culpa odit neque molestiae ipsam voluptas quae reiciendis et',
    slug: 'Fantastic-Snow-Shirt-1',
    added: 1480182622296,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Lighthouse', 'Stars'],
    price: 12.99,
    name: 'Handmade Stars Shirt',
    description:
      'voluptatibus id quae temporibus at quasi dolore explicabo atque eligendi sit modi temporibus cumque facilis ea',
    slug: 'Handmade-Stars-Shirt',
    added: 1484070546765,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Lake'],
    price: 10.99,
    name: 'Generic Fog Shirt',
    description:
      'et vel eum sed magnam est facere vero ut illo voluptatum unde aut',
    slug: 'Generic-Fog-Shirt-2',
    added: 1478880126542,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Boats', 'Fog', 'Ocean'],
    price: 14.99,
    name: 'Fantastic Ocean Shirt',
    description:
      'non est et et veritatis distinctio culpa quia non dolores et quo similique fugit voluptate id rem blanditiis non',
    slug: 'Fantastic-Ocean-Shirt-4',
    added: 1486130264159,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Meadow', 'Plants'],
    price: 15.99,
    name: 'Unbranded Plants Shirt',
    description: 'nemo tempore deleniti nisi sit sit quasi illo quia ut',
    slug: 'Unbranded-Plants-Shirt',
    added: 1479607921168,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Barn', 'Trees'],
    price: 17.99,
    name: 'Practical Barn Shirt',
    description:
      'ipsum accusantium explicabo occaecati itaque ad culpa voluptas et consequatur dolorem quia',
    slug: 'Practical-Barn-Shirt',
    added: 1483541342448,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Ocean'],
    price: 15.99,
    name: 'Ergonomic Nature Shirt',
    description:
      'maiores et dignissimos ea ad itaque dicta culpa vero enim nesciunt necessitatibus blanditiis qui aut nemo magnam iste est at voluptatem quaerat doloremque cum',
    slug: 'Ergonomic-Nature-Shirt-1',
    added: 1483242301385,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Lantern', 'Ethnic'],
    price: 16.99,
    name: 'Small Ethnic Shirt',
    description:
      'consequuntur et ut qui modi quidem aperiam blanditiis maxime magni',
    slug: 'Small-Ethnic-Shirt',
    added: 1479802387631,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Church', 'Building'],
    price: 19.99,
    name: 'Practical Church Shirt',
    description:
      'excepturi quidem qui distinctio esse debitis voluptatibus facere neque ab est quas sit modi accusantium voluptate rerum ipsum aut at maiores provident sint nihil',
    slug: 'Practical-Church-Shirt',
    added: 1479742111690,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Sunny', 'Ocean', 'Flowers'],
    price: 11.99,
    name: 'Ergonomic Ocean Shirt',
    description:
      'distinctio ducimus reiciendis dolores et dolore quia quia possimus aut suscipit soluta recusandae vel doloremque dignissimos minima aperiam dicta non minima',
    slug: 'Ergonomic-Ocean-Shirt-2',
    added: 1480905423698,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings', 'Rain'],
    price: 18.99,
    name: 'Intelligent Buildings Shirt',
    description:
      'reprehenderit quis deleniti nesciunt provident sed dolore rerum nemo ut quo minus blanditiis et',
    slug: 'Intelligent-Buildings-Shirt',
    added: 1483855783862,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Stadium', 'Event', 'Sports', 'People', 'Football'],
    price: 18.99,
    name: 'Ergonomic People Shirt',
    description:
      'repellat omnis nostrum adipisci accusantium sapiente ab explicabo odio suscipit doloremque consequatur qui autem accusantium officiis et',
    slug: 'Ergonomic-People-Shirt',
    added: 1482819374303,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Man', 'Railroad'],
    price: 20.99,
    name: 'Rustic Man Shirt',
    description:
      'ratione rerum voluptatem et consequatur dolor sunt quas esse delectus et in eos amet error impedit sapiente minus',
    slug: 'Rustic-Man-Shirt',
    added: 1483745456449,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Northern lights', 'Snow', 'Trees'],
    price: 13.99,
    name: 'Sleek Northern Lights Shirt',
    description:
      'quia laborum consequatur id ut voluptatem ducimus sit quo vero optio id ea neque esse sed',
    slug: 'Sleek-Northern-Lights-Shirt',
    added: 1482811050127,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Car', 'Building'],
    price: 18.99,
    name: 'Licensed City Shirt',
    description:
      'quisquam at quis aspernatur sequi harum est voluptatem veniam repellendus sequi id quia nemo ducimus quia numquam quis harum qui omnis facilis',
    slug: 'Licensed-City-Shirt-2',
    added: 1484375191707,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Nature'],
    price: 17.99,
    name: 'Practical Nature Shirt',
    description:
      'similique ea officia rerum libero enim doloremque eum similique illo qui rerum qui architecto perferendis quo in placeat sint aut numquam perspiciatis',
    slug: 'Practical-Nature-Shirt',
    added: 1485110769947,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings', 'People'],
    price: 19.99,
    name: 'Refined Buildings Shirt',
    description:
      'alias accusantium est ut omnis inventore quia aliquam aspernatur nostrum sapiente sint consequatur sit nobis',
    slug: 'Refined-Buildings-Shirt-3',
    added: 1478967752787,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'Desert', 'Stars'],
    price: 19.99,
    name: 'Incredible Desert Shirt',
    description:
      'aut doloribus ad recusandae in aliquam provident est consectetur ut saepe est debitis omnis cumque sit et inventore autem aut quia ratione',
    slug: 'Incredible-Desert-Shirt-1',
    added: 1478385477739,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Cars', 'Freeway'],
    price: 15.99,
    name: 'Small Freeway Shirt',
    description:
      'cupiditate ipsa reiciendis occaecati libero et omnis aspernatur est tempora sapiente nihil',
    slug: 'Small-Freeway-Shirt',
    added: 1485171199241,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Surfboard', 'Person', 'Silhouette'],
    price: 14.99,
    name: 'Rustic Surfboard Shirt',
    description:
      'molestias dicta qui quis qui molestiae quod voluptatum cumque porro omnis rerum porro nihil tempore quis et ullam quae corrupti et vel amet unde',
    slug: 'Rustic-Surfboard-Shirt',
    added: 1484565627103,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge', 'City', 'Building'],
    price: 13.99,
    name: 'Intelligent Building Shirt',
    description:
      'quis et voluptate voluptas omnis sit incidunt optio labore sed sit quod hic quam consectetur et',
    slug: 'Intelligent-Building-Shirt',
    added: 1485286353184,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'Stars', 'Rocks'],
    price: 11.99,
    name: 'Licensed Rocks Shirt',
    description:
      'atque perferendis fugiat repellendus reprehenderit omnis est et exercitationem doloremque et eveniet repellendus et',
    slug: 'Licensed-Rocks-Shirt',
    added: 1479982959619,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Fog'],
    price: 14.99,
    name: 'Unbranded Fog Shirt',
    description:
      'sit voluptatem ullam non mollitia sit totam commodi et voluptas vel et mollitia',
    slug: 'Unbranded-Fog-Shirt-1',
    added: 1483596753850,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Concert', 'Band', 'People'],
    price: 12.99,
    name: 'Sleek Band Shirt',
    description:
      'porro sit numquam aut aut doloremque voluptas ab magni aperiam qui id voluptate est eos earum',
    slug: 'Sleek-Band-Shirt',
    added: 1485135378226,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings'],
    price: 16.99,
    name: 'Practical City Shirt',
    description:
      'veritatis velit quod autem deserunt maiores quos et magnam repellat mollitia doloremque quos dolorem est nobis magnam ullam reiciendis dolores',
    slug: 'Practical-City-Shirt',
    added: 1478376987111,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Rocks'],
    price: 13.99,
    name: 'Intelligent Beach Shirt',
    description:
      'molestias amet quos nemo voluptates voluptatum totam laboriosam pariatur explicabo est culpa necessitatibus dolores esse et reiciendis occaecati alias provident',
    slug: 'Intelligent-Beach-Shirt',
    added: 1483247466088,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Berries', 'Frozen', 'Food'],
    price: 20.99,
    name: 'Sleek Frozen Shirt',
    description:
      'praesentium ea voluptate libero fugiat possimus similique aut consequuntur culpa ut possimus assumenda aut cum eum',
    slug: 'Sleek-Frozen-Shirt',
    added: 1479715759403,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Fog'],
    price: 11.99,
    name: 'Refined Person Shirt',
    description:
      'architecto et deserunt ea optio ut iste eum in commodi qui autem similique sunt accusamus repudiandae repudiandae repudiandae vel',
    slug: 'Refined-Person-Shirt-2',
    added: 1486374365425,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Stairs', 'Feet', 'People'],
    price: 11.99,
    name: 'Generic Feet Shirt',
    description:
      'ut corrupti omnis ratione repudiandae debitis nostrum cupiditate consequatur tempora minus quod nobis laborum deserunt voluptatem inventore perferendis architecto est a',
    slug: 'Generic-Feet-Shirt',
    added: 1482216726333,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains', 'People'],
    price: 18.99,
    name: 'Ergonomic Mountains Shirt',
    description:
      'recusandae tempora eligendi molestias architecto perspiciatis dolorem cumque rem eum recusandae minus quas at sit qui veritatis perspiciatis perferendis aperiam expedita',
    slug: 'Ergonomic-Mountains-Shirt-3',
    added: 1484096894397,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Old', 'Building'],
    price: 9.99,
    name: 'Refined Building Shirt',
    description:
      'voluptas aut et aspernatur accusantium animi quae odit asperiores qui occaecati voluptatem rerum quisquam similique rerum',
    slug: 'Refined-Building-Shirt',
    added: 1486158665090,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Hands', 'Plant'],
    price: 12.99,
    name: 'Licensed Plant Shirt',
    description:
      'minima veniam temporibus at aut labore libero inventore culpa ullam et et explicabo',
    slug: 'Licensed-Plant-Shirt',
    added: 1483072371202,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunrise', 'Metro', 'City'],
    price: 16.99,
    name: 'Handcrafted Metro Shirt',
    description:
      'nam odio non fuga ducimus illo reiciendis ut laborum dolores magnam rem eum molestias delectus qui voluptatem temporibus necessitatibus quis quis',
    slug: 'Handcrafted-Metro-Shirt',
    added: 1481461529017,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Jellyfish', 'Ocean'],
    price: 13.99,
    name: 'Incredible Jellyfish Shirt',
    description:
      'sit soluta tempora et voluptatem deleniti omnis omnis distinctio ex nisi ea quis tempore est odit alias qui saepe quisquam aut eum recusandae',
    slug: 'Incredible-Jellyfish-Shirt',
    added: 1483811759291,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Field', 'Trees', 'Fog'],
    price: 15.99,
    name: 'Unbranded Field Shirt',
    description:
      'dicta asperiores nostrum non vel ea enim et molestias rerum amet iste',
    slug: 'Unbranded-Field-Shirt',
    added: 1479888370826,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Desert', 'Sun'],
    price: 12.99,
    name: 'Incredible Desert Shirt',
    description:
      'perferendis assumenda alias ut non veritatis nostrum aut provident officiis et laborum magni voluptate cum nesciunt dolorum voluptates est nisi quis ipsum dolor occaecati',
    slug: 'Incredible-Desert-Shirt-2',
    added: 1481092813105,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Wood'],
    price: 17.99,
    name: 'Handmade Wood Shirt',
    description:
      'commodi quidem pariatur minus quasi rerum eum recusandae et omnis animi aliquam quam labore tempora id molestiae aliquid magnam ipsum consequuntur sed libero possimus voluptatem',
    slug: 'Handmade-Wood-Shirt',
    added: 1478327595999,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Tea', 'Bed'],
    price: 14.99,
    name: 'Tasty Tea Shirt',
    description:
      'consequatur omnis possimus nesciunt maiores quia voluptatibus dolor numquam sed quo vero qui quia occaecati non deleniti sapiente ut earum officiis quod',
    slug: 'Tasty-Tea-Shirt',
    added: 1478408696881,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Underwater'],
    price: 19.99,
    name: 'Small Underwater Shirt',
    description:
      'non error quisquam consequuntur qui mollitia in sapiente sit non',
    slug: 'Small-Underwater-Shirt',
    added: 1482370537711,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings', 'Architecture'],
    price: 10.99,
    name: 'Gorgeous Buildings Shirt',
    description:
      'eos repellendus sed delectus suscipit assumenda sit incidunt est pariatur quaerat ipsa aut quos non odit sequi dignissimos enim',
    slug: 'Gorgeous-Buildings-Shirt-1',
    added: 1479857874341,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Beach', 'Ocean'],
    price: 9.99,
    name: 'Generic Beach Shirt',
    description:
      'vitae et corrupti et quidem aut voluptatem necessitatibus expedita laudantium vel eaque quod',
    slug: 'Generic-Beach-Shirt',
    added: 1482709886317,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Ocean', 'Dock'],
    price: 11.99,
    name: 'Gorgeous Sunset Shirt',
    description:
      'qui officiis consequatur velit nam est voluptatibus sapiente non iste non ipsum commodi dignissimos molestiae maiores odio autem quia id quidem officia molestiae',
    slug: 'Gorgeous-Sunset-Shirt-1',
    added: 1485784988247,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Trees', 'Mountains'],
    price: 14.99,
    name: 'Sleek Mountains Shirt',
    description:
      'sed eligendi dolor sed delectus perferendis consequatur non laudantium ea quam',
    slug: 'Sleek-Mountains-Shirt-2',
    added: 1481128610828,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Rocks'],
    price: 11.99,
    name: 'Practical Rocks Shirt',
    description:
      'laudantium deserunt dolorem earum praesentium nulla autem sed ut velit voluptas facere cum qui consequatur veniam',
    slug: 'Practical-Rocks-Shirt-1',
    added: 1479168843410,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Blueberries', 'Fruit'],
    price: 11.99,
    name: 'Practical Blueberries Shirt',
    description:
      'nemo quae cupiditate rerum eligendi eveniet ab ut repudiandae id aut veritatis dolores vel debitis enim soluta quis autem assumenda',
    slug: 'Practical-Blueberries-Shirt',
    added: 1484736782645,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Building'],
    price: 17.99,
    name: 'Tasty Building Shirt',
    description:
      'error eos accusantium non consequuntur rerum quo tempore consequatur dolores modi',
    slug: 'Tasty-Building-Shirt',
    added: 1480285102022,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Field', 'Stadium', 'Soccer'],
    price: 13.99,
    name: 'Refined Soccer Shirt',
    description:
      'voluptatibus dolor eveniet id est nam neque velit animi consequuntur mollitia in',
    slug: 'Refined-Soccer-Shirt',
    added: 1478016433652,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Fog', 'Rocks'],
    price: 20.99,
    name: 'Incredible Fog Shirt',
    description:
      'odio voluptas dolor magnam voluptatum dolorem unde inventore quam occaecati sunt temporibus veritatis ea',
    slug: 'Incredible-Fog-Shirt-3',
    added: 1481931307879,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 14.99,
    name: 'Small Forest Shirt',
    description:
      'assumenda voluptas sed ab ipsam itaque qui excepturi doloremque repellat magni voluptatem est explicabo sed rem ducimus nostrum voluptatem omnis labore aut',
    slug: 'Small-Forest-Shirt',
    added: 1481635830166,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Macro', 'Leaves'],
    price: 19.99,
    name: 'Incredible Macro Shirt',
    description:
      'et accusamus iure aut ullam tenetur sit debitis nostrum eaque dolorem quia',
    slug: 'Incredible-Macro-Shirt',
    added: 1485254851377,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Night', 'Nature', 'Mountains'],
    price: 16.99,
    name: 'Refined Night Shirt',
    description:
      'dolor doloribus voluptatem reiciendis cumque autem vel adipisci autem error autem',
    slug: 'Refined-Night-Shirt',
    added: 1479899576824,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Buildings', 'City'],
    price: 9.99,
    name: 'Unbranded Buildings Shirt',
    description:
      'eos ducimus excepturi hic placeat et quia aliquid adipisci nobis',
    slug: 'Unbranded-Buildings-Shirt',
    added: 1484711651268,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Dew', 'Spider web'],
    price: 18.99,
    name: 'Rustic Spider Web Shirt',
    description:
      'eum id qui sint totam inventore qui et fugit natus quasi libero ullam architecto fuga quod eos sed veritatis voluptate temporibus dolor quis',
    slug: 'Rustic-Spider-Web-Shirt',
    added: 1480028633673,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Tree', 'Plant', 'Rain', 'Leaves'],
    price: 20.99,
    name: 'Refined Tree Shirt',
    description:
      'aut et dolores cum nihil impedit magnam illo praesentium sed non aliquid ex maxime dolores nulla est ut veritatis',
    slug: 'Refined-Tree-Shirt',
    added: 1479334976753,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Plants'],
    price: 19.99,
    name: 'Generic Plants Shirt',
    description:
      'voluptatem consequatur nulla veniam eum commodi tempora id qui fugit cumque voluptas consequatur repellat temporibus deleniti est',
    slug: 'Generic-Plants-Shirt',
    added: 1484820333067,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Stairs', 'People'],
    price: 10.99,
    name: 'Refined People Shirt',
    description:
      'fugit sit deleniti iste nobis et eaque voluptas et quia quia aliquam harum ratione et voluptas quia blanditiis ut suscipit',
    slug: 'Refined-People-Shirt-1',
    added: 1481201753037,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Hills', 'Fog'],
    price: 18.99,
    name: 'Licensed Fog Shirt',
    description:
      'animi eum officia ut vel cupiditate ipsa ut ducimus mollitia in odit',
    slug: 'Licensed-Fog-Shirt-1',
    added: 1485054025293,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Waterfall', 'Valley', 'Nature'],
    price: 20.99,
    name: 'Ergonomic Nature Shirt',
    description:
      'quaerat ut adipisci magnam debitis ipsa enim nisi quo provident ut est quia suscipit tempora asperiores repellendus voluptatum iusto excepturi fuga quo',
    slug: 'Ergonomic-Nature-Shirt-2',
    added: 1485643988019,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog'],
    price: 19.99,
    name: 'Gorgeous Fog Shirt',
    description:
      'odit aut ex perferendis sapiente aspernatur in expedita necessitatibus saepe adipisci perspiciatis laboriosam dolores laboriosam vel fugit ut rerum aut molestiae dolorum rem',
    slug: 'Gorgeous-Fog-Shirt-1',
    added: 1482837441556,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Cactus'],
    price: 12.99,
    name: 'Awesome Cactus Shirt',
    description:
      'et et eum eos eos quas nobis itaque provident distinctio nobis repellat eos autem id incidunt in eos porro unde',
    slug: 'Awesome-Cactus-Shirt',
    added: 1480770503851,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Bear'],
    price: 10.99,
    name: 'Generic Animal Shirt',
    description:
      'omnis placeat quaerat debitis est rerum et vitae molestiae porro necessitatibus adipisci quam cupiditate sit sed est reiciendis',
    slug: 'Generic-Animal-Shirt',
    added: 1478295356913,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Surfer', 'Person', 'Man', 'Ocean'],
    price: 18.99,
    name: 'Practical Surfer Shirt',
    description:
      'accusantium eligendi quae autem ea nihil neque neque necessitatibus sit harum possimus et sunt reprehenderit perspiciatis ut consequatur possimus porro animi culpa aut',
    slug: 'Practical-Surfer-Shirt',
    added: 1486121685925,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Forest', 'Sun'],
    price: 14.99,
    name: 'Fantastic Person Shirt',
    description:
      'ut perspiciatis doloremque deserunt quo quia voluptatibus nulla sit et aperiam sed sit sunt',
    slug: 'Fantastic-Person-Shirt-1',
    added: 1485875168147,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees'],
    price: 14.99,
    name: 'Intelligent Trees Shirt',
    description:
      'ut quis tempore dignissimos quia quidem voluptatem asperiores ut in laboriosam ut ratione deserunt rerum repellat recusandae eligendi ipsum voluptatibus architecto animi dignissimos',
    slug: 'Intelligent-Trees-Shirt-3',
    added: 1484037265749,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Night', 'Stars', 'Space'],
    price: 14.99,
    name: 'Unbranded Stars Shirt',
    description:
      'est sit inventore dolorem optio cumque ut ut odio esse illum aut beatae voluptatem voluptatem saepe',
    slug: 'Unbranded-Stars-Shirt',
    added: 1479950373785,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Island', 'Ocean'],
    price: 16.99,
    name: 'Practical Ocean Shirt',
    description:
      'et eum animi harum ipsa excepturi magni reprehenderit in eligendi error dolore nemo itaque',
    slug: 'Practical-Ocean-Shirt-1',
    added: 1482694326122,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Boat', 'Ocean', 'People'],
    price: 11.99,
    name: 'Generic Boat Shirt',
    description:
      'eum maiores ratione dolorem error qui voluptas est nostrum quia amet recusandae rerum quam perferendis veritatis est qui amet et fugiat',
    slug: 'Generic-Boat-Shirt',
    added: 1485146789635,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 18.99,
    name: 'Incredible Building Shirt',
    description:
      'tenetur qui perferendis ipsum et temporibus voluptatem eius fugiat rem expedita quasi molestiae ipsa et expedita dolore occaecati expedita sit sed et',
    slug: 'Incredible-Building-Shirt-2',
    added: 1486142324579,
    manufacturer: 'Hodkiewicz-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Tree', 'Orange', 'Fruit'],
    price: 14.99,
    name: 'Refined Orange Shirt',
    description:
      'accusamus est et quis aut necessitatibus similique exercitationem vel qui quia aut architecto',
    slug: 'Refined-Orange-Shirt',
    added: 1483851781199,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Night', 'Fireworks'],
    price: 14.99,
    name: 'Awesome Sunset Shirt',
    description:
      'et ullam qui natus ut repellendus hic tenetur aliquid eaque sunt quibusdam non excepturi sequi vero excepturi molestias',
    slug: 'Awesome-Sunset-Shirt',
    added: 1478178367103,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Keyboard', 'Computer'],
    price: 12.99,
    name: 'Fantastic Computer Shirt',
    description:
      'deserunt ut autem quasi consequuntur autem occaecati praesentium dolorem incidunt ut dolorem excepturi in omnis unde veritatis deserunt veritatis delectus beatae tempore',
    slug: 'Fantastic-Computer-Shirt',
    added: 1479185282186,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Water', 'People'],
    price: 18.99,
    name: 'Practical Water Shirt',
    description:
      'non minima ut laudantium tempora voluptatem sint ducimus sunt quia alias deleniti dolores et quisquam velit vitae cum laboriosam labore quae eius quas non',
    slug: 'Practical-Water-Shirt-1',
    added: 1481819174164,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Tree'],
    price: 18.99,
    name: 'Gorgeous Sunset Shirt',
    description:
      'non quam iusto eligendi sit quo ea aut rerum animi omnis et repellat ut',
    slug: 'Gorgeous-Sunset-Shirt-2',
    added: 1481457240921,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Plants', 'Leaves'],
    price: 12.99,
    name: 'Incredible Leaves Shirt',
    description:
      'eum sint nostrum est quibusdam praesentium cumque sit accusantium consequatur est',
    slug: 'Incredible-Leaves-Shirt',
    added: 1480339132445,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Flowers', 'Food'],
    price: 11.99,
    name: 'Ergonomic Flowers Shirt',
    description:
      'maxime eos expedita possimus in non minus iste omnis nam ea expedita velit eligendi est quis aperiam dolores necessitatibus aut fugit et',
    slug: 'Ergonomic-Flowers-Shirt',
    added: 1478465141000,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Office', 'Laptop'],
    price: 18.99,
    name: 'Handcrafted Laptop Shirt',
    description:
      'tempore ipsum aut cupiditate dolore et quia sequi quae impedit autem accusantium excepturi molestiae sequi laborum minus temporibus eligendi perferendis eum amet earum',
    slug: 'Handcrafted-Laptop-Shirt',
    added: 1478806191055,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Dirt', 'Road'],
    price: 13.99,
    name: 'Ergonomic Road Shirt',
    description:
      'est itaque vel dicta incidunt deleniti rerum nihil necessitatibus aut consequatur praesentium rerum aperiam',
    slug: 'Ergonomic-Road-Shirt-1',
    added: 1486304021030,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Child', 'City', 'People'],
    price: 10.99,
    name: 'Licensed People Shirt',
    description:
      'quidem hic nihil nihil debitis optio omnis adipisci qui rerum corrupti temporibus veritatis ipsum excepturi et at est repellat deserunt explicabo sit fuga esse',
    slug: 'Licensed-People-Shirt',
    added: 1478165580123,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Ocean', 'Bird'],
    price: 20.99,
    name: 'Refined Ocean Shirt',
    description:
      'et ea rerum autem maxime reiciendis voluptate vel repellat consectetur sed cumque nam',
    slug: 'Refined-Ocean-Shirt',
    added: 1480431024105,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Building'],
    price: 19.99,
    name: 'Awesome Building Shirt',
    description:
      'assumenda at sapiente et alias quisquam a placeat aut doloremque voluptatum ut consequatur quam recusandae error dolor eius blanditiis nihil at eveniet fugit omnis quia',
    slug: 'Awesome-Building-Shirt-2',
    added: 1478433544473,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset'],
    price: 15.99,
    name: 'Handmade Sunset Shirt',
    description:
      'impedit possimus at qui voluptatem ut ratione voluptatibus rem sequi facere consequatur quasi sed aliquid soluta aliquid incidunt voluptates rerum odit placeat nisi et rem',
    slug: 'Handmade-Sunset-Shirt-2',
    added: 1478609116130,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Flowers'],
    price: 14.99,
    name: 'Rustic Flowers Shirt',
    description:
      'dolore quis aut animi odio beatae dolor odio minima et delectus perferendis qui sapiente totam est consequatur accusamus tempora dolorem',
    slug: 'Rustic-Flowers-Shirt-1',
    added: 1483137755179,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Night', 'City', 'Railroad'],
    price: 18.99,
    name: 'Incredible City Shirt',
    description:
      'architecto accusantium assumenda beatae ullam aperiam nostrum quidem ut dolor perferendis cum aut consequatur tempore amet ut dolorum blanditiis nam distinctio',
    slug: 'Incredible-City-Shirt',
    added: 1480955796574,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 9.99,
    name: 'Sleek City Shirt',
    description:
      'qui ducimus saepe rerum quo et nesciunt aperiam incidunt ea voluptas cumque',
    slug: 'Sleek-City-Shirt-1',
    added: 1481264434844,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Dog', 'Animal', 'Husky'],
    price: 14.99,
    name: 'Handcrafted Husky Shirt',
    description:
      'perspiciatis reiciendis totam earum ratione sunt sint occaecati et et fuga voluptates et eum dolorum odit qui et molestias',
    slug: 'Handcrafted-Husky-Shirt',
    added: 1479473069344,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 17.99,
    name: 'Intelligent Mountains Shirt',
    description:
      'nisi et debitis voluptas similique repellat officia dolore beatae velit et impedit nulla in culpa sapiente aliquam optio suscipit et',
    slug: 'Intelligent-Mountains-Shirt-3',
    added: 1478741655948,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Woman'],
    price: 10.99,
    name: 'Handmade Woman Shirt',
    description:
      'debitis pariatur deserunt fugiat accusantium distinctio incidunt sapiente quas modi molestias rem',
    slug: 'Handmade-Woman-Shirt-1',
    added: 1479104838365,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Horizon', 'Ocean'],
    price: 11.99,
    name: 'Ergonomic Ocean Shirt',
    description:
      'dignissimos dolores atque est quis dolores sed dolor nemo et rerum quisquam',
    slug: 'Ergonomic-Ocean-Shirt-3',
    added: 1483255048732,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Dock', 'Lake'],
    price: 14.99,
    name: 'Unbranded Lake Shirt',
    description:
      'dolorem sunt quas aut nemo eos totam tempore libero odit tenetur ea molestiae rerum quod doloremque molestiae eius itaque quod sapiente cumque nisi ut est',
    slug: 'Unbranded-Lake-Shirt',
    added: 1480419130140,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Waves', 'Water'],
    price: 18.99,
    name: 'Small Water Shirt',
    description:
      'non in maiores totam rerum ipsa recusandae et sunt dolores consequuntur eligendi excepturi magnam nesciunt reiciendis reiciendis et molestiae soluta',
    slug: 'Small-Water-Shirt',
    added: 1482302028294,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Horizon', 'Ocean'],
    price: 16.99,
    name: 'Handcrafted Ocean Shirt',
    description:
      'ex temporibus dolor ut consectetur nostrum tempore culpa ratione porro autem',
    slug: 'Handcrafted-Ocean-Shirt-1',
    added: 1485153262170,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Person'],
    price: 14.99,
    name: 'Unbranded Person Shirt',
    description: 'animi nisi non quis quia aperiam illum nulla qui nisi',
    slug: 'Unbranded-Person-Shirt',
    added: 1484695647745,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Winter', 'Snow', 'Frost'],
    price: 17.99,
    name: 'Handmade Snow Shirt',
    description:
      'est delectus labore saepe et sunt fugit magnam nesciunt mollitia sunt et et tempora eligendi ducimus aut illo impedit laborum distinctio tempora eius sunt totam',
    slug: 'Handmade-Snow-Shirt-2',
    added: 1478690143842,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Lights', 'City', 'Buildings'],
    price: 20.99,
    name: 'Awesome Buildings Shirt',
    description:
      'nostrum libero beatae consequatur omnis distinctio et non aut similique suscipit sapiente aliquid et tenetur id dicta et inventore reprehenderit sint inventore est consequatur iusto',
    slug: 'Awesome-Buildings-Shirt',
    added: 1485680184669,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'City'],
    price: 9.99,
    name: 'Licensed Ocean Shirt',
    description:
      'molestiae ducimus quia est porro quisquam autem et deserunt sed',
    slug: 'Licensed-Ocean-Shirt-2',
    added: 1485179791319,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Nature', 'Road', 'Water'],
    price: 16.99,
    name: 'Gorgeous Road Shirt',
    description:
      'consequatur omnis iste quisquam voluptatum tenetur praesentium sit veritatis corrupti ut optio nobis repellendus est qui qui non sint',
    slug: 'Gorgeous-Road-Shirt',
    added: 1478638633319,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Glass', 'Architecture'],
    price: 19.99,
    name: 'Gorgeous Glass Shirt',
    description:
      'inventore porro iure quod quas quia quia sit nisi ad facere non et est voluptatibus quaerat eos impedit libero eaque voluptatem earum',
    slug: 'Gorgeous-Glass-Shirt',
    added: 1480329934592,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Bus', 'Machine'],
    price: 17.99,
    name: 'Incredible Bus Shirt',
    description:
      'numquam et eveniet corrupti neque labore in est a laboriosam ut ducimus aspernatur voluptas omnis culpa ad aut ut nemo aut dolor similique consequatur',
    slug: 'Incredible-Bus-Shirt',
    added: 1479089410288,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Trees'],
    price: 10.99,
    name: 'Intelligent Sunset Shirt',
    description:
      'consequatur consequuntur aut eaque cum adipisci aspernatur nesciunt magni sit pariatur quia inventore dolorem ea',
    slug: 'Intelligent-Sunset-Shirt',
    added: 1481860324779,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Boats', 'Ocean'],
    price: 17.99,
    name: 'Small Boats Shirt',
    description:
      'magnam ipsam et enim optio porro laudantium facilis expedita est voluptatem et porro aut est qui enim in nisi impedit cum eos debitis',
    slug: 'Small-Boats-Shirt',
    added: 1478261275293,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Space', 'NASA', 'Mars'],
    price: 13.99,
    name: 'Rustic NASA Shirt',
    description:
      'temporibus commodi rerum hic quibusdam ut eaque illo et maxime quam quasi quo aut impedit reprehenderit saepe aut numquam soluta facilis illum',
    slug: 'Rustic-NASA-Shirt',
    added: 1478562264905,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Mountains'],
    price: 11.99,
    name: 'Handcrafted Mountains Shirt',
    description:
      'quibusdam est voluptates quasi officia dolorum nihil a laboriosam iste nesciunt ut accusantium tenetur delectus et',
    slug: 'Handcrafted-Mountains-Shirt-1',
    added: 1479338875596,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Plane'],
    price: 12.99,
    name: 'Gorgeous Plane Shirt',
    description:
      'cupiditate cum quod aliquid at exercitationem quo qui ex dolores autem sapiente repudiandae magnam nihil animi',
    slug: 'Gorgeous-Plane-Shirt-1',
    added: 1486202329840,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Boat'],
    price: 14.99,
    name: 'Fantastic Boat Shirt',
    description:
      'eaque veritatis iure ea ipsam voluptatem rem modi optio deserunt reprehenderit similique iusto molestiae expedita eaque',
    slug: 'Fantastic-Boat-Shirt',
    added: 1484826469556,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean'],
    price: 9.99,
    name: 'Sleek Ocean Shirt',
    description:
      'ut aliquid omnis est magnam doloremque iste aut expedita rerum nulla quaerat sit culpa voluptatem et hic et labore possimus minima recusandae molestiae',
    slug: 'Sleek-Ocean-Shirt-1',
    added: 1480514887242,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Sand', 'Pebble'],
    price: 10.99,
    name: 'Generic Sand Shirt',
    description:
      'magnam quaerat tenetur quas deleniti aut eaque dolores animi veniam et non molestiae repudiandae dolor id ex cum omnis',
    slug: 'Generic-Sand-Shirt',
    added: 1486388860713,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Aerial', 'Cars', 'Road'],
    price: 12.99,
    name: 'Tasty Road Shirt',
    description: 'id sint totam aut magni omnis voluptatem non autem et',
    slug: 'Tasty-Road-Shirt-1',
    added: 1479678162429,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Ocean'],
    price: 13.99,
    name: 'Handmade Ocean Shirt',
    description:
      'assumenda impedit minus voluptatibus delectus magnam asperiores sunt ut laboriosam fugit aspernatur sint aut necessitatibus quia et deleniti harum accusamus illo repellat facere doloremque quaerat',
    slug: 'Handmade-Ocean-Shirt-1',
    added: 1483590398413,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Books', 'Library'],
    price: 15.99,
    name: 'Awesome Books Shirt',
    description:
      'perspiciatis suscipit molestiae omnis quis illum itaque et expedita explicabo doloribus et officiis aliquam sunt illo illo odit molestias sint voluptas consequatur aut quia',
    slug: 'Awesome-Books-Shirt',
    added: 1486249370757,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset'],
    price: 14.99,
    name: 'Generic Sunset Shirt',
    description:
      'ex dolore non distinctio ut enim dolores quo maiores quo voluptatem officia ut porro reiciendis vel',
    slug: 'Generic-Sunset-Shirt',
    added: 1486039423030,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Abstract', 'Architecture'],
    price: 13.99,
    name: 'Small Architecture Shirt',
    description:
      'recusandae sunt eveniet tempore est eveniet itaque aspernatur rerum qui et facilis architecto animi neque voluptatum praesentium non nihil corrupti quis',
    slug: 'Small-Architecture-Shirt',
    added: 1483428003371,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Nature', 'Forest'],
    price: 14.99,
    name: 'Ergonomic Forest Shirt',
    description:
      'laboriosam et id vel fuga quam vero ea vitae quisquam rerum iste ea aspernatur assumenda alias consequatur ab asperiores temporibus architecto animi officia',
    slug: 'Ergonomic-Forest-Shirt-2',
    added: 1485082581154,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Beans', 'Coffee'],
    price: 11.99,
    name: 'Small Beans Shirt',
    description:
      'dolorum natus eos qui amet provident quia neque facere quia odit repudiandae in omnis et delectus doloribus reiciendis sunt aut delectus aperiam',
    slug: 'Small-Beans-Shirt',
    added: 1483732129959,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Coffee', 'Paper', 'Book'],
    price: 11.99,
    name: 'Fantastic Coffee Shirt',
    description:
      'aut rerum id et laborum veritatis animi officia necessitatibus animi vero',
    slug: 'Fantastic-Coffee-Shirt',
    added: 1485349115272,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 18.99,
    name: 'Refined Beach Shirt',
    description:
      'et quas earum sed non molestias atque culpa aut voluptas atque assumenda rem quo',
    slug: 'Refined-Beach-Shirt-2',
    added: 1486379550799,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Aerial', 'Bridge', 'Cars', 'Meatal'],
    price: 20.99,
    name: 'Ergonomic Cars Shirt',
    description:
      'quaerat dignissimos in aut quibusdam consequatur et quae cupiditate eum doloribus praesentium veritatis voluptas fuga adipisci aspernatur nam rerum officiis',
    slug: 'Ergonomic-Cars-Shirt',
    added: 1485831362687,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 9.99,
    name: 'Handmade Desk Shirt',
    description:
      'aut voluptatum voluptates debitis impedit ut commodi sint rerum velit sed doloremque perspiciatis id mollitia est nesciunt quo',
    slug: 'Handmade-Desk-Shirt',
    added: 1486200461144,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Man', 'City', 'Coffee shop', 'People'],
    price: 14.99,
    name: 'Incredible Coffee Shop Shirt',
    description:
      'nihil fuga aliquid delectus facere recusandae vitae ad minima numquam enim doloribus consectetur et repudiandae',
    slug: 'Incredible-Coffee-Shop-Shirt',
    added: 1478527726963,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Water', 'Cliffs'],
    price: 11.99,
    name: 'Gorgeous Cliffs Shirt',
    description:
      'repellendus a est eveniet occaecati veritatis delectus aut quisquam omnis accusamus',
    slug: 'Gorgeous-Cliffs-Shirt',
    added: 1485885713502,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 12.99,
    name: 'Generic Snow Shirt',
    description:
      'fuga voluptates excepturi et omnis et dolorem et similique omnis laudantium natus itaque perferendis non aliquam odit voluptatem ab possimus placeat consectetur necessitatibus molestiae',
    slug: 'Generic-Snow-Shirt',
    added: 1479762887897,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Car', 'Vehicle'],
    price: 9.99,
    name: 'Licensed Vehicle Shirt',
    description:
      'aut consectetur eum velit qui ducimus nobis omnis exercitationem rem',
    slug: 'Licensed-Vehicle-Shirt',
    added: 1485469704981,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Cars', 'City', 'Buildings'],
    price: 13.99,
    name: 'Intelligent Cars Shirt',
    description:
      'laboriosam illo ducimus eos distinctio ex qui iusto quo iste delectus sint omnis eos id minima voluptatum perferendis',
    slug: 'Intelligent-Cars-Shirt',
    added: 1478463067915,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Coffee bar', 'Brew', 'Coffee'],
    price: 18.99,
    name: 'Ergonomic Brew Shirt',
    description:
      'vel a corrupti optio soluta rem voluptas atque accusamus quos vel aut',
    slug: 'Ergonomic-Brew-Shirt',
    added: 1477846125777,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Trees', 'Forest', 'Water', 'River'],
    price: 11.99,
    name: 'Unbranded River Shirt',
    description:
      'est rerum in accusantium iusto quis et sunt accusamus porro ullam et nemo distinctio nemo ut ut sequi voluptates occaecati nam eaque ab distinctio dolorem',
    slug: 'Unbranded-River-Shirt',
    added: 1484508603221,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Buildings'],
    price: 10.99,
    name: 'Awesome Buildings Shirt',
    description:
      'hic delectus ut ut fuga dolor dolorum quo perferendis debitis dolorum',
    slug: 'Awesome-Buildings-Shirt-1',
    added: 1485879609574,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog'],
    price: 12.99,
    name: 'Generic Fog Shirt',
    description:
      'officia recusandae debitis rerum praesentium eius iste et sed consequatur aut dolor blanditiis officia facere est quas est odit ut',
    slug: 'Generic-Fog-Shirt-3',
    added: 1484583755146,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Night', 'Mountains', 'Stars'],
    price: 18.99,
    name: 'Licensed Mountains Shirt',
    description:
      'ut eum error vero alias vel ipsa facilis est officia sequi exercitationem',
    slug: 'Licensed-Mountains-Shirt-3',
    added: 1480224429239,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Fog'],
    price: 17.99,
    name: 'Unbranded Fog Shirt',
    description:
      'quod eum aut magnam exercitationem saepe natus excepturi ut voluptas libero',
    slug: 'Unbranded-Fog-Shirt-2',
    added: 1481979954089,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Night', 'Stars'],
    price: 17.99,
    name: 'Generic Night Shirt',
    description:
      'corrupti similique quis enim sint animi quibusdam porro porro facilis ut sed tenetur',
    slug: 'Generic-Night-Shirt',
    added: 1485068742816,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Trees'],
    price: 20.99,
    name: 'Sleek Trees Shirt',
    description:
      'nobis dolorem dolor nostrum nobis enim vero qui laboriosam magnam ut molestiae id ut voluptas dolorem dolores',
    slug: 'Sleek-Trees-Shirt-1',
    added: 1484420660816,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge'],
    price: 11.99,
    name: 'Generic Bridge Shirt',
    description:
      'vel autem voluptatem enim voluptatem cumque ut soluta molestiae vel',
    slug: 'Generic-Bridge-Shirt-1',
    added: 1485432533697,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Clock'],
    price: 14.99,
    name: 'Generic Clock Shirt',
    description:
      'quod amet facere pariatur voluptas neque sunt accusamus ipsum ex aspernatur explicabo nihil illum unde',
    slug: 'Generic-Clock-Shirt',
    added: 1484498068198,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Sunrise', 'Forest'],
    price: 19.99,
    name: 'Small Forest Shirt',
    description:
      'molestiae fuga et ut voluptate amet ut asperiores quia rerum numquam necessitatibus odio voluptas reiciendis aut et placeat quia sapiente reiciendis itaque iste rerum',
    slug: 'Small-Forest-Shirt-1',
    added: 1482976396892,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Buildings'],
    price: 11.99,
    name: 'Handmade Buildings Shirt',
    description:
      'fugit non harum porro sint aut sapiente libero rerum ipsam provident sint quas',
    slug: 'Handmade-Buildings-Shirt',
    added: 1480513137577,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Lake'],
    price: 11.99,
    name: 'Practical River Shirt',
    description:
      'ipsum et nihil ex molestias ut aperiam eum nemo adipisci dignissimos est et accusantium molestiae porro vel molestias dolorum molestiae esse qui aut quia',
    slug: 'Practical-River-Shirt',
    added: 1483153121433,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Hiker', 'Person', 'Woman'],
    price: 16.99,
    name: 'Handmade Woman Shirt',
    description:
      'quia et ducimus reprehenderit enim vitae enim porro ut accusantium omnis illum earum ut debitis cupiditate maiores ex',
    slug: 'Handmade-Woman-Shirt-2',
    added: 1483072274424,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Silhouette'],
    price: 19.99,
    name: 'Incredible Silhouette Shirt',
    description:
      'et odio eligendi illo vitae eos iure mollitia inventore et assumenda minima est accusamus',
    slug: 'Incredible-Silhouette-Shirt',
    added: 1482670610123,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Cars', 'City', 'Buildings'],
    price: 10.99,
    name: 'Licensed City Shirt',
    description:
      'blanditiis quas saepe necessitatibus autem quia ratione beatae natus quisquam quos hic velit voluptatem qui quo quo architecto dolorem sit eius dicta quia est',
    slug: 'Licensed-City-Shirt-3',
    added: 1484153875312,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Water'],
    price: 14.99,
    name: 'Licensed Ocean Shirt',
    description:
      'tempore nobis blanditiis facilis at quae omnis neque itaque rerum laborum adipisci enim',
    slug: 'Licensed-Ocean-Shirt-3',
    added: 1486376216081,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 16.99,
    name: 'Ergonomic Ocean Shirt',
    description:
      'amet quos incidunt consequatur nobis iusto cum ipsam eveniet quis placeat sit',
    slug: 'Ergonomic-Ocean-Shirt-4',
    added: 1483035417441,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Desert', 'People'],
    price: 17.99,
    name: 'Practical People Shirt',
    description:
      'et repellat voluptatibus corrupti labore velit ut voluptatem sequi tenetur nulla nam incidunt et maiores impedit qui vel quos ut fugiat',
    slug: 'Practical-People-Shirt',
    added: 1478785068028,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Mountains'],
    price: 12.99,
    name: 'Rustic Nature Shirt',
    description:
      'numquam est sint ab rerum nihil deserunt repellat dolorem autem',
    slug: 'Rustic-Nature-Shirt-2',
    added: 1482167097862,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Forest'],
    price: 13.99,
    name: 'Gorgeous Fog Shirt',
    description:
      'reprehenderit velit reprehenderit quia deserunt eum velit non nam distinctio consequuntur laboriosam suscipit distinctio est et beatae',
    slug: 'Gorgeous-Fog-Shirt-2',
    added: 1481174350521,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Child', 'Man', 'People'],
    price: 17.99,
    name: 'Licensed Man Shirt',
    description:
      'excepturi repudiandae quaerat rerum repellat molestiae maiores dolorem doloribus corrupti aut repellat et delectus qui mollitia ut accusamus provident nihil mollitia similique est est eaque',
    slug: 'Licensed-Man-Shirt',
    added: 1478940905880,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Fog', 'Mountains'],
    price: 20.99,
    name: 'Handcrafted Fog Shirt',
    description:
      'voluptatem mollitia dolorem inventore et alias nihil ipsum aut aut possimus et recusandae',
    slug: 'Handcrafted-Fog-Shirt-2',
    added: 1481288974683,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Cliff', 'Ocean', 'Rocks'],
    price: 10.99,
    name: 'Generic Rocks Shirt',
    description:
      'blanditiis consequuntur aut laudantium sit recusandae quidem aliquid minus libero vel itaque vero odio sed sunt voluptatem temporibus quibusdam ut quod nostrum provident id repudiandae',
    slug: 'Generic-Rocks-Shirt-1',
    added: 1485247387342,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Woman', 'Sleeping'],
    price: 19.99,
    name: 'Gorgeous Sleeping Shirt',
    description:
      'itaque sint nihil expedita aperiam velit et eum saepe odit vel saepe deserunt unde voluptatem commodi tempora dolorem nostrum officiis necessitatibus quaerat sint eius reprehenderit',
    slug: 'Gorgeous-Sleeping-Shirt',
    added: 1481496498141,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Fog', 'City'],
    price: 12.99,
    name: 'Ergonomic Fog Shirt',
    description:
      'dolor quos provident accusamus in optio omnis autem blanditiis architecto',
    slug: 'Ergonomic-Fog-Shirt-1',
    added: 1484073900347,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 17.99,
    name: 'Practical City Shirt',
    description:
      'unde autem harum dolor est quam debitis culpa deleniti tempore consequatur nostrum assumenda voluptas qui fuga',
    slug: 'Practical-City-Shirt-1',
    added: 1484831495667,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Trees', 'Mountains', 'Forest'],
    price: 11.99,
    name: 'Fantastic Mountains Shirt',
    description:
      'voluptatem commodi sit voluptatem qui quia distinctio quae et repudiandae aliquam voluptatibus qui enim aut sit est dolores at',
    slug: 'Fantastic-Mountains-Shirt-1',
    added: 1480171759674,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Plants', 'Flowers'],
    price: 15.99,
    name: 'Intelligent Flowers Shirt',
    description:
      'debitis atque quia enim quasi cupiditate assumenda reprehenderit aut soluta ipsam non aut consequatur reprehenderit esse mollitia cupiditate porro et voluptatem',
    slug: 'Intelligent-Flowers-Shirt',
    added: 1484653224939,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Boardwalk', 'Beach', 'People'],
    price: 13.99,
    name: 'Unbranded Boardwalk Shirt',
    description:
      'omnis doloremque omnis dolorem omnis ea quis unde qui cumque id vel quo libero',
    slug: 'Unbranded-Boardwalk-Shirt',
    added: 1481878601384,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Succulent', 'Nature', 'Plant'],
    price: 19.99,
    name: 'Sleek Succulent Shirt',
    description:
      'deserunt laudantium illum et dicta animi totam quibusdam quia non ut voluptatem sit eum',
    slug: 'Sleek-Succulent-Shirt',
    added: 1485779912704,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'People'],
    price: 11.99,
    name: 'Refined Beach Shirt',
    description:
      'sed sed quis veritatis accusantium dignissimos expedita quidem dolore voluptatem',
    slug: 'Refined-Beach-Shirt-3',
    added: 1486412495666,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Mountains', 'Dock', 'Lake'],
    price: 16.99,
    name: 'Awesome Sunset Shirt',
    description: 'vel quia ratione qui rerum dolorum aliquam quae est eligendi',
    slug: 'Awesome-Sunset-Shirt-1',
    added: 1483573525950,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Rocks'],
    price: 20.99,
    name: 'Rustic Rocks Shirt',
    description:
      'qui eius corrupti voluptatem amet quae et cum quia et et iste in necessitatibus autem facilis iste cupiditate',
    slug: 'Rustic-Rocks-Shirt',
    added: 1485042162105,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Frost', 'Train'],
    price: 11.99,
    name: 'Ergonomic Frost Shirt',
    description:
      'sunt neque ducimus omnis fugiat aut quos dignissimos asperiores doloremque eius architecto consequatur et saepe sed aperiam sed ipsam itaque qui enim sunt vel adipisci',
    slug: 'Ergonomic-Frost-Shirt',
    added: 1484861985273,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Architecture', 'Building'],
    price: 16.99,
    name: 'Generic Building Shirt',
    description:
      'minus accusantium molestiae eius omnis quia doloremque sit explicabo amet minus eum nihil sunt',
    slug: 'Generic-Building-Shirt',
    added: 1481498169289,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Lake', 'Cabin'],
    price: 19.99,
    name: 'Small Trees Shirt',
    description:
      'aperiam tempora nulla tempora et necessitatibus enim dolore dolor et necessitatibus quia in voluptas et cumque rerum asperiores',
    slug: 'Small-Trees-Shirt-1',
    added: 1478222722414,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Woman', 'People'],
    price: 20.99,
    name: 'Refined People Shirt',
    description:
      'omnis quis voluptate laboriosam sit sed iure dolor nostrum occaecati quidem ducimus in voluptas repellat qui aspernatur nulla voluptatem debitis ipsa itaque molestias',
    slug: 'Refined-People-Shirt-2',
    added: 1481900625937,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Flowers', 'Plants'],
    price: 20.99,
    name: 'Ergonomic Plants Shirt',
    description:
      'voluptatem ex iure deleniti facilis molestiae enim voluptas dolorem voluptatem est nobis eaque aliquam fugiat',
    slug: 'Ergonomic-Plants-Shirt',
    added: 1486379191054,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Architecture', 'Station', 'People'],
    price: 14.99,
    name: 'Unbranded Station Shirt',
    description:
      'quasi et est ut autem odio omnis est excepturi ut rerum hic consectetur itaque iste',
    slug: 'Unbranded-Station-Shirt',
    added: 1478820378002,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Horse'],
    price: 19.99,
    name: 'Small Animal Shirt',
    description:
      'quo cupiditate ipsa recusandae molestias quibusdam quaerat iusto sequi qui occaecati consequatur recusandae',
    slug: 'Small-Animal-Shirt',
    added: 1484674419156,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Boat', 'Ocean'],
    price: 10.99,
    name: 'Refined Ocean Shirt',
    description:
      'commodi molestiae autem quas quisquam earum eaque consequatur debitis et facilis neque et officiis expedita aliquid consectetur natus',
    slug: 'Refined-Ocean-Shirt-1',
    added: 1481054271062,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Metal', 'Bridge', 'City'],
    price: 9.99,
    name: 'Generic Metal Shirt',
    description:
      'officia at sunt placeat pariatur impedit facilis corrupti reiciendis sit ut quis quam et repellat aut rerum voluptas quia quo odit consectetur omnis',
    slug: 'Generic-Metal-Shirt',
    added: 1485528023586,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Sunset', 'Trees', 'Mountains'],
    price: 14.99,
    name: 'Unbranded Mountains Shirt',
    description: 'iure aliquam est saepe et et dolorem aliquid et ipsum',
    slug: 'Unbranded-Mountains-Shirt-1',
    added: 1483472100679,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean'],
    price: 13.99,
    name: 'Unbranded Ocean Shirt',
    description:
      'aliquam omnis est minus fugit pariatur ex iste cum odio consequatur consequatur debitis maiores',
    slug: 'Unbranded-Ocean-Shirt-3',
    added: 1483917735646,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Sky', 'Volcano', 'Night'],
    price: 15.99,
    name: 'Rustic Sky Shirt',
    description:
      'qui tenetur at nihil maxime aut quod alias facilis aut aut ut voluptas tenetur dolores assumenda voluptates aperiam error iste sapiente ea',
    slug: 'Rustic-Sky-Shirt',
    added: 1481489052990,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Kindle', 'Ereader'],
    price: 20.99,
    name: 'Refined Ereader Shirt',
    description:
      'consequuntur deserunt labore magni porro sunt minus voluptatem commodi et molestias est ducimus',
    slug: 'Refined-Ereader-Shirt',
    added: 1485665740770,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Trees', 'Cars', 'Building'],
    price: 18.99,
    name: 'Licensed Trees Shirt',
    description:
      'architecto vel quod temporibus rem et quam assumenda dolores corporis sed sit quasi eum incidunt',
    slug: 'Licensed-Trees-Shirt-1',
    added: 1479002376819,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Lights', 'City'],
    price: 13.99,
    name: 'Tasty Lights Shirt',
    description:
      'totam facere adipisci assumenda dicta architecto dicta ut voluptas aliquam et eum a rerum enim itaque aut assumenda consequuntur exercitationem animi sed voluptates',
    slug: 'Tasty-Lights-Shirt',
    added: 1478561606998,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Fog', 'Mountains'],
    price: 17.99,
    name: 'Ergonomic Mountains Shirt',
    description:
      'aut ad tempora porro a nostrum voluptatibus aspernatur temporibus deserunt laborum molestias nihil nihil dolore quos quas quia aliquid iure dolorem voluptate et',
    slug: 'Ergonomic-Mountains-Shirt-4',
    added: 1482572465753,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Abstract', 'Glass', 'Building'],
    price: 9.99,
    name: 'Unbranded Abstract Shirt',
    description:
      'eveniet minima totam vero minima eum placeat totam id porro dolor ratione quibusdam nisi quam est rerum temporibus ullam labore in aut consequatur officia',
    slug: 'Unbranded-Abstract-Shirt',
    added: 1479008234503,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Surf', 'Beach', 'Ocean'],
    price: 9.99,
    name: 'Sleek Beach Shirt',
    description:
      'enim illum sunt eum officia totam atque eos iusto porro assumenda illo velit exercitationem eos quo facere aut eum quisquam sequi non dolorem ullam',
    slug: 'Sleek-Beach-Shirt-1',
    added: 1480884199570,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean', 'Buildings'],
    price: 10.99,
    name: 'Small Buildings Shirt',
    description:
      'eius optio distinctio enim in dolore sed modi aliquam sint voluptas blanditiis aut itaque ea animi omnis iusto magni',
    slug: 'Small-Buildings-Shirt',
    added: 1484382670770,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Clothes', 'Tshirt', 'Retail'],
    price: 16.99,
    name: 'Small Clothes Shirt',
    description:
      'voluptas reprehenderit ex libero reiciendis quis voluptatum quia et nemo quia ab nam necessitatibus veniam',
    slug: 'Small-Clothes-Shirt',
    added: 1484852230213,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Road'],
    price: 18.99,
    name: 'Tasty Road Shirt',
    description:
      'est repudiandae explicabo et iusto omnis occaecati autem minus reprehenderit eveniet quis quis voluptas rerum id',
    slug: 'Tasty-Road-Shirt-2',
    added: 1482180951383,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Cars', 'Streets', 'City', 'Architecture'],
    price: 15.99,
    name: 'Intelligent Cars Shirt',
    description:
      'asperiores aut accusamus et veritatis et id ad occaecati autem',
    slug: 'Intelligent-Cars-Shirt-1',
    added: 1483625099342,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Waterfall', 'Trees', 'Nature'],
    price: 10.99,
    name: 'Gorgeous Trees Shirt',
    description:
      'eius ducimus odio impedit quidem sed placeat repellat et quia et',
    slug: 'Gorgeous-Trees-Shirt-4',
    added: 1484914939972,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Water'],
    price: 10.99,
    name: 'Licensed Water Shirt',
    description:
      'totam incidunt itaque laboriosam ex provident asperiores velit dignissimos dolorem dolorem voluptas velit magnam',
    slug: 'Licensed-Water-Shirt',
    added: 1486340356210,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['River', 'Ice'],
    price: 13.99,
    name: 'Rustic Ice Shirt',
    description:
      'autem suscipit quibusdam eum ea a culpa ea distinctio magni animi doloribus recusandae commodi veritatis nostrum delectus laudantium voluptates pariatur consequuntur',
    slug: 'Rustic-Ice-Shirt',
    added: 1481282618364,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Tulip', 'Flower'],
    price: 15.99,
    name: 'Sleek Flower Shirt',
    description:
      'vero et assumenda temporibus quibusdam unde voluptas et minus optio ut ratione doloribus culpa incidunt consequuntur accusantium consectetur',
    slug: 'Sleek-Flower-Shirt',
    added: 1478880629541,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Silhouette'],
    price: 17.99,
    name: 'Small Silhouette Shirt',
    description:
      'omnis vitae fuga perferendis nobis debitis necessitatibus provident quibusdam natus culpa sit soluta id non sit qui aut corporis sed est ratione temporibus hic',
    slug: 'Small-Silhouette-Shirt',
    added: 1482558070303,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Field', 'Person', 'Car'],
    price: 17.99,
    name: 'Refined Field Shirt',
    description:
      'sunt nesciunt molestias aliquid dolor quasi iure sed voluptatem recusandae dolore rerum ducimus voluptatem velit laborum illo et sunt sit iste quos',
    slug: 'Refined-Field-Shirt',
    added: 1483047597218,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'Ocean'],
    price: 16.99,
    name: 'Handcrafted Ocean Shirt',
    description:
      'maiores eos sapiente veniam suscipit velit natus iusto ex voluptas',
    slug: 'Handcrafted-Ocean-Shirt-2',
    added: 1485248588389,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Sand', 'Desert', 'People'],
    price: 12.99,
    name: 'Rustic Sand Shirt',
    description:
      'reiciendis architecto qui quam expedita ea est enim recusandae aut voluptate a et unde rem perferendis',
    slug: 'Rustic-Sand-Shirt',
    added: 1484329201474,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Hands', 'Office', 'Laptop'],
    price: 20.99,
    name: 'Generic Laptop Shirt',
    description:
      'provident sed quis et harum minus dignissimos consequatur est perspiciatis adipisci autem sapiente dolorem eum explicabo qui illo alias',
    slug: 'Generic-Laptop-Shirt',
    added: 1481929777038,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Child', 'Person', 'Man', 'Father', 'Dad'],
    price: 14.99,
    name: 'Handcrafted Dad Shirt',
    description:
      'et ullam sunt rem est explicabo excepturi magnam rerum blanditiis nostrum est ut praesentium quia aliquid accusantium quo dolorem et magni sed officia ipsum',
    slug: 'Handcrafted-Dad-Shirt',
    added: 1477946548630,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Person', 'Night'],
    price: 15.99,
    name: 'Tasty Night Shirt',
    description:
      'sit ut perferendis veritatis dicta totam non quaerat voluptatem et eum voluptatem enim impedit',
    slug: 'Tasty-Night-Shirt-1',
    added: 1478837546506,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 18.99,
    name: 'Tasty Snow Shirt',
    description:
      'nulla hic impedit dolore voluptas accusamus maiores quis rerum quis provident sequi veniam autem perspiciatis exercitationem fugiat',
    slug: 'Tasty-Snow-Shirt',
    added: 1485220164107,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 15.99,
    name: 'Practical Wood Shirt',
    description:
      'amet ut dolores earum dignissimos aliquid pariatur laudantium saepe esse quia ut eligendi quae illo',
    slug: 'Practical-Wood-Shirt',
    added: 1478594747202,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees'],
    price: 17.99,
    name: 'Ergonomic Trees Shirt',
    description:
      'voluptatem numquam deleniti laborum deleniti ut voluptatibus est distinctio expedita commodi ut',
    slug: 'Ergonomic-Trees-Shirt-1',
    added: 1485567879295,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Alley', 'Brick'],
    price: 19.99,
    name: 'Intelligent Alley Shirt',
    description:
      'harum voluptas laborum provident ut dicta harum asperiores dolor corporis cupiditate non sit assumenda qui velit quo dolor officia cupiditate enim porro',
    slug: 'Intelligent-Alley-Shirt',
    added: 1485387784011,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Desert'],
    price: 19.99,
    name: 'Tasty Desert Shirt',
    description:
      'qui accusamus praesentium eos numquam perspiciatis minima ut autem totam blanditiis dolorum porro repudiandae ipsam accusamus molestiae aspernatur recusandae',
    slug: 'Tasty-Desert-Shirt',
    added: 1481701719166,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Sunset', 'Road'],
    price: 18.99,
    name: 'Licensed Mountain Shirt',
    description:
      'nulla rem mollitia eos illo officia nulla qui ipsa consequatur non',
    slug: 'Licensed-Mountain-Shirt',
    added: 1484972776727,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'People'],
    price: 20.99,
    name: 'Small People Shirt',
    description:
      'impedit aliquid explicabo accusamus saepe iste similique molestiae ut sed et beatae',
    slug: 'Small-People-Shirt-1',
    added: 1482516621723,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Man', 'Hands', 'Lake', 'People'],
    price: 19.99,
    name: 'Intelligent Man Shirt',
    description:
      'atque facere sit dolores maxime voluptatem reiciendis ut sint ipsam sequi odit dolorum excepturi quia sit pariatur beatae reprehenderit repudiandae et recusandae expedita quo',
    slug: 'Intelligent-Man-Shirt',
    added: 1481619791030,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Train', 'Railroad'],
    price: 9.99,
    name: 'Licensed Train Shirt',
    description:
      'similique aut cumque dolores minus et doloremque id ex nesciunt aliquam non ipsum praesentium aut explicabo blanditiis labore',
    slug: 'Licensed-Train-Shirt',
    added: 1481616535175,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Leopard'],
    price: 19.99,
    name: 'Tasty Animal Shirt',
    description:
      'qui et ut nulla sunt ut repudiandae facilis unde modi aut ut id ut illo quas non vitae',
    slug: 'Tasty-Animal-Shirt',
    added: 1486067757350,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Nature', 'Mountains'],
    price: 13.99,
    name: 'Tasty Nature Shirt',
    description:
      'facilis perferendis et ipsum voluptate distinctio consequatur porro provident in eos cupiditate modi',
    slug: 'Tasty-Nature-Shirt',
    added: 1485070473271,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Arch', 'Abstract', 'Architecture'],
    price: 15.99,
    name: 'Small Arch Shirt',
    description:
      'ipsa voluptatum odit distinctio ut ad repellendus ea cupiditate atque magnam nulla',
    slug: 'Small-Arch-Shirt-1',
    added: 1482372157698,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Man', 'City'],
    price: 19.99,
    name: 'Unbranded Person Shirt',
    description:
      'nesciunt officia ut quas nihil iusto tempore accusamus ut aliquam voluptatem',
    slug: 'Unbranded-Person-Shirt-1',
    added: 1485988506677,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Field', 'Farm'],
    price: 17.99,
    name: 'Licensed Field Shirt',
    description:
      'est ratione necessitatibus repellat et reiciendis et ut autem eum laboriosam facilis dolor sit nisi',
    slug: 'Licensed-Field-Shirt',
    added: 1484314592674,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Night', 'Stars', 'Silhouette'],
    price: 14.99,
    name: 'Generic Silhouette Shirt',
    description:
      'repudiandae consequuntur qui quo maiores sed quis iusto repudiandae dignissimos autem aliquam error explicabo enim veniam qui at veniam commodi corporis qui ut quia',
    slug: 'Generic-Silhouette-Shirt',
    added: 1478883447964,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Transportation', 'Railroad', 'Train'],
    price: 11.99,
    name: 'Rustic Train Shirt',
    description:
      'dolor itaque sed in architecto voluptatem sit error sit molestias magni similique eligendi illum temporibus blanditiis',
    slug: 'Rustic-Train-Shirt',
    added: 1478139368950,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'City', 'Buildings'],
    price: 20.99,
    name: 'Ergonomic Sunset Shirt',
    description:
      'magnam aspernatur voluptatem temporibus officia facere aperiam nihil qui totam cumque ex dicta earum quisquam consequatur est accusamus',
    slug: 'Ergonomic-Sunset-Shirt',
    added: 1485085900751,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Hands', 'Piano', 'People'],
    price: 19.99,
    name: 'Intelligent People Shirt',
    description:
      'voluptatem reiciendis in animi voluptatum rerum perferendis omnis saepe et ad maiores iusto laborum ut voluptatem voluptatem ex nihil sapiente ut',
    slug: 'Intelligent-People-Shirt',
    added: 1484014809742,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Building'],
    price: 10.99,
    name: 'Tasty Building Shirt',
    description:
      'aut veritatis reiciendis saepe ducimus maiores minus est vel unde voluptatem quia vero nobis praesentium ab voluptas dignissimos sed tempora perspiciatis libero',
    slug: 'Tasty-Building-Shirt-1',
    added: 1484779440869,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Beach', 'People'],
    price: 16.99,
    name: 'Gorgeous Beach Shirt',
    description:
      'dolores explicabo deserunt laborum consequatur sint ut qui nulla doloribus sequi quaerat occaecati aut exercitationem dicta ut quia hic deserunt qui soluta non et modi',
    slug: 'Gorgeous-Beach-Shirt-3',
    added: 1483300519267,
    manufacturer: 'Heathcote-Kautzer-and-Turner',
    itemType: 'shirt',
  },
  {
    tags: ['Cloud', 'Antique'],
    price: 13.99,
    name: 'Rustic Cloud Shirt',
    description:
      'ullam nostrum vero corporis maiores nulla placeat qui molestiae sit veritatis ea animi aut sequi voluptas perferendis',
    slug: 'Rustic-Cloud-Shirt',
    added: 1477924618177,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Animal', 'Cat'],
    price: 13.99,
    name: 'Sleek Animal Shirt',
    description:
      'voluptatem ut consectetur ab vitae enim harum suscipit dolore impedit illum eligendi',
    slug: 'Sleek-Animal-Shirt',
    added: 1479475330776,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Mountains'],
    price: 15.99,
    name: 'Awesome Fog Shirt',
    description:
      'distinctio assumenda nisi reiciendis beatae commodi iste qui omnis enim quis voluptatem qui officiis et ut mollitia nobis',
    slug: 'Awesome-Fog-Shirt-4',
    added: 1477853113240,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'People'],
    price: 12.99,
    name: 'Sleek Fog Shirt',
    description:
      'repudiandae tempore praesentium dolore vel quia vitae ea voluptatum incidunt placeat nostrum consequatur et minima placeat quia odit nemo cumque est dolores accusamus',
    slug: 'Sleek-Fog-Shirt-3',
    added: 1478786739039,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Machine', 'Stars', 'Space'],
    price: 15.99,
    name: 'Rustic Machine Shirt',
    description:
      'nemo quisquam voluptatem eius aut praesentium aut illo neque atque velit repellendus et maiores et consequatur',
    slug: 'Rustic-Machine-Shirt',
    added: 1482603948133,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest', 'Railroad'],
    price: 10.99,
    name: 'Handcrafted Trees Shirt',
    description:
      'cupiditate ut sed velit quam voluptatem libero quis est sequi et quis',
    slug: 'Handcrafted-Trees-Shirt-2',
    added: 1485027583520,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Person', 'Fog'],
    price: 9.99,
    name: 'Handmade Fog Shirt',
    description:
      'qui consequatur sit dolorem dolor recusandae a quam sint architecto nemo animi quibusdam consectetur assumenda accusamus',
    slug: 'Handmade-Fog-Shirt-2',
    added: 1485077558136,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Strawberries', 'Food', 'Fruit'],
    price: 19.99,
    name: 'Tasty Strawberries Shirt',
    description:
      'qui aut delectus quasi distinctio qui sed ullam quam omnis velit iste autem quaerat est qui quisquam debitis eos accusantium',
    slug: 'Tasty-Strawberries-Shirt',
    added: 1481338866017,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Nature', 'Forest'],
    price: 9.99,
    name: 'Intelligent Trees Shirt',
    description:
      'sint vitae minus fugiat perspiciatis aperiam quis consectetur maxime modi ut esse animi sint dolorum non aliquid et nostrum ipsa',
    slug: 'Intelligent-Trees-Shirt-4',
    added: 1480958280270,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Scuba dive', 'Diver', 'People'],
    price: 11.99,
    name: 'Handcrafted Scuba Dive Shirt',
    description:
      'et quisquam sapiente nostrum id placeat est assumenda sunt vitae fugiat ut blanditiis facere qui ut non voluptas',
    slug: 'Handcrafted-Scuba-Dive-Shirt',
    added: 1480200345790,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Railroad'],
    price: 9.99,
    name: 'Intelligent Railroad Shirt',
    description:
      'quaerat consequatur fugiat inventore quae fugit qui commodi aliquam odit magni voluptatem temporibus iure culpa',
    slug: 'Intelligent-Railroad-Shirt',
    added: 1481737795609,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Snow', 'Trees'],
    price: 15.99,
    name: 'Handcrafted Trees Shirt',
    description:
      'itaque sapiente nihil doloribus placeat dignissimos est temporibus ea qui laborum ipsam qui pariatur sed voluptas id ut quaerat veritatis aut molestias',
    slug: 'Handcrafted-Trees-Shirt-3',
    added: 1484920884849,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ferris wheel', 'Machine'],
    price: 9.99,
    name: 'Licensed Ferris Wheel Shirt',
    description:
      'iure earum similique vitae assumenda rerum perspiciatis ut reiciendis itaque sequi ipsam cupiditate et ipsa sint maxime exercitationem',
    slug: 'Licensed-Ferris-Wheel-Shirt',
    added: 1483944194932,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Hands', 'Map'],
    price: 15.99,
    name: 'Rustic Map Shirt',
    description:
      'ut error ex mollitia facere esse quia et repudiandae ut accusamus voluptas dolores esse assumenda veniam rerum',
    slug: 'Rustic-Map-Shirt',
    added: 1482424199409,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Sunset', 'Clouds'],
    price: 16.99,
    name: 'Small Sunset Shirt',
    description:
      'enim iure quam atque porro nobis alias qui praesentium quis quos',
    slug: 'Small-Sunset-Shirt',
    added: 1478068363540,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Hands', 'Woman', 'Camera'],
    price: 19.99,
    name: 'Generic Hands Shirt',
    description:
      'voluptas numquam et delectus laudantium perspiciatis numquam dolor dolore asperiores nisi tenetur deserunt qui aspernatur voluptatem debitis et sint consequuntur aliquam',
    slug: 'Generic-Hands-Shirt',
    added: 1478217892213,
    manufacturer: 'Sipes-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Old', 'Car'],
    price: 13.99,
    name: 'Tasty Old Shirt',
    description:
      'et quia doloribus fugit enim ut optio sit ut sunt est sint est iste deleniti dolorem et',
    slug: 'Tasty-Old-Shirt',
    added: 1480670005741,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Waterfall', 'Nature', 'Rocks'],
    price: 15.99,
    name: 'Handmade Nature Shirt',
    description:
      'nemo soluta iusto sunt officia perspiciatis rerum est nesciunt quis aperiam et et nesciunt enim autem mollitia id in iste dolorem',
    slug: 'Handmade-Nature-Shirt-2',
    added: 1485595556218,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Mountains'],
    price: 20.99,
    name: 'Intelligent Mountains Shirt',
    description:
      'quia nam eaque recusandae non qui eaque ut sint laborum hic ducimus ipsum illum dolores delectus tempora vel quaerat soluta dolores',
    slug: 'Intelligent-Mountains-Shirt-4',
    added: 1485315573285,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Lake'],
    price: 15.99,
    name: 'Incredible Lake Shirt',
    description:
      'corporis aspernatur corporis saepe ut quis hic nesciunt ut ratione voluptatem fugit debitis incidunt commodi voluptates dignissimos molestiae quia assumenda est autem ea quia',
    slug: 'Incredible-Lake-Shirt',
    added: 1483373942158,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Food'],
    price: 15.99,
    name: 'Ergonomic Food Shirt',
    description:
      'laboriosam cumque labore itaque qui beatae numquam quia fugiat qui veritatis porro cupiditate nisi voluptatem quae voluptas impedit quos corporis',
    slug: 'Ergonomic-Food-Shirt',
    added: 1481394265029,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Mountains', 'Road'],
    price: 9.99,
    name: 'Refined Road Shirt',
    description:
      'recusandae libero error sed aut quis esse fugiat repellat et vel quis',
    slug: 'Refined-Road-Shirt-1',
    added: 1484372697374,
    manufacturer: 'Lowe-Wunsch-and-Stoltenberg',
    itemType: 'shirt',
  },
  {
    tags: ['Antique', 'Typewriter', 'Machine'],
    price: 12.99,
    name: 'Tasty Machine Shirt',
    description:
      'autem labore dolorum unde dicta vitae consequuntur fuga dolore optio similique sed iste ut aperiam architecto in',
    slug: 'Tasty-Machine-Shirt',
    added: 1484896179047,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Light'],
    price: 17.99,
    name: 'Ergonomic Light Shirt',
    description:
      'similique quas accusantium voluptas harum ratione sit impedit in quos ut assumenda sed itaque harum esse in sint minus voluptates architecto praesentium deleniti quae',
    slug: 'Ergonomic-Light-Shirt',
    added: 1480854412114,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Waves', 'Water'],
    price: 19.99,
    name: 'Unbranded Water Shirt',
    description:
      'molestiae non eaque nulla dolorum quis sed quis exercitationem recusandae natus occaecati voluptates',
    slug: 'Unbranded-Water-Shirt-1',
    added: 1482325982948,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Shoes', 'Person', 'Feet'],
    price: 19.99,
    name: 'Practical Shoes Shirt',
    description:
      'labore ea odio fugit exercitationem tenetur voluptas vel nemo distinctio assumenda veniam',
    slug: 'Practical-Shoes-Shirt',
    added: 1481481692237,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'People'],
    price: 19.99,
    name: 'Generic City Shirt',
    description:
      'porro eligendi explicabo et ducimus similique nemo pariatur quos doloribus repellat suscipit dolores sint doloribus ut tempore quasi nam ea',
    slug: 'Generic-City-Shirt',
    added: 1478689905281,
    manufacturer: 'Boyle-LLC',
    itemType: 'shirt',
  },
  {
    tags: ['Field'],
    price: 20.99,
    name: 'Generic Field Shirt',
    description:
      'et itaque quod ut et eius corrupti doloremque qui tempora qui laborum deserunt harum quasi voluptate doloribus qui eius dolorem',
    slug: 'Generic-Field-Shirt',
    added: 1486031839323,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Road'],
    price: 17.99,
    name: 'Gorgeous Trees Shirt',
    description:
      'aut totam consectetur minima minima temporibus amet unde voluptatem ipsum ratione dolores quaerat officiis nulla ut incidunt atque tenetur',
    slug: 'Gorgeous-Trees-Shirt-5',
    added: 1480422741525,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Meadow', 'Flowers'],
    price: 10.99,
    name: 'Unbranded Flowers Shirt',
    description:
      'excepturi aut ut officia vitae magni non animi odit eius officia hic temporibus ea laudantium dicta fugiat at distinctio voluptas voluptatem porro aliquid soluta ea',
    slug: 'Unbranded-Flowers-Shirt-2',
    added: 1485374755220,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Person', 'Lake'],
    price: 10.99,
    name: 'Rustic Mountain Shirt',
    description:
      'reiciendis a eum ab ut consequatur eum nostrum aut voluptatem',
    slug: 'Rustic-Mountain-Shirt-1',
    added: 1479567726274,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Nature', 'Mountains', 'Road', 'Clouds'],
    price: 20.99,
    name: 'Licensed Nature Shirt',
    description:
      'accusamus quisquam vel temporibus velit sed porro quas iste sunt sunt dolores nisi repellat enim ipsum et voluptatem consectetur',
    slug: 'Licensed-Nature-Shirt',
    added: 1483199552127,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Night', 'Stars'],
    price: 17.99,
    name: 'Gorgeous Night Shirt',
    description:
      'qui ex nobis est neque occaecati sunt quae quia voluptatem id ut atque rem nihil mollitia',
    slug: 'Gorgeous-Night-Shirt-1',
    added: 1483744028073,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Person', 'Coffee', 'Book', 'Camera'],
    price: 14.99,
    name: 'Small Person Shirt',
    description:
      'adipisci enim consequuntur impedit culpa eos nesciunt possimus pariatur nam ab ipsa asperiores voluptas placeat et minima sunt aut laudantium amet est',
    slug: 'Small-Person-Shirt',
    added: 1485172456727,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Flower'],
    price: 15.99,
    name: 'Incredible Flower Shirt',
    description:
      'explicabo autem et aliquid autem vitae corrupti officia dolore consequatur et magnam officia minima ut',
    slug: 'Incredible-Flower-Shirt',
    added: 1484735897612,
    manufacturer: 'Cruickshank-Bayer-and-Gerlach',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Trees', 'Fog'],
    price: 13.99,
    name: 'Ergonomic Mountain Shirt',
    description:
      'placeat amet voluptas harum in minima vero nihil labore vero vel saepe quia',
    slug: 'Ergonomic-Mountain-Shirt-1',
    added: 1481851489801,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 17.99,
    name: 'Handcrafted Wood Shirt',
    description:
      'voluptatem dolores pariatur voluptates tenetur molestiae vitae totam est nisi dolor provident rem rerum totam',
    slug: 'Handcrafted-Wood-Shirt',
    added: 1482000810699,
    manufacturer: 'Nikolaus-Schinner',
    itemType: 'shirt',
  },
  {
    tags: ['Macro', 'Bamboo'],
    price: 15.99,
    name: 'Small Bamboo Shirt',
    description:
      'temporibus quae autem voluptas iusto sint qui ullam nostrum tenetur',
    slug: 'Small-Bamboo-Shirt',
    added: 1478282193128,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Dog', 'Animal', 'Puppy'],
    price: 18.99,
    name: 'Sleek Puppy Shirt',
    description:
      'soluta quae voluptate cumque maiores corrupti repellat fugit quisquam a aliquid accusantium rem harum sint ex provident impedit ut et provident et quam',
    slug: 'Sleek-Puppy-Shirt',
    added: 1486280696656,
    manufacturer: 'OHara-Group',
    itemType: 'shirt',
  },
  {
    tags: ['City', 'Buildings'],
    price: 17.99,
    name: 'Awesome Buildings Shirt',
    description:
      'autem reiciendis quae non asperiores aut quis labore exercitationem voluptatem et rerum quis tenetur',
    slug: 'Awesome-Buildings-Shirt-2',
    added: 1478690559826,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Tree', 'Fog'],
    price: 10.99,
    name: 'Handcrafted Fog Shirt',
    description:
      'nemo et quaerat possimus vel ad repellendus quia ex ex repellendus quia officia adipisci',
    slug: 'Handcrafted-Fog-Shirt-3',
    added: 1477962579126,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Sky', 'Night'],
    price: 10.99,
    name: 'Small Night Shirt',
    description:
      'cum at rem nobis ad in adipisci ex dolore quam quia quis consectetur eius quibusdam ut sunt quibusdam corrupti est',
    slug: 'Small-Night-Shirt-3',
    added: 1478677131565,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 13.99,
    name: 'Rustic Mountains Shirt',
    description:
      'est voluptas hic dolores ipsum vitae rerum molestiae repudiandae hic tempore',
    slug: 'Rustic-Mountains-Shirt-1',
    added: 1481172184605,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Water'],
    price: 13.99,
    name: 'Unbranded Water Shirt',
    description:
      'quas mollitia similique alias aut aut modi sequi accusantium eius inventore aliquid nisi inventore facilis placeat non officiis provident molestiae exercitationem voluptate rerum',
    slug: 'Unbranded-Water-Shirt-2',
    added: 1484677371851,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Nature', 'Fog'],
    price: 18.99,
    name: 'Generic Nature Shirt',
    description:
      'a veniam aliquam non hic distinctio qui doloremque aut velit iure sapiente rerum ex et libero unde natus consequatur perspiciatis quis',
    slug: 'Generic-Nature-Shirt-2',
    added: 1478763941271,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Plants', 'Succulents'],
    price: 20.99,
    name: 'Awesome Succulents Shirt',
    description:
      'deleniti dolore consequuntur repudiandae qui omnis consectetur ut est vel voluptatibus',
    slug: 'Awesome-Succulents-Shirt',
    added: 1486253491269,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Wave', 'Ocean', 'Water'],
    price: 20.99,
    name: 'Intelligent Water Shirt',
    description:
      'totam aut aliquam illo quas atque laborum enim quis laborum ducimus impedit dignissimos nostrum ex voluptatem id qui quaerat et',
    slug: 'Intelligent-Water-Shirt-1',
    added: 1479930371917,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Person', 'Mountains', 'Silhouette'],
    price: 13.99,
    name: 'Handcrafted Silhouette Shirt',
    description:
      'sit sapiente consequatur vel nesciunt sed et blanditiis voluptate deserunt et in sunt debitis odit voluptates dolores',
    slug: 'Handcrafted-Silhouette-Shirt',
    added: 1481824051232,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Hand', 'Night'],
    price: 17.99,
    name: 'Incredible Night Shirt',
    description:
      'aperiam cum minus eius placeat occaecati tenetur impedit id et dolore consequuntur ut iusto eaque voluptas atque eveniet fuga eligendi totam facilis sit sit',
    slug: 'Incredible-Night-Shirt',
    added: 1486132957436,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Terminal', 'Stairs'],
    price: 19.99,
    name: 'Sleek Stairs Shirt',
    description:
      'sed dolore et fuga alias esse ut non vitae doloremque ducimus',
    slug: 'Sleek-Stairs-Shirt',
    added: 1480760751768,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
  {
    tags: ['Fog', 'Water'],
    price: 15.99,
    name: 'Unbranded Water Shirt',
    description:
      'aperiam temporibus modi mollitia et enim accusamus laboriosam molestiae ducimus ipsa ab fugit qui reiciendis ducimus quia et at consequatur est',
    slug: 'Unbranded-Water-Shirt-3',
    added: 1478693503710,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Snow', 'Mountains'],
    price: 19.99,
    name: 'Refined Sunset Shirt',
    description:
      'commodi mollitia enim aspernatur sed ullam voluptas consequatur dolorem est dicta sit voluptatum et consequatur qui sequi nulla autem facere minus distinctio explicabo consectetur tempora',
    slug: 'Refined-Sunset-Shirt',
    added: 1479003479547,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Mountains'],
    price: 20.99,
    name: 'Unbranded Mountains Shirt',
    description:
      'nulla fugiat molestiae ratione tempore sed occaecati consequatur ut eum et autem',
    slug: 'Unbranded-Mountains-Shirt-2',
    added: 1483781522680,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Arial', 'Forest'],
    price: 13.99,
    name: 'Rustic Arial Shirt',
    description:
      'facilis harum facere rem quisquam enim quidem est provident deleniti non beatae repellat ullam qui enim et molestias laudantium deleniti aliquid',
    slug: 'Rustic-Arial-Shirt',
    added: 1484527576669,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Sunset', 'Dock', 'Ocean'],
    price: 13.99,
    name: 'Handmade Ocean Shirt',
    description:
      'quaerat omnis ab ab veritatis et ab enim amet voluptate quia aperiam eveniet beatae voluptas quidem consequatur nihil veniam maxime',
    slug: 'Handmade-Ocean-Shirt-2',
    added: 1477819216248,
    manufacturer: 'Dickens-Franecki',
    itemType: 'shirt',
  },
  {
    tags: ['Snow', 'Animal', 'Wolf'],
    price: 14.99,
    name: 'Ergonomic Animal Shirt',
    description:
      'consequatur perspiciatis et temporibus non recusandae modi laboriosam omnis cupiditate officiis voluptatem aperiam deserunt dolorem',
    slug: 'Ergonomic-Animal-Shirt',
    added: 1480448656770,
    manufacturer: 'Oberbrunner-Block-and-Mills',
    itemType: 'shirt',
  },
  {
    tags: ['Trees', 'Forest'],
    price: 11.99,
    name: 'Incredible Forest Shirt',
    description:
      'modi dolore aliquid autem aspernatur voluptatem consequatur aliquid placeat expedita esse sequi perspiciatis laudantium reprehenderit ea non sed voluptatem totam rerum',
    slug: 'Incredible-Forest-Shirt-1',
    added: 1481958005263,
    manufacturer: 'Rice-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Desert', 'Road'],
    price: 19.99,
    name: 'Fantastic Desert Shirt',
    description:
      'et ut sit earum voluptas est in quisquam quo dolor dolorem eos modi dicta perferendis odit consectetur quidem qui quasi voluptatem quas',
    slug: 'Fantastic-Desert-Shirt',
    added: 1485250278780,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Bird', 'Water'],
    price: 17.99,
    name: 'Incredible Water Shirt',
    description:
      'voluptas recusandae veritatis sed tempore quam sint enim amet magnam',
    slug: 'Incredible-Water-Shirt',
    added: 1479556980768,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Food'],
    price: 10.99,
    name: 'Refined Food Shirt',
    description:
      'accusamus reiciendis dolores nam velit omnis et sunt eligendi est saepe velit perspiciatis saepe maiores enim possimus rem in sint aut saepe possimus',
    slug: 'Refined-Food-Shirt',
    added: 1479857731820,
    manufacturer: 'Konopelski-Inc',
    itemType: 'shirt',
  },
  {
    tags: ['Cars'],
    price: 12.99,
    name: 'Unbranded Cars Shirt',
    description:
      'rerum atque nisi ut nesciunt officiis sequi eligendi ratione ipsum nihil dolorem ipsa sed enim odio accusamus harum quae necessitatibus quas laudantium',
    slug: 'Unbranded-Cars-Shirt',
    added: 1482920108874,
    manufacturer: 'Bernier-Hane',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Typewriter', 'Paper', 'Book'],
    price: 20.99,
    name: 'Rustic Desk Shirt',
    description:
      'neque eveniet deleniti temporibus sed et quo ea nobis deleniti voluptates nihil tenetur veniam eum ducimus labore minima',
    slug: 'Rustic-Desk-Shirt',
    added: 1485470651230,
    manufacturer: 'Bayer-and-Sons',
    itemType: 'shirt',
  },
  {
    tags: ['Ocean', 'Cliffs'],
    price: 13.99,
    name: 'Small Ocean Shirt',
    description:
      'ea quia delectus et ipsam aut quia et ducimus consectetur vel alias dignissimos aut repudiandae quis nihil aut qui quam necessitatibus tempore',
    slug: 'Small-Ocean-Shirt-2',
    added: 1480168877390,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Volcano', 'Nature', 'Desert'],
    price: 10.99,
    name: 'Gorgeous Nature Shirt',
    description:
      'esse esse et doloremque quia aut molestiae recusandae eos fugit ipsa adipisci vitae',
    slug: 'Gorgeous-Nature-Shirt-1',
    added: 1482790035172,
    manufacturer: 'Weissnat-Schowalter-and-Koelpin',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office', 'Wood'],
    price: 20.99,
    name: 'Rustic Office Shirt',
    description:
      'est accusantium adipisci iste est beatae eaque doloremque qui nostrum ut cum perspiciatis aperiam expedita ut hic veniam distinctio libero illo eum et',
    slug: 'Rustic-Office-Shirt',
    added: 1479987051494,
    manufacturer: 'Leuschke-Smith-and-Conroy',
    itemType: 'shirt',
  },
  {
    tags: ['Bridge'],
    price: 10.99,
    name: 'Rustic Bridge Shirt',
    description:
      'rerum distinctio sunt pariatur incidunt et praesentium enim est quia inventore ex ut necessitatibus aut praesentium dolor vitae',
    slug: 'Rustic-Bridge-Shirt',
    added: 1481640296920,
    manufacturer: 'McCullough---Lueilwitz',
    itemType: 'shirt',
  },
  {
    tags: ['Coffee', 'Hands'],
    price: 13.99,
    name: 'Rustic Hands Shirt',
    description:
      'at ullam tempora accusantium mollitia id qui voluptas non velit occaecati aut porro qui et recusandae',
    slug: 'Rustic-Hands-Shirt',
    added: 1478578035413,
    manufacturer: 'Metz---Kautzer',
    itemType: 'shirt',
  },
  {
    tags: ['Desk', 'Office', 'Laptop'],
    price: 10.99,
    name: 'Rustic Office Shirt',
    description:
      'error distinctio minima tenetur nihil vero nostrum magni qui veniam dolorem iusto nostrum expedita',
    slug: 'Rustic-Office-Shirt-1',
    added: 1483230128213,
    manufacturer: 'Leannon-Fahey-and-Sawayn',
    itemType: 'shirt',
  },
  {
    tags: ['Pipe', 'Fog'],
    price: 16.99,
    name: 'Practical Fog Shirt',
    description:
      'voluptas quia numquam nemo qui asperiores quo qui corrupti quae pariatur beatae expedita ut praesentium dignissimos',
    slug: 'Practical-Fog-Shirt-1',
    added: 1484682964932,
    manufacturer: 'Konopelski-Group',
    itemType: 'shirt',
  },
  {
    tags: ['Walrus', 'Animal'],
    price: 15.99,
    name: 'Unbranded Animal Shirt',
    description:
      'est alias repudiandae modi soluta quisquam id in quia aut exercitationem',
    slug: 'Unbranded-Animal-Shirt',
    added: 1478371623125,
    manufacturer: 'Franecki---Gaylord',
    itemType: 'shirt',
  },
  {
    tags: ['Mountain', 'Snow', 'Fog'],
    price: 20.99,
    name: 'Handmade Fog Shirt',
    description:
      'sunt fugiat labore sunt est suscipit ab eos praesentium ad aliquid rerum qui ut odio eveniet modi enim dignissimos repellendus temporibus dolorum odio ducimus',
    slug: 'Handmade-Fog-Shirt-3',
    added: 1482749110863,
    manufacturer: 'Feil-Dooley-and-Reinger',
    itemType: 'shirt',
  },
]

export default itemsJson
